/* eslint-disable prettier/prettier */
export default {
	groups: [
		["sunrise", 1, 12, "#ff5085"],
		["forest", 13, 80, "#00b286"],
		["canyon", 81, 160, "#c90000"],
		["sky", 161, 240, "#ffa41e"],
		["tropic", 241, 320, "#edee21"],
		["mountain", 321, 400, "#7600d0"],
		["winter", 401, 480, "#3750eb"],
		["flora", 481, 560, "#d600ad"],
		["autumn", 561, 640, "#f26900"],
		["jungle", 641, 720, "#009916"],
		["desert", 721, 800, "#fa606c"],
		["ocean", 801, 880, "#0050f2"],
		["field", 881, 960, "#513a9a"],
		["lake", 961, 1040, "#28abb4"],
		["vista", 1041, 1120, "#b50000"],
		["cliff", 1121, 1200, "#7600d0"],
		["beach", 1201, 1280, "#edee21"],
		["fog", 1281, 1360, "#3750eb"],
		["celestial", 1361, 1440, "#ff5085"],
		["woodland", 1441, 1520, "#00b286"],
		["outback", 1521, 1600, "#fa606c"],
		["frost", 1601, 1680, "#3750eb"],
		["timberland", 1681, 1760, "#7600d0"],
		["hills", 1761, 1840, "#b50000"],
		["mist", 1841, 1920, "#00b286"],
		["formation", 1921, 2000, "#28abb4"],
		["coast", 2001, 2080, "#edee21"],
		["twilight", 2081, 2160, "#7600d0"],
		["marsh", 2161, 2240, "#f26900"],
		["woods", 2241, 2320, "#00b286"],
		["arid", 2321, 2400, "#fa606c"],
		["tide", 2401, 2480, "#0050f2"],
		["passage", 2481, 2560, "#c90000"],
		["air", 2561, 2640, "#ffa41e"],
		["lagoon", 2641, 2720, "#edee21"],
		["peak", 2721, 2800, "#7600d0"],
		["ice", 2801, 2880, "#3750eb"],
		["bloom", 2881, 2960, "#d600ad"],
		["fall", 2961, 3040, "#f26900"],
		["rain forest", 3041, 3120, "#009916"],
		["rows", 3121, 3200, "#513a9a"],
		["basin", 3201, 3280, "#28abb4"],
		["view", 3281, 3360, "#b50000"],
		["precipice", 3361, 3440, "#7600d0"],
		["starlight", 3441, 3520, "#3750f1"],
		["reflect", 3521, 3600, "#d600ad"],
		["majesty", 3601, 3680, "#7600d0"],
		["astral", 3681, 3760, "#28abb4"],
		["stone", 3761, 3840, "#b50000"],
		["green", 3841, 3920, "#009916"],
		["west", 3921, 4000, "#fa606c"],
		["wind", 4001, 4080, "#438aff"],
		["shore", 4081, 4160, "#ffb84b"],
		["ravine", 4161, 4240, "#fa606c"],
		["botanical", 4241, 4320, "#e70074"],
		["arctic", 4321, 4400, "#007beb"],
		["galaxy", 4401, 4480, "#7600d0"],
		["tower", 4481, 4560, "#ffa41e"],
		["placid", 4561, 4640, "#d600ad"],
		["thrive", 4641, 4720, "#009916"],
		["parched", 4721, 4800, "#fa606c"],
		["frigid", 4801, 4880, "#3750eb"],
		["flourish", 4881, 4960, "#f20045"],
		["aurora", 4961, 5040, "#7600d0"],
		["crest", 5041, 5120, "#b50000"],
		["foliage", 5121, 5200, "#ff78ae"],
		["wildwood", 5201, 5280, "#009916"],
		["bare", 5281, 5360, "#fa606c"],
		["high seas", 5361, 5440, "#0050f2"],
		["meadow", 5441, 5520, "#513a9a"],
		["tarn", 5521, 5600, "#28abb4"],
		["summit", 5601, 5680, "#b50000"],
		["bluff", 5681, 5760, "#7600d0"],
		["strand", 5761, 5840, "#edee21"],
		["cloud", 5841, 5920, "#3750eb"],
		["sublime", 5921, 6000, "#ff5085"],
		["master", 6001, 100000, "#282d32"],
	],
	packs: [
		["rise", 1, 4, "#e78d46", "sunrise"],
		["grow", 5, 8, "#c5d51f", "sunrise"],
		["shine", 9, 12, "#f79926", "sunrise"],
		["pine", 13, 20, "#15573d", "forest"],
		["dew", 21, 32, "#779c35", "forest"],
		["flow", 33, 48, "#7a5d2b", "forest"],
		["fog", 49, 64, "#7ab4d6", "forest"],
		["life", 65, 80, "#b2ba44", "forest"],
		["ravine", 81, 96, "#1b89d3", "canyon"],
		["pass", 97, 112, "#904024", "canyon"],
		["arch", 113, 128, "#20202c", "canyon"],
		["cliff", 129, 144, "#052d65", "canyon"],
		["pillar", 145, 160, "#36483b", "canyon"],
		["wind", 161, 176, "#c37966", "sky"],
		["rays", 177, 192, "#8a5425", "sky"],
		["dusk", 193, 208, "#d5c57b", "sky"],
		["cloud", 209, 224, "#ee9361", "sky"],
		["sun", 225, 240, "#cf8382", "sky"],
		["shore", 241, 256, "#44c7ca", "tropic"],
		["frond", 257, 272, "#cdad81", "tropic"],
		["palm", 273, 288, "#40addf", "tropic"],
		["beach", 289, 304, "#3270cd", "tropic"],
		["coast", 305, 320, "#5b447b", "tropic"],
		["crest", 321, 336, "#d3bf7e", "mountain"],
		["fjord", 337, 352, "#2a7b93", "mountain"],
		["climb", 353, 368, "#454c50", "mountain"],
		["scale", 369, 384, "#789395", "mountain"],
		["peak", 385, 400, "#9987ca", "mountain"],
		["chill", 401, 416, "#99a9b7", "winter"],
		["bite", 417, 432, "#73a0bd", "winter"],
		["flake", 433, 448, "#184d4e", "winter"],
		["white", 449, 464, "#2d6194", "winter"],
		["frost", 465, 480, "#90a0c1", "winter"],
		["petal", 481, 496, "#b9989b", "flora"],
		["lily", 497, 512, "#36342a", "flora"],
		["bloom", 513, 528, "#a3904f", "flora"],
		["field", 529, 544, "#32283c", "flora"],
		["seed", 545, 560, "#c3b98e", "flora"],
		["fall", 561, 576, "#8c8237", "autumn"],
		["bark", 577, 592, "#b7af99", "autumn"],
		["red", 593, 608, "#6d1a10", "autumn"],
		["vivid", 609, 624, "#609fdc", "autumn"],
		["cover", 625, 640, "#90510a", "autumn"],
		["vine", 641, 656, "#4c6111", "jungle"],
		["thick", 657, 672, "#3d3a16", "jungle"],
		["wild", 673, 688, "#1c600b", "jungle"],
		["lush", 689, 704, "#3b4b18", "jungle"],
		["green", 705, 720, "#263206", "jungle"],
		["spire", 721, 736, "#a587c9", "desert"],
		["rock", 737, 752, "#1e558c", "desert"],
		["sierra", 753, 768, "#c36910", "desert"],
		["dune", 769, 784, "#6c78e5", "desert"],
		["sand", 785, 800, "#0f46bf", "desert"],
		["vast", 801, 816, "#c7a884", "ocean"],
		["wave", 817, 832, "#138cc5", "ocean"],
		["storm", 833, 848, "#548eb1", "ocean"],
		["blue", 849, 864, "#a0b79a", "ocean"],
		["depth", 865, 880, "#3a6daf", "ocean"],
		["sail", 881, 896, "#8da40a", "field"],
		["haze", 897, 912, "#4f80c0", "field"],
		["soar", 913, 928, "#367bcb", "field"],
		["wind", 929, 944, "#e49f6d", "field"],
		["amber", 945, 960, "#b5674f", "field"],
		["calm", 961, 976, "#897ed3", "lake"],
		["set", 977, 992, "#372f30", "lake"],
		["serene", 993, 1008, "#97b9b5", "lake"],
		["air", 1009, 1024, "#8da5c4", "lake"],
		["grace", 1025, 1040, "#1b0d35", "lake"],
		["climb", 1041, 1056, "#4186c8", "vista"],
		["above", 1057, 1072, "#88b3c9", "vista"],
		["fall", 1073, 1088, "#43b2eb", "vista"],
		["below", 1089, 1104, "#85b1cc", "vista"],
		["arrive", 1105, 1120, "#66a9eb", "vista"],
		["mist", 1121, 1136, "#b1a5a0", "cliff"],
		["bright", 1137, 1152, "#355732", "cliff"],
		["dawn", 1153, 1168, "#6a68c7", "cliff"],
		["brood", 1169, 1184, "#856d1c", "cliff"],
		["view", 1185, 1200, "#3f6e9a", "cliff"],
		["fresh", 1201, 1216, "#7bb0d5", "beach"],
		["shell", 1217, 1232, "#d0a973", "beach"],
		["wash", 1233, 1248, "#756e8d", "beach"],
		["aqua", 1249, 1264, "#82b6cf", "beach"],
		["pebble", 1265, 1280, "#7e707b", "beach"],
		["wood", 1281, 1296, "#b0a7a1", "fog"],
		["valley", 1297, 1312, "#cea37e", "fog"],
		["lake", 1313, 1328, "#84857f", "fog"],
		["range", 1329, 1344, "#34447a", "fog"],
		["river", 1345, 1360, "#587a75", "fog"],
		["cosmo", 1361, 1376, "#3b2446", "celestial"],
		["luna", 1377, 1392, "#051227", "celestial"],
		["strato", 1393, 1408, "#0a408a", "celestial"],
		["polar", 1409, 1424, "#819864", "celestial"],
		["solis", 1425, 1440, "#d58265", "celestial"],
		["ray", 1441, 1456, "#b1934b", "woodland"],
		["azure", 1457, 1472, "#0f98b9", "woodland"],
		["toad", 1473, 1488, "#264056", "woodland"],
		["brook", 1489, 1504, "#566f3c", "woodland"],
		["leaf", 1505, 1520, "#cbe76a", "woodland"],
		["flat", 1521, 1536, "#3d90ce", "outback"],
		["erode", 1537, 1552, "#5e92f3", "outback"],
		["arid", 1553, 1568, "#b2af9f", "outback"],
		["lime", 1569, 1584, "#75a7dc", "outback"],
		["arch", 1585, 1600, "#1778d2", "outback"],
		["white", 1601, 1616, "#6d8cab", "frost"],
		["valley", 1617, 1632, "#7e93a8", "frost"],
		["lake", 1633, 1648, "#225c75", "frost"],
		["icey", 1649, 1664, "#173ebd", "frost"],
		["shine", 1665, 1680, "#a17b63", "frost"],
		["mist", 1681, 1696, "#94b6bd", "timberland"],
		["bright", 1697, 1712, "#38423a", "timberland"],
		["dawn", 1713, 1728, "#444b23", "timberland"],
		["brood", 1729, 1744, "#85a7c8", "timberland"],
		["view", 1745, 1760, "#3b7fa6", "timberland"],
		["climb", 1761, 1776, "#1d443b", "hills"],
		["above", 1777, 1792, "#cdce83", "hills"],
		["fall", 1793, 1808, "#364821", "hills"],
		["below", 1809, 1824, "#344f3d", "hills"],
		["arrive", 1825, 1840, "#a5b69b", "hills"],
		["ray", 1841, 1856, "#8a8f89", "mist"],
		["azure", 1857, 1872, "#585e31", "mist"],
		["toad", 1873, 1888, "#898391", "mist"],
		["brook", 1889, 1904, "#5e4144", "mist"],
		["leaf", 1905, 1920, "#516152", "mist"],
		["calm", 1921, 1936, "#7e6064", "formation"],
		["set", 1937, 1952, "#6b4a3e", "formation"],
		["serene", 1953, 1968, "#664755", "formation"],
		["air", 1969, 1984, "#885c2d", "formation"],
		["grace", 1985, 2000, "#0561d1", "formation"],
		["fresh", 2001, 2016, "#42a198", "coast"],
		["shell", 2017, 2032, "#3d7ac9", "coast"],
		["wash", 2033, 2048, "#bd9794", "coast"],
		["aqua", 2049, 2064, "#295771", "coast"],
		["pebble", 2065, 2080, "#cac086", "coast"],
		["mist", 2081, 2096, "#714936", "twilight"],
		["bright", 2097, 2112, "#52373c", "twilight"],
		["dawn", 2113, 2128, "#ae8b14", "twilight"],
		["brood", 2129, 2144, "#71851e", "twilight"],
		["view", 2145, 2160, "#060a1f", "twilight"],
		["fall", 2161, 2176, "#3989b3", "marsh"],
		["bark", 2177, 2192, "#a17e5e", "marsh"],
		["red", 2193, 2208, "#675d45", "marsh"],
		["vivid", 2209, 2224, "#638cac", "marsh"],
		["cover", 2225, 2240, "#134f7b", "marsh"],
		["fir", 2241, 2256, "#15573d", "woods"],
		["leaf", 2257, 2272, "#779c35", "woods"],
		["fall", 2273, 2288, "#7a5d2b", "woods"],
		["mossy", 2289, 2304, "#7ab4d6", "woods"],
		["bright", 2305, 2320, "#b2ba44", "woods"],
		["rise", 2321, 2336, "#a587c9", "arid"],
		["sand", 2337, 2352, "#1e558c", "arid"],
		["dawn", 2353, 2368, "#c36910", "arid"],
		["drift", 2369, 2384, "#6c78e5", "arid"],
		["dry", 2385, 2400, "#0f46bf", "arid"],
		["ripple", 2401, 2416, "#c7a884", "tide"],
		["wave", 2417, 2432, "#138cc5", "tide"],
		["calm", 2433, 2448, "#548eb1", "tide"],
		["breeze", 2449, 2464, "#a0b79a", "tide"],
		["float", 2465, 2480, "#3a6daf", "tide"],
		["river", 2481, 2496, "#1b89d3", "passage"],
		["curve", 2497, 2512, "#904024", "passage"],
		["hole", 2513, 2528, "#20202c", "passage"],
		["mist", 2529, 2544, "#052d65", "passage"],
		["spire", 2545, 2560, "#36483b", "passage"],
		["valley", 2561, 2576, "#c37966", "air"],
		["sky", 2577, 2592, "#8a5425", "air"],
		["lake", 2593, 2608, "#d5c57b", "air"],
		["vast", 2609, 2624, "#ee9361", "air"],
		["shore", 2625, 2640, "#cf8382", "air"],
		["palm", 2641, 2656, "#44c7ca", "lagoon"],
		["beach", 2657, 2672, "#cdad81", "lagoon"],
		["clear", 2673, 2688, "#40addf", "lagoon"],
		["star", 2689, 2704, "#3270cd", "lagoon"],
		["dusk", 2705, 2720, "#5b447b", "lagoon"],
		["valley", 2721, 2736, "#d3bf7e", "peak"],
		["up", 2737, 2752, "#2a7b93", "peak"],
		["height", 2753, 2768, "#454c50", "peak"],
		["peace", 2769, 2784, "#789395", "peak"],
		["crest", 2785, 2800, "#9987ca", "peak"],
		["frost", 2801, 2816, "#99a9b7", "ice"],
		["freeze", 2817, 2832, "#73a0bd", "ice"],
		["light", 2833, 2848, "#184d4e", "ice"],
		["melt", 2849, 2864, "#2d6194", "ice"],
		["snow", 2865, 2880, "#90a0c1", "ice"],
		["mist", 2881, 2896, "#b9989b", "bloom"],
		["pond", 2897, 2912, "#36342a", "bloom"],
		["shine", 2913, 2928, "#a3904f", "bloom"],
		["grass", 2929, 2944, "#32283c", "bloom"],
		["frond", 2945, 2960, "#c3b98e", "bloom"],
		["fog", 2961, 2976, "#8c8237", "fall"],
		["birch", 2977, 2992, "#b7af99", "fall"],
		["ruby", 2993, 3008, "#6d1a10", "fall"],
		["oak", 3009, 3024, "#609fdc", "fall"],
		["grove", 3025, 3040, "#90510a", "fall"],
		["green", 3041, 3056, "#4c6111", "rain forest"],
		["grow", 3057, 3072, "#3d3a16", "rain forest"],
		["curl", 3073, 3088, "#1c600b", "rain forest"],
		["frond", 3089, 3104, "#3b4b18", "rain forest"],
		["lush", 3105, 3120, "#263206", "rain forest"],
		["field", 3121, 3136, "#8da40a", "rows"],
		["lines", 3137, 3152, "#4f80c0", "rows"],
		["far", 3153, 3168, "#367bcb", "rows"],
		["grain", 3169, 3184, "#e49f6d", "rows"],
		["seed", 3185, 3200, "#b5674f", "rows"],
		["chill", 3201, 3216, "#897ed3", "basin"],
		["slope", 3217, 3232, "#372f30", "basin"],
		["rock", 3233, 3248, "#97b9b5", "basin"],
		["cove", 3249, 3264, "#8da5c4", "basin"],
		["marsh", 3265, 3280, "#1b0d35", "basin"],
		["view", 3281, 3296, "#4186c8", "view"],
		["river", 3297, 3312, "#88b3c9", "view"],
		["cliff", 3313, 3328, "#43b2eb", "view"],
		["rapid", 3329, 3344, "#85b1cc", "view"],
		["pine", 3345, 3360, "#66a9eb", "view"],
		["below", 3361, 3376, "#b1a5a0", "precipice"],
		["coast", 3377, 3392, "#355732", "precipice"],
		["sea", 3393, 3408, "#6a68c7", "precipice"],
		["lavish", 3409, 3424, "#856d1c", "precipice"],
		["bluff", 3425, 3440, "#3f6e9a", "precipice"],
		["light", 3441, 3456, "#0e0f1d", "starlight"],
		["gaze", 3457, 3472, "#040c18", "starlight"],
		["sky", 3473, 3488, "#081328", "starlight"],
		["watch", 3489, 3504, "#0a2a41", "starlight"],
		["shine", 3505, 3520, "#2f387b", "starlight"],
		["glass", 3521, 3536, "#6e9ecf", "reflect"],
		["still", 3537, 3552, "#c77fd2", "reflect"],
		["crest", 3553, 3568, "#8cabc5", "reflect"],
		["ripple", 3569, 3584, "#a7a3a0", "reflect"],
		["arise", 3585, 3600, "#0e3650", "reflect"],
		["pyre", 3601, 3616, "#451624", "majesty"],
		["opal", 3617, 3632, "#cb86bc", "majesty"],
		["zeal", 3633, 3648, "#70b0e1", "majesty"],
		["fit", 3649, 3664, "#3b6fa7", "majesty"],
		["space", 3665, 3680, "#2b2c41", "majesty"],
		["bright", 3681, 3696, "#1f305b", "astral"],
		["emit", 3697, 3712, "#1c3528", "astral"],
		["sol", 3713, 3728, "#0b545c", "astral"],
		["arise", 3729, 3744, "#385e76", "astral"],
		["gift", 3745, 3760, "#b371e0", "astral"],
		["bask", 3761, 3776, "#939aa5", "stone"],
		["wall", 3777, 3792, "#aea3a8", "stone"],
		["chisel", 3793, 3808, "#593d35", "stone"],
		["tower", 3809, 3824, "#83a9ce", "stone"],
		["wisp", 3825, 3840, "#8fa2c1", "stone"],
		["fern", 3841, 3856, "#226715", "green"],
		["leaf", 3857, 3872, "#a3cc85", "green"],
		["aerial", 3873, 3888, "#6891c4", "green"],
		["bank", 3889, 3904, "#516246", "green"],
		["roll", 3905, 3920, "#7c9923", "green"],
		["heat", 3921, 3936, "#59a9f8", "west"],
		["erode", 3937, 3952, "#93a8be", "west"],
		["bare", 3953, 3968, "#d2975a", "west"],
		["set", 3969, 3984, "#d1a67f", "west"],
		["fuchsia", 3985, 4000, "#bc83b1", "west"],
		["breeze", 4001, 4016, "#34447a", "wind"],
		["gust", 4017, 4032, "#548eb1", "wind"],
		["air", 4033, 4048, "#0a408a", "wind"],
		["gale", 4049, 4064, "#77777b", "wind"],
		["whisk", 4065, 4080, "#6a68c7", "wind"],
		["sand", 4081, 4096, "#3270cd", "shore"],
		["brim", 4097, 4112, "#43b2eb", "shore"],
		["bank", 4113, 4128, "#587a75", "shore"],
		["tide", 4129, 4144, "#a0b79a", "shore"],
		["sea", 4145, 4160, "#7e707b", "shore"],
		["gully", 4161, 4176, "#c0b790", "ravine"],
		["chasm", 4177, 4192, "#b1a5a0", "ravine"],
		["flume", 4193, 4208, "#1b89d3", "ravine"],
		["pass", 4209, 4224, "#3f5a61", "ravine"],
		["depth", 4225, 4240, "#94a0bc", "ravine"],
		["grass", 4241, 4256, "#8da40a", "botanical"],
		["vine", 4257, 4272, "#263206", "botanical"],
		["shrub", 4273, 4288, "#b2ba44", "botanical"],
		["flower", 4289, 4304, "#32283c", "botanical"],
		["tree", 4305, 4320, "#b0a7a1", "botanical"],
		["glacial", 4321, 4336, "#2d6194", "arctic"],
		["frigid", 4337, 4352, "#9196a0", "arctic"],
		["polar", 4353, 4368, "#819864", "arctic"],
		["glaze", 4369, 4384, "#99a9b7", "arctic"],
		["ice", 4385, 4400, "#73a0bd", "arctic"],
		["celest", 4401, 4416, "#3b2446", "galaxy"],
		["sky", 4417, 4432, "#385e76", "galaxy"],
		["sol", 4433, 4448, "#d58265", "galaxy"],
		["depth", 4449, 4464, "#1c3528", "galaxy"],
		["moon", 4465, 4480, "#081328", "galaxy"],
		["crag", 4481, 4496, "#593d35", "tower"],
		["geode", 4497, 4512, "#59a9f8", "tower"],
		["grand", 4513, 4528, "#8cabc5", "tower"],
		["crest", 4529, 4544, "#bc83b1", "tower"],
		["top", 4545, 4560, "#1d443b", "tower"],
		["still", 4561, 4576, "#bd9794", "placid"],
		["calm", 4577, 4592, "#97b9b5", "placid"],
		["quell", 4593, 4608, "#897ed3", "placid"],
		["flat", 4609, 4624, "#8a8f89", "placid"],
		["bare", 4625, 4640, "#789395", "placid"],
		["bud", 4641, 4656, "#15573d", "thrive"],
		["seed", 4657, 4672, "#1c600b", "thrive"],
		["jade", 4673, 4688, "#c5d51f", "thrive"],
		["fern", 4689, 4704, "#444b23", "thrive"],
		["verde", 4705, 4720, "#566f3c", "thrive"],
		["crag", 4721, 4736, "#59a9f8", "parched"],
		["swept", 4737, 4752, "#93a8be", "parched"],
		["plain", 4753, 4768, "#d2975a", "parched"],
		["dust", 4769, 4784, "#d1a67f", "parched"],
		["warm", 4785, 4800, "#bc83b1", "parched"],
		["icicle", 4801, 4816, "#184d4e", "frigid"],
		["sleet", 4817, 4832, "#7e93a8", "frigid"],
		["chill", 4833, 4848, "#90a0c1", "frigid"],
		["shiver", 4849, 4864, "#a17b63", "frigid"],
		["cube", 4865, 4880, "#225c75", "frigid"],
		["bulb", 4881, 4896, "#a3904f", "flourish"],
		["float", 4897, 4912, "#36342a", "flourish"],
		["bud", 4913, 4928, "#c3b98e", "flourish"],
		["pollen", 4929, 4944, "#4f80c0", "flourish"],
		["bloom", 4945, 4960, "#b9989b", "flourish"],
		["star", 4961, 4976, "#0e0f1d", "aurora"],
		["way", 4977, 4992, "#1c3528", "aurora"],
		["bask", 4993, 5008, "#0b545c", "aurora"],
		["vast", 5009, 5024, "#819864", "aurora"],
		["space", 5025, 5040, "#2f387b", "aurora"],
		["fault", 5041, 5056, "#d3bf7e", "crest"],
		["peak", 5057, 5072, "#2a7b93", "crest"],
		["crag", 5073, 5088, "#454c50", "crest"],
		["high", 5089, 5104, "#8cabc5", "crest"],
		["climb", 5105, 5120, "#9987ca", "crest"],
		["wood", 5121, 5136, "#6d1a10", "foliage"],
		["mist", 5137, 5152, "#7ab4d6", "foliage"],
		["path", 5153, 5168, "#714936", "foliage"],
		["lush", 5169, 5184, "#b2ba44", "foliage"],
		["grove", 5185, 5200, "#90510a", "foliage"],
		["marsh", 5201, 5216, "#4c6111", "wildwood"],
		["erode", 5217, 5232, "#3d3a16", "wildwood"],
		["solice", 5233, 5248, "#1c600b", "wildwood"],
		["adrift", 5249, 5264, "#3b4b18", "wildwood"],
		["inlet", 5265, 5280, "#263206", "wildwood"],
		["tower", 5281, 5296, "#a587c9", "bare"],
		["stone", 5297, 5312, "#1e558c", "bare"],
		["desert", 5313, 5328, "#c36910", "bare"],
		["knoll", 5329, 5344, "#6c78e5", "bare"],
		["brink", 5345, 5360, "#0f46bf", "bare"],
		["under", 5361, 5376, "#c7a884", "high seas"],
		["crest", 5377, 5392, "#138cc5", "high seas"],
		["squall", 5393, 5408, "#548eb1", "high seas"],
		["azure", 5409, 5424, "#a0b79a", "high seas"],
		["brisk", 5425, 5440, "#3a6daf", "high seas"],
		["soar", 5441, 5456, "#8da40a", "meadow"],
		["lane", 5457, 5472, "#4f80c0", "meadow"],
		["fall", 5473, 5488, "#367bcb", "meadow"],
		["gale", 5489, 5504, "#e49f6d", "meadow"],
		["gold", 5505, 5520, "#b5674f", "meadow"],
		["still", 5521, 5536, "#897ed3", "tarn"],
		["rock", 5537, 5552, "#372f30", "tarn"],
		["placid", 5553, 5568, "#97b9b5", "tarn"],
		["still 2", 5569, 5584, "#8da5c4", "tarn"],
		["peace", 5585, 5600, "#1b0d35", "tarn"],
		["rise", 5601, 5616, "#4186c8", "summit"],
		["aloft", 5617, 5632, "#88b3c9", "summit"],
		["free", 5633, 5648, "#43b2eb", "summit"],
		["flow", 5649, 5664, "#85b1cc", "summit"],
		["reach", 5665, 5680, "#66a9eb", "summit"],
		["haze", 5681, 5696, "#b1a5a0", "bluff"],
		["join", 5697, 5712, "#355732", "bluff"],
		["blush", 5713, 5728, "#6a68c7", "bluff"],
		["flock", 5729, 5744, "#856d1c", "bluff"],
		["vista", 5745, 5760, "#3f6e9a", "bluff"],
		["gleam", 5761, 5776, "#7bb0d5", "strand"],
		["chase", 5777, 5792, "#d0a973", "strand"],
		["bank", 5793, 5808, "#756e8d", "strand"],
		["tide", 5809, 5824, "#82b6cf", "strand"],
		["soak", 5825, 5840, "#7e707b", "strand"],
		["grove", 5841, 5856, "#b0a7a1", "cloud"],
		["vale", 5857, 5872, "#cea37e", "cloud"],
		["pond", 5873, 5888, "#84857f", "cloud"],
		["field", 5889, 5904, "#34447a", "cloud"],
		["steam", 5905, 5920, "#587a75", "cloud"],
		["mood", 5921, 5936, "#3b2446", "sublime"],
		["moon", 5937, 5952, "#051227", "sublime"],
		["stars", 5953, 5968, "#0a408a", "sublime"],
		["arctic", 5969, 5984, "#819864", "sublime"],
		["sails", 5985, 6000, "#d58265", "sublime"],
		["river", 6001, 6016, "#587a75", "master"],
		["arid", 6017, 6032, "#c5c3b7", "master"],
		["view", 6033, 6048, "#3b7fa6", "master"],
		["serene", 6049, 6064, "#664755", "master"],
		["view 2", 6065, 6080, "#060a1f", "master"],
		["sand", 6081, 6096, "#1e558c", "master"],
		["spire", 6097, 6112, "#36483b", "master"],
		["up", 6113, 6128, "#2a7b93", "master"],
		["frond", 6129, 6144, "#cfc7a5", "master"],
		["lines", 6145, 6160, "#4f80c0", "master"],
		["pine", 6161, 6176, "#b2d4f5", "master"],
		["still", 6177, 6192, "#c77fd2", "master"],
		["arise", 6193, 6208, "#385e76", "master"],
		["rock", 6209, 6224, "#1e558c", "master"],
		["wind", 6225, 6240, "#f8e6d9", "master"],
		["bright", 6241, 6256, "#355732", "master"],
		["range", 6257, 6272, "#34447a", "master"],
		["flat", 6273, 6288, "#3d90ce", "master"],
		["brood", 6289, 6304, "#85a7c8", "master"],
		["calm", 6305, 6320, "#7e6064", "master"],
		["brood 2", 6321, 6336, "#71851e", "master"],
		["rise", 6337, 6352, "#bca6d7", "master"],
		["hole", 6353, 6368, "#20202c", "master"],
		["valley", 6369, 6384, "#d5c284", "master"],
		["shine", 6385, 6400, "#a3904f", "master"],
		["field", 6401, 6416, "#8da40a", "master"],
		["cliff", 6417, 6432, "#43b2eb", "master"],
		["shine 2", 6433, 6448, "#2f387b", "master"],
		["sol", 6449, 6464, "#0b545c", "master"],
		["green", 6465, 6480, "#263206", "master"],
		["soar", 6481, 6496, "#367bcb", "master"],
		["arrive", 6497, 6512, "#b2d4f5", "master"],
		["valley 2", 6513, 6528, "#cea37e", "master"],
		["leaf", 6529, 6544, "#daee95", "master"],
		["bright 2", 6545, 6560, "#38423a", "master"],
		["leaf 2", 6561, 6576, "#516152", "master"],
		["bright 3", 6577, 6592, "#52373c", "master"],
		["mossy", 6593, 6608, "#96c4df", "master"],
		["curve", 6609, 6624, "#904024", "master"],
		["star", 6625, 6640, "#3270cd", "master"],
		["pond", 6641, 6656, "#36342a", "master"],
		["frond 2", 6657, 6672, "#3b4b18", "master"],
		["view 3", 6673, 6688, "#4186c8", "master"],
		["watch", 6689, 6704, "#0a2a41", "master"],
		["bright 4", 6705, 6720, "#1f305b", "master"],
		["lush", 6721, 6736, "#3b4b18", "master"],
		["sail", 6737, 6752, "#8da40a", "master"],
		["fall", 6753, 6768, "#43b2eb", "master"],
		["wood", 6769, 6784, "#b2aaa4", "master"],
		["toad", 6785, 6800, "#264056", "master"],
		["mist", 6801, 6816, "#a4c1c7", "master"],
		["toad 2", 6817, 6832, "#898391", "master"],
		["pebble", 6833, 6848, "#E6E4B7", "master"],
		["fall 2", 6849, 6864, "#7a5d2b", "master"],
		["float", 6865, 6880, "#3a6daf", "master"],
		["clear", 6881, 6896, "#40addf", "master"],
		["snow", 6897, 6912, "#bbc5d9", "master"],
		["grow", 6913, 6928, "#3d3a16", "master"],
		["marsh", 6929, 6944, "#1b0d35", "master"],
		["gaze", 6945, 6960, "#040c18", "master"],
		["space", 6961, 6976, "#2b2c41", "master"],
		["thick", 6977, 6992, "#3d3a16", "master"],
		["blue", 6993, 7008, "#dee6dc", "master"],
		["above", 7009, 7024, "#c8dce6", "master"],
		["aqua", 7025, 7040, "#b9d6e4", "master"],
		["azure", 7041, 7056, "#0f98b9", "master"],
		["icey", 7057, 7072, "#173ebd", "master"],
		["ray", 7073, 7088, "#8a8f89", "master"],
		["aqua 2", 7089, 7104, "#295771", "master"],
		["fir", 7105, 7120, "#15573d", "master"],
		["breeze", 7121, 7136, "#dee6dc", "master"],
		["palm", 7137, 7152, "#44c7ca", "master"],
		["light", 7153, 7168, "#184d4e", "master"],
		["green 2", 7169, 7184, "#4c6111", "master"],
		["rock 2", 7185, 7200, "#b2cbc8", "master"],
		["light 2", 7201, 7216, "#0e0f1d", "master"],
		["zeal", 7217, 7232, "#89bee6", "master"],
		["cover", 7233, 7248, "#90510a", "master"],
		["storm", 7249, 7264, "#548eb1", "master"],
		["grace", 7265, 7280, "#1b0d35", "master"],
		["wash", 7281, 7296, "#756e8d", "master"],
		["solis", 7297, 7312, "#d58265", "master"],
		["valley 3", 7313, 7328, "#7e93a8", "master"],
		["arrive 2", 7329, 7344, "#d3dbce", "master"],
		["shell", 7345, 7360, "#3d7ac9", "master"],
		["cover 2", 7361, 7376, "#134f7b", "master"],
		["wave", 7377, 7392, "#138cc5", "master"],
		["vast", 7393, 7408, "#ee9361", "master"],
		["freeze", 7409, 7424, "#73a0bd", "master"],
		["oak", 7425, 7440, "#609fdc", "master"],
		["slope", 7441, 7456, "#372f30", "master"],
		["lavish", 7457, 7472, "#856d1c", "master"],
		["pyre", 7473, 7488, "#451624", "master"],
		["vivid", 7489, 7504, "#609fdc", "master"],
		["vast 2", 7505, 7520, "#c7a884", "master"],
		["air", 7521, 7536, "#c3d0e0", "master"],
		["fresh", 7537, 7552, "#c6dded", "master"],
		["strato", 7553, 7568, "#0a408a", "master"],
		["white", 7569, 7584, "#6d8cab", "master"],
		["fall 3", 7585, 7600, "#364821", "master"],
		["fresh 2", 7601, 7616, "#42a198", "master"],
		["red", 7617, 7632, "#675d45", "master"],
		["dry", 7633, 7648, "#0f46bf", "master"],
		["lake", 7649, 7664, "#d9ca87", "master"],
		["crest", 7665, 7680, "#b8abda", "master"],
		["ruby", 7681, 7696, "#6d1a10", "master"],
		["seed", 7697, 7712, "#b5674f", "master"],
		["coast", 7713, 7728, "#355732", "master"],
		["arise 2", 7729, 7744, "#0e3650", "master"],
		["wall", 7745, 7760, "#b5abb0", "master"],
		["sand 2", 7761, 7776, "#0f46bf", "master"],
		["set", 7777, 7792, "#372f30", "master"],
		["brood 3", 7793, 7808, "#856d1c", "master"],
		["luna", 7809, 7824, "#051227", "master"],
		["lime", 7825, 7840, "#75a7dc", "master"],
		["above 2", 7841, 7856, "#cfd088", "master"],
		["air 2", 7857, 7872, "#885c2d", "master"],
		["fall 4", 7873, 7888, "#3989b3", "master"],
		["drift", 7889, 7904, "#9fa7ee", "master"],
		["valley 4", 7905, 7920, "#c37966", "master"],
		["peace", 7921, 7936, "#789395", "master"],
		["fog", 7937, 7952, "#8c8237", "master"],
		["far", 7953, 7968, "#367bcb", "master"],
		["below", 7969, 7984, "#c1b8b4", "master"],
		["crest 2", 7985, 8000, "#b2c7d8", "master"],
		["bask", 8001, 8016, "#939aa5", "master"],
		["sierra", 8017, 8032, "#c36910", "master"],
		["calm 2", 8033, 8048, "#aaa2df", "master"],
		["dawn", 8049, 8064, "#6a68c7", "master"],
		["river 2", 8065, 8080, "#587a75", "master"],
		["arid 2", 8081, 8096, "#c5c3b7", "master"],
		["view 4", 8097, 8112, "#3b7fa6", "master"],
		["serene 2", 8113, 8128, "#664755", "master"],
		["view 5", 8129, 8144, "#060a1f", "master"],
		["sand 3", 8145, 8160, "#1e558c", "master"],
		["spire 2", 8161, 8176, "#36483b", "master"],
		["up 2", 8177, 8192, "#2a7b93", "master"],
		["frond 3", 8193, 8208, "#cfc7a5", "master"],
		["lines 2", 8209, 8224, "#4f80c0", "master"],
		["rapid", 8225, 8240, "#bad3e2", "master"],
		["still 2", 8241, 8256, "#c77fd2", "master"],
		["arise 3", 8257, 8272, "#385e76", "master"],
		["rock 3", 8273, 8288, "#1e558c", "master"],
		["wind 2", 8289, 8304, "#f8e6d9", "master"],
		["mist 2", 8305, 8320, "#c1b8b4", "master"],
		["range 2", 8321, 8336, "#34447a", "master"],
		["flat 2", 8337, 8352, "#3d90ce", "master"],
		["brood 4", 8353, 8368, "#85a7c8", "master"],
		["calm 3", 8369, 8384, "#7e6064", "master"],
		["dawn 2", 8385, 8400, "#ae8b14", "master"],
		["rise 2", 8401, 8416, "#bca6d7", "master"],
		["hole 2", 8417, 8432, "#20202c", "master"],
		["valley 5", 8433, 8448, "#d5c284", "master"],
		["shine 3", 8449, 8464, "#a3904f", "master"],
		["lush 2", 8465, 8480, "#263206", "master"],
		["cliff 2", 8481, 8496, "#43b2eb", "master"],
		["shine 4", 8497, 8512, "#2f387b", "master"],
		["sol 2", 8513, 8528, "#0b545c", "master"],
		["green 3", 8529, 8544, "#263206", "master"],
		["haze", 8545, 8560, "#4f80c0", "master"],
		["arrive 3", 8561, 8576, "#b2d4f5", "master"],
		["valley 6", 8577, 8592, "#cea37e", "master"],
		["leaf 3", 8593, 8608, "#daee95", "master"],
		["bright 5", 8609, 8624, "#38423a", "master"],
		["brook", 8625, 8640, "#5e4144", "master"],
		["bright 6", 8641, 8656, "#52373c", "master"],
		["mossy 2", 8657, 8672, "#96c4df", "master"],
		["curve 2", 8673, 8688, "#904024", "master"],
		["star 2", 8689, 8704, "#3270cd", "master"],
		["mist 3", 8705, 8720, "#d6c3c5", "master"],
		["frond 4", 8721, 8736, "#3b4b18", "master"],
		["view 6", 8737, 8752, "#4186c8", "master"],
		["watch 2", 8753, 8768, "#0a2a41", "master"],
		["bright 7", 8769, 8784, "#1f305b", "master"],
		["wild", 8785, 8800, "#1c600b", "master"],
		["sail 2", 8801, 8816, "#8da40a", "master"],
		["fall 5", 8817, 8832, "#43b2eb", "master"],
		["wood 2", 8833, 8848, "#b2aaa4", "master"],
		["toad 3", 8849, 8864, "#264056", "master"],
		["shine 5", 8865, 8880, "#a17b63", "master"],
		["toad 4", 8881, 8896, "#898391", "master"],
		["pebble 2", 8897, 8912, "#E6E4B7", "master"],
		["fall 6", 8913, 8928, "#7a5d2b", "master"],
		["float 2", 8929, 8944, "#3a6daf", "master"],
		["beach", 8945, 8960, "#cdad81", "master"],
		["snow 2", 8961, 8976, "#bbc5d9", "master"],
		["grow 2", 8977, 8992, "#3d3a16", "master"],
		["marsh 2", 8993, 9008, "#1b0d35", "master"],
		["gaze 2", 9009, 9024, "#040c18", "master"],
		["fit", 9025, 9040, "#3b6fa7", "master"],
		["thick 2", 9041, 9056, "#3d3a16", "master"],
		["blue 2", 9057, 9072, "#dee6dc", "master"],
		["above 3", 9073, 9088, "#c8dce6", "master"],
		["aqua 3", 9089, 9104, "#b9d6e4", "master"],
		["ray 2", 9105, 9120, "#b1934b", "master"],
		["icey 2", 9121, 9136, "#173ebd", "master"],
		["ray 3", 9137, 9152, "#8a8f89", "master"],
		["aqua 4", 9153, 9168, "#295771", "master"],
		["fir 2", 9169, 9184, "#15573d", "master"],
		["calm 4", 9185, 9200, "#548eb1", "master"],
		["palm 2", 9201, 9216, "#44c7ca", "master"],
		["light 3", 9217, 9232, "#184d4e", "master"],
		["green 4", 9233, 9248, "#4c6111", "master"],
		["rock 4", 9249, 9264, "#b2cbc8", "master"],
		["bluff", 9265, 9280, "#3f6e9a", "master"],
		["zeal 2", 9281, 9296, "#89bee6", "master"],
		["cover 3", 9297, 9312, "#90510a", "master"],
		["storm 2", 9313, 9328, "#548eb1", "master"],
		["grace 2", 9329, 9344, "#1b0d35", "master"],
		["shell 2", 9345, 9360, "#d0a973", "master"],
		["solis 2", 9361, 9376, "#d58265", "master"],
		["valley 7", 9377, 9392, "#7e93a8", "master"],
		["arrive 4", 9393, 9408, "#d3dbce", "master"],
		["shell 3", 9409, 9424, "#3d7ac9", "master"],
		["vivid 2", 9425, 9440, "#638cac", "master"],
		["wave 2", 9441, 9456, "#138cc5", "master"],
		["vast 3", 9457, 9472, "#ee9361", "master"],
		["freeze 2", 9473, 9488, "#73a0bd", "master"],
		["oak 2", 9489, 9504, "#609fdc", "master"],
		["chill", 9505, 9520, "#aaa2df", "master"],
		["lavish 2", 9521, 9536, "#856d1c", "master"],
		["pyre 2", 9537, 9552, "#451624", "master"],
		["vivid 3", 9553, 9568, "#609fdc", "master"],
		["vast 4", 9569, 9584, "#c7a884", "master"],
		["serene 3", 9585, 9600, "#b2cbc8", "master"],
		["fresh 3", 9601, 9616, "#c6dded", "master"],
		["strato 2", 9617, 9632, "#0a408a", "master"],
		["white 2", 9633, 9648, "#6d8cab", "master"],
		["fall 7", 9649, 9664, "#364821", "master"],
		["grace 3", 9665, 9680, "#0561d1", "master"],
		["red 2", 9681, 9696, "#675d45", "master"],
		["dry 2", 9697, 9712, "#0f46bf", "master"],
		["lake 2", 9713, 9728, "#d9ca87", "master"],
		["crest 3", 9729, 9744, "#b8abda", "master"],
		["birch", 9745, 9760, "#ccc6b7", "master"],
		["seed 2", 9761, 9776, "#b5674f", "master"],
		["coast 2", 9777, 9792, "#355732", "master"],
		["arise 4", 9793, 9808, "#0e3650", "master"],
		["wall 2", 9809, 9824, "#b5abb0", "master"],
		["dune", 9825, 9840, "#9fa7ee", "master"],
		["set 2", 9841, 9856, "#372f30", "master"],
		["brood 5", 9857, 9872, "#856d1c", "master"],
		["luna 2", 9873, 9888, "#051227", "master"],
		["lime 2", 9889, 9904, "#75a7dc", "master"],
		["climb", 9905, 9920, "#1d443b", "master"],
		["air 3", 9921, 9936, "#885c2d", "master"],
		["fall 8", 9937, 9952, "#3989b3", "master"],
		["drift 2", 9953, 9968, "#9fa7ee", "master"],
		["valley 8", 9969, 9984, "#c37966", "master"],
		["peace 2", 9985, 10000, "#789395", "master"],
		["fog 2", 10001, 10016, "#8c8237", "master"],
		["far 2", 10017, 10032, "#367bcb", "master"],
		["below 2", 10033, 10048, "#c1b8b4", "master"],
		["crest 4", 10049, 10064, "#b2c7d8", "master"],
		["bask 2", 10065, 10080, "#939aa5", "master"],
		["sierra 2", 10081, 10096, "#c36910", "master"],
		["amber", 10097, 10112, "#b5674f", "master"],
		["dawn 3", 10113, 10128, "#6a68c7", "master"],
		["river 3", 10129, 10144, "#587a75", "master"],
		["arid 3", 10145, 10160, "#c5c3b7", "master"],
		["view 7", 10161, 10176, "#3b7fa6", "master"],
		["set 3", 10177, 10192, "#6b4a3e", "master"],
		["view 8", 10193, 10208, "#060a1f", "master"],
		["sand 4", 10209, 10224, "#1e558c", "master"],
		["spire 3", 10225, 10240, "#36483b", "master"],
		["up 3", 10241, 10256, "#2a7b93", "master"],
		["grass", 10257, 10272, "#32283c", "master"],
		["lines 3", 10273, 10288, "#4f80c0", "master"],
		["rapid 2", 10289, 10304, "#bad3e2", "master"],
		["still 3", 10305, 10320, "#c77fd2", "master"],
		["arise 5", 10321, 10336, "#385e76", "master"],
		["spire 4", 10337, 10352, "#bca6d7", "master"],
		["wind 3", 10353, 10368, "#f8e6d9", "master"],
		["mist 4", 10369, 10384, "#c1b8b4", "master"],
		["range 3", 10385, 10400, "#34447a", "master"],
		["flat 3", 10401, 10416, "#3d90ce", "master"],
		["dawn 4", 10417, 10432, "#444b23", "master"],
		["calm 5", 10433, 10448, "#7e6064", "master"],
		["dawn 5", 10449, 10464, "#ae8b14", "master"],
		["rise 3", 10465, 10480, "#bca6d7", "master"],
		["hole 3", 10481, 10496, "#20202c", "master"],
		["dusk", 10497, 10512, "#5b447b", "master"],
		["shine 6", 10513, 10528, "#a3904f", "master"],
		["lush 3", 10529, 10544, "#263206", "master"],
		["cliff 3", 10545, 10560, "#43b2eb", "master"],
		["shine 7", 10561, 10576, "#2f387b", "master"],
		["emit", 10577, 10592, "#1c3528", "master"],
		["green 5", 10593, 10608, "#263206", "master"],
		["haze 2", 10609, 10624, "#4f80c0", "master"],
		["arrive 5", 10625, 10640, "#b2d4f5", "master"],
		["valley 9", 10641, 10656, "#cea37e", "master"],
		["brook 2", 10657, 10672, "#566f3c", "master"],
		["bright 8", 10673, 10688, "#38423a", "master"],
		["brook 3", 10689, 10704, "#5e4144", "master"],
		["bright 9", 10705, 10720, "#52373c", "master"],
		["mossy 3", 10721, 10736, "#96c4df", "master"],
		["river 4", 10737, 10752, "#1b89d3", "master"],
		["star 3", 10753, 10768, "#3270cd", "master"],
		["mist 5", 10769, 10784, "#d6c3c5", "master"],
		["frond 5", 10785, 10800, "#3b4b18", "master"],
		["view 9", 10801, 10816, "#4186c8", "master"],
		["sky", 10817, 10832, "#081328", "master"],
		["bright 10", 10833, 10848, "#1f305b", "master"],
		["wild 2", 10849, 10864, "#1c600b", "master"],
		["sail 3", 10865, 10880, "#8da40a", "master"],
		["fall 9", 10881, 10896, "#43b2eb", "master"],
		["pebble 3", 10897, 10912, "#7e707b", "master"],
		["toad 5", 10913, 10928, "#264056", "master"],
		["shine 8", 10929, 10944, "#a17b63", "master"],
		["toad 6", 10945, 10960, "#898391", "master"],
		["pebble 4", 10961, 10976, "#E6E4B7", "master"],
		["leaf 4", 10977, 10992, "#779c35", "master"],
		["float 3", 10993, 11008, "#3a6daf", "master"],
		["beach 2", 11009, 11024, "#cdad81", "master"],
		["snow 3", 11025, 11040, "#bbc5d9", "master"],
		["grow 3", 11041, 11056, "#3d3a16", "master"],
		["cove", 11057, 11072, "#c3d0e0", "master"],
		["gaze 3", 11073, 11088, "#040c18", "master"],
		["fit 2", 11089, 11104, "#3b6fa7", "master"],
		["thick 3", 11105, 11120, "#3d3a16", "master"],
		["blue 3", 11121, 11136, "#dee6dc", "master"],
		["climb 2", 11137, 11152, "#4186c8", "master"],
		["aqua 5", 11153, 11168, "#b9d6e4", "master"],
		["ray 4", 11169, 11184, "#b1934b", "master"],
		["icey 3", 11185, 11200, "#173ebd", "master"],
		["ray 5", 11201, 11216, "#8a8f89", "master"],
		["wash 2", 11217, 11232, "#bd9794", "master"],
		["fir 3", 11233, 11248, "#15573d", "master"],
		["calm 6", 11249, 11264, "#548eb1", "master"],
		["palm 3", 11265, 11280, "#44c7ca", "master"],
		["light 4", 11281, 11296, "#184d4e", "master"],
		["grove", 11297, 11312, "#90510a", "master"],
		["rock 5", 11313, 11328, "#b2cbc8", "master"],
		["bluff 2", 11329, 11344, "#3f6e9a", "master"],
		["zeal 3", 11345, 11360, "#89bee6", "master"],
		["cover 4", 11361, 11376, "#90510a", "master"],
		["wave 3", 11377, 11392, "#138cc5", "master"],
		["grace 4", 11393, 11408, "#1b0d35", "master"],
		["shell 4", 11409, 11424, "#d0a973", "master"],
		["solis 3", 11425, 11440, "#d58265", "master"],
		["valley 10", 11441, 11456, "#7e93a8", "master"],
		["below 3", 11457, 11472, "#344f3d", "master"],
		["shell 5", 11473, 11488, "#3d7ac9", "master"],
		["vivid 4", 11489, 11504, "#638cac", "master"],
		["wave 4", 11505, 11520, "#138cc5", "master"],
		["vast 5", 11521, 11536, "#ee9361", "master"],
		["frost", 11537, 11552, "#bec8d1", "master"],
		["oak 3", 11553, 11568, "#609fdc", "master"],
		["chill 2", 11569, 11584, "#aaa2df", "master"],
		["lavish 3", 11585, 11600, "#856d1c", "master"],
		["pyre 3", 11601, 11616, "#451624", "master"],
		["red 3", 11617, 11632, "#6d1a10", "master"],
		["vast 6", 11633, 11648, "#c7a884", "master"],
		["serene 4", 11649, 11664, "#b2cbc8", "master"],
		["fresh 4", 11665, 11680, "#c6dded", "master"],
		["strato 3", 11681, 11696, "#0a408a", "master"],
		["arch", 11697, 11712, "#1778d2", "master"],
		["fall 10", 11713, 11728, "#364821", "master"],
		["grace 5", 11729, 11744, "#0561d1", "master"],
		["red 4", 11745, 11760, "#675d45", "master"],
		["dry 3", 11761, 11776, "#0f46bf", "master"],
		["sky 2", 11777, 11792, "#8a5425", "master"],
		["crest 5", 11793, 11808, "#b8abda", "master"],
		["birch 2", 11809, 11824, "#ccc6b7", "master"],
		["seed 3", 11825, 11840, "#b5674f", "master"],
		["coast 3", 11841, 11856, "#355732", "master"],
		["arise 6", 11857, 11872, "#0e3650", "master"],
		["wall 3", 11873, 11888, "#b5abb0", "master"],
		["dune 2", 11889, 11904, "#9fa7ee", "master"],
		["set 4", 11905, 11920, "#372f30", "master"],
		["brood 6", 11921, 11936, "#856d1c", "master"],
		["luna 3", 11937, 11952, "#051227", "master"],
		["lime 3", 11953, 11968, "#75a7dc", "master"],
		["climb 3", 11969, 11984, "#1d443b", "master"],
		["air 4", 11985, 12000, "#885c2d", "master"],
		["fall 11", 12001, 12016, "#3989b3", "master"],
		["drift 3", 12017, 12032, "#9fa7ee", "master"],
		["valley 11", 12033, 12048, "#c37966", "master"],
		["height", 12049, 12064, "#454c50", "master"],
		["fog 3", 12065, 12080, "#8c8237", "master"],
		["far 3", 12081, 12096, "#367bcb", "master"],
		["below 4", 12097, 12112, "#c1b8b4", "master"],
		["crest 6", 12113, 12128, "#b2c7d8", "master"],
		["gift", 12129, 12144, "#c797e8", "master"],
		["sierra 3", 12145, 12160, "#c36910", "master"],
		["amber 2", 12161, 12176, "#b5674f", "master"],
		["dawn 6", 12177, 12192, "#6a68c7", "master"],
		["river 5", 12193, 12208, "#587a75", "master"],
		["erode", 12209, 12224, "#5e92f3", "master"],
		["view 10", 12225, 12240, "#3b7fa6", "master"],
		["set 5", 12241, 12256, "#6b4a3e", "master"],
		["view 11", 12257, 12272, "#060a1f", "master"],
		["sand 5", 12273, 12288, "#1e558c", "master"],
		["mist 6", 12289, 12304, "#052d65", "master"],
		["up 4", 12305, 12320, "#2a7b93", "master"],
		["grass 2", 12321, 12336, "#32283c", "master"],
		["lines 4", 12337, 12352, "#4f80c0", "master"],
		["rapid 3", 12353, 12368, "#bad3e2", "master"],
		["glass", 12369, 12384, "#6e9ecf", "master"],
		["arise 7", 12385, 12400, "#385e76", "master"],
		["spire 5", 12401, 12416, "#bca6d7", "master"],
		["wind 4", 12417, 12432, "#f8e6d9", "master"],
		["mist 7", 12433, 12448, "#c1b8b4", "master"],
		["lake 3", 12449, 12464, "#84857f", "master"],
		["flat 4", 12465, 12480, "#3d90ce", "master"],
		["dawn 7", 12481, 12496, "#444b23", "master"],
		["calm 7", 12497, 12512, "#7e6064", "master"],
		["dawn 8", 12513, 12528, "#ae8b14", "master"],
		["bright 11", 12529, 12544, "#b2ba44", "master"],
		["hole 4", 12545, 12560, "#20202c", "master"],
		["dusk 2", 12561, 12576, "#5b447b", "master"],
		["shine 9", 12577, 12592, "#a3904f", "master"],
		["lush 4", 12593, 12608, "#263206", "master"],
		["river 6", 12609, 12624, "#c8dce6", "master"],
		["shine 10", 12625, 12640, "#2f387b", "master"],
		["emit 2", 12641, 12656, "#1c3528", "master"],
		["green 6", 12657, 12672, "#263206", "master"],
		["haze 3", 12673, 12688, "#4f80c0", "master"],
		["below 5", 12689, 12704, "#bad3e2", "master"],
		["valley 12", 12705, 12720, "#cea37e", "master"],
		["brook 4", 12721, 12736, "#566f3c", "master"],
		["bright 12", 12737, 12752, "#38423a", "master"],
		["brook 5", 12753, 12768, "#5e4144", "master"],
		["mist 8", 12769, 12784, "#714936", "master"],
		["mossy 4", 12785, 12800, "#96c4df", "master"],
		["river 7", 12801, 12816, "#1b89d3", "master"],
		["star 4", 12817, 12832, "#3270cd", "master"],
		["mist 9", 12833, 12848, "#d6c3c5", "master"],
		["curl", 12849, 12864, "#1c600b", "master"],
		["view 12", 12865, 12880, "#4186c8", "master"],
		["sky 3", 12881, 12896, "#081328", "master"],
		["bright 13", 12897, 12912, "#1f305b", "master"],
		["wild 3", 12913, 12928, "#1c600b", "master"],
		["depth", 12929, 12944, "#3a6daf", "master"],
		["fall 12", 12945, 12960, "#43b2eb", "master"],
		["pebble 5", 12961, 12976, "#7e707b", "master"],
		["toad 7", 12977, 12992, "#264056", "master"],
		["shine 11", 12993, 13008, "#a17b63", "master"],
		["azure 2", 13009, 13024, "#585e31", "master"],
		["pebble 6", 13025, 13040, "#E6E4B7", "master"],
		["leaf 5", 13041, 13056, "#779c35", "master"],
		["float 4", 13057, 13072, "#3a6daf", "master"],
		["beach 3", 13073, 13088, "#cdad81", "master"],
		["melt", 13089, 13104, "#2d6194", "master"],
		["grow 4", 13105, 13120, "#3d3a16", "master"],
		["cove 2", 13121, 13136, "#c3d0e0", "master"],
		["gaze 4", 13137, 13152, "#040c18", "master"],
		["fit 3", 13153, 13168, "#3b6fa7", "master"],
		["vine", 13169, 13184, "#4c6111", "master"],
		["blue 4", 13185, 13200, "#dee6dc", "master"],
		["climb 4", 13201, 13216, "#4186c8", "master"],
		["aqua 6", 13217, 13232, "#b9d6e4", "master"],
		["ray 6", 13233, 13248, "#b1934b", "master"],
		["lake 4", 13249, 13264, "#225c75", "master"],
		["ray 7", 13265, 13280, "#8a8f89", "master"],
		["wash 3", 13281, 13296, "#bd9794", "master"],
		["fir 4", 13297, 13312, "#15573d", "master"],
		["calm 8", 13313, 13328, "#548eb1", "master"],
		["shore", 13329, 13344, "#e0afae", "master"],
		["light 5", 13345, 13360, "#184d4e", "master"],
		["grove 2", 13361, 13376, "#90510a", "master"],
		["rock 6", 13377, 13392, "#b2cbc8", "master"],
		["bluff 3", 13393, 13408, "#3f6e9a", "master"],
		["opal", 13409, 13424, "#d49bc8", "master"],
		["cover 5", 13425, 13440, "#90510a", "master"],
		["wave 5", 13441, 13456, "#138cc5", "master"],
		["grace 6", 13457, 13472, "#1b0d35", "master"],
		["shell 6", 13473, 13488, "#d0a973", "master"],
		["polar", 13489, 13504, "#819864", "master"],
		["valley 13", 13505, 13520, "#7e93a8", "master"],
		["below 6", 13521, 13536, "#344f3d", "master"],
		["shell 7", 13537, 13552, "#3d7ac9", "master"],
		["vivid 5", 13553, 13568, "#638cac", "master"],
		["ripple", 13569, 13584, "#c7a884", "master"],
		["vast 7", 13585, 13600, "#ee9361", "master"],
		["frost 2", 13601, 13616, "#bec8d1", "master"],
		["oak 4", 13617, 13632, "#609fdc", "master"],
		["chill 3", 13633, 13648, "#aaa2df", "master"],
		["sea", 13649, 13664, "#6a68c7", "master"],
		["pyre 4", 13665, 13680, "#451624", "master"],
		["red 5", 13681, 13696, "#6d1a10", "master"],
		["vast 8", 13697, 13712, "#c7a884", "master"],
		["serene 5", 13713, 13728, "#b2cbc8", "master"],
		["view 13", 13729, 13744, "#3f6e9a", "master"],
		["strato 4", 13745, 13760, "#0a408a", "master"],
		["arch 2", 13761, 13776, "#1778d2", "master"],
		["fall 13", 13777, 13792, "#364821", "master"],
		["grace 7", 13793, 13808, "#0561d1", "master"],
		["red 6", 13809, 13824, "#675d45", "master"],
		["dry 4", 13825, 13840, "#0f46bf", "master"],
		["sky 4", 13841, 13856, "#8a5425", "master"],
		["crest 7", 13857, 13872, "#b8abda", "master"],
		["birch 3", 13873, 13888, "#ccc6b7", "master"],
		["seed 4", 13889, 13904, "#b5674f", "master"],
		["coast 4", 13905, 13920, "#355732", "master"],
		["ripple 2", 13921, 13936, "#a7a3a0", "master"],
		["wall 4", 13937, 13952, "#b5abb0", "master"],
		["dune 3", 13953, 13968, "#9fa7ee", "master"],
		["set 6", 13969, 13984, "#372f30", "master"],
		["brood 7", 13985, 14000, "#856d1c", "master"],
		["cosmo", 14001, 14016, "#3b2446", "master"],
		["lime 4", 14017, 14032, "#75a7dc", "master"],
		["climb 5", 14033, 14048, "#1d443b", "master"],
		["air 5", 14049, 14064, "#885c2d", "master"],
		["fall 14", 14065, 14080, "#3989b3", "master"],
		["dawn 9", 14081, 14096, "#c36910", "master"],
		["valley 14", 14097, 14112, "#c37966", "master"],
		["height 2", 14113, 14128, "#454c50", "master"],
		["fog 4", 14129, 14144, "#8c8237", "master"],
		["far 4", 14145, 14160, "#367bcb", "master"],
		["pine 2", 14161, 14176, "#b2d4f5", "master"],
		["crest 8", 14177, 14192, "#b2c7d8", "master"],
		["gift 2", 14193, 14208, "#c797e8", "master"],
		["sierra 4", 14209, 14224, "#c36910", "master"],
		["amber 3", 14225, 14240, "#b5674f", "master"],
		["bright 14", 14241, 14256, "#355732", "master"],
		["river 8", 14257, 14272, "#587a75", "master"],
		["erode 2", 14273, 14288, "#5e92f3", "master"],
		["view 14", 14289, 14304, "#3b7fa6", "master"],
		["set 7", 14305, 14320, "#6b4a3e", "master"],
		["brood 8", 14321, 14336, "#71851e", "master"],
		["sand 6", 14337, 14352, "#1e558c", "master"],
		["mist 10", 14353, 14368, "#052d65", "master"],
		["up 5", 14369, 14384, "#2a7b93", "master"],
		["grass 3", 14385, 14400, "#32283c", "master"],
		["field 2", 14401, 14416, "#8da40a", "master"],
		["rapid 4", 14417, 14432, "#bad3e2", "master"],
		["glass 2", 14433, 14448, "#6e9ecf", "master"],
		["arise 8", 14449, 14464, "#385e76", "master"],
		["spire 6", 14465, 14480, "#bca6d7", "master"],
		["soar 2", 14481, 14496, "#367bcb", "master"],
		["mist 11", 14497, 14512, "#c1b8b4", "master"],
		["lake 5", 14513, 14528, "#84857f", "master"],
		["flat 5", 14529, 14544, "#3d90ce", "master"],
		["dawn 10", 14545, 14560, "#444b23", "master"],
		["leaf 6", 14561, 14576, "#516152", "master"],
		["dawn 11", 14577, 14592, "#ae8b14", "master"],
		["bright 15", 14593, 14608, "#b2ba44", "master"],
		["hole 5", 14609, 14624, "#20202c", "master"],
		["dusk 3", 14625, 14640, "#5b447b", "master"],
		["pond 2", 14641, 14656, "#36342a", "master"],
		["lush 5", 14657, 14672, "#263206", "master"],
		["river 9", 14673, 14688, "#c8dce6", "master"],
		["shine 12", 14689, 14704, "#2f387b", "master"],
		["emit 3", 14705, 14720, "#1c3528", "master"],
		["lush 6", 14721, 14736, "#3b4b18", "master"],
		["haze 4", 14737, 14752, "#4f80c0", "master"],
		["below 7", 14753, 14768, "#bad3e2", "master"],
		["valley 15", 14769, 14784, "#cea37e", "master"],
		["brook 6", 14785, 14800, "#566f3c", "master"],
		["mist 12", 14801, 14816, "#a4c1c7", "master"],
		["brook 7", 14817, 14832, "#5e4144", "master"],
		["mist 13", 14833, 14848, "#714936", "master"],
		["mossy 5", 14849, 14864, "#96c4df", "master"],
		["river 10", 14865, 14880, "#1b89d3", "master"],
		["clear 2", 14881, 14896, "#40addf", "master"],
		["mist 14", 14897, 14912, "#d6c3c5", "master"],
		["curl 2", 14913, 14928, "#1c600b", "master"],
		["view 15", 14929, 14944, "#4186c8", "master"],
		["sky 5", 14945, 14960, "#081328", "master"],
		["space 2", 14961, 14976, "#2b2c41", "master"],
		["wild 4", 14977, 14992, "#1c600b", "master"],
		["depth 2", 14993, 15008, "#3a6daf", "master"],
		["fall 15", 15009, 15024, "#43b2eb", "master"],
		["pebble 7", 15025, 15040, "#7e707b", "master"],
		["azure 3", 15041, 15056, "#0f98b9", "master"],
		["shine 13", 15057, 15072, "#a17b63", "master"],
		["azure 4", 15073, 15088, "#585e31", "master"],
		["pebble 8", 15089, 15104, "#E6E4B7", "master"],
		["leaf 7", 15105, 15120, "#779c35", "master"],
		["breeze 2", 15121, 15136, "#dee6dc", "master"],
		["beach 4", 15137, 15152, "#cdad81", "master"],
		["melt 2", 15153, 15168, "#2d6194", "master"],
		["grow 5", 15169, 15184, "#3d3a16", "master"],
		["cove 3", 15185, 15200, "#c3d0e0", "master"],
		["light 6", 15201, 15216, "#0e0f1d", "master"],
		["fit 4", 15217, 15232, "#3b6fa7", "master"],
		["vine 2", 15233, 15248, "#4c6111", "master"],
		["blue 5", 15249, 15264, "#dee6dc", "master"],
		["climb 6", 15265, 15280, "#4186c8", "master"],
		["wash 4", 15281, 15296, "#756e8d", "master"],
		["ray 8", 15297, 15312, "#b1934b", "master"],
		["lake 6", 15313, 15328, "#225c75", "master"],
		["ray 9", 15329, 15344, "#8a8f89", "master"],
		["wash 5", 15345, 15360, "#bd9794", "master"],
		["cover 6", 15361, 15376, "#134f7b", "master"],
		["calm 9", 15377, 15392, "#548eb1", "master"],
		["shore 2", 15393, 15408, "#e0afae", "master"],
		["light 7", 15409, 15424, "#184d4e", "master"],
		["grove 3", 15425, 15440, "#90510a", "master"],
		["slope 2", 15441, 15456, "#372f30", "master"],
		["bluff 4", 15457, 15472, "#3f6e9a", "master"],
		["opal 2", 15473, 15488, "#d49bc8", "master"],
		["cover 7", 15489, 15504, "#90510a", "master"],
		["wave 6", 15505, 15520, "#138cc5", "master"],
		["air 6", 15521, 15536, "#c3d0e0", "master"],
		["shell 8", 15537, 15552, "#d0a973", "master"],
		["polar 2", 15553, 15568, "#819864", "master"],
		["valley 16", 15569, 15584, "#7e93a8", "master"],
		["below 8", 15585, 15600, "#344f3d", "master"],
		["fresh 5", 15601, 15616, "#42a198", "master"],
		["vivid 6", 15617, 15632, "#638cac", "master"],
		["ripple 3", 15633, 15648, "#c7a884", "master"],
		["vast 9", 15649, 15664, "#ee9361", "master"],
		["frost 3", 15665, 15680, "#bec8d1", "master"],
		["oak 5", 15681, 15696, "#609fdc", "master"],
		["chill 4", 15697, 15712, "#aaa2df", "master"],
		["sea 2", 15713, 15728, "#6a68c7", "master"],
		["pyre 5", 15729, 15744, "#451624", "master"],
		["red 7", 15745, 15760, "#6d1a10", "master"],
		["vast 10", 15761, 15776, "#c7a884", "master"],
		["serene 6", 15777, 15792, "#b2cbc8", "master"],
		["view 16", 15793, 15808, "#3f6e9a", "master"],
		["strato 5", 15809, 15824, "#0a408a", "master"],
		["arch 3", 15825, 15840, "#1778d2", "master"],
		["fall 16", 15841, 15856, "#364821", "master"],
		["grace 8", 15857, 15872, "#0561d1", "master"],
		["bark", 15873, 15888, "#a17e5e", "master"],
		["dry 5", 15889, 15904, "#0f46bf", "master"],
		["sky 6", 15905, 15920, "#8a5425", "master"],
		["crest 9", 15921, 15936, "#b8abda", "master"],
		["birch 4", 15937, 15952, "#ccc6b7", "master"],
		["grain", 15953, 15968, "#f8e6d9", "master"],
		["coast 5", 15969, 15984, "#355732", "master"],
		["ripple 4", 15985, 16000, "#a7a3a0", "master"],
		["wall 5", 16001, 16016, "#b5abb0", "master"],
		["dune 4", 16017, 16032, "#9fa7ee", "master"],
		["calm 10", 16033, 16048, "#aaa2df", "master"],
		["brood 9", 16049, 16064, "#856d1c", "master"],
		["cosmo 2", 16065, 16080, "#3b2446", "master"],
		["lime 5", 16081, 16096, "#75a7dc", "master"],
		["climb 7", 16097, 16112, "#1d443b", "master"],
		["serene 7", 16113, 16128, "#664755", "master"],
		["fall 17", 16129, 16144, "#3989b3", "master"],
		["dawn 12", 16145, 16160, "#c36910", "master"],
		["valley 17", 16161, 16176, "#c37966", "master"],
		["height 3", 16177, 16192, "#454c50", "master"],
		["frond 6", 16193, 16208, "#cfc7a5", "master"],
		["far 5", 16209, 16224, "#367bcb", "master"],
		["pine 3", 16225, 16240, "#b2d4f5", "master"],
		["crest 10", 16241, 16256, "#b2c7d8", "master"],
		["gift 3", 16257, 16272, "#c797e8", "master"],
		["rock 7", 16273, 16288, "#1e558c", "master"],
		["amber 4", 16289, 16304, "#b5674f", "master"],
		["bright 16", 16305, 16320, "#355732", "master"],
		["river 11", 16321, 16336, "#587a75", "master"],
		["erode 3", 16337, 16352, "#5e92f3", "master"],
		["brood 10", 16353, 16368, "#85a7c8", "master"],
		["set 8", 16369, 16384, "#6b4a3e", "master"],
		["brood 11", 16385, 16400, "#71851e", "master"],
		["sand 7", 16401, 16416, "#1e558c", "master"],
		["mist 15", 16417, 16432, "#052d65", "master"],
		["valley 18", 16433, 16448, "#d5c284", "master"],
		["grass 4", 16449, 16464, "#32283c", "master"],
		["field 3", 16465, 16480, "#8da40a", "master"],
		["rapid 5", 16481, 16496, "#bad3e2", "master"],
		["glass 3", 16497, 16512, "#6e9ecf", "master"],
		["sol 3", 16513, 16528, "#0b545c", "master"],
		["spire 7", 16529, 16544, "#bca6d7", "master"],
		["soar 3", 16545, 16560, "#367bcb", "master"],
		["mist 16", 16561, 16576, "#c1b8b4", "master"],
		["lake 7", 16577, 16592, "#84857f", "master"],
		["leaf 8", 16593, 16608, "#daee95", "master"],
		["dawn 13", 16609, 16624, "#444b23", "master"],
		["leaf 9", 16625, 16640, "#516152", "master"],
		["dawn 14", 16641, 16656, "#ae8b14", "master"],
		["bright 17", 16657, 16672, "#b2ba44", "master"],
		["curve 3", 16673, 16688, "#904024", "master"],
		["dusk 4", 16689, 16704, "#5b447b", "master"],
		["pond 3", 16705, 16720, "#36342a", "master"],
		["lush 7", 16721, 16736, "#263206", "master"],
		["river 12", 16737, 16752, "#c8dce6", "master"],
		["watch 3", 16753, 16768, "#0a2a41", "master"],
		["emit 4", 16769, 16784, "#1c3528", "master"],
		["lush 8", 16785, 16800, "#3b4b18", "master"],
		["haze 5", 16801, 16816, "#4f80c0", "master"],
		["below 9", 16817, 16832, "#bad3e2", "master"],
		["wood 3", 16833, 16848, "#b2aaa4", "master"],
		["brook 8", 16849, 16864, "#566f3c", "master"],
		["mist 17", 16865, 16880, "#a4c1c7", "master"],
		["brook 9", 16881, 16896, "#5e4144", "master"],
		["mist 18", 16897, 16912, "#714936", "master"],
		["fall 18", 16913, 16928, "#7a5d2b", "master"],
		["river 13", 16929, 16944, "#1b89d3", "master"],
		["clear 3", 16945, 16960, "#40addf", "master"],
		["mist 19", 16961, 16976, "#d6c3c5", "master"],
		["curl 3", 16977, 16992, "#1c600b", "master"],
		["marsh 3", 16993, 17008, "#1b0d35", "master"],
		["sky 7", 17009, 17024, "#081328", "master"],
		["space 3", 17025, 17040, "#2b2c41", "master"],
		["wild 5", 17041, 17056, "#1c600b", "master"],
		["depth 3", 17057, 17072, "#3a6daf", "master"],
		["above 4", 17073, 17088, "#c8dce6", "master"],
		["pebble 9", 17089, 17104, "#7e707b", "master"],
		["azure 5", 17105, 17120, "#0f98b9", "master"],
		["shine 14", 17121, 17136, "#a17b63", "master"],
		["azure 6", 17137, 17152, "#585e31", "master"],
		["aqua 7", 17153, 17168, "#295771", "master"],
		["leaf 10", 17169, 17184, "#779c35", "master"],
		["breeze 3", 17185, 17200, "#dee6dc", "master"],
		["beach 5", 17201, 17216, "#cdad81", "master"],
		["melt 3", 17217, 17232, "#2d6194", "master"],
		["green 7", 17233, 17248, "#4c6111", "master"],
		["cove 4", 17249, 17264, "#c3d0e0", "master"],
		["light 8", 17265, 17280, "#0e0f1d", "master"],
		["fit 5", 17281, 17296, "#3b6fa7", "master"],
		["vine 3", 17297, 17312, "#4c6111", "master"],
		["storm 3", 17313, 17328, "#548eb1", "master"],
		["climb 8", 17329, 17344, "#4186c8", "master"],
		["wash 6", 17345, 17360, "#756e8d", "master"],
		["ray 10", 17361, 17376, "#b1934b", "master"],
		["lake 8", 17377, 17392, "#225c75", "master"],
		["arrive 6", 17393, 17408, "#d3dbce", "master"],
		["wash 7", 17409, 17424, "#bd9794", "master"],
		["cover 8", 17425, 17440, "#134f7b", "master"],
		["calm 11", 17441, 17456, "#548eb1", "master"],
		["shore 3", 17457, 17472, "#e0afae", "master"],
		["freeze 3", 17473, 17488, "#73a0bd", "master"],
		["grove 4", 17489, 17504, "#90510a", "master"],
		["slope 3", 17505, 17520, "#372f30", "master"],
		["bluff 5", 17521, 17536, "#3f6e9a", "master"],
		["opal 3", 17537, 17552, "#d49bc8", "master"],
		["vivid 7", 17553, 17568, "#609fdc", "master"],
		["wave 7", 17569, 17584, "#138cc5", "master"],
		["air 7", 17585, 17600, "#c3d0e0", "master"],
		["shell 9", 17601, 17616, "#d0a973", "master"],
		["polar 3", 17617, 17632, "#819864", "master"],
		["valley 19", 17633, 17648, "#7e93a8", "master"],
		["below 10", 17649, 17664, "#344f3d", "master"],
		["fresh 6", 17665, 17680, "#42a198", "master"],
		["vivid 8", 17681, 17696, "#638cac", "master"],
		["ripple 5", 17697, 17712, "#c7a884", "master"],
		["vast 11", 17713, 17728, "#ee9361", "master"],
		["frost 4", 17729, 17744, "#bec8d1", "master"],
		["ruby 2", 17745, 17760, "#6d1a10", "master"],
		["chill 5", 17761, 17776, "#aaa2df", "master"],
		["sea 3", 17777, 17792, "#6a68c7", "master"],
		["pyre 6", 17793, 17808, "#451624", "master"],
		["red 8", 17809, 17824, "#6d1a10", "master"],
		["sand 8", 17825, 17840, "#0f46bf", "master"],
		["serene 8", 17841, 17856, "#b2cbc8", "master"],
		["view 17", 17857, 17872, "#3f6e9a", "master"],
		["strato 6", 17873, 17888, "#0a408a", "master"],
		["arch 4", 17889, 17904, "#1778d2", "master"],
		["above 5", 17905, 17920, "#cfd088", "master"],
		["grace 9", 17921, 17936, "#0561d1", "master"],
		["bark 2", 17937, 17952, "#a17e5e", "master"],
		["dry 6", 17953, 17968, "#0f46bf", "master"],
		["sky 8", 17969, 17984, "#8a5425", "master"],
		["peace 3", 17985, 18000, "#789395", "master"],
		["birch 5", 18001, 18016, "#ccc6b7", "master"],
		["grain 2", 18017, 18032, "#f8e6d9", "master"],
		["coast 6", 18033, 18048, "#355732", "master"],
		["ripple 6", 18049, 18064, "#a7a3a0", "master"],
		["bask 3", 18065, 18080, "#939aa5", "master"],
		["dune 5", 18081, 18096, "#9fa7ee", "master"],
		["calm 12", 18097, 18112, "#aaa2df", "master"],
		["brood 12", 18113, 18128, "#856d1c", "master"],
		["cosmo 3", 18129, 18144, "#3b2446", "master"],
		["arid 4", 18145, 18160, "#c5c3b7", "master"],
		["climb 9", 18161, 18176, "#1d443b", "master"],
		["serene 9", 18177, 18192, "#664755", "master"],
		["fall 19", 18193, 18208, "#3989b3", "master"],
		["dawn 15", 18209, 18224, "#c36910", "master"],
		["spire 8", 18225, 18240, "#36483b", "master"],
		["height 4", 18241, 18256, "#454c50", "master"],
		["frond 7", 18257, 18272, "#cfc7a5", "master"],
		["far 6", 18273, 18288, "#367bcb", "master"],
		["pine 4", 18289, 18304, "#b2d4f5", "master"],
		["still 4", 18305, 18320, "#c77fd2", "master"],
		["gift 4", 18321, 18336, "#c797e8", "master"],
		["rock 8", 18337, 18352, "#1e558c", "master"],
		["amber 5", 18353, 18368, "#b5674f", "master"],
		["bright 18", 18369, 18384, "#355732", "master"],
		["range 4", 18385, 18400, "#34447a", "master"],
		["erode 4", 18401, 18416, "#5e92f3", "master"],
		["brood 13", 18417, 18432, "#85a7c8", "master"],
		["set 9", 18433, 18448, "#6b4a3e", "master"],
		["brood 14", 18449, 18464, "#71851e", "master"],
		["rise 4", 18465, 18480, "#bca6d7", "master"],
		["mist 20", 18481, 18496, "#052d65", "master"],
		["valley 20", 18497, 18512, "#d5c284", "master"],
		["grass 5", 18513, 18528, "#32283c", "master"],
		["field 4", 18529, 18544, "#8da40a", "master"],
		["cliff 4", 18545, 18560, "#43b2eb", "master"],
		["glass 4", 18561, 18576, "#6e9ecf", "master"],
		["sol 4", 18577, 18592, "#0b545c", "master"],
		["spire 9", 18593, 18608, "#bca6d7", "master"],
		["soar 4", 18609, 18624, "#367bcb", "master"],
		["arrive 7", 18625, 18640, "#b2d4f5", "master"],
		["lake 9", 18641, 18656, "#84857f", "master"],
		["leaf 11", 18657, 18672, "#daee95", "master"],
		["dawn 16", 18673, 18688, "#444b23", "master"],
		["leaf 12", 18689, 18704, "#516152", "master"],
		["bright 19", 18705, 18736, "#52373c", "master"],
		["curve 4", 18737, 18752, "#904024", "master"],
		["dusk 5", 18753, 18768, "#5b447b", "master"],
		["pond 4", 18769, 18784, "#36342a", "master"],
		["frond 8", 18785, 18800, "#3b4b18", "master"],
		["river 14", 18801, 18816, "#c8dce6", "master"],
		["watch 4", 18817, 18832, "#0a2a41", "master"],
		["emit 5", 18833, 18848, "#1c3528", "master"],
		["lush 9", 18849, 18864, "#3b4b18", "master"],
		["sail 4", 18865, 18880, "#8da40a", "master"],
		["below 11", 18881, 18896, "#bad3e2", "master"],
		["wood 4", 18897, 18912, "#b2aaa4", "master"],
		["brook 10", 18913, 18928, "#566f3c", "master"],
		["mist 21", 18929, 18944, "#a4c1c7", "master"],
		["toad 8", 18945, 18960, "#898391", "master"],
		["mist 22", 18961, 18976, "#714936", "master"],
		["fall 20", 18977, 18992, "#7a5d2b", "master"],
		["river 15", 18993, 19008, "#1b89d3", "master"],
		["clear 4", 19009, 19024, "#40addf", "master"],
		["snow 4", 19025, 19040, "#bbc5d9", "master"],
		["curl 4", 19041, 19056, "#1c600b", "master"],
		["marsh 4", 19057, 19072, "#1b0d35", "master"],
		["sky 9", 19073, 19088, "#081328", "master"],
		["space 4", 19089, 19104, "#2b2c41", "master"],
		["thick 4", 19105, 19120, "#3d3a16", "master"],
		["depth 4", 19121, 19136, "#3a6daf", "master"],
		["above 6", 19137, 19152, "#c8dce6", "master"],
		["pebble 10", 19153, 19168, "#7e707b", "master"],
		["azure 7", 19169, 19184, "#0f98b9", "master"],
		["icey 4", 19185, 19200, "#173ebd", "master"],
		["azure 8", 19201, 19216, "#585e31", "master"],
		["aqua 8", 19217, 19232, "#295771", "master"],
		["leaf 13", 19233, 19248, "#779c35", "master"],
		["breeze 4", 19249, 19264, "#dee6dc", "master"],
		["palm 4", 19265, 19280, "#44c7ca", "master"],
		["melt 4", 19281, 19296, "#2d6194", "master"],
		["green 8", 19297, 19312, "#4c6111", "master"],
		["cove 5", 19313, 19328, "#c3d0e0", "master"],
		["light 9", 19329, 19344, "#0e0f1d", "master"],
		["zeal 4", 19345, 19360, "#89bee6", "master"],
		["vine 4", 19361, 19376, "#4c6111", "master"],
		["storm 4", 19377, 19392, "#548eb1", "master"],
		["climb 10", 19393, 19408, "#4186c8", "master"],
		["wash 8", 19409, 19424, "#756e8d", "master"],
		["solis 4", 19425, 19440, "#d58265", "master"],
		["lake 10", 19441, 19456, "#225c75", "master"],
		["arrive 8", 19457, 19472, "#d3dbce", "master"],
		["wash 9", 19473, 19488, "#bd9794", "master"],
		["cover 9", 19489, 19504, "#134f7b", "master"],
		["calm 13", 19505, 19520, "#548eb1", "master"],
		["shore 4", 19521, 19536, "#e0afae", "master"],
		["freeze 4", 19537, 19552, "#73a0bd", "master"],
		["grove 5", 19553, 19568, "#90510a", "master"],
		["slope 4", 19569, 19584, "#372f30", "master"],
		["bluff 6", 19585, 19600, "#3f6e9a", "master"],
		["opal 4", 19601, 19616, "#d49bc8", "master"],
		["vivid 9", 19617, 19632, "#609fdc", "master"],
		["wave 8", 19633, 19648, "#138cc5", "master"],
		["air 8", 19649, 19664, "#c3d0e0", "master"],
		["shell 10", 19665, 19680, "#d0a973", "master"],
		["polar 4", 19681, 19696, "#819864", "master"],
		["white 3", 19697, 19712, "#6d8cab", "master"],
		["below 12", 19713, 19728, "#344f3d", "master"],
		["fresh 7", 19729, 19744, "#42a198", "master"],
		["vivid 10", 19745, 19760, "#638cac", "master"],
		["ripple 7", 19761, 19776, "#c7a884", "master"],
		["lake 11", 19777, 19792, "#d9ca87", "master"],
		["frost 5", 19793, 19808, "#bec8d1", "master"],
		["ruby 3", 19809, 19824, "#6d1a10", "master"],
		["chill 6", 19825, 19840, "#aaa2df", "master"],
		["sea 4", 19841, 19856, "#6a68c7", "master"],
		["arise 9", 19857, 19872, "#0e3650", "master"],
		["red 9", 19873, 19888, "#6d1a10", "master"],
		["sand 9", 19889, 19904, "#0f46bf", "master"],
		["serene 10", 19905, 19920, "#b2cbc8", "master"],
		["view 18", 19921, 19936, "#3f6e9a", "master"],
		["luna 4", 19937, 19952, "#051227", "master"],
		["arch 5", 19953, 19968, "#1778d2", "master"],
		["above 7", 19969, 19984, "#cfd088", "master"],
		["grace 10", 19985, 20000, "#0561d1", "master"],
		["bark 3", 20001, 20016, "#a17e5e", "master"],
		["drift 4", 20017, 20032, "#9fa7ee", "master"],
		["sky 10", 20033, 20048, "#8a5425", "master"],
		["peace 4", 20049, 20064, "#789395", "master"],
		["birch 6", 20065, 20080, "#ccc6b7", "master"],
		["grain 3", 20081, 20096, "#f8e6d9", "master"],
		["below 13", 20097, 20112, "#c1b8b4", "master"],
		["ripple 8", 20113, 20128, "#a7a3a0", "master"],
		["bask 4", 20129, 20144, "#939aa5", "master"],
		["dune 6", 20145, 20160, "#9fa7ee", "master"],
		["calm 14", 20161, 20176, "#aaa2df", "master"],
		["dawn 17", 20177, 20192, "#6a68c7", "master"],
		["cosmo 4", 20193, 20208, "#3b2446", "master"],
		["arid 5", 20209, 20224, "#c5c3b7", "master"],
		["climb 11", 20225, 20240, "#1d443b", "master"],
		["serene 11", 20241, 20256, "#664755", "master"],
		["view 19", 20257, 20272, "#060a1f", "master"],
		["dawn 18", 20273, 20288, "#c36910", "master"],
		["spire 10", 20289, 20304, "#36483b", "master"],
		["height 5", 20305, 20320, "#454c50", "master"],
		["frond 9", 20321, 20336, "#cfc7a5", "master"],
		["lines 5", 20337, 20352, "#4f80c0", "master"],
		["pine 5", 20353, 20368, "#b2d4f5", "master"],
		["still 5", 20369, 20384, "#c77fd2", "master"],
		["gift 5", 20385, 20400, "#c797e8", "master"],
		["rock 9", 20401, 20416, "#1e558c", "master"],
		["wind 5", 20417, 20432, "#f8e6d9", "master"],
		["bright 20", 20433, 20448, "#355732", "master"],
		["range 5", 20449, 20464, "#34447a", "master"],
		["erode 5", 20465, 20480, "#5e92f3", "master"],
		["brood 15", 20481, 20496, "#85a7c8", "master"],
		["calm 15", 20497, 20512, "#7e6064", "master"],
		["brood 16", 20513, 20528, "#71851e", "master"],
		["rise 5", 20529, 20544, "#bca6d7", "master"],
		["mist 23", 20545, 20560, "#052d65", "master"],
		["valley 21", 20561, 20576, "#d5c284", "master"],
		["shine 15", 20577, 20592, "#a3904f", "master"],
		["field 5", 20593, 20608, "#8da40a", "master"],
		["cliff 5", 20609, 20624, "#43b2eb", "master"],
		["glass 5", 20625, 20640, "#6e9ecf", "master"],
		["sol 5", 20641, 20656, "#0b545c", "master"],
		["green 9", 20657, 20672, "#263206", "master"],
		["soar 5", 20673, 20688, "#367bcb", "master"],
		["arrive 9", 20689, 20704, "#b2d4f5", "master"],
		["lake 12", 20705, 20720, "#84857f", "master"],
		["leaf 14", 20721, 20736, "#daee95", "master"],
		["bright 21", 20737, 20752, "#38423a", "master"],
		["leaf 15", 20753, 20768, "#516152", "master"],
		["bright 22", 20769, 20800, "#52373c", "master"],
		["curve 5", 20801, 20816, "#904024", "master"],
		["star 5", 20817, 20832, "#3270cd", "master"],
		["pond 5", 20833, 20848, "#36342a", "master"],
		["frond 10", 20849, 20864, "#3b4b18", "master"],
		["river 16", 20865, 20880, "#c8dce6", "master"],
		["watch 5", 20881, 20896, "#0a2a41", "master"],
		["bright 23", 20897, 20912, "#1f305b", "master"],
		["lush 10", 20913, 20928, "#3b4b18", "master"],
		["sail 5", 20929, 20944, "#8da40a", "master"],
		["below 14", 20945, 20960, "#bad3e2", "master"],
		["wood 5", 20961, 20976, "#b2aaa4", "master"],
		["toad 9", 20977, 20992, "#264056", "master"],
		["mist 24", 20993, 21008, "#a4c1c7", "master"],
		["toad 10", 21009, 21024, "#898391", "master"],
		["mist 25", 21025, 21040, "#714936", "master"],
		["fall 21", 21041, 21056, "#7a5d2b", "master"],
		["float 5", 21057, 21072, "#3a6daf", "master"],
		["clear 5", 21073, 21088, "#40addf", "master"],
		["snow 5", 21089, 21104, "#bbc5d9", "master"],
		["curl 5", 21105, 21120, "#1c600b", "master"],
		["marsh 5", 21121, 21136, "#1b0d35", "master"],
		["gaze 5", 21137, 21152, "#040c18", "master"],
		["space 5", 21153, 21168, "#2b2c41", "master"],
		["thick 5", 21169, 21184, "#3d3a16", "master"],
		["depth 5", 21185, 21200, "#3a6daf", "master"],
		["above 8", 21201, 21216, "#c8dce6", "master"],
		["aqua 9", 21217, 21232, "#b9d6e4", "master"],
		["azure 9", 21233, 21248, "#0f98b9", "master"],
		["icey 5", 21249, 21264, "#173ebd", "master"],
		["azure 10", 21265, 21280, "#585e31", "master"],
		["aqua 10", 21281, 21296, "#295771", "master"],
		["fir 5", 21297, 21312, "#15573d", "master"],
		["breeze 5", 21313, 21328, "#dee6dc", "master"],
		["palm 5", 21329, 21344, "#44c7ca", "master"],
		["melt 5", 21345, 21360, "#2d6194", "master"],
		["green 10", 21361, 21376, "#4c6111", "master"],
		["cove 6", 21377, 21392, "#c3d0e0", "master"],
		["light 10", 21393, 21408, "#0e0f1d", "master"],
		["zeal 5", 21409, 21424, "#89bee6", "master"],
		["vine 5", 21425, 21440, "#4c6111", "master"],
		["storm 5", 21441, 21456, "#548eb1", "master"],
		["climb 12", 21457, 21472, "#4186c8", "master"],
		["wash 10", 21473, 21488, "#756e8d", "master"],
		["solis 5", 21489, 21504, "#d58265", "master"],
		["lake 13", 21505, 21520, "#225c75", "master"],
		["arrive 10", 21521, 21536, "#d3dbce", "master"],
		["wash 11", 21537, 21552, "#bd9794", "master"],
		["cover 10", 21553, 21568, "#134f7b", "master"],
		["wave 9", 21569, 21584, "#138cc5", "master"],
		["shore 5", 21585, 21600, "#e0afae", "master"],
		["freeze 5", 21601, 21616, "#73a0bd", "master"],
		["grove 6", 21617, 21632, "#90510a", "master"],
		["slope 5", 21633, 21648, "#372f30", "master"],
		["lavish 4", 21649, 21664, "#856d1c", "master"],
		["opal 5", 21665, 21680, "#d49bc8", "master"],
		["vivid 11", 21681, 21696, "#609fdc", "master"],
		["wave 10", 21697, 21712, "#138cc5", "master"],
		["air 9", 21713, 21728, "#c3d0e0", "master"],
		["fresh 8", 21729, 21744, "#c6dded", "master"],
		["polar 5", 21745, 21760, "#819864", "master"],
		["white 4", 21761, 21776, "#6d8cab", "master"],
		["below 15", 21777, 21792, "#344f3d", "master"],
		["fresh 9", 21793, 21808, "#42a198", "master"],
		["red 10", 21809, 21824, "#675d45", "master"],
		["ripple 9", 21825, 21840, "#c7a884", "master"],
		["lake 14", 21841, 21856, "#d9ca87", "master"],
		["frost 6", 21857, 21872, "#bec8d1", "master"],
		["ruby 4", 21873, 21888, "#6d1a10", "master"],
		["seed 5", 21889, 21904, "#b5674f", "master"],
		["sea 5", 21905, 21920, "#6a68c7", "master"],
		["arise 10", 21921, 21936, "#0e3650", "master"],
		["red 11", 21937, 21952, "#6d1a10", "master"],
		["sand 10", 21953, 21968, "#0f46bf", "master"],
		["set 10", 21969, 21984, "#372f30", "master"],
		["view 20", 21985, 22000, "#3f6e9a", "master"],
		["luna 5", 22001, 22016, "#051227", "master"],
		["arch 6", 22017, 22032, "#1778d2", "master"],
		["above 9", 22033, 22048, "#cfd088", "master"],
		["air 10", 22049, 22064, "#885c2d", "master"],
		["bark 4", 22065, 22080, "#a17e5e", "master"],
		["drift 5", 22081, 22096, "#9fa7ee", "master"],
		["sky 11", 22097, 22112, "#8a5425", "master"],
		["peace 5", 22113, 22128, "#789395", "master"],
		["fog 5", 22129, 22144, "#8c8237", "master"],
		["grain 4", 22145, 22160, "#f8e6d9", "master"],
		["below 16", 22161, 22176, "#c1b8b4", "master"],
		["ripple 10", 22177, 22192, "#a7a3a0", "master"],
		["bask 5", 22193, 22208, "#939aa5", "master"],
		["sierra 5", 22209, 22224, "#c36910", "master"],
		["calm 16", 22225, 22240, "#aaa2df", "master"],
		["dawn 19", 22241, 22256, "#6a68c7", "master"],
		["cosmo 5", 22257, 22272, "#3b2446", "master"],
		["arid 6", 22273, 22288, "#c5c3b7", "master"],
		["view 21", 22289, 22304, "#3b7fa6", "master"],
		["serene 12", 22305, 22320, "#664755", "master"],
		["view 22", 22321, 22336, "#060a1f", "master"],
		["dawn 20", 22337, 22352, "#c36910", "master"],
		["spire 11", 22353, 22368, "#36483b", "master"],
		["up 6", 22369, 22384, "#2a7b93", "master"],
		["frond 11", 22385, 22400, "#cfc7a5", "master"],
		["lines 6", 22401, 22416, "#4f80c0", "master"],
		["pine 6", 22417, 22432, "#b2d4f5", "master"],
		["still 6", 22433, 22448, "#c77fd2", "master"],
		["arise 11", 22449, 22464, "#385e76", "master"],
		["rock 10", 22465, 22480, "#1e558c", "master"],
		["wind 6", 22481, 22496, "#f8e6d9", "master"],
		["bright 24", 22497, 22512, "#355732", "master"],
		["range 6", 22513, 22528, "#34447a", "master"],
		["flat 6", 22529, 22544, "#3d90ce", "master"],
		["brood 17", 22545, 22560, "#85a7c8", "master"],
		["calm 17", 22561, 22576, "#7e6064", "master"],
		["brood 18", 22577, 22592, "#71851e", "master"],
		["rise 6", 22593, 22608, "#bca6d7", "master"],
		["hole 6", 22609, 22624, "#20202c", "master"],
		["valley 22", 22625, 22640, "#d5c284", "master"],
		["shine 16", 22641, 22656, "#a3904f", "master"],
		["field 6", 22657, 22672, "#8da40a", "master"],
		["cliff 6", 22673, 22688, "#43b2eb", "master"],
		["shine 17", 22689, 22704, "#2f387b", "master"],
		["sol 6", 22705, 22720, "#0b545c", "master"],
		["green 11", 22721, 22736, "#263206", "master"],
		["soar 6", 22737, 22752, "#367bcb", "master"],
		["arrive 11", 22753, 22768, "#b2d4f5", "master"],
		["valley 23", 22769, 22784, "#cea37e", "master"],
		["leaf 16", 22785, 22800, "#daee95", "master"],
		["bright 25", 22801, 22816, "#38423a", "master"],
		["leaf 17", 22817, 22832, "#516152", "master"],
		["bright 26", 22833, 22848, "#52373c", "master"],
		["mossy 6", 22849, 22864, "#96c4df", "master"],
		["curve 6", 22865, 22880, "#904024", "master"],
		["star 6", 22881, 22896, "#3270cd", "master"],
		["pond 6", 22897, 22912, "#36342a", "master"],
		["frond 12", 22913, 22928, "#3b4b18", "master"],
		["view 23", 22929, 22944, "#4186c8", "master"],
		["watch 6", 22945, 22960, "#0a2a41", "master"],
		["bright 27", 22961, 22976, "#1f305b", "master"],
		["lush 11", 22977, 22992, "#3b4b18", "master"],
		["sail 6", 22993, 23008, "#8da40a", "master"],
		["fall 22", 23009, 23024, "#43b2eb", "master"],
		["wood 6", 23025, 23040, "#b2aaa4", "master"],
		["toad 11", 23041, 23056, "#264056", "master"],
		["mist 26", 23057, 23072, "#a4c1c7", "master"],
		["toad 12", 23073, 23088, "#898391", "master"],
		["pebble 11", 23089, 23104, "#E6E4B7", "master"],
		["fall 23", 23105, 23120, "#7a5d2b", "master"],
		["float 6", 23121, 23136, "#3a6daf", "master"],
		["clear 6", 23137, 23152, "#40addf", "master"],
		["snow 6", 23153, 23168, "#bbc5d9", "master"],
		["grow 6", 23169, 23184, "#3d3a16", "master"],
		["marsh 6", 23185, 23200, "#1b0d35", "master"],
		["gaze 6", 23201, 23216, "#040c18", "master"],
		["space 6", 23217, 23232, "#2b2c41", "master"],
		["thick 6", 23233, 23248, "#3d3a16", "master"],
		["blue 6", 23249, 23264, "#dee6dc", "master"],
		["above 10", 23265, 23280, "#c8dce6", "master"],
		["aqua 11", 23281, 23296, "#b9d6e4", "master"],
		["azure 11", 23297, 23312, "#0f98b9", "master"],
		["icey 6", 23313, 23328, "#173ebd", "master"],
		["azure 12", 23329, 23344, "#585e31", "master"],
		["aqua 12", 23345, 23360, "#295771", "master"],
		["fir 6", 23361, 23376, "#15573d", "master"],
		["breeze 6", 23377, 23392, "#dee6dc", "master"],
		["palm 6", 23393, 23408, "#44c7ca", "master"],
		["melt 6", 23409, 23424, "#2d6194", "master"],
		["green 12", 23425, 23440, "#4c6111", "master"],
		["rock 11", 23441, 23456, "#b2cbc8", "master"],
		["light 11", 23457, 23472, "#0e0f1d", "master"],
		["zeal 6", 23473, 23488, "#89bee6", "master"],
		["vine 6", 23489, 23504, "#4c6111", "master"],
		["storm 6", 23505, 23520, "#548eb1", "master"],
		["grace 11", 23521, 23536, "#1b0d35", "master"],
		["wash 12", 23537, 23552, "#756e8d", "master"],
		["solis 6", 23553, 23568, "#d58265", "master"],
		["lake 15", 23569, 23584, "#225c75", "master"],
		["arrive 12", 23585, 23600, "#d3dbce", "master"],
		["shell 11", 23601, 23616, "#3d7ac9", "master"],
		["cover 11", 23617, 23632, "#134f7b", "master"],
		["wave 11", 23633, 23648, "#138cc5", "master"],
		["shore 6", 23649, 23664, "#e0afae", "master"],
		["freeze 6", 23665, 23680, "#73a0bd", "master"],
		["oak 6", 23681, 23696, "#609fdc", "master"],
		["slope 6", 23697, 23712, "#372f30", "master"],
		["lavish 5", 23713, 23728, "#856d1c", "master"],
		["opal 6", 23729, 23744, "#d49bc8", "master"],
		["vivid 12", 23745, 23760, "#609fdc", "master"],
		["vast 12", 23761, 23776, "#c7a884", "master"],
		["air 11", 23777, 23792, "#c3d0e0", "master"],
		["fresh 10", 23793, 23808, "#c6dded", "master"],
		["polar 6", 23809, 23824, "#819864", "master"],
		["white 5", 23825, 23840, "#6d8cab", "master"],
		["fall 24", 23841, 23856, "#364821", "master"],
		["fresh 11", 23857, 23872, "#42a198", "master"],
		["red 12", 23873, 23888, "#675d45", "master"],
		["ripple 11", 23889, 23904, "#c7a884", "master"],
		["lake 16", 23905, 23920, "#d9ca87", "master"],
		["crest 11", 23921, 23936, "#b8abda", "master"],
		["ruby 5", 23937, 23952, "#6d1a10", "master"],
		["seed 6", 23953, 23968, "#b5674f", "master"],
		["sea 6", 23969, 23984, "#6a68c7", "master"],
		["arise 12", 23985, 24000, "#0e3650", "master"],
		["wall 6", 24001, 24016, "#b5abb0", "master"],
		["sand 11", 24017, 24032, "#0f46bf", "master"],
		["set 11", 24033, 24048, "#372f30", "master"],
		["view 24", 24049, 24064, "#3f6e9a", "master"],
		["luna 6", 24065, 24080, "#051227", "master"],
		["lime 6", 24081, 24096, "#75a7dc", "master"],
		["above 11", 24097, 24112, "#cfd088", "master"],
		["air 12", 24113, 24128, "#885c2d", "master"],
		["bark 5", 24129, 24144, "#a17e5e", "master"],
		["drift 6", 24145, 24160, "#9fa7ee", "master"],
		["valley 24", 24161, 24176, "#c37966", "master"],
		["peace 6", 24177, 24192, "#789395", "master"],
		["fog 6", 24193, 24208, "#8c8237", "master"],
		["grain 5", 24209, 24224, "#f8e6d9", "master"],
		["below 17", 24225, 24240, "#c1b8b4", "master"],
		["crest 12", 24241, 24256, "#b2c7d8", "master"],
		["bask 6", 24257, 24272, "#939aa5", "master"],
		["sierra 6", 24273, 24288, "#c36910", "master"],
		["calm 18", 24289, 24304, "#aaa2df", "master"],
		["dawn 21", 24305, 24320, "#6a68c7", "master"],
		["river 17", 24321, 24336, "#587a75", "master"],
		["arid 7", 24337, 24352, "#c5c3b7", "master"],
		["view 25", 24353, 24368, "#3b7fa6", "master"],
		["serene 13", 24369, 24384, "#664755", "master"],
		["view 26", 24385, 24400, "#060a1f", "master"],
		["sand 12", 24401, 24416, "#1e558c", "master"],
		["spire 12", 24417, 24432, "#36483b", "master"],
		["up 7", 24433, 24448, "#2a7b93", "master"],
		["frond 13", 24449, 24464, "#cfc7a5", "master"],
		["lines 7", 24465, 24480, "#4f80c0", "master"],
		["rapid 6", 24481, 24496, "#bad3e2", "master"],
		["still 7", 24497, 24512, "#c77fd2", "master"],
		["arise 13", 24513, 24528, "#385e76", "master"],
		["rock 12", 24529, 24544, "#1e558c", "master"],
		["wind 7", 24545, 24560, "#f8e6d9", "master"],
		["mist 27", 24561, 24576, "#c1b8b4", "master"],
		["range 7", 24577, 24592, "#34447a", "master"],
		["flat 7", 24593, 24608, "#3d90ce", "master"],
		["brood 19", 24609, 24624, "#85a7c8", "master"],
		["calm 19", 24625, 24640, "#7e6064", "master"],
		["dawn 22", 24641, 24656, "#ae8b14", "master"],
		["rise 7", 24657, 24672, "#bca6d7", "master"],
		["hole 7", 24673, 24688, "#20202c", "master"],
		["valley 25", 24689, 24704, "#d5c284", "master"],
		["shine 18", 24705, 24720, "#a3904f", "master"],
		["lush 12", 24721, 24736, "#263206", "master"],
		["cliff 7", 24737, 24752, "#43b2eb", "master"],
		["shine 19", 24753, 24768, "#2f387b", "master"],
		["sol 7", 24769, 24784, "#0b545c", "master"],
		["green 13", 24785, 24800, "#263206", "master"],
		["haze 6", 24801, 24816, "#4f80c0", "master"],
		["arrive 13", 24817, 24832, "#b2d4f5", "master"],
		["valley 26", 24833, 24848, "#cea37e", "master"],
		["leaf 18", 24849, 24864, "#daee95", "master"],
		["bright 28", 24865, 24880, "#38423a", "master"],
		["brook 11", 24881, 24896, "#5e4144", "master"],
		["bright 29", 24897, 24912, "#52373c", "master"],
		["mossy 7", 24913, 24928, "#96c4df", "master"],
		["curve 7", 24929, 24944, "#904024", "master"],
		["star 7", 24945, 24960, "#3270cd", "master"],
		["mist 28", 24961, 24976, "#d6c3c5", "master"],
		["frond 14", 24977, 24992, "#3b4b18", "master"],
		["view 27", 24993, 25008, "#4186c8", "master"],
		["watch 7", 25009, 25024, "#0a2a41", "master"],
		["bright 30", 25025, 25040, "#1f305b", "master"],
		["wild 6", 25041, 25056, "#1c600b", "master"],
		["sail 7", 25057, 25072, "#8da40a", "master"],
		["fall 25", 25073, 25088, "#43b2eb", "master"],
		["wood 7", 25089, 25104, "#b2aaa4", "master"],
		["toad 13", 25105, 25120, "#264056", "master"],
		["shine 20", 25121, 25136, "#a17b63", "master"],
		["toad 14", 25137, 25152, "#898391", "master"],
		["pebble 12", 25153, 25168, "#E6E4B7", "master"],
		["fall 26", 25169, 25184, "#7a5d2b", "master"],
		["float 7", 25185, 25200, "#3a6daf", "master"],
		["clear 7", 25201, 25216, "#40addf", "master"],
		["snow 7", 25217, 25232, "#bbc5d9", "master"],
		["grow 7", 25233, 25248, "#3d3a16", "master"],
		["marsh 7", 25249, 25264, "#1b0d35", "master"],
		["gaze 7", 25265, 25280, "#040c18", "master"],
		["space 7", 25281, 25296, "#2b2c41", "master"],
		["thick 7", 25297, 25312, "#3d3a16", "master"],
		["blue 7", 25313, 25328, "#dee6dc", "master"],
		["above 12", 25329, 25344, "#c8dce6", "master"],
		["aqua 13", 25345, 25360, "#b9d6e4", "master"],
		["azure 13", 25361, 25376, "#0f98b9", "master"],
		["icey 7", 25377, 25392, "#173ebd", "master"],
		["ray 11", 25393, 25408, "#8a8f89", "master"],
		["aqua 14", 25409, 25424, "#295771", "master"],
		["fir 7", 25425, 25440, "#15573d", "master"],
		["breeze 7", 25441, 25456, "#dee6dc", "master"],
		["palm 7", 25457, 25472, "#44c7ca", "master"],
		["light 12", 25473, 25488, "#184d4e", "master"],
		["green 14", 25489, 25504, "#4c6111", "master"],
		["rock 13", 25505, 25520, "#b2cbc8", "master"],
		["light 13", 25521, 25536, "#0e0f1d", "master"],
		["zeal 7", 25537, 25552, "#89bee6", "master"],
		["cover 12", 25553, 25568, "#90510a", "master"],
		["storm 7", 25569, 25584, "#548eb1", "master"],
		["grace 12", 25585, 25600, "#1b0d35", "master"],
		["wash 13", 25601, 25616, "#756e8d", "master"],
		["solis 7", 25617, 25632, "#d58265", "master"],
		["valley 27", 25633, 25648, "#7e93a8", "master"],
		["arrive 14", 25649, 25664, "#d3dbce", "master"],
		["shell 12", 25665, 25680, "#3d7ac9", "master"],
		["cover 13", 25681, 25696, "#134f7b", "master"],
		["wave 12", 25697, 25712, "#138cc5", "master"],
		["vast 13", 25713, 25728, "#ee9361", "master"],
		["freeze 7", 25729, 25744, "#73a0bd", "master"],
		["oak 7", 25745, 25760, "#609fdc", "master"],
		["slope 7", 25761, 25776, "#372f30", "master"],
		["lavish 6", 25777, 25792, "#856d1c", "master"],
		["pyre 7", 25793, 25808, "#451624", "master"],
		["vivid 13", 25809, 25824, "#609fdc", "master"],
		["vast 14", 25825, 25840, "#c7a884", "master"],
		["air 13", 25841, 25856, "#c3d0e0", "master"],
		["fresh 12", 25857, 25872, "#c6dded", "master"],
		["strato 7", 25873, 25888, "#0a408a", "master"],
		["white 6", 25889, 25904, "#6d8cab", "master"],
		["fall 27", 25905, 25920, "#364821", "master"],
		["fresh 13", 25921, 25936, "#42a198", "master"],
		["red 13", 25937, 25952, "#675d45", "master"],
		["dry 7", 25953, 25968, "#0f46bf", "master"],
		["lake 17", 25969, 25984, "#d9ca87", "master"],
		["crest 13", 25985, 26000, "#b8abda", "master"],
		["ruby 6", 26001, 26016, "#6d1a10", "master"],
		["seed 7", 26017, 26032, "#b5674f", "master"],
		["coast 7", 26033, 26048, "#355732", "master"],
		["arise 14", 26049, 26064, "#0e3650", "master"],
		["wall 7", 26065, 26080, "#b5abb0", "master"],
		["sand 13", 26081, 26096, "#0f46bf", "master"],
		["set 12", 26097, 26112, "#372f30", "master"],
		["brood 20", 26113, 26128, "#856d1c", "master"],
		["luna 7", 26129, 26144, "#051227", "master"],
		["lime 7", 26145, 26160, "#75a7dc", "master"],
		["above 13", 26161, 26176, "#cfd088", "master"],
		["air 14", 26177, 26192, "#885c2d", "master"],
		["fall 28", 26193, 26208, "#3989b3", "master"],
		["drift 7", 26209, 26224, "#9fa7ee", "master"],
		["valley 28", 26225, 26240, "#c37966", "master"],
		["peace 7", 26241, 26256, "#789395", "master"],
		["fog 7", 26257, 26272, "#8c8237", "master"],
		["far 7", 26273, 26288, "#367bcb", "master"],
		["below 18", 26289, 26304, "#c1b8b4", "master"],
		["crest 14", 26305, 26320, "#b2c7d8", "master"],
		["bask 7", 26321, 26336, "#939aa5", "master"],
		["sierra 7", 26337, 26352, "#c36910", "master"],
		["amber 6", 26353, 26368, "#b5674f", "master"],
		["dawn 23", 26369, 26384, "#6a68c7", "master"],
		["river 18", 26385, 26400, "#587a75", "master"],
		["arid 8", 26401, 26416, "#c5c3b7", "master"],
		["view 28", 26417, 26432, "#3b7fa6", "master"],
		["set 13", 26433, 26448, "#6b4a3e", "master"],
		["view 29", 26449, 26464, "#060a1f", "master"],
		["sand 14", 26465, 26480, "#1e558c", "master"],
		["spire 13", 26481, 26496, "#36483b", "master"],
		["up 8", 26497, 26512, "#2a7b93", "master"],
		["grass 6", 26513, 26528, "#32283c", "master"],
		["lines 8", 26529, 26544, "#4f80c0", "master"],
		["rapid 7", 26545, 26560, "#bad3e2", "master"],
		["still 8", 26561, 26576, "#c77fd2", "master"],
		["arise 15", 26577, 26592, "#385e76", "master"],
		["spire 14", 26593, 26608, "#bca6d7", "master"],
		["wind 8", 26609, 26624, "#f8e6d9", "master"],
		["mist 29", 26625, 26640, "#c1b8b4", "master"],
		["range 8", 26641, 26656, "#34447a", "master"],
		["flat 8", 26657, 26672, "#3d90ce", "master"],
		["dawn 24", 26673, 26688, "#444b23", "master"],
		["calm 20", 26689, 26704, "#7e6064", "master"],
		["dawn 25", 26705, 26720, "#ae8b14", "master"],
		["rise 8", 26721, 26736, "#bca6d7", "master"],
		["hole 8", 26737, 26752, "#20202c", "master"],
		["dusk 6", 26753, 26768, "#5b447b", "master"],
		["shine 21", 26769, 26784, "#a3904f", "master"],
		["lush 13", 26785, 26800, "#263206", "master"],
		["cliff 8", 26801, 26816, "#43b2eb", "master"],
		["shine 22", 26817, 26832, "#2f387b", "master"],
		["emit 6", 26833, 26848, "#1c3528", "master"],
		["green 15", 26849, 26864, "#263206", "master"],
		["haze 7", 26865, 26880, "#4f80c0", "master"],
		["arrive 15", 26881, 26896, "#b2d4f5", "master"],
		["valley 29", 26897, 26912, "#cea37e", "master"],
		["brook 12", 26913, 26928, "#566f3c", "master"],
		["bright 31", 26929, 26944, "#38423a", "master"],
		["brook 13", 26945, 26960, "#5e4144", "master"],
		["bright 32", 26961, 26976, "#52373c", "master"],
		["mossy 8", 26977, 26992, "#96c4df", "master"],
		["river 19", 26993, 27008, "#1b89d3", "master"],
		["star 8", 27009, 27024, "#3270cd", "master"],
		["mist 30", 27025, 27040, "#d6c3c5", "master"],
		["frond 15", 27041, 27056, "#3b4b18", "master"],
		["view 30", 27057, 27072, "#4186c8", "master"],
		["sky 12", 27073, 27088, "#081328", "master"],
		["bright 33", 27089, 27104, "#1f305b", "master"],
		["wild 7", 27105, 27120, "#1c600b", "master"],
		["sail 8", 27121, 27136, "#8da40a", "master"],
		["fall 29", 27137, 27152, "#43b2eb", "master"],
		["wood 8", 27153, 27168, "#b2aaa4", "master"],
		["toad 15", 27169, 27184, "#264056", "master"],
		["shine 23", 27185, 27200, "#a17b63", "master"],
		["toad 16", 27201, 27216, "#898391", "master"],
		["pebble 13", 27217, 27232, "#E6E4B7", "master"],
		["fall 30", 27233, 27248, "#7a5d2b", "master"],
		["float 8", 27249, 27264, "#3a6daf", "master"],
		["beach 6", 27265, 27280, "#cdad81", "master"],
		["snow 8", 27281, 27296, "#bbc5d9", "master"],
		["grow 8", 27297, 27312, "#3d3a16", "master"],
		["marsh 8", 27313, 27328, "#1b0d35", "master"],
		["gaze 8", 27329, 27344, "#040c18", "master"],
		["fit 6", 27345, 27360, "#3b6fa7", "master"],
		["thick 8", 27361, 27376, "#3d3a16", "master"],
		["blue 8", 27377, 27392, "#dee6dc", "master"],
		["above 14", 27393, 27408, "#c8dce6", "master"],
		["aqua 15", 27409, 27424, "#b9d6e4", "master"],
		["ray 12", 27425, 27440, "#b1934b", "master"],
		["icey 8", 27441, 27456, "#173ebd", "master"],
		["ray 13", 27457, 27472, "#8a8f89", "master"],
		["aqua 16", 27473, 27488, "#295771", "master"],
		["fir 8", 27489, 27504, "#15573d", "master"],
		["calm 21", 27505, 27520, "#548eb1", "master"],
		["palm 8", 27521, 27536, "#44c7ca", "master"],
		["light 14", 27537, 27552, "#184d4e", "master"],
		["green 16", 27553, 27568, "#4c6111", "master"],
		["rock 14", 27569, 27584, "#b2cbc8", "master"],
		["bluff 7", 27585, 27600, "#3f6e9a", "master"],
		["zeal 8", 27601, 27616, "#89bee6", "master"],
		["cover 14", 27617, 27632, "#90510a", "master"],
		["storm 8", 27633, 27648, "#548eb1", "master"],
		["grace 13", 27649, 27664, "#1b0d35", "master"],
		["shell 13", 27665, 27680, "#d0a973", "master"],
		["solis 8", 27681, 27696, "#d58265", "master"],
		["valley 30", 27697, 27712, "#7e93a8", "master"],
		["arrive 16", 27713, 27728, "#d3dbce", "master"],
		["shell 14", 27729, 27744, "#3d7ac9", "master"],
		["vivid 14", 27745, 27760, "#638cac", "master"],
		["wave 13", 27761, 27776, "#138cc5", "master"],
		["vast 15", 27777, 27792, "#ee9361", "master"],
		["freeze 8", 27793, 27808, "#73a0bd", "master"],
		["oak 8", 27809, 27824, "#609fdc", "master"],
		["chill 7", 27825, 27840, "#aaa2df", "master"],
		["lavish 7", 27841, 27856, "#856d1c", "master"],
		["pyre 8", 27857, 27872, "#451624", "master"],
		["vivid 15", 27873, 27888, "#609fdc", "master"],
		["vast 16", 27889, 27904, "#c7a884", "master"],
		["serene 14", 27905, 27920, "#b2cbc8", "master"],
		["fresh 14", 27921, 27936, "#c6dded", "master"],
		["strato 8", 27937, 27952, "#0a408a", "master"],
		["white 7", 27953, 27968, "#6d8cab", "master"],
		["fall 31", 27969, 27984, "#364821", "master"],
		["grace 14", 27985, 28000, "#0561d1", "master"],
		["red 14", 28001, 28016, "#675d45", "master"],
		["dry 8", 28017, 28032, "#0f46bf", "master"],
		["lake 18", 28033, 28048, "#d9ca87", "master"],
		["crest 15", 28049, 28064, "#b8abda", "master"],
		["birch 7", 28065, 28080, "#ccc6b7", "master"],
		["seed 8", 28081, 28096, "#b5674f", "master"],
		["coast 8", 28097, 28112, "#355732", "master"],
		["arise 16", 28113, 28128, "#0e3650", "master"],
		["wall 8", 28129, 28144, "#b5abb0", "master"],
		["dune 7", 28145, 28160, "#9fa7ee", "master"],
		["set 14", 28161, 28176, "#372f30", "master"],
		["brood 21", 28177, 28192, "#856d1c", "master"],
		["luna 8", 28193, 28208, "#051227", "master"],
		["lime 8", 28209, 28224, "#75a7dc", "master"],
		["climb 13", 28225, 28240, "#1d443b", "master"],
		["air 15", 28241, 28256, "#885c2d", "master"],
		["fall 32", 28257, 28272, "#3989b3", "master"],
		["drift 8", 28273, 28288, "#9fa7ee", "master"],
		["valley 31", 28289, 28304, "#c37966", "master"],
		["height 6", 28305, 28320, "#454c50", "master"],
		["fog 8", 28321, 28336, "#8c8237", "master"],
		["far 8", 28337, 28352, "#367bcb", "master"],
		["below 19", 28353, 28368, "#c1b8b4", "master"],
		["crest 16", 28369, 28384, "#b2c7d8", "master"],
		["gift 6", 28385, 28400, "#c797e8", "master"],
		["sierra 8", 28401, 28416, "#c36910", "master"],
		["amber 7", 28417, 28432, "#b5674f", "master"],
		["dawn 26", 28433, 28448, "#6a68c7", "master"],
		["river 20", 28449, 28464, "#587a75", "master"],
		["erode 6", 28465, 28480, "#5e92f3", "master"],
		["view 31", 28481, 28496, "#3b7fa6", "master"],
		["set 15", 28497, 28512, "#6b4a3e", "master"],
		["view 32", 28513, 28528, "#060a1f", "master"],
		["sand 15", 28529, 28544, "#1e558c", "master"],
		["mist 31", 28545, 28560, "#052d65", "master"],
		["up 9", 28561, 28576, "#2a7b93", "master"],
		["grass 7", 28577, 28592, "#32283c", "master"],
		["lines 9", 28593, 28608, "#4f80c0", "master"],
		["rapid 8", 28609, 28624, "#bad3e2", "master"],
		["glass 6", 28625, 28640, "#6e9ecf", "master"],
		["arise 17", 28641, 28656, "#385e76", "master"],
		["spire 15", 28657, 28672, "#bca6d7", "master"],
		["wind 9", 28673, 28688, "#f8e6d9", "master"],
		["mist 32", 28689, 28704, "#c1b8b4", "master"],
		["lake 19", 28705, 28720, "#84857f", "master"],
		["flat 9", 28721, 28736, "#3d90ce", "master"],
		["dawn 27", 28737, 28752, "#444b23", "master"],
		["calm 22", 28753, 28768, "#7e6064", "master"],
		["dawn 28", 28769, 28784, "#ae8b14", "master"],
		["bright 34", 28785, 28800, "#b2ba44", "master"],
		["hole 9", 28801, 28816, "#20202c", "master"],
		["dusk 7", 28817, 28832, "#5b447b", "master"],
		["shine 24", 28833, 28848, "#a3904f", "master"],
		["lush 14", 28849, 28864, "#263206", "master"],
		["river 21", 28865, 28880, "#c8dce6", "master"],
		["shine 25", 28881, 28896, "#2f387b", "master"],
		["emit 7", 28897, 28912, "#1c3528", "master"],
		["green 17", 28913, 28928, "#263206", "master"],
		["haze 8", 28929, 28944, "#4f80c0", "master"],
		["below 20", 28945, 28960, "#bad3e2", "master"],
		["valley 32", 28961, 28976, "#cea37e", "master"],
		["brook 14", 28977, 28992, "#566f3c", "master"],
		["bright 35", 28993, 29008, "#38423a", "master"],
		["brook 15", 29009, 29024, "#5e4144", "master"],
		["bright 36", 29025, 29040, "#52373c", "master"],
		["mossy 9", 29041, 29056, "#96c4df", "master"],
		["river 22", 29057, 29072, "#1b89d3", "master"],
		["star 9", 29073, 29088, "#3270cd", "master"],
		["mist 33", 29089, 29104, "#d6c3c5", "master"],
		["frond 16", 29105, 29120, "#3b4b18", "master"],
		["view 33", 29121, 29136, "#4186c8", "master"],
		["sky 13", 29137, 29152, "#081328", "master"],
		["bright 37", 29153, 29168, "#1f305b", "master"],
		["wild 8", 29169, 29184, "#1c600b", "master"],
		["sail 9", 29185, 29200, "#8da40a", "master"],
		["fall 33", 29201, 29216, "#43b2eb", "master"],
		["pebble 14", 29217, 29232, "#7e707b", "master"],
		["toad 17", 29233, 29248, "#264056", "master"],
		["shine 26", 29249, 29264, "#a17b63", "master"],
		["toad 18", 29265, 29280, "#898391", "master"],
		["pebble 15", 29281, 29296, "#E6E4B7", "master"],
		["leaf 19", 29297, 29312, "#779c35", "master"],
		["float 9", 29313, 29328, "#3a6daf", "master"],
		["beach 7", 29329, 29344, "#cdad81", "master"],
		["snow 9", 29345, 29360, "#bbc5d9", "master"],
		["grow 9", 29361, 29376, "#3d3a16", "master"],
		["cove 7", 29377, 29392, "#c3d0e0", "master"],
		["gaze 9", 29393, 29408, "#040c18", "master"],
		["fit 7", 29409, 29424, "#3b6fa7", "master"],
		["thick 9", 29425, 29440, "#3d3a16", "master"],
		["blue 9", 29441, 29456, "#dee6dc", "master"],
		["climb 14", 29457, 29472, "#4186c8", "master"],
		["aqua 17", 29473, 29488, "#b9d6e4", "master"],
		["ray 14", 29489, 29504, "#b1934b", "master"],
		["icey 9", 29505, 29520, "#173ebd", "master"],
		["ray 15", 29521, 29536, "#8a8f89", "master"],
		["wash 14", 29537, 29552, "#bd9794", "master"],
		["fir 9", 29553, 29568, "#15573d", "master"],
		["calm 23", 29569, 29584, "#548eb1", "master"],
		["palm 9", 29585, 29600, "#44c7ca", "master"],
		["light 15", 29601, 29616, "#184d4e", "master"],
		["grove 7", 29617, 29632, "#90510a", "master"],
		["rock 15", 29633, 29648, "#b2cbc8", "master"],
		["bluff 8", 29649, 29664, "#3f6e9a", "master"],
		["zeal 9", 29665, 29680, "#89bee6", "master"],
		["cover 15", 29681, 29696, "#90510a", "master"],
		["wave 14", 29697, 29712, "#138cc5", "master"],
		["grace 15", 29713, 29728, "#1b0d35", "master"],
		["shell 15", 29729, 29744, "#d0a973", "master"],
		["solis 9", 29745, 29760, "#d58265", "master"],
		["valley 33", 29761, 29776, "#7e93a8", "master"],
		["below 21", 29777, 29792, "#344f3d", "master"],
		["shell 16", 29793, 29808, "#3d7ac9", "master"],
		["vivid 16", 29809, 29824, "#638cac", "master"],
		["wave 15", 29825, 29840, "#138cc5", "master"],
		["vast 17", 29841, 29856, "#ee9361", "master"],
		["frost 7", 29857, 29872, "#bec8d1", "master"],
		["oak 9", 29873, 29888, "#609fdc", "master"],
		["chill 8", 29889, 29904, "#aaa2df", "master"],
		["lavish 8", 29905, 29920, "#856d1c", "master"],
		["pyre 9", 29921, 29936, "#451624", "master"],
		["red 15", 29937, 29952, "#6d1a10", "master"],
		["vast 18", 29953, 29968, "#c7a884", "master"],
		["serene 15", 29969, 29984, "#b2cbc8", "master"],
		["fresh 15", 29985, 30000, "#c6dded", "master"],
		["strato 9", 30001, 30016, "#0a408a", "master"],
		["arch 7", 30017, 30032, "#1778d2", "master"],
		["fall 34", 30033, 30048, "#364821", "master"],
		["grace 16", 30049, 30064, "#0561d1", "master"],
		["red 16", 30065, 30080, "#675d45", "master"],
		["dry 9", 30081, 30096, "#0f46bf", "master"],
		["sky 14", 30097, 30112, "#8a5425", "master"],
		["crest 17", 30113, 30128, "#b8abda", "master"],
		["birch 8", 30129, 30144, "#ccc6b7", "master"],
		["seed 9", 30145, 30160, "#b5674f", "master"],
		["coast 9", 30161, 30176, "#355732", "master"],
		["ripple 12", 30177, 30192, "#a7a3a0", "master"],
		["wall 9", 30193, 30208, "#b5abb0", "master"],
		["dune 8", 30209, 30224, "#9fa7ee", "master"],
		["set 16", 30225, 30240, "#372f30", "master"],
		["brood 22", 30241, 30256, "#856d1c", "master"],
		["cosmo 6", 30257, 30272, "#3b2446", "master"],
		["lime 9", 30273, 30288, "#75a7dc", "master"],
		["climb 15", 30289, 30304, "#1d443b", "master"],
		["air 16", 30305, 30320, "#885c2d", "master"],
		["fall 35", 30321, 30336, "#3989b3", "master"],
		["dawn 29", 30337, 30352, "#c36910", "master"],
		["valley 34", 30353, 30368, "#c37966", "master"],
		["height 7", 30369, 30384, "#454c50", "master"],
		["fog 9", 30385, 30400, "#8c8237", "master"],
		["far 9", 30401, 30416, "#367bcb", "master"],
		["pine 7", 30417, 30432, "#b2d4f5", "master"],
		["crest 18", 30433, 30448, "#b2c7d8", "master"],
		["gift 7", 30449, 30464, "#c797e8", "master"],
		["sierra 9", 30465, 30480, "#c36910", "master"],
		["amber 8", 30481, 30496, "#b5674f", "master"],
		["bright 38", 30497, 30512, "#355732", "master"],
		["river 23", 30513, 30528, "#587a75", "master"],
		["erode 7", 30529, 30544, "#5e92f3", "master"],
		["view 34", 30545, 30560, "#3b7fa6", "master"],
		["set 17", 30561, 30576, "#6b4a3e", "master"],
		["brood 23", 30577, 30592, "#71851e", "master"],
		["sand 16", 30593, 30608, "#1e558c", "master"],
		["mist 34", 30609, 30624, "#052d65", "master"],
		["up 10", 30625, 30640, "#2a7b93", "master"],
		["grass 8", 30641, 30656, "#32283c", "master"],
		["field 7", 30657, 30672, "#8da40a", "master"],
		["rapid 9", 30673, 30688, "#bad3e2", "master"],
		["glass 7", 30689, 30704, "#6e9ecf", "master"],
		["arise 18", 30705, 30720, "#385e76", "master"],
		["spire 16", 30721, 30736, "#bca6d7", "master"],
		["soar 7", 30737, 30752, "#367bcb", "master"],
		["mist 35", 30753, 30768, "#c1b8b4", "master"],
		["lake 20", 30769, 30784, "#84857f", "master"],
		["flat 10", 30785, 30800, "#3d90ce", "master"],
		["dawn 30", 30801, 30816, "#444b23", "master"],
		["leaf 20", 30817, 30832, "#516152", "master"],
		["dawn 31", 30833, 30848, "#ae8b14", "master"],
		["bright 39", 30849, 30864, "#b2ba44", "master"],
		["hole 10", 30865, 30880, "#20202c", "master"],
		["dusk 8", 30881, 30896, "#5b447b", "master"],
		["pond 7", 30897, 30912, "#36342a", "master"],
		["lush 15", 30913, 30928, "#263206", "master"],
		["river 24", 30929, 30944, "#c8dce6", "master"],
		["shine 27", 30945, 30960, "#2f387b", "master"],
		["emit 8", 30961, 30976, "#1c3528", "master"],
		["green 18", 30977, 30992, "#263206", "master"],
		["haze 9", 30993, 31008, "#4f80c0", "master"],
		["below 22", 31009, 31024, "#bad3e2", "master"],
		["valley 35", 31025, 31040, "#cea37e", "master"],
		["brook 16", 31041, 31056, "#566f3c", "master"],
		["bright 40", 31057, 31072, "#38423a", "master"],
		["brook 17", 31073, 31088, "#5e4144", "master"],
		["mist 36", 31089, 31104, "#714936", "master"],
		["mossy 10", 31105, 31120, "#96c4df", "master"],
		["river 25", 31121, 31136, "#1b89d3", "master"],
		["star 10", 31137, 31152, "#3270cd", "master"],
		["mist 37", 31153, 31168, "#d6c3c5", "master"],
		["curl 6", 31169, 31184, "#1c600b", "master"],
		["view 35", 31185, 31200, "#4186c8", "master"],
		["sky 15", 31201, 31216, "#081328", "master"],
		["bright 41", 31217, 31232, "#1f305b", "master"],
		["wild 9", 31233, 31248, "#1c600b", "master"],
		["depth 6", 31249, 31264, "#3a6daf", "master"],
		["fall 36", 31265, 31280, "#43b2eb", "master"],
		["pebble 16", 31281, 31296, "#7e707b", "master"],
		["toad 19", 31297, 31312, "#264056", "master"],
		["shine 28", 31313, 31328, "#a17b63", "master"],
		["azure 14", 31329, 31344, "#585e31", "master"],
		["pebble 17", 31345, 31360, "#E6E4B7", "master"],
		["leaf 21", 31361, 31376, "#779c35", "master"],
		["float 10", 31377, 31392, "#3a6daf", "master"],
		["beach 8", 31393, 31408, "#cdad81", "master"],
		["melt 7", 31409, 31424, "#2d6194", "master"],
		["grow 10", 31425, 31440, "#3d3a16", "master"],
		["cove 8", 31441, 31456, "#c3d0e0", "master"],
		["gaze 10", 31457, 31472, "#040c18", "master"],
		["fit 8", 31473, 31488, "#3b6fa7", "master"],
		["vine 7", 31489, 31504, "#4c6111", "master"],
		["blue 10", 31505, 31520, "#dee6dc", "master"],
		["climb 16", 31521, 31536, "#4186c8", "master"],
		["aqua 18", 31537, 31552, "#b9d6e4", "master"],
		["ray 16", 31553, 31568, "#b1934b", "master"],
		["lake 21", 31569, 31584, "#225c75", "master"],
		["ray 17", 31585, 31600, "#8a8f89", "master"],
		["wash 15", 31601, 31616, "#bd9794", "master"],
		["fir 10", 31617, 31632, "#15573d", "master"],
		["calm 24", 31633, 31648, "#548eb1", "master"],
		["shore 7", 31649, 31664, "#e0afae", "master"],
		["light 16", 31665, 31680, "#184d4e", "master"],
		["grove 8", 31681, 31696, "#90510a", "master"],
		["rock 16", 31697, 31712, "#b2cbc8", "master"],
		["bluff 9", 31713, 31728, "#3f6e9a", "master"],
		["opal 7", 31729, 31744, "#d49bc8", "master"],
		["cover 16", 31745, 31760, "#90510a", "master"],
		["wave 16", 31761, 31776, "#138cc5", "master"],
		["grace 17", 31777, 31792, "#1b0d35", "master"],
		["shell 17", 31793, 31808, "#d0a973", "master"],
		["polar 7", 31809, 31824, "#819864", "master"],
		["valley 36", 31825, 31840, "#7e93a8", "master"],
		["below 23", 31841, 31856, "#344f3d", "master"],
		["shell 18", 31857, 31872, "#3d7ac9", "master"],
		["vivid 17", 31873, 31888, "#638cac", "master"],
		["ripple 13", 31889, 31904, "#c7a884", "master"],
		["vast 19", 31905, 31920, "#ee9361", "master"],
		["frost 8", 31921, 31936, "#bec8d1", "master"],
		["oak 10", 31937, 31952, "#609fdc", "master"],
		["chill 9", 31953, 31968, "#aaa2df", "master"],
		["sea 7", 31969, 31984, "#6a68c7", "master"],
		["pyre 10", 31985, 32000, "#451624", "master"],
		["red 17", 32001, 32016, "#6d1a10", "master"],
		["vast 20", 32017, 32032, "#c7a884", "master"],
		["serene 16", 32033, 32048, "#b2cbc8", "master"],
		["view 36", 32049, 32064, "#3f6e9a", "master"],
		["strato 10", 32065, 32080, "#0a408a", "master"],
		["arch 8", 32081, 32096, "#1778d2", "master"],
		["fall 37", 32097, 32112, "#364821", "master"],
		["grace 18", 32113, 32128, "#0561d1", "master"],
		["bark 6", 32129, 32144, "#a17e5e", "master"],
		["dry 10", 32145, 32160, "#0f46bf", "master"],
		["sky 16", 32161, 32176, "#8a5425", "master"],
		["crest 19", 32177, 32192, "#b8abda", "master"],
		["birch 9", 32193, 32208, "#ccc6b7", "master"],
		["grain 6", 32209, 32224, "#f8e6d9", "master"],
		["coast 10", 32225, 32240, "#355732", "master"],
		["ripple 14", 32241, 32256, "#a7a3a0", "master"],
		["wall 10", 32257, 32272, "#b5abb0", "master"],
		["dune 9", 32273, 32288, "#9fa7ee", "master"],
		["calm 25", 32289, 32304, "#aaa2df", "master"],
		["brood 24", 32305, 32320, "#856d1c", "master"],
		["cosmo 7", 32321, 32336, "#3b2446", "master"],
		["lime 10", 32337, 32352, "#75a7dc", "master"],
		["climb 17", 32353, 32368, "#1d443b", "master"],
		["serene 17", 32369, 32384, "#664755", "master"],
		["fall 38", 32385, 32400, "#3989b3", "master"],
		["dawn 32", 32401, 32416, "#c36910", "master"],
		["valley 37", 32417, 32432, "#c37966", "master"],
		["height 8", 32433, 32448, "#454c50", "master"],
		["frond 17", 32449, 32464, "#cfc7a5", "master"],
		["far 10", 32465, 32480, "#367bcb", "master"],
		["pine 8", 32481, 32496, "#b2d4f5", "master"],
		["crest 20", 32497, 32512, "#b2c7d8", "master"],
		["gift 8", 32513, 32528, "#c797e8", "master"],
		["rock 17", 32529, 32544, "#1e558c", "master"],
		["amber 9", 32545, 32560, "#b5674f", "master"],
		["bright 42", 32561, 32576, "#355732", "master"],
		["river 26", 32577, 32592, "#587a75", "master"],
		["erode 8", 32593, 32608, "#5e92f3", "master"],
		["brood 25", 32609, 32624, "#85a7c8", "master"],
		["set 18", 32625, 32640, "#6b4a3e", "master"],
		["brood 26", 32641, 32656, "#71851e", "master"],
		["sand 17", 32657, 32672, "#1e558c", "master"],
		["mist 38", 32673, 32688, "#052d65", "master"],
		["valley 38", 32689, 32704, "#d5c284", "master"],
		["grass 9", 32705, 32720, "#32283c", "master"],
		["field 8", 32721, 32736, "#8da40a", "master"],
		["rapid 10", 32737, 32752, "#bad3e2", "master"],
		["glass 8", 32753, 32768, "#6e9ecf", "master"],
		["sol 8", 32769, 32784, "#0b545c", "master"],
		["spire 17", 32785, 32800, "#bca6d7", "master"],
		["soar 8", 32801, 32816, "#367bcb", "master"],
		["mist 39", 32817, 32832, "#c1b8b4", "master"],
		["lake 22", 32833, 32848, "#84857f", "master"],
		["flat 11", 32849, 32864, "#3d90ce", "master"],
		["dawn 33", 32865, 32880, "#444b23", "master"],
		["leaf 22", 32881, 32896, "#516152", "master"],
		["dawn 34", 32897, 32912, "#ae8b14", "master"],
		["bright 43", 32913, 32928, "#b2ba44", "master"],
		["hole 11", 32929, 32944, "#20202c", "master"],
		["dusk 9", 32945, 32960, "#5b447b", "master"],
		["pond 8", 32961, 32976, "#36342a", "master"],
		["lush 16", 32977, 32992, "#263206", "master"],
		["river 27", 32993, 33008, "#c8dce6", "master"],
		["shine 29", 33009, 33024, "#2f387b", "master"],
		["emit 9", 33025, 33040, "#1c3528", "master"],
		["lush 17", 33041, 33056, "#3b4b18", "master"],
		["haze 10", 33057, 33072, "#4f80c0", "master"],
		["below 24", 33073, 33088, "#bad3e2", "master"],
		["valley 39", 33089, 33104, "#cea37e", "master"],
		["brook 18", 33105, 33120, "#566f3c", "master"],
		["mist 40", 33121, 33136, "#a4c1c7", "master"],
		["brook 19", 33137, 33152, "#5e4144", "master"],
		["mist 41", 33153, 33168, "#714936", "master"],
		["mossy 11", 33169, 33184, "#96c4df", "master"],
		["river 28", 33185, 33200, "#1b89d3", "master"],
		["clear 8", 33201, 33216, "#40addf", "master"],
		["mist 42", 33217, 33232, "#d6c3c5", "master"],
		["curl 7", 33233, 33248, "#1c600b", "master"],
		["view 37", 33249, 33264, "#4186c8", "master"],
		["sky 17", 33265, 33280, "#081328", "master"],
		["space 8", 33281, 33296, "#2b2c41", "master"],
		["wild 10", 33297, 33312, "#1c600b", "master"],
		["depth 7", 33313, 33328, "#3a6daf", "master"],
		["fall 39", 33329, 33344, "#43b2eb", "master"],
		["pebble 18", 33345, 33360, "#7e707b", "master"],
		["azure 15", 33361, 33376, "#0f98b9", "master"],
		["shine 30", 33377, 33392, "#a17b63", "master"],
		["azure 16", 33393, 33408, "#585e31", "master"],
		["pebble 19", 33409, 33424, "#E6E4B7", "master"],
		["leaf 23", 33425, 33440, "#779c35", "master"],
		["breeze 8", 33441, 33456, "#dee6dc", "master"],
		["beach 9", 33457, 33472, "#cdad81", "master"],
		["melt 8", 33473, 33488, "#2d6194", "master"],
		["grow 11", 33489, 33504, "#3d3a16", "master"],
		["cove 9", 33505, 33520, "#c3d0e0", "master"],
		["light 17", 33521, 33536, "#0e0f1d", "master"],
		["fit 9", 33537, 33552, "#3b6fa7", "master"],
		["vine 8", 33553, 33568, "#4c6111", "master"],
		["blue 11", 33569, 33584, "#dee6dc", "master"],
		["climb 18", 33585, 33600, "#4186c8", "master"],
		["wash 16", 33601, 33616, "#756e8d", "master"],
		["ray 18", 33617, 33632, "#b1934b", "master"],
		["lake 23", 33633, 33648, "#225c75", "master"],
		["ray 19", 33649, 33664, "#8a8f89", "master"],
		["wash 17", 33665, 33680, "#bd9794", "master"],
		["cover 17", 33681, 33696, "#134f7b", "master"],
		["calm 26", 33697, 33712, "#548eb1", "master"],
		["shore 8", 33713, 33728, "#e0afae", "master"],
		["light 18", 33729, 33744, "#184d4e", "master"],
		["grove 9", 33745, 33760, "#90510a", "master"],
		["slope 8", 33761, 33776, "#372f30", "master"],
		["bluff 10", 33777, 33792, "#3f6e9a", "master"],
		["opal 8", 33793, 33808, "#d49bc8", "master"],
		["cover 18", 33809, 33824, "#90510a", "master"],
		["wave 17", 33825, 33840, "#138cc5", "master"],
		["air 17", 33841, 33856, "#c3d0e0", "master"],
		["shell 19", 33857, 33872, "#d0a973", "master"],
		["polar 8", 33873, 33888, "#819864", "master"],
		["valley 40", 33889, 33904, "#7e93a8", "master"],
		["below 25", 33905, 33920, "#344f3d", "master"],
		["fresh 16", 33921, 33936, "#42a198", "master"],
		["vivid 18", 33937, 33952, "#638cac", "master"],
		["ripple 15", 33953, 33968, "#c7a884", "master"],
		["vast 21", 33969, 33984, "#ee9361", "master"],
		["frost 9", 33985, 34000, "#bec8d1", "master"],
		["ruby 7", 34001, 34016, "#6d1a10", "master"],
		["chill 10", 34017, 34032, "#aaa2df", "master"],
		["sea 8", 34033, 34048, "#6a68c7", "master"],
		["pyre 11", 34049, 34064, "#451624", "master"],
		["red 18", 34065, 34080, "#6d1a10", "master"],
		["sand 18", 34081, 34096, "#0f46bf", "master"],
		["serene 18", 34097, 34112, "#b2cbc8", "master"],
		["view 38", 34113, 34128, "#3f6e9a", "master"],
		["strato 11", 34129, 34144, "#0a408a", "master"],
		["arch 9", 34145, 34160, "#1778d2", "master"],
		["above 15", 34161, 34176, "#cfd088", "master"],
		["grace 19", 34177, 34192, "#0561d1", "master"],
		["bark 7", 34193, 34208, "#a17e5e", "master"],
		["dry 11", 34209, 34224, "#0f46bf", "master"],
		["sky 18", 34225, 34240, "#8a5425", "master"],
		["peace 8", 34241, 34256, "#789395", "master"],
		["birch 10", 34257, 34272, "#ccc6b7", "master"],
		["grain 7", 34273, 34288, "#f8e6d9", "master"],
		["coast 11", 34289, 34304, "#355732", "master"],
		["ripple 16", 34305, 34320, "#a7a3a0", "master"],
		["bask 8", 34321, 34336, "#939aa5", "master"],
		["dune 10", 34337, 34352, "#9fa7ee", "master"],
		["calm 27", 34353, 34368, "#aaa2df", "master"],
		["brood 27", 34369, 34384, "#856d1c", "master"],
		["cosmo 8", 34385, 34400, "#3b2446", "master"],
		["arid 9", 34401, 34416, "#c5c3b7", "master"],
		["climb 19", 34417, 34432, "#1d443b", "master"],
		["serene 19", 34433, 34448, "#664755", "master"],
		["fall 40", 34449, 34464, "#3989b3", "master"],
		["dawn 35", 34465, 34480, "#c36910", "master"],
		["spire 18", 34481, 34496, "#36483b", "master"],
		["height 9", 34497, 34512, "#454c50", "master"],
		["frond 18", 34513, 34528, "#cfc7a5", "master"],
		["far 11", 34529, 34544, "#367bcb", "master"],
		["pine 9", 34545, 34560, "#b2d4f5", "master"],
		["still 9", 34561, 34576, "#c77fd2", "master"],
		["gift 9", 34577, 34592, "#c797e8", "master"],
		["rock 18", 34593, 34608, "#1e558c", "master"],
		["amber 10", 34609, 34624, "#b5674f", "master"],
		["bright 44", 34625, 34640, "#355732", "master"],
		["range 9", 34641, 34656, "#34447a", "master"],
		["erode 9", 34657, 34672, "#5e92f3", "master"],
		["brood 28", 34673, 34688, "#85a7c8", "master"],
		["set 19", 34689, 34704, "#6b4a3e", "master"],
		["brood 29", 34705, 34720, "#71851e", "master"],
		["sand 19", 34721, 34736, "#1e558c", "master"],
		["mist 43", 34737, 34752, "#052d65", "master"],
		["valley 41", 34753, 34768, "#d5c284", "master"],
		["grass 10", 34769, 34784, "#32283c", "master"],
		["field 9", 34785, 34800, "#8da40a", "master"],
		["rapid 11", 34801, 34816, "#bad3e2", "master"],
		["glass 9", 34817, 34832, "#6e9ecf", "master"],
		["sol 9", 34833, 34848, "#0b545c", "master"],
		["spire 19", 34849, 34864, "#bca6d7", "master"],
		["soar 9", 34865, 34880, "#367bcb", "master"],
		["mist 44", 34881, 34896, "#c1b8b4", "master"],
		["lake 24", 34897, 34912, "#84857f", "master"],
		["leaf 24", 34913, 34928, "#daee95", "master"],
		["dawn 36", 34929, 34944, "#444b23", "master"],
		["leaf 25", 34945, 34960, "#516152", "master"],
		["dawn 37", 34961, 34976, "#ae8b14", "master"],
		["bright 45", 34977, 34992, "#b2ba44", "master"],
		["curve 8", 34993, 35008, "#904024", "master"],
		["dusk 10", 35009, 35024, "#5b447b", "master"],
		["pond 9", 35025, 35040, "#36342a", "master"],
		["lush 18", 35041, 35056, "#263206", "master"],
		["river 29", 35057, 35072, "#c8dce6", "master"],
		["watch 8", 35073, 35088, "#0a2a41", "master"],
		["emit 10", 35089, 35104, "#1c3528", "master"],
		["lush 19", 35105, 35120, "#3b4b18", "master"],
		["haze 11", 35121, 35136, "#4f80c0", "master"],
		["below 26", 35137, 35152, "#bad3e2", "master"],
		["wood 9", 35153, 35168, "#b2aaa4", "master"],
		["brook 20", 35169, 35184, "#566f3c", "master"],
		["mist 45", 35185, 35200, "#a4c1c7", "master"],
		["brook 21", 35201, 35216, "#5e4144", "master"],
		["mist 46", 35217, 35232, "#714936", "master"],
		["fall 41", 35233, 35248, "#7a5d2b", "master"],
		["river 30", 35249, 35264, "#1b89d3", "master"],
		["clear 9", 35265, 35280, "#40addf", "master"],
		["mist 47", 35281, 35296, "#d6c3c5", "master"],
		["curl 8", 35297, 35312, "#1c600b", "master"],
		["marsh 9", 35313, 35328, "#1b0d35", "master"],
		["sky 19", 35329, 35344, "#081328", "master"],
		["space 9", 35345, 35360, "#2b2c41", "master"],
		["wild 11", 35361, 35376, "#1c600b", "master"],
		["depth 8", 35377, 35392, "#3a6daf", "master"],
		["above 16", 35393, 35408, "#c8dce6", "master"],
		["pebble 20", 35409, 35424, "#7e707b", "master"],
		["azure 17", 35425, 35440, "#0f98b9", "master"],
		["shine 31", 35441, 35456, "#a17b63", "master"],
		["azure 18", 35457, 35472, "#585e31", "master"],
		["aqua 19", 35473, 35488, "#295771", "master"],
		["leaf 26", 35489, 35504, "#779c35", "master"],
		["breeze 9", 35505, 35520, "#dee6dc", "master"],
		["beach 10", 35521, 35536, "#cdad81", "master"],
		["melt 9", 35537, 35552, "#2d6194", "master"],
		["green 19", 35553, 35568, "#4c6111", "master"],
		["cove 10", 35569, 35584, "#c3d0e0", "master"],
		["light 19", 35585, 35600, "#0e0f1d", "master"],
		["fit 10", 35601, 35616, "#3b6fa7", "master"],
		["vine 9", 35617, 35632, "#4c6111", "master"],
		["storm 9", 35633, 35648, "#548eb1", "master"],
		["climb 20", 35649, 35664, "#4186c8", "master"],
		["wash 18", 35665, 35680, "#756e8d", "master"],
		["ray 20", 35681, 35696, "#b1934b", "master"],
		["lake 25", 35697, 35712, "#225c75", "master"],
		["arrive 17", 35713, 35728, "#d3dbce", "master"],
		["wash 19", 35729, 35744, "#bd9794", "master"],
		["cover 19", 35745, 35760, "#134f7b", "master"],
		["calm 28", 35761, 35776, "#548eb1", "master"],
		["shore 9", 35777, 35792, "#e0afae", "master"],
		["freeze 9", 35793, 35808, "#73a0bd", "master"],
		["grove 10", 35809, 35824, "#90510a", "master"],
		["slope 9", 35825, 35840, "#372f30", "master"],
		["bluff 11", 35841, 35856, "#3f6e9a", "master"],
		["opal 9", 35857, 35872, "#d49bc8", "master"],
		["vivid 19", 35873, 35888, "#609fdc", "master"],
		["wave 18", 35889, 35904, "#138cc5", "master"],
		["air 18", 35905, 35920, "#c3d0e0", "master"],
		["shell 20", 35921, 35936, "#d0a973", "master"],
		["polar 9", 35937, 35952, "#819864", "master"],
		["white 8", 35953, 35968, "#6d8cab", "master"],
		["below 27", 35969, 35984, "#344f3d", "master"],
		["fresh 17", 35985, 36000, "#42a198", "master"],
		["vivid 20", 36001, 36016, "#638cac", "master"],
		["ripple 17", 36017, 36032, "#c7a884", "master"],
		["lake 26", 36033, 36048, "#d9ca87", "master"],
		["frost 10", 36049, 36064, "#bec8d1", "master"],
		["ruby 8", 36065, 36080, "#6d1a10", "master"],
		["chill 11", 36081, 36096, "#aaa2df", "master"],
		["sea 9", 36097, 36112, "#6a68c7", "master"],
		["arise 19", 36113, 36128, "#0e3650", "master"],
		["red 19", 36129, 36144, "#6d1a10", "master"],
		["sand 20", 36145, 36160, "#0f46bf", "master"],
		["serene 20", 36161, 36176, "#b2cbc8", "master"],
		["view 39", 36177, 36192, "#3f6e9a", "master"],
		["luna 9", 36193, 36208, "#051227", "master"],
		["arch 10", 36209, 36224, "#1778d2", "master"],
		["above 17", 36225, 36240, "#cfd088", "master"],
		["grace 20", 36241, 36256, "#0561d1", "master"],
		["bark 8", 36257, 36272, "#a17e5e", "master"],
		["drift 9", 36273, 36288, "#9fa7ee", "master"],
		["sky 20", 36289, 36304, "#8a5425", "master"],
		["peace 9", 36305, 36320, "#789395", "master"],
		["birch 11", 36321, 36336, "#ccc6b7", "master"],
		["grain 8", 36337, 36352, "#f8e6d9", "master"],
		["below 28", 36353, 36368, "#c1b8b4", "master"],
		["ripple 18", 36369, 36384, "#a7a3a0", "master"],
		["bask 9", 36385, 36400, "#939aa5", "master"],
		["dune 11", 36401, 36416, "#9fa7ee", "master"],
		["calm 29", 36417, 36432, "#aaa2df", "master"],
		["dawn 38", 36433, 36448, "#6a68c7", "master"],
		["cosmo 9", 36449, 36464, "#3b2446", "master"],
		["arid 10", 36465, 36480, "#c5c3b7", "master"],
		["climb 21", 36481, 36496, "#1d443b", "master"],
		["serene 21", 36497, 36512, "#664755", "master"],
		["view 40", 36513, 36528, "#060a1f", "master"],
		["dawn 39", 36529, 36544, "#c36910", "master"],
		["spire 20", 36545, 36560, "#36483b", "master"],
		["height 10", 36561, 36576, "#454c50", "master"],
		["frond 19", 36577, 36592, "#cfc7a5", "master"],
		["lines 10", 36593, 36608, "#4f80c0", "master"],
		["pine 10", 36609, 36624, "#b2d4f5", "master"],
		["still 10", 36625, 36640, "#c77fd2", "master"],
		["gift 10", 36641, 36656, "#c797e8", "master"],
		["rock 19", 36657, 36672, "#1e558c", "master"],
		["amber 11", 36673, 36688, "#b5674f", "master"],
		["bright 46", 36689, 36704, "#355732", "master"],
		["range 10", 36705, 36720, "#34447a", "master"],
		["erode 10", 36721, 36736, "#5e92f3", "master"],
		["brood 30", 36737, 36752, "#85a7c8", "master"],
		["set 20", 36753, 36768, "#6b4a3e", "master"],
		["brood 31", 36769, 36784, "#71851e", "master"],
		["rise 9", 36785, 36800, "#bca6d7", "master"],
		["mist 48", 36801, 36816, "#052d65", "master"],
		["valley 42", 36817, 36832, "#d5c284", "master"],
		["grass 11", 36833, 36848, "#32283c", "master"],
		["field 10", 36849, 36864, "#8da40a", "master"],
		["cliff 9", 36865, 36880, "#43b2eb", "master"],
		["glass 10", 36881, 36896, "#6e9ecf", "master"],
		["sol 10", 36897, 36912, "#0b545c", "master"],
		["spire 21", 36913, 36928, "#bca6d7", "master"],
		["soar 10", 36929, 36944, "#367bcb", "master"],
		["arrive 18", 36945, 36960, "#b2d4f5", "master"],
		["lake 27", 36961, 36976, "#84857f", "master"],
		["leaf 27", 36977, 36992, "#daee95", "master"],
		["dawn 40", 36993, 37008, "#444b23", "master"],
		["leaf 28", 37009, 37024, "#516152", "master"],
		["bright 47", 37025, 37056, "#52373c", "master"],
		["curve 9", 37057, 37072, "#904024", "master"],
		["dusk 11", 37073, 37088, "#5b447b", "master"],
		["pond 10", 37089, 37104, "#36342a", "master"],
		["frond 20", 37105, 37120, "#3b4b18", "master"],
		["river 31", 37121, 37136, "#c8dce6", "master"],
		["watch 9", 37137, 37152, "#0a2a41", "master"],
		["emit 11", 37153, 37168, "#1c3528", "master"],
		["lush 20", 37169, 37184, "#3b4b18", "master"],
		["sail 10", 37185, 37200, "#8da40a", "master"],
		["below 29", 37201, 37216, "#bad3e2", "master"],
		["wood 10", 37217, 37232, "#b2aaa4", "master"],
		["brook 22", 37233, 37248, "#566f3c", "master"],
		["mist 49", 37249, 37264, "#a4c1c7", "master"],
		["toad 20", 37265, 37280, "#898391", "master"],
		["mist 50", 37281, 37296, "#714936", "master"],
		["fall 42", 37297, 37312, "#7a5d2b", "master"],
		["river 32", 37313, 37328, "#1b89d3", "master"],
		["clear 10", 37329, 37344, "#40addf", "master"],
		["snow 10", 37345, 37360, "#bbc5d9", "master"],
		["curl 9", 37361, 37376, "#1c600b", "master"],
		["marsh 10", 37377, 37392, "#1b0d35", "master"],
		["sky 21", 37393, 37408, "#081328", "master"],
		["space 10", 37409, 37424, "#2b2c41", "master"],
		["thick 10", 37425, 37440, "#3d3a16", "master"],
		["depth 9", 37441, 37456, "#3a6daf", "master"],
		["above 18", 37457, 37472, "#c8dce6", "master"],
		["pebble 21", 37473, 37488, "#7e707b", "master"],
		["azure 19", 37489, 37504, "#0f98b9", "master"],
		["icey 10", 37505, 37520, "#173ebd", "master"],
		["azure 20", 37521, 37536, "#585e31", "master"],
		["aqua 20", 37537, 37552, "#295771", "master"],
		["leaf 29", 37553, 37568, "#779c35", "master"],
		["breeze 10", 37569, 37584, "#dee6dc", "master"],
		["palm 10", 37585, 37600, "#44c7ca", "master"],
		["melt 10", 37601, 37616, "#2d6194", "master"],
		["green 20", 37617, 37632, "#4c6111", "master"],
		["cove 11", 37633, 37648, "#c3d0e0", "master"],
		["light 20", 37649, 37664, "#0e0f1d", "master"],
		["zeal 10", 37665, 37680, "#89bee6", "master"],
		["vine 10", 37681, 37696, "#4c6111", "master"],
		["storm 10", 37697, 37712, "#548eb1", "master"],
		["climb 22", 37713, 37728, "#4186c8", "master"],
		["wash 20", 37729, 37744, "#756e8d", "master"],
		["solis 10", 37745, 37760, "#d58265", "master"],
		["lake 28", 37761, 37776, "#225c75", "master"],
		["arrive 19", 37777, 37792, "#d3dbce", "master"],
		["wash 21", 37793, 37808, "#bd9794", "master"],
		["cover 20", 37809, 37824, "#134f7b", "master"],
		["wave 19", 37825, 37840, "#138cc5", "master"],
		["shore 10", 37841, 37856, "#e0afae", "master"],
		["freeze 10", 37857, 37872, "#73a0bd", "master"],
		["grove 11", 37873, 37888, "#90510a", "master"],
		["slope 10", 37889, 37904, "#372f30", "master"],
		["lavish 9", 37905, 37920, "#856d1c", "master"],
		["opal 10", 37921, 37936, "#d49bc8", "master"],
		["vivid 21", 37937, 37952, "#609fdc", "master"],
		["wave 20", 37953, 37968, "#138cc5", "master"],
		["air 19", 37969, 37984, "#c3d0e0", "master"],
		["fresh 18", 37985, 38000, "#c6dded", "master"],
		["polar 10", 38001, 38016, "#819864", "master"],
		["white 9", 38017, 38032, "#6d8cab", "master"],
		["below 30", 38033, 38048, "#344f3d", "master"],
		["fresh 19", 38049, 38064, "#42a198", "master"],
		["red 20", 38065, 38080, "#675d45", "master"],
		["ripple 19", 38081, 38096, "#c7a884", "master"],
		["lake 29", 38097, 38112, "#d9ca87", "master"],
		["frost 11", 38113, 38128, "#bec8d1", "master"],
		["ruby 9", 38129, 38144, "#6d1a10", "master"],
		["seed 10", 38145, 38160, "#b5674f", "master"],
		["sea 10", 38161, 38176, "#6a68c7", "master"],
		["arise 20", 38177, 38192, "#0e3650", "master"],
		["red 21", 38193, 38208, "#6d1a10", "master"],
		["sand 21", 38209, 38224, "#0f46bf", "master"],
		["set 21", 38225, 38240, "#372f30", "master"],
		["view 41", 38241, 38256, "#3f6e9a", "master"],
		["luna 10", 38257, 38272, "#051227", "master"],
		["arch 11", 38273, 38288, "#1778d2", "master"],
		["above 19", 38289, 38304, "#cfd088", "master"],
		["air 20", 38305, 38320, "#885c2d", "master"],
		["bark 9", 38321, 38336, "#a17e5e", "master"],
		["drift 10", 38337, 38352, "#9fa7ee", "master"],
		["sky 22", 38353, 38368, "#8a5425", "master"],
		["peace 10", 38369, 38384, "#789395", "master"],
		["fog 10", 38385, 38400, "#8c8237", "master"],
		["grain 9", 38401, 38416, "#f8e6d9", "master"],
		["below 31", 38417, 38432, "#c1b8b4", "master"],
		["ripple 20", 38433, 38448, "#a7a3a0", "master"],
		["bask 10", 38449, 38464, "#939aa5", "master"],
		["sierra 10", 38465, 38480, "#c36910", "master"],
		["calm 30", 38481, 38496, "#aaa2df", "master"],
		["dawn 41", 38497, 38512, "#6a68c7", "master"],
		["cosmo 10", 38513, 38528, "#3b2446", "master"],
		["arid 11", 38529, 38544, "#c5c3b7", "master"],
		["climb 23", 38545, 38560, "#1d443b", "master"],
		["serene 22", 38561, 38576, "#664755", "master"],
		["view 42", 38577, 38592, "#060a1f", "master"],
		["dawn 42", 38593, 38608, "#c36910", "master"],
		["spire 22", 38609, 38624, "#36483b", "master"],
		["height 11", 38625, 38640, "#454c50", "master"],
		["frond 21", 38641, 38656, "#cfc7a5", "master"],
		["lines 11", 38657, 38672, "#4f80c0", "master"],
		["pine 11", 38673, 38688, "#b2d4f5", "master"],
		["still 11", 38689, 38704, "#c77fd2", "master"],
		["gift 11", 38705, 38720, "#c797e8", "master"],
		["rock 20", 38721, 38736, "#1e558c", "master"],
		["wind 10", 38737, 38752, "#f8e6d9", "master"],
		["bright 48", 38753, 38768, "#355732", "master"],
		["range 11", 38769, 38784, "#34447a", "master"],
		["erode 11", 38785, 38800, "#5e92f3", "master"],
		["brood 32", 38801, 38816, "#85a7c8", "master"],
		["calm 31", 38817, 38832, "#7e6064", "master"],
		["brood 33", 38833, 38848, "#71851e", "master"],
		["rise 10", 38849, 38864, "#bca6d7", "master"],
		["mist 51", 38865, 38880, "#052d65", "master"],
		["valley 43", 38881, 38896, "#d5c284", "master"],
		["shine 32", 38897, 38912, "#a3904f", "master"],
		["field 11", 38913, 38928, "#8da40a", "master"],
		["cliff 10", 38929, 38944, "#43b2eb", "master"],
		["glass 11", 38945, 38960, "#6e9ecf", "master"],
		["sol 11", 38961, 38976, "#0b545c", "master"],
		["green 21", 38977, 38992, "#263206", "master"],
		["soar 11", 38993, 39008, "#367bcb", "master"],
		["arrive 20", 39009, 39024, "#b2d4f5", "master"],
		["lake 30", 39025, 39040, "#84857f", "master"],
		["leaf 30", 39041, 39056, "#daee95", "master"],
		["bright 49", 39057, 39072, "#38423a", "master"],
		["leaf 31", 39073, 39088, "#516152", "master"],
		["bright 50", 39089, 39120, "#52373c", "master"],
		["curve 10", 39121, 39136, "#904024", "master"],
		["star 11", 39137, 39152, "#3270cd", "master"],
		["pond 11", 39153, 39168, "#36342a", "master"],
		["frond 22", 39169, 39184, "#3b4b18", "master"],
		["river 33", 39185, 39200, "#c8dce6", "master"],
		["watch 10", 39201, 39216, "#0a2a41", "master"],
		["bright 51", 39217, 39232, "#1f305b", "master"],
		["lush 21", 39233, 39248, "#3b4b18", "master"],
		["sail 11", 39249, 39264, "#8da40a", "master"],
		["below 32", 39265, 39280, "#bad3e2", "master"],
		["wood 11", 39281, 39296, "#b2aaa4", "master"],
		["toad 21", 39297, 39312, "#264056", "master"],
		["mist 52", 39313, 39328, "#a4c1c7", "master"],
		["toad 22", 39329, 39344, "#898391", "master"],
		["mist 53", 39345, 39360, "#714936", "master"],
		["fall 43", 39361, 39376, "#7a5d2b", "master"],
		["float 11", 39377, 39392, "#3a6daf", "master"],
		["clear 11", 39393, 39408, "#40addf", "master"],
		["snow 11", 39409, 39424, "#bbc5d9", "master"],
		["curl 10", 39425, 39440, "#1c600b", "master"],
		["marsh 11", 39441, 39456, "#1b0d35", "master"],
		["gaze 11", 39457, 39472, "#040c18", "master"],
		["space 11", 39473, 39488, "#2b2c41", "master"],
		["thick 11", 39489, 39504, "#3d3a16", "master"],
		["depth 10", 39505, 39520, "#3a6daf", "master"],
		["above 20", 39521, 39536, "#c8dce6", "master"],
		["aqua 21", 39537, 39552, "#b9d6e4", "master"],
		["azure 21", 39553, 39568, "#0f98b9", "master"],
		["icey 11", 39569, 39584, "#173ebd", "master"],
		["azure 22", 39585, 39600, "#585e31", "master"],
		["aqua 22", 39601, 39616, "#295771", "master"],
		["fir 11", 39617, 39632, "#15573d", "master"],
		["breeze 11", 39633, 39648, "#dee6dc", "master"],
		["palm 11", 39649, 39664, "#44c7ca", "master"],
		["melt 11", 39665, 39680, "#2d6194", "master"],
		["green 22", 39681, 39696, "#4c6111", "master"],
		["rock 21", 39697, 39712, "#b2cbc8", "master"],
		["light 21", 39713, 39728, "#0e0f1d", "master"],
		["zeal 11", 39729, 39744, "#89bee6", "master"],
		["vine 11", 39745, 39760, "#4c6111", "master"],
		["storm 11", 39761, 39776, "#548eb1", "master"],
		["grace 21", 39777, 39792, "#1b0d35", "master"],
		["wash 22", 39793, 39808, "#756e8d", "master"],
		["solis 11", 39809, 39824, "#d58265", "master"],
		["lake 31", 39825, 39840, "#225c75", "master"],
		["arrive 21", 39841, 39856, "#d3dbce", "master"],
		["shell 21", 39857, 39872, "#3d7ac9", "master"],
		["cover 21", 39873, 39888, "#134f7b", "master"],
		["wave 21", 39889, 39904, "#138cc5", "master"],
		["shore 11", 39905, 39920, "#e0afae", "master"],
		["freeze 11", 39921, 39936, "#73a0bd", "master"],
		["oak 11", 39937, 39952, "#609fdc", "master"],
		["slope 11", 39953, 39968, "#372f30", "master"],
		["lavish 10", 39969, 39984, "#856d1c", "master"],
		["opal 11", 39985, 40000, "#d49bc8", "master"],
		["vivid 22", 40001, 40016, "#609fdc", "master"],
		["vast 22", 40017, 40032, "#c7a884", "master"],
		["air 21", 40033, 40048, "#c3d0e0", "master"],
		["fresh 20", 40049, 40064, "#c6dded", "master"],
		["polar 11", 40065, 40080, "#819864", "master"],
		["white 10", 40081, 40096, "#6d8cab", "master"],
		["fall 44", 40097, 40112, "#364821", "master"],
		["fresh 21", 40113, 40128, "#42a198", "master"],
		["red 22", 40129, 40144, "#675d45", "master"],
		["ripple 21", 40145, 40160, "#c7a884", "master"],
		["lake 32", 40161, 40176, "#d9ca87", "master"],
		["crest 21", 40177, 40192, "#b8abda", "master"],
		["ruby 10", 40193, 40208, "#6d1a10", "master"],
		["seed 11", 40209, 40224, "#b5674f", "master"],
		["sea 11", 40225, 40240, "#6a68c7", "master"],
		["arise 21", 40241, 40256, "#0e3650", "master"],
		["wall 11", 40257, 40272, "#b5abb0", "master"],
		["sand 22", 40273, 40288, "#0f46bf", "master"],
		["set 22", 40289, 40304, "#372f30", "master"],
		["view 43", 40305, 40320, "#3f6e9a", "master"],
		["luna 11", 40321, 40336, "#051227", "master"],
		["lime 11", 40337, 40352, "#75a7dc", "master"],
		["above 21", 40353, 40368, "#cfd088", "master"],
		["air 22", 40369, 40384, "#885c2d", "master"],
		["bark 10", 40385, 40400, "#a17e5e", "master"],
		["drift 11", 40401, 40416, "#9fa7ee", "master"],
		["valley 44", 40417, 40432, "#c37966", "master"],
		["peace 11", 40433, 40448, "#789395", "master"],
		["fog 11", 40449, 40464, "#8c8237", "master"],
		["grain 10", 40465, 40480, "#f8e6d9", "master"],
		["below 33", 40481, 40496, "#c1b8b4", "master"],
		["ripple 22", 40497, 40512, "#a7a3a0", "master"],
		["bask 11", 40513, 40528, "#939aa5", "master"],
		["sierra 11", 40529, 40544, "#c36910", "master"],
		["calm 32", 40545, 40560, "#aaa2df", "master"],
		["dawn 43", 40561, 40576, "#6a68c7", "master"],
		["cosmo 11", 40577, 40592, "#3b2446", "master"],
		["arid 12", 40593, 40608, "#c5c3b7", "master"],
		["view 44", 40609, 40624, "#3b7fa6", "master"],
		["serene 23", 40625, 40640, "#664755", "master"],
		["view 45", 40641, 40656, "#060a1f", "master"],
		["dawn 44", 40657, 40672, "#c36910", "master"],
		["spire 23", 40673, 40688, "#36483b", "master"],
		["up 11", 40689, 40704, "#2a7b93", "master"],
		["frond 23", 40705, 40720, "#cfc7a5", "master"],
		["lines 12", 40721, 40736, "#4f80c0", "master"],
		["pine 12", 40737, 40752, "#b2d4f5", "master"],
		["still 12", 40753, 40768, "#c77fd2", "master"],
		["arise 22", 40769, 40784, "#385e76", "master"],
		["rock 22", 40785, 40800, "#1e558c", "master"],
		["wind 11", 40801, 40816, "#f8e6d9", "master"],
		["bright 52", 40817, 40832, "#355732", "master"],
		["range 12", 40833, 40848, "#34447a", "master"],
		["flat 12", 40849, 40864, "#3d90ce", "master"],
		["brood 34", 40865, 40880, "#85a7c8", "master"],
		["calm 33", 40881, 40896, "#7e6064", "master"],
		["brood 35", 40897, 40912, "#71851e", "master"],
		["rise 11", 40913, 40928, "#bca6d7", "master"],
		["hole 12", 40929, 40944, "#20202c", "master"],
		["valley 45", 40945, 40960, "#d5c284", "master"],
		["shine 33", 40961, 40976, "#a3904f", "master"],
		["field 12", 40977, 40992, "#8da40a", "master"],
		["cliff 11", 40993, 41008, "#43b2eb", "master"],
		["shine 34", 41009, 41024, "#2f387b", "master"],
		["sol 12", 41025, 41040, "#0b545c", "master"],
		["green 23", 41041, 41056, "#263206", "master"],
		["soar 12", 41057, 41072, "#367bcb", "master"],
		["arrive 22", 41073, 41088, "#b2d4f5", "master"],
		["valley 46", 41089, 41104, "#cea37e", "master"],
		["leaf 32", 41105, 41120, "#daee95", "master"],
		["bright 53", 41121, 41136, "#38423a", "master"],
		["leaf 33", 41137, 41152, "#516152", "master"],
		["bright 54", 41153, 41168, "#52373c", "master"],
		["mossy 12", 41169, 41184, "#96c4df", "master"],
		["curve 11", 41185, 41200, "#904024", "master"],
		["star 12", 41201, 41216, "#3270cd", "master"],
		["pond 12", 41217, 41232, "#36342a", "master"],
		["frond 24", 41233, 41248, "#3b4b18", "master"],
		["view 46", 41249, 41264, "#4186c8", "master"],
		["watch 11", 41265, 41280, "#0a2a41", "master"],
		["bright 55", 41281, 41296, "#1f305b", "master"],
		["lush 22", 41297, 41312, "#3b4b18", "master"],
		["sail 12", 41313, 41328, "#8da40a", "master"],
		["fall 45", 41329, 41344, "#43b2eb", "master"],
		["wood 12", 41345, 41360, "#b2aaa4", "master"],
		["toad 23", 41361, 41376, "#264056", "master"],
		["mist 54", 41377, 41392, "#a4c1c7", "master"],
		["toad 24", 41393, 41408, "#898391", "master"],
		["pebble 22", 41409, 41424, "#E6E4B7", "master"],
		["fall 46", 41425, 41440, "#7a5d2b", "master"],
		["float 12", 41441, 41456, "#3a6daf", "master"],
		["clear 12", 41457, 41472, "#40addf", "master"],
		["snow 12", 41473, 41488, "#bbc5d9", "master"],
		["grow 12", 41489, 41504, "#3d3a16", "master"],
		["marsh 12", 41505, 41520, "#1b0d35", "master"],
		["gaze 12", 41521, 41536, "#040c18", "master"],
		["space 12", 41537, 41552, "#2b2c41", "master"],
		["thick 12", 41553, 41568, "#3d3a16", "master"],
		["blue 12", 41569, 41584, "#dee6dc", "master"],
		["above 22", 41585, 41600, "#c8dce6", "master"],
		["aqua 23", 41601, 41616, "#b9d6e4", "master"],
		["azure 23", 41617, 41632, "#0f98b9", "master"],
		["icey 12", 41633, 41648, "#173ebd", "master"],
		["ray 21", 41649, 41664, "#8a8f89", "master"],
		["aqua 24", 41665, 41680, "#295771", "master"],
		["fir 12", 41681, 41696, "#15573d", "master"],
		["breeze 12", 41697, 41712, "#dee6dc", "master"],
		["palm 12", 41713, 41728, "#44c7ca", "master"],
		["light 22", 41729, 41744, "#184d4e", "master"],
		["green 24", 41745, 41760, "#4c6111", "master"],
		["rock 23", 41761, 41776, "#b2cbc8", "master"],
		["light 23", 41777, 41792, "#0e0f1d", "master"],
		["zeal 12", 41793, 41808, "#89bee6", "master"],
		["cover 22", 41809, 41824, "#90510a", "master"],
		["storm 12", 41825, 41840, "#548eb1", "master"],
		["grace 22", 41841, 41856, "#1b0d35", "master"],
		["wash 23", 41857, 41872, "#756e8d", "master"],
		["solis 12", 41873, 41888, "#d58265", "master"],
		["valley 47", 41889, 41904, "#7e93a8", "master"],
		["arrive 23", 41905, 41920, "#d3dbce", "master"],
		["shell 22", 41921, 41936, "#3d7ac9", "master"],
		["cover 23", 41937, 41952, "#134f7b", "master"],
		["wave 22", 41953, 41968, "#138cc5", "master"],
		["vast 23", 41969, 41984, "#ee9361", "master"],
		["freeze 12", 41985, 42000, "#73a0bd", "master"],
		["oak 12", 42001, 42016, "#609fdc", "master"],
		["slope 12", 42017, 42032, "#372f30", "master"],
		["lavish 11", 42033, 42048, "#856d1c", "master"],
		["pyre 12", 42049, 42064, "#451624", "master"],
		["vivid 23", 42065, 42080, "#609fdc", "master"],
		["vast 24", 42081, 42096, "#c7a884", "master"],
		["air 23", 42097, 42112, "#c3d0e0", "master"],
		["fresh 22", 42113, 42128, "#c6dded", "master"],
		["strato 12", 42129, 42144, "#0a408a", "master"],
		["white 11", 42145, 42160, "#6d8cab", "master"],
		["fall 47", 42161, 42176, "#364821", "master"],
		["fresh 23", 42177, 42192, "#42a198", "master"],
		["red 23", 42193, 42208, "#675d45", "master"],
		["dry 12", 42209, 42224, "#0f46bf", "master"],
		["lake 33", 42225, 42240, "#d9ca87", "master"],
		["crest 22", 42241, 42256, "#b8abda", "master"],
		["ruby 11", 42257, 42272, "#6d1a10", "master"],
		["seed 12", 42273, 42288, "#b5674f", "master"],
		["coast 12", 42289, 42304, "#355732", "master"],
		["arise 23", 42305, 42320, "#0e3650", "master"],
		["wall 12", 42321, 42336, "#b5abb0", "master"],
		["sand 23", 42337, 42352, "#0f46bf", "master"],
		["set 23", 42353, 42368, "#372f30", "master"],
		["view 47", 42369, 42384, "#3f6e9a", "master"],
		["luna 12", 42385, 42400, "#051227", "master"],
		["lime 12", 42401, 42416, "#75a7dc", "master"],
		["above 23", 42417, 42432, "#cfd088", "master"],
		["air 24", 42433, 42448, "#885c2d", "master"],
		["bark 11", 42449, 42464, "#a17e5e", "master"],
		["drift 12", 42465, 42480, "#9fa7ee", "master"],
		["valley 48", 42481, 42496, "#c37966", "master"],
		["peace 12", 42497, 42512, "#789395", "master"],
		["fog 12", 42513, 42528, "#8c8237", "master"],
		["grain 11", 42529, 42544, "#f8e6d9", "master"],
		["below 34", 42545, 42560, "#c1b8b4", "master"],
		["crest 23", 42561, 42576, "#b2c7d8", "master"],
		["bask 12", 42577, 42592, "#939aa5", "master"],
		["sierra 12", 42593, 42608, "#c36910", "master"],
		["calm 34", 42609, 42624, "#aaa2df", "master"],
		["dawn 45", 42625, 42640, "#6a68c7", "master"],
		["river 34", 42641, 42656, "#587a75", "master"],
		["arid 13", 42657, 42672, "#c5c3b7", "master"],
		["view 48", 42673, 42688, "#3b7fa6", "master"],
		["serene 24", 42689, 42704, "#664755", "master"],
		["view 49", 42705, 42720, "#060a1f", "master"],
		["sand 24", 42721, 42736, "#1e558c", "master"],
		["spire 24", 42737, 42752, "#36483b", "master"],
		["up 12", 42753, 42768, "#2a7b93", "master"],
		["frond 25", 42769, 42784, "#cfc7a5", "master"],
		["lines 13", 42785, 42800, "#4f80c0", "master"],
		["rapid 12", 42801, 42816, "#bad3e2", "master"],
		["still 13", 42817, 42832, "#c77fd2", "master"],
		["arise 24", 42833, 42848, "#385e76", "master"],
		["rock 24", 42849, 42864, "#1e558c", "master"],
		["wind 12", 42865, 42880, "#f8e6d9", "master"],
		["mist 55", 42881, 42896, "#c1b8b4", "master"],
		["range 13", 42897, 42912, "#34447a", "master"],
		["flat 13", 42913, 42928, "#3d90ce", "master"],
		["brood 36", 42929, 42944, "#85a7c8", "master"],
		["calm 35", 42945, 42960, "#7e6064", "master"],
		["dawn 46", 42961, 42976, "#ae8b14", "master"],
		["rise 12", 42977, 42992, "#bca6d7", "master"],
		["hole 13", 42993, 43008, "#20202c", "master"],
		["valley 49", 43009, 43024, "#d5c284", "master"],
		["shine 35", 43025, 43040, "#a3904f", "master"],
		["lush 23", 43041, 43056, "#263206", "master"],
		["cliff 12", 43057, 43072, "#43b2eb", "master"],
		["shine 36", 43073, 43088, "#2f387b", "master"],
		["sol 13", 43089, 43104, "#0b545c", "master"],
		["green 25", 43105, 43120, "#263206", "master"],
		["haze 12", 43121, 43136, "#4f80c0", "master"],
		["arrive 24", 43137, 43152, "#b2d4f5", "master"],
		["valley 50", 43153, 43168, "#cea37e", "master"],
		["leaf 34", 43169, 43184, "#daee95", "master"],
		["bright 56", 43185, 43200, "#38423a", "master"],
		["brook 23", 43201, 43216, "#5e4144", "master"],
		["bright 57", 43217, 43232, "#52373c", "master"],
		["mossy 13", 43233, 43248, "#96c4df", "master"],
		["curve 12", 43249, 43264, "#904024", "master"],
		["star 13", 43265, 43280, "#3270cd", "master"],
		["mist 56", 43281, 43296, "#d6c3c5", "master"],
		["frond 26", 43297, 43312, "#3b4b18", "master"],
		["view 50", 43313, 43328, "#4186c8", "master"],
		["watch 12", 43329, 43344, "#0a2a41", "master"],
		["bright 58", 43345, 43360, "#1f305b", "master"],
		["wild 12", 43361, 43376, "#1c600b", "master"],
		["sail 13", 43377, 43392, "#8da40a", "master"],
		["fall 48", 43393, 43408, "#43b2eb", "master"],
		["wood 13", 43409, 43424, "#b2aaa4", "master"],
		["toad 25", 43425, 43440, "#264056", "master"],
		["shine 37", 43441, 43456, "#a17b63", "master"],
		["toad 26", 43457, 43472, "#898391", "master"],
		["pebble 23", 43473, 43488, "#E6E4B7", "master"],
		["fall 49", 43489, 43504, "#7a5d2b", "master"],
		["float 13", 43505, 43520, "#3a6daf", "master"],
		["beach 11", 43521, 43536, "#cdad81", "master"],
		["snow 13", 43537, 43552, "#bbc5d9", "master"],
		["grow 13", 43553, 43568, "#3d3a16", "master"],
		["marsh 13", 43569, 43584, "#1b0d35", "master"],
		["gaze 13", 43585, 43600, "#040c18", "master"],
		["fit 11", 43601, 43616, "#3b6fa7", "master"],
		["thick 13", 43617, 43632, "#3d3a16", "master"],
		["blue 13", 43633, 43648, "#dee6dc", "master"],
		["above 24", 43649, 43664, "#c8dce6", "master"],
		["aqua 25", 43665, 43680, "#b9d6e4", "master"],
		["ray 22", 43681, 43696, "#b1934b", "master"],
		["icey 13", 43697, 43712, "#173ebd", "master"],
		["ray 23", 43713, 43728, "#8a8f89", "master"],
		["aqua 26", 43729, 43744, "#295771", "master"],
		["fir 13", 43745, 43760, "#15573d", "master"],
		["calm 36", 43761, 43776, "#548eb1", "master"],
		["palm 13", 43777, 43792, "#44c7ca", "master"],
		["light 24", 43793, 43808, "#184d4e", "master"],
		["green 26", 43809, 43824, "#4c6111", "master"],
		["rock 25", 43825, 43840, "#b2cbc8", "master"],
		["bluff 12", 43841, 43856, "#3f6e9a", "master"],
		["zeal 13", 43857, 43872, "#89bee6", "master"],
		["cover 24", 43873, 43888, "#90510a", "master"],
		["storm 13", 43889, 43904, "#548eb1", "master"],
		["grace 23", 43905, 43920, "#1b0d35", "master"],
		["shell 23", 43921, 43936, "#d0a973", "master"],
		["solis 13", 43937, 43952, "#d58265", "master"],
		["valley 51", 43953, 43968, "#7e93a8", "master"],
		["arrive 25", 43969, 43984, "#d3dbce", "master"],
		["shell 24", 43985, 44000, "#3d7ac9", "master"],
		["vivid 24", 44001, 44016, "#638cac", "master"],
		["wave 23", 44017, 44032, "#138cc5", "master"],
		["vast 25", 44033, 44048, "#ee9361", "master"],
		["freeze 13", 44049, 44064, "#73a0bd", "master"],
		["oak 13", 44065, 44080, "#609fdc", "master"],
		["chill 12", 44081, 44096, "#aaa2df", "master"],
		["lavish 12", 44097, 44112, "#856d1c", "master"],
		["pyre 13", 44113, 44128, "#451624", "master"],
		["vivid 25", 44129, 44144, "#609fdc", "master"],
		["vast 26", 44145, 44160, "#c7a884", "master"],
		["serene 25", 44161, 44176, "#b2cbc8", "master"],
		["fresh 24", 44177, 44192, "#c6dded", "master"],
		["strato 13", 44193, 44208, "#0a408a", "master"],
		["white 12", 44209, 44224, "#6d8cab", "master"],
		["fall 50", 44225, 44240, "#364821", "master"],
		["grace 24", 44241, 44256, "#0561d1", "master"],
		["red 24", 44257, 44272, "#675d45", "master"],
		["dry 13", 44273, 44288, "#0f46bf", "master"],
		["lake 34", 44289, 44304, "#d9ca87", "master"],
		["crest 24", 44305, 44320, "#b8abda", "master"],
		["ruby 12", 44321, 44336, "#6d1a10", "master"],
		["seed 13", 44337, 44352, "#b5674f", "master"],
		["coast 13", 44353, 44368, "#355732", "master"],
		["arise 25", 44369, 44384, "#0e3650", "master"],
		["wall 13", 44385, 44400, "#b5abb0", "master"],
		["sand 25", 44401, 44416, "#0f46bf", "master"],
		["set 24", 44417, 44432, "#372f30", "master"],
		["brood 37", 44433, 44448, "#856d1c", "master"],
		["luna 13", 44449, 44464, "#051227", "master"],
		["lime 13", 44465, 44480, "#75a7dc", "master"],
		["above 25", 44481, 44496, "#cfd088", "master"],
		["air 25", 44497, 44512, "#885c2d", "master"],
		["fall 51", 44513, 44528, "#3989b3", "master"],
		["drift 13", 44529, 44544, "#9fa7ee", "master"],
		["valley 52", 44545, 44560, "#c37966", "master"],
		["peace 13", 44561, 44576, "#789395", "master"],
		["fog 13", 44577, 44592, "#8c8237", "master"],
		["far 12", 44593, 44608, "#367bcb", "master"],
		["below 35", 44609, 44624, "#c1b8b4", "master"],
		["crest 25", 44625, 44640, "#b2c7d8", "master"],
		["bask 13", 44641, 44656, "#939aa5", "master"],
		["sierra 13", 44657, 44672, "#c36910", "master"],
		["amber 12", 44673, 44688, "#b5674f", "master"],
		["dawn 47", 44689, 44704, "#6a68c7", "master"],
		["river 35", 44705, 44720, "#587a75", "master"],
		["arid 14", 44721, 44736, "#c5c3b7", "master"],
		["view 51", 44737, 44752, "#3b7fa6", "master"],
		["set 25", 44753, 44768, "#6b4a3e", "master"],
		["view 52", 44769, 44784, "#060a1f", "master"],
		["sand 26", 44785, 44800, "#1e558c", "master"],
		["spire 25", 44801, 44816, "#36483b", "master"],
		["up 13", 44817, 44832, "#2a7b93", "master"],
		["grass 12", 44833, 44848, "#32283c", "master"],
		["lines 14", 44849, 44864, "#4f80c0", "master"],
		["rapid 13", 44865, 44880, "#bad3e2", "master"],
		["still 14", 44881, 44896, "#c77fd2", "master"],
		["arise 26", 44897, 44912, "#385e76", "master"],
		["spire 26", 44913, 44928, "#bca6d7", "master"],
		["wind 13", 44929, 44944, "#f8e6d9", "master"],
		["mist 57", 44945, 44960, "#c1b8b4", "master"],
		["range 14", 44961, 44976, "#34447a", "master"],
		["flat 14", 44977, 44992, "#3d90ce", "master"],
		["dawn 48", 44993, 45008, "#444b23", "master"],
		["calm 37", 45009, 45024, "#7e6064", "master"],
		["dawn 49", 45025, 45040, "#ae8b14", "master"],
		["rise 13", 45041, 45056, "#bca6d7", "master"],
		["hole 14", 45057, 45072, "#20202c", "master"],
		["dusk 12", 45073, 45088, "#5b447b", "master"],
		["shine 38", 45089, 45104, "#a3904f", "master"],
		["lush 24", 45105, 45120, "#263206", "master"],
		["cliff 13", 45121, 45136, "#43b2eb", "master"],
		["shine 39", 45137, 45152, "#2f387b", "master"],
		["emit 12", 45153, 45168, "#1c3528", "master"],
		["green 27", 45169, 45184, "#263206", "master"],
		["haze 13", 45185, 45200, "#4f80c0", "master"],
		["arrive 26", 45201, 45216, "#b2d4f5", "master"],
		["valley 53", 45217, 45232, "#cea37e", "master"],
		["brook 24", 45233, 45248, "#566f3c", "master"],
		["bright 59", 45249, 45264, "#38423a", "master"],
		["brook 25", 45265, 45280, "#5e4144", "master"],
		["bright 60", 45281, 45296, "#52373c", "master"],
		["mossy 14", 45297, 45312, "#96c4df", "master"],
		["river 36", 45313, 45328, "#1b89d3", "master"],
		["star 14", 45329, 45344, "#3270cd", "master"],
		["mist 58", 45345, 45360, "#d6c3c5", "master"],
		["frond 27", 45361, 45376, "#3b4b18", "master"],
		["view 53", 45377, 45392, "#4186c8", "master"],
		["sky 23", 45393, 45408, "#081328", "master"],
		["bright 61", 45409, 45424, "#1f305b", "master"],
		["wild 13", 45425, 45440, "#1c600b", "master"],
		["sail 14", 45441, 45456, "#8da40a", "master"],
		["fall 52", 45457, 45472, "#43b2eb", "master"],
		["pebble 24", 45473, 45488, "#7e707b", "master"],
		["toad 27", 45489, 45504, "#264056", "master"],
		["shine 40", 45505, 45520, "#a17b63", "master"],
		["toad 28", 45521, 45536, "#898391", "master"],
		["pebble 25", 45537, 45552, "#E6E4B7", "master"],
		["leaf 35", 45553, 45568, "#779c35", "master"],
		["float 14", 45569, 45584, "#3a6daf", "master"],
		["beach 12", 45585, 45600, "#cdad81", "master"],
		["snow 14", 45601, 45616, "#bbc5d9", "master"],
		["grow 14", 45617, 45632, "#3d3a16", "master"],
		["cove 12", 45633, 45648, "#c3d0e0", "master"],
		["gaze 14", 45649, 45664, "#040c18", "master"],
		["fit 12", 45665, 45680, "#3b6fa7", "master"],
		["thick 14", 45681, 45696, "#3d3a16", "master"],
		["blue 14", 45697, 45712, "#dee6dc", "master"],
		["climb 24", 45713, 45728, "#4186c8", "master"],
		["aqua 27", 45729, 45744, "#b9d6e4", "master"],
		["ray 24", 45745, 45760, "#b1934b", "master"],
		["icey 14", 45761, 45776, "#173ebd", "master"],
		["ray 25", 45777, 45792, "#8a8f89", "master"],
		["wash 24", 45793, 45808, "#bd9794", "master"],
		["fir 14", 45809, 45824, "#15573d", "master"],
		["calm 38", 45825, 45840, "#548eb1", "master"],
		["palm 14", 45841, 45856, "#44c7ca", "master"],
		["light 25", 45857, 45872, "#184d4e", "master"],
		["grove 12", 45873, 45888, "#90510a", "master"],
		["rock 26", 45889, 45904, "#b2cbc8", "master"],
		["bluff 13", 45905, 45920, "#3f6e9a", "master"],
		["zeal 14", 45921, 45936, "#89bee6", "master"],
		["cover 25", 45937, 45952, "#90510a", "master"],
		["wave 24", 45953, 45968, "#138cc5", "master"],
		["grace 25", 45969, 45984, "#1b0d35", "master"],
		["shell 25", 45985, 46000, "#d0a973", "master"],
		["solis 14", 46001, 46016, "#d58265", "master"],
		["valley 54", 46017, 46032, "#7e93a8", "master"],
		["below 36", 46033, 46048, "#344f3d", "master"],
		["shell 26", 46049, 46064, "#3d7ac9", "master"],
		["vivid 26", 46065, 46080, "#638cac", "master"],
		["wave 25", 46081, 46096, "#138cc5", "master"],
		["vast 27", 46097, 46112, "#ee9361", "master"],
		["frost 12", 46113, 46128, "#bec8d1", "master"],
		["oak 14", 46129, 46144, "#609fdc", "master"],
		["chill 13", 46145, 46160, "#aaa2df", "master"],
		["lavish 13", 46161, 46176, "#856d1c", "master"],
		["pyre 14", 46177, 46192, "#451624", "master"],
		["vivid 27", 46193, 46208, "#609fdc", "master"],
		["vast 28", 46209, 46224, "#c7a884", "master"],
		["serene 26", 46225, 46240, "#b2cbc8", "master"],
		["fresh 25", 46241, 46256, "#c6dded", "master"],
		["strato 14", 46257, 46272, "#0a408a", "master"],
		["white 13", 46273, 46288, "#6d8cab", "master"],
		["fall 53", 46289, 46304, "#364821", "master"],
		["grace 26", 46305, 46320, "#0561d1", "master"],
		["red 25", 46321, 46336, "#675d45", "master"],
		["dry 14", 46337, 46352, "#0f46bf", "master"],
		["lake 35", 46353, 46368, "#d9ca87", "master"],
		["crest 26", 46369, 46384, "#b8abda", "master"],
		["birch 12", 46385, 46400, "#ccc6b7", "master"],
		["seed 14", 46401, 46416, "#b5674f", "master"],
		["coast 14", 46417, 46432, "#355732", "master"],
		["arise 27", 46433, 46448, "#0e3650", "master"],
		["wall 14", 46449, 46464, "#b5abb0", "master"],
		["dune 12", 46465, 46480, "#9fa7ee", "master"],
		["set 26", 46481, 46496, "#372f30", "master"],
		["brood 38", 46497, 46512, "#856d1c", "master"],
		["luna 14", 46513, 46528, "#051227", "master"],
		["lime 14", 46529, 46544, "#75a7dc", "master"],
		["climb 25", 46545, 46560, "#1d443b", "master"],
		["air 26", 46561, 46576, "#885c2d", "master"],
		["fall 54", 46577, 46592, "#3989b3", "master"],
		["drift 14", 46593, 46608, "#9fa7ee", "master"],
		["valley 55", 46609, 46624, "#c37966", "master"],
		["height 12", 46625, 46640, "#454c50", "master"],
		["fog 14", 46641, 46656, "#8c8237", "master"],
		["far 13", 46657, 46672, "#367bcb", "master"],
		["below 37", 46673, 46688, "#c1b8b4", "master"],
		["crest 27", 46689, 46704, "#b2c7d8", "master"],
		["gift 12", 46705, 46720, "#c797e8", "master"],
		["sierra 14", 46721, 46736, "#c36910", "master"],
		["amber 13", 46737, 46752, "#b5674f", "master"],
		["dawn 50", 46753, 46768, "#6a68c7", "master"],
		["river 37", 46769, 46784, "#587a75", "master"],
		["erode 12", 46785, 46800, "#5e92f3", "master"],
		["view 54", 46801, 46816, "#3b7fa6", "master"],
		["set 27", 46817, 46832, "#6b4a3e", "master"],
		["view 55", 46833, 46848, "#060a1f", "master"],
		["sand 27", 46849, 46864, "#1e558c", "master"],
		["mist 59", 46865, 46880, "#052d65", "master"],
		["up 14", 46881, 46896, "#2a7b93", "master"],
		["grass 13", 46897, 46912, "#32283c", "master"],
		["lines 15", 46913, 46928, "#4f80c0", "master"],
		["rapid 14", 46929, 46944, "#bad3e2", "master"],
		["glass 12", 46945, 46960, "#6e9ecf", "master"],
		["arise 28", 46961, 46976, "#385e76", "master"],
		["spire 27", 46977, 46992, "#bca6d7", "master"],
		["wind 14", 46993, 47008, "#f8e6d9", "master"],
		["mist 60", 47009, 47024, "#c1b8b4", "master"],
		["lake 36", 47025, 47040, "#84857f", "master"],
		["flat 15", 47041, 47056, "#3d90ce", "master"],
		["dawn 51", 47057, 47072, "#444b23", "master"],
		["calm 39", 47073, 47088, "#7e6064", "master"],
		["dawn 52", 47089, 47104, "#ae8b14", "master"],
		["bright 62", 47105, 47120, "#b2ba44", "master"],
		["hole 15", 47121, 47136, "#20202c", "master"],
		["dusk 13", 47137, 47152, "#5b447b", "master"],
		["shine 41", 47153, 47168, "#a3904f", "master"],
		["lush 25", 47169, 47184, "#263206", "master"],
		["river 38", 47185, 47200, "#c8dce6", "master"],
		["shine 42", 47201, 47216, "#2f387b", "master"],
		["emit 13", 47217, 47232, "#1c3528", "master"],
		["green 28", 47233, 47248, "#263206", "master"],
		["haze 14", 47249, 47264, "#4f80c0", "master"],
		["below 38", 47265, 47280, "#bad3e2", "master"],
		["valley 56", 47281, 47296, "#cea37e", "master"],
		["brook 26", 47297, 47312, "#566f3c", "master"],
		["bright 63", 47313, 47328, "#38423a", "master"],
		["brook 27", 47329, 47344, "#5e4144", "master"],
		["mist 61", 47345, 47360, "#714936", "master"],
		["mossy 15", 47361, 47376, "#96c4df", "master"],
		["river 39", 47377, 47392, "#1b89d3", "master"],
		["star 15", 47393, 47408, "#3270cd", "master"],
		["mist 62", 47409, 47424, "#d6c3c5", "master"],
		["curl 11", 47425, 47440, "#1c600b", "master"],
		["view 56", 47441, 47456, "#4186c8", "master"],
		["sky 24", 47457, 47472, "#081328", "master"],
		["bright 64", 47473, 47488, "#1f305b", "master"],
		["wild 14", 47489, 47504, "#1c600b", "master"],
		["depth 11", 47505, 47520, "#3a6daf", "master"],
		["fall 55", 47521, 47536, "#43b2eb", "master"],
		["pebble 26", 47537, 47552, "#7e707b", "master"],
		["toad 29", 47553, 47568, "#264056", "master"],
		["shine 43", 47569, 47584, "#a17b63", "master"],
		["azure 24", 47585, 47600, "#585e31", "master"],
		["pebble 27", 47601, 47616, "#E6E4B7", "master"],
		["leaf 36", 47617, 47632, "#779c35", "master"],
		["float 15", 47633, 47648, "#3a6daf", "master"],
		["beach 13", 47649, 47664, "#cdad81", "master"],
		["melt 12", 47665, 47680, "#2d6194", "master"],
		["grow 15", 47681, 47696, "#3d3a16", "master"],
		["cove 13", 47697, 47712, "#c3d0e0", "master"],
		["gaze 15", 47713, 47728, "#040c18", "master"],
		["fit 13", 47729, 47744, "#3b6fa7", "master"],
		["vine 12", 47745, 47760, "#4c6111", "master"],
		["blue 15", 47761, 47776, "#dee6dc", "master"],
		["climb 26", 47777, 47792, "#4186c8", "master"],
		["aqua 28", 47793, 47808, "#b9d6e4", "master"],
		["ray 26", 47809, 47824, "#b1934b", "master"],
		["lake 37", 47825, 47840, "#225c75", "master"],
		["ray 27", 47841, 47856, "#8a8f89", "master"],
		["wash 25", 47857, 47872, "#bd9794", "master"],
		["fir 15", 47873, 47888, "#15573d", "master"],
		["calm 40", 47889, 47904, "#548eb1", "master"],
		["shore 12", 47905, 47920, "#e0afae", "master"],
		["light 26", 47921, 47936, "#184d4e", "master"],
		["grove 13", 47937, 47952, "#90510a", "master"],
		["rock 27", 47953, 47968, "#b2cbc8", "master"],
		["bluff 14", 47969, 47984, "#3f6e9a", "master"],
		["opal 12", 47985, 48000, "#d49bc8", "master"],
		["cover 26", 48001, 48016, "#90510a", "master"],
		["wave 26", 48017, 48032, "#138cc5", "master"],
		["grace 27", 48033, 48048, "#1b0d35", "master"],
		["shell 27", 48049, 48064, "#d0a973", "master"],
		["polar 12", 48065, 48080, "#819864", "master"],
		["valley 57", 48081, 48096, "#7e93a8", "master"],
		["below 39", 48097, 48112, "#344f3d", "master"],
		["shell 28", 48113, 48128, "#3d7ac9", "master"],
		["vivid 28", 48129, 48144, "#638cac", "master"],
		["wave 27", 48145, 48160, "#138cc5", "master"],
		["vast 29", 48161, 48176, "#ee9361", "master"],
		["frost 13", 48177, 48192, "#bec8d1", "master"],
		["oak 15", 48193, 48208, "#609fdc", "master"],
		["chill 14", 48209, 48224, "#aaa2df", "master"],
		["lavish 14", 48225, 48240, "#856d1c", "master"],
		["pyre 15", 48241, 48256, "#451624", "master"],
		["red 26", 48257, 48272, "#6d1a10", "master"],
		["vast 30", 48273, 48288, "#c7a884", "master"],
		["serene 27", 48289, 48304, "#b2cbc8", "master"],
		["fresh 26", 48305, 48320, "#c6dded", "master"],
		["strato 15", 48321, 48336, "#0a408a", "master"],
		["arch 12", 48337, 48352, "#1778d2", "master"],
		["fall 56", 48353, 48368, "#364821", "master"],
		["grace 28", 48369, 48384, "#0561d1", "master"],
		["red 27", 48385, 48400, "#675d45", "master"],
		["dry 15", 48401, 48416, "#0f46bf", "master"],
		["sky 25", 48417, 48432, "#8a5425", "master"],
		["crest 28", 48433, 48448, "#b8abda", "master"],
		["birch 13", 48449, 48464, "#ccc6b7", "master"],
		["seed 15", 48465, 48480, "#b5674f", "master"],
		["coast 15", 48481, 48496, "#355732", "master"],
		["ripple 23", 48497, 48512, "#a7a3a0", "master"],
		["wall 15", 48513, 48528, "#b5abb0", "master"],
		["dune 13", 48529, 48544, "#9fa7ee", "master"],
		["set 28", 48545, 48560, "#372f30", "master"],
		["brood 39", 48561, 48576, "#856d1c", "master"],
		["cosmo 12", 48577, 48592, "#3b2446", "master"],
		["lime 15", 48593, 48608, "#75a7dc", "master"],
		["climb 27", 48609, 48624, "#1d443b", "master"],
		["air 27", 48625, 48640, "#885c2d", "master"],
		["fall 57", 48641, 48656, "#3989b3", "master"],
		["dawn 53", 48657, 48672, "#c36910", "master"],
		["valley 58", 48673, 48688, "#c37966", "master"],
		["height 13", 48689, 48704, "#454c50", "master"],
		["fog 15", 48705, 48720, "#8c8237", "master"],
		["far 14", 48721, 48736, "#367bcb", "master"],
		["pine 13", 48737, 48752, "#b2d4f5", "master"],
		["crest 29", 48753, 48768, "#b2c7d8", "master"],
		["gift 13", 48769, 48784, "#c797e8", "master"],
		["sierra 15", 48785, 48800, "#c36910", "master"],
		["amber 14", 48801, 48816, "#b5674f", "master"],
		["bright 65", 48817, 48832, "#355732", "master"],
		["river 40", 48833, 48848, "#587a75", "master"],
		["erode 13", 48849, 48864, "#5e92f3", "master"],
		["view 57", 48865, 48880, "#3b7fa6", "master"],
		["set 29", 48881, 48896, "#6b4a3e", "master"],
		["brood 40", 48897, 48912, "#71851e", "master"],
		["sand 28", 48913, 48928, "#1e558c", "master"],
		["mist 63", 48929, 48944, "#052d65", "master"],
		["up 15", 48945, 48960, "#2a7b93", "master"],
		["grass 14", 48961, 48976, "#32283c", "master"],
		["field 13", 48977, 48992, "#8da40a", "master"],
		["rapid 15", 48993, 49008, "#bad3e2", "master"],
		["glass 13", 49009, 49024, "#6e9ecf", "master"],
		["arise 29", 49025, 49040, "#385e76", "master"],
		["spire 28", 49041, 49056, "#bca6d7", "master"],
		["soar 13", 49057, 49072, "#367bcb", "master"],
		["mist 64", 49073, 49088, "#c1b8b4", "master"],
		["lake 38", 49089, 49104, "#84857f", "master"],
		["flat 16", 49105, 49120, "#3d90ce", "master"],
		["dawn 54", 49121, 49136, "#444b23", "master"],
		["leaf 37", 49137, 49152, "#516152", "master"],
		["dawn 55", 49153, 49168, "#ae8b14", "master"],
		["bright 66", 49169, 49184, "#b2ba44", "master"],
		["hole 16", 49185, 49200, "#20202c", "master"],
		["dusk 14", 49201, 49216, "#5b447b", "master"],
		["pond 13", 49217, 49232, "#36342a", "master"],
		["lush 26", 49233, 49248, "#263206", "master"],
		["river 41", 49249, 49264, "#c8dce6", "master"],
		["shine 44", 49265, 49280, "#2f387b", "master"],
		["emit 14", 49281, 49296, "#1c3528", "master"],
		["lush 27", 49297, 49312, "#3b4b18", "master"],
		["haze 15", 49313, 49328, "#4f80c0", "master"],
		["below 40", 49329, 49344, "#bad3e2", "master"],
		["valley 59", 49345, 49360, "#cea37e", "master"],
		["brook 28", 49361, 49376, "#566f3c", "master"],
		["mist 65", 49377, 49392, "#a4c1c7", "master"],
		["brook 29", 49393, 49408, "#5e4144", "master"],
		["mist 66", 49409, 49424, "#714936", "master"],
		["mossy 16", 49425, 49440, "#96c4df", "master"],
		["river 42", 49441, 49456, "#1b89d3", "master"],
		["clear 13", 49457, 49472, "#40addf", "master"],
		["mist 67", 49473, 49488, "#d6c3c5", "master"],
		["curl 12", 49489, 49504, "#1c600b", "master"],
		["view 58", 49505, 49520, "#4186c8", "master"],
		["sky 26", 49521, 49536, "#081328", "master"],
		["space 13", 49537, 49552, "#2b2c41", "master"],
		["wild 15", 49553, 49568, "#1c600b", "master"],
		["depth 12", 49569, 49584, "#3a6daf", "master"],
		["fall 58", 49585, 49600, "#43b2eb", "master"],
		["pebble 28", 49601, 49616, "#7e707b", "master"],
		["azure 25", 49617, 49632, "#0f98b9", "master"],
		["shine 45", 49633, 49648, "#a17b63", "master"],
		["azure 26", 49649, 49664, "#585e31", "master"],
		["pebble 29", 49665, 49680, "#E6E4B7", "master"],
		["leaf 38", 49681, 49696, "#779c35", "master"],
		["breeze 13", 49697, 49712, "#dee6dc", "master"],
		["beach 14", 49713, 49728, "#cdad81", "master"],
		["melt 13", 49729, 49744, "#2d6194", "master"],
		["grow 16", 49745, 49760, "#3d3a16", "master"],
		["cove 14", 49761, 49776, "#c3d0e0", "master"],
		["light 27", 49777, 49792, "#0e0f1d", "master"],
		["fit 14", 49793, 49808, "#3b6fa7", "master"],
		["vine 13", 49809, 49824, "#4c6111", "master"],
		["blue 16", 49825, 49840, "#dee6dc", "master"],
		["climb 28", 49841, 49856, "#4186c8", "master"],
		["wash 26", 49857, 49872, "#756e8d", "master"],
		["ray 28", 49873, 49888, "#b1934b", "master"],
		["lake 39", 49889, 49904, "#225c75", "master"],
		["ray 29", 49905, 49920, "#8a8f89", "master"],
		["wash 27", 49921, 49936, "#bd9794", "master"],
		["cover 27", 49937, 49952, "#134f7b", "master"],
		["calm 41", 49953, 49968, "#548eb1", "master"],
		["shore 13", 49969, 49984, "#e0afae", "master"],
		["light 28", 49985, 50000, "#184d4e", "master"],
		["grove 14", 50001, 50016, "#90510a", "master"],
		["rock 28", 50017, 50032, "#b2cbc8", "master"],
		["bluff 15", 50033, 50048, "#3f6e9a", "master"],
		["opal 13", 50049, 50064, "#d49bc8", "master"],
		["cover 28", 50065, 50080, "#90510a", "master"],
		["wave 28", 50081, 50096, "#138cc5", "master"],
		["grace 29", 50097, 50112, "#1b0d35", "master"],
		["shell 29", 50113, 50128, "#d0a973", "master"],
		["polar 13", 50129, 50144, "#819864", "master"],
		["valley 60", 50145, 50160, "#7e93a8", "master"],
		["below 41", 50161, 50176, "#344f3d", "master"],
		["shell 30", 50177, 50192, "#3d7ac9", "master"],
		["vivid 29", 50193, 50208, "#638cac", "master"],
		["ripple 24", 50209, 50224, "#c7a884", "master"],
		["vast 31", 50225, 50240, "#ee9361", "master"],
		["frost 14", 50241, 50256, "#bec8d1", "master"],
		["oak 16", 50257, 50272, "#609fdc", "master"],
		["chill 15", 50273, 50288, "#aaa2df", "master"],
		["sea 12", 50289, 50304, "#6a68c7", "master"],
		["pyre 16", 50305, 50320, "#451624", "master"],
		["red 28", 50321, 50336, "#6d1a10", "master"],
		["vast 32", 50337, 50352, "#c7a884", "master"],
		["serene 28", 50353, 50368, "#b2cbc8", "master"],
		["view 59", 50369, 50384, "#3f6e9a", "master"],
		["strato 16", 50385, 50400, "#0a408a", "master"],
		["arch 13", 50401, 50416, "#1778d2", "master"],
		["fall 59", 50417, 50432, "#364821", "master"],
		["grace 30", 50433, 50448, "#0561d1", "master"],
		["bark 12", 50449, 50464, "#a17e5e", "master"],
		["dry 16", 50465, 50480, "#0f46bf", "master"],
		["sky 27", 50481, 50496, "#8a5425", "master"],
		["crest 30", 50497, 50512, "#b8abda", "master"],
		["birch 14", 50513, 50528, "#ccc6b7", "master"],
		["grain 12", 50529, 50544, "#f8e6d9", "master"],
		["coast 16", 50545, 50560, "#355732", "master"],
		["ripple 25", 50561, 50576, "#a7a3a0", "master"],
		["wall 16", 50577, 50592, "#b5abb0", "master"],
		["dune 14", 50593, 50608, "#9fa7ee", "master"],
		["calm 42", 50609, 50624, "#aaa2df", "master"],
		["brood 41", 50625, 50640, "#856d1c", "master"],
		["cosmo 13", 50641, 50656, "#3b2446", "master"],
		["lime 16", 50657, 50672, "#75a7dc", "master"],
		["climb 29", 50673, 50688, "#1d443b", "master"],
		["serene 29", 50689, 50704, "#664755", "master"],
		["fall 60", 50705, 50720, "#3989b3", "master"],
		["dawn 56", 50721, 50736, "#c36910", "master"],
		["valley 61", 50737, 50752, "#c37966", "master"],
		["height 14", 50753, 50768, "#454c50", "master"],
		["frond 28", 50769, 50784, "#cfc7a5", "master"],
		["far 15", 50785, 50800, "#367bcb", "master"],
		["pine 14", 50801, 50816, "#b2d4f5", "master"],
		["crest 31", 50817, 50832, "#b2c7d8", "master"],
		["gift 14", 50833, 50848, "#c797e8", "master"],
		["rock 29", 50849, 50864, "#1e558c", "master"],
		["amber 15", 50865, 50880, "#b5674f", "master"],
		["bright 67", 50881, 50896, "#355732", "master"],
		["river 43", 50897, 50912, "#587a75", "master"],
		["erode 14", 50913, 50928, "#5e92f3", "master"],
		["brood 42", 50929, 50944, "#85a7c8", "master"],
		["set 30", 50945, 50960, "#6b4a3e", "master"],
		["brood 43", 50961, 50976, "#71851e", "master"],
		["sand 29", 50977, 50992, "#1e558c", "master"],
		["mist 68", 50993, 51008, "#052d65", "master"],
		["valley 62", 51009, 51024, "#d5c284", "master"],
		["grass 15", 51025, 51040, "#32283c", "master"],
		["field 14", 51041, 51056, "#8da40a", "master"],
		["rapid 16", 51057, 51072, "#bad3e2", "master"],
		["glass 14", 51073, 51088, "#6e9ecf", "master"],
		["sol 14", 51089, 51104, "#0b545c", "master"],
		["spire 29", 51105, 51120, "#bca6d7", "master"],
		["soar 14", 51121, 51136, "#367bcb", "master"],
		["mist 69", 51137, 51152, "#c1b8b4", "master"],
		["lake 40", 51153, 51168, "#84857f", "master"],
		["leaf 39", 51169, 51184, "#daee95", "master"],
		["dawn 57", 51185, 51200, "#444b23", "master"],
		["leaf 40", 51201, 51216, "#516152", "master"],
		["dawn 58", 51217, 51232, "#ae8b14", "master"],
		["bright 68", 51233, 51248, "#b2ba44", "master"],
		["curve 13", 51249, 51264, "#904024", "master"],
		["dusk 15", 51265, 51280, "#5b447b", "master"],
		["pond 14", 51281, 51296, "#36342a", "master"],
		["lush 28", 51297, 51312, "#263206", "master"],
		["river 44", 51313, 51328, "#c8dce6", "master"],
		["watch 13", 51329, 51344, "#0a2a41", "master"],
		["emit 15", 51345, 51360, "#1c3528", "master"],
		["lush 29", 51361, 51376, "#3b4b18", "master"],
		["haze 16", 51377, 51392, "#4f80c0", "master"],
		["below 42", 51393, 51408, "#bad3e2", "master"],
		["wood 14", 51409, 51424, "#b2aaa4", "master"],
		["brook 30", 51425, 51440, "#566f3c", "master"],
		["mist 70", 51441, 51456, "#a4c1c7", "master"],
		["brook 31", 51457, 51472, "#5e4144", "master"],
		["mist 71", 51473, 51488, "#714936", "master"],
		["fall 61", 51489, 51504, "#7a5d2b", "master"],
		["river 45", 51505, 51520, "#1b89d3", "master"],
		["clear 14", 51521, 51536, "#40addf", "master"],
		["mist 72", 51537, 51552, "#d6c3c5", "master"],
		["curl 13", 51553, 51568, "#1c600b", "master"],
		["marsh 14", 51569, 51584, "#1b0d35", "master"],
		["sky 28", 51585, 51600, "#081328", "master"],
		["space 14", 51601, 51616, "#2b2c41", "master"],
		["wild 16", 51617, 51632, "#1c600b", "master"],
		["depth 13", 51633, 51648, "#3a6daf", "master"],
		["above 26", 51649, 51664, "#c8dce6", "master"],
		["pebble 30", 51665, 51680, "#7e707b", "master"],
		["azure 27", 51681, 51696, "#0f98b9", "master"],
		["shine 46", 51697, 51712, "#a17b63", "master"],
		["azure 28", 51713, 51728, "#585e31", "master"],
		["aqua 29", 51729, 51744, "#295771", "master"],
		["leaf 41", 51745, 51760, "#779c35", "master"],
		["breeze 14", 51761, 51776, "#dee6dc", "master"],
		["beach 15", 51777, 51792, "#cdad81", "master"],
		["melt 14", 51793, 51808, "#2d6194", "master"],
		["green 29", 51809, 51824, "#4c6111", "master"],
		["cove 15", 51825, 51840, "#c3d0e0", "master"],
		["light 29", 51841, 51856, "#0e0f1d", "master"],
		["fit 15", 51857, 51872, "#3b6fa7", "master"],
		["vine 14", 51873, 51888, "#4c6111", "master"],
		["blue 17", 51889, 51904, "#dee6dc", "master"],
		["climb 30", 51905, 51920, "#4186c8", "master"],
		["wash 28", 51921, 51936, "#756e8d", "master"],
		["ray 30", 51937, 51952, "#b1934b", "master"],
		["lake 41", 51953, 51968, "#225c75", "master"],
		["ray 31", 51969, 51984, "#8a8f89", "master"],
		["wash 29", 51985, 52000, "#bd9794", "master"],
		["cover 29", 52001, 52016, "#134f7b", "master"],
		["calm 43", 52017, 52032, "#548eb1", "master"],
		["shore 14", 52033, 52048, "#e0afae", "master"],
		["light 30", 52049, 52064, "#184d4e", "master"],
		["grove 15", 52065, 52080, "#90510a", "master"],
		["slope 13", 52081, 52096, "#372f30", "master"],
		["bluff 16", 52097, 52112, "#3f6e9a", "master"],
		["opal 14", 52113, 52128, "#d49bc8", "master"],
		["cover 30", 52129, 52144, "#90510a", "master"],
		["wave 29", 52145, 52160, "#138cc5", "master"],
		["air 28", 52161, 52176, "#c3d0e0", "master"],
		["shell 31", 52177, 52192, "#d0a973", "master"],
		["polar 14", 52193, 52208, "#819864", "master"],
		["valley 63", 52209, 52224, "#7e93a8", "master"],
		["below 43", 52225, 52240, "#344f3d", "master"],
		["fresh 27", 52241, 52256, "#42a198", "master"],
		["vivid 30", 52257, 52272, "#638cac", "master"],
		["ripple 26", 52273, 52288, "#c7a884", "master"],
		["vast 33", 52289, 52304, "#ee9361", "master"],
		["frost 15", 52305, 52320, "#bec8d1", "master"],
		["ruby 13", 52321, 52336, "#6d1a10", "master"],
		["chill 16", 52337, 52352, "#aaa2df", "master"],
		["sea 13", 52353, 52368, "#6a68c7", "master"],
		["pyre 17", 52369, 52384, "#451624", "master"],
		["red 29", 52385, 52400, "#6d1a10", "master"],
		["sand 30", 52401, 52416, "#0f46bf", "master"],
		["serene 30", 52417, 52432, "#b2cbc8", "master"],
		["view 60", 52433, 52448, "#3f6e9a", "master"],
		["strato 17", 52449, 52464, "#0a408a", "master"],
		["arch 14", 52465, 52480, "#1778d2", "master"],
		["above 27", 52481, 52496, "#cfd088", "master"],
		["grace 31", 52497, 52512, "#0561d1", "master"],
		["bark 13", 52513, 52528, "#a17e5e", "master"],
		["dry 17", 52529, 52544, "#0f46bf", "master"],
		["sky 29", 52545, 52560, "#8a5425", "master"],
		["peace 14", 52561, 52576, "#789395", "master"],
		["birch 15", 52577, 52592, "#ccc6b7", "master"],
		["grain 13", 52593, 52608, "#f8e6d9", "master"],
		["coast 17", 52609, 52624, "#355732", "master"],
		["ripple 27", 52625, 52640, "#a7a3a0", "master"],
		["bask 14", 52641, 52656, "#939aa5", "master"],
		["dune 15", 52657, 52672, "#9fa7ee", "master"],
		["calm 44", 52673, 52688, "#aaa2df", "master"],
		["brood 44", 52689, 52704, "#856d1c", "master"],
		["cosmo 14", 52705, 52720, "#3b2446", "master"],
		["arid 15", 52721, 52736, "#c5c3b7", "master"],
		["climb 31", 52737, 52752, "#1d443b", "master"],
		["serene 31", 52753, 52768, "#664755", "master"],
		["fall 62", 52769, 52784, "#3989b3", "master"],
		["dawn 59", 52785, 52800, "#c36910", "master"],
		["spire 30", 52801, 52816, "#36483b", "master"],
		["height 15", 52817, 52832, "#454c50", "master"],
		["frond 29", 52833, 52848, "#cfc7a5", "master"],
		["far 16", 52849, 52864, "#367bcb", "master"],
		["pine 15", 52865, 52880, "#b2d4f5", "master"],
		["still 15", 52881, 52896, "#c77fd2", "master"],
		["gift 15", 52897, 52912, "#c797e8", "master"],
		["rock 30", 52913, 52928, "#1e558c", "master"],
		["amber 16", 52929, 52944, "#b5674f", "master"],
		["bright 69", 52945, 52960, "#355732", "master"],
		["range 15", 52961, 52976, "#34447a", "master"],
		["erode 15", 52977, 52992, "#5e92f3", "master"],
		["brood 45", 52993, 53008, "#85a7c8", "master"],
		["set 31", 53009, 53024, "#6b4a3e", "master"],
		["brood 46", 53025, 53040, "#71851e", "master"],
		["rise 14", 53041, 53056, "#bca6d7", "master"],
		["mist 73", 53057, 53072, "#052d65", "master"],
		["valley 64", 53073, 53088, "#d5c284", "master"],
		["grass 16", 53089, 53104, "#32283c", "master"],
		["field 15", 53105, 53120, "#8da40a", "master"],
		["cliff 14", 53121, 53136, "#43b2eb", "master"],
		["glass 15", 53137, 53152, "#6e9ecf", "master"],
		["sol 15", 53153, 53168, "#0b545c", "master"],
		["spire 31", 53169, 53184, "#bca6d7", "master"],
		["soar 15", 53185, 53200, "#367bcb", "master"],
		["arrive 27", 53201, 53216, "#b2d4f5", "master"],
		["lake 42", 53217, 53232, "#84857f", "master"],
		["leaf 42", 53233, 53248, "#daee95", "master"],
		["dawn 60", 53249, 53264, "#444b23", "master"],
		["leaf 43", 53265, 53280, "#516152", "master"],
		["bright 70", 53281, 53312, "#52373c", "master"],
		["curve 14", 53313, 53328, "#904024", "master"],
		["dusk 16", 53329, 53344, "#5b447b", "master"],
		["pond 15", 53345, 53360, "#36342a", "master"],
		["frond 30", 53361, 53376, "#3b4b18", "master"],
		["river 46", 53377, 53392, "#c8dce6", "master"],
		["watch 14", 53393, 53408, "#0a2a41", "master"],
		["emit 16", 53409, 53424, "#1c3528", "master"],
		["lush 30", 53425, 53440, "#3b4b18", "master"],
		["sail 15", 53441, 53456, "#8da40a", "master"],
		["below 44", 53457, 53472, "#bad3e2", "master"],
		["wood 15", 53473, 53488, "#b2aaa4", "master"],
		["brook 32", 53489, 53504, "#566f3c", "master"],
		["mist 74", 53505, 53520, "#a4c1c7", "master"],
		["toad 30", 53521, 53536, "#898391", "master"],
		["mist 75", 53537, 53552, "#714936", "master"],
		["fall 63", 53553, 53568, "#7a5d2b", "master"],
		["river 47", 53569, 53584, "#1b89d3", "master"],
		["clear 15", 53585, 53600, "#40addf", "master"],
		["snow 15", 53601, 53616, "#bbc5d9", "master"],
		["curl 14", 53617, 53632, "#1c600b", "master"],
		["marsh 15", 53633, 53648, "#1b0d35", "master"],
		["sky 30", 53649, 53664, "#081328", "master"],
		["space 15", 53665, 53680, "#2b2c41", "master"],
		["thick 15", 53681, 53696, "#3d3a16", "master"],
		["depth 14", 53697, 53712, "#3a6daf", "master"],
		["above 28", 53713, 53728, "#c8dce6", "master"],
		["pebble 31", 53729, 53744, "#7e707b", "master"],
		["azure 29", 53745, 53760, "#0f98b9", "master"],
		["icey 15", 53761, 53776, "#173ebd", "master"],
		["azure 30", 53777, 53792, "#585e31", "master"],
		["aqua 30", 53793, 53808, "#295771", "master"],
		["leaf 44", 53809, 53824, "#779c35", "master"],
		["breeze 15", 53825, 53840, "#dee6dc", "master"],
		["beach 16", 53841, 53856, "#cdad81", "master"],
		["melt 15", 53857, 53872, "#2d6194", "master"],
		["green 30", 53873, 53888, "#4c6111", "master"],
		["cove 16", 53889, 53904, "#c3d0e0", "master"],
		["light 31", 53905, 53920, "#0e0f1d", "master"],
		["fit 16", 53921, 53936, "#3b6fa7", "master"],
		["vine 15", 53937, 53952, "#4c6111", "master"],
		["storm 14", 53953, 53968, "#548eb1", "master"],
		["climb 32", 53969, 53984, "#4186c8", "master"],
		["wash 30", 53985, 54000, "#756e8d", "master"],
		["ray 32", 54001, 54016, "#b1934b", "master"],
		["lake 43", 54017, 54032, "#225c75", "master"],
		["arrive 28", 54033, 54048, "#d3dbce", "master"],
		["wash 31", 54049, 54064, "#bd9794", "master"],
		["cover 31", 54065, 54080, "#134f7b", "master"],
		["calm 45", 54081, 54096, "#548eb1", "master"],
		["shore 15", 54097, 54112, "#e0afae", "master"],
		["freeze 14", 54113, 54128, "#73a0bd", "master"],
		["grove 16", 54129, 54144, "#90510a", "master"],
		["slope 14", 54145, 54160, "#372f30", "master"],
		["bluff 17", 54161, 54176, "#3f6e9a", "master"],
		["opal 15", 54177, 54192, "#d49bc8", "master"],
		["vivid 31", 54193, 54208, "#609fdc", "master"],
		["wave 30", 54209, 54224, "#138cc5", "master"],
		["air 29", 54225, 54240, "#c3d0e0", "master"],
		["shell 32", 54241, 54256, "#d0a973", "master"],
		["polar 15", 54257, 54272, "#819864", "master"],
		["white 14", 54273, 54288, "#6d8cab", "master"],
		["below 45", 54289, 54304, "#344f3d", "master"],
		["fresh 28", 54305, 54320, "#42a198", "master"],
		["vivid 32", 54321, 54336, "#638cac", "master"],
		["ripple 28", 54337, 54352, "#c7a884", "master"],
		["lake 44", 54353, 54368, "#d9ca87", "master"],
		["frost 16", 54369, 54384, "#bec8d1", "master"],
		["ruby 14", 54385, 54400, "#6d1a10", "master"],
		["chill 17", 54401, 54416, "#aaa2df", "master"],
		["sea 14", 54417, 54432, "#6a68c7", "master"],
		["arise 30", 54433, 54448, "#0e3650", "master"],
		["red 30", 54449, 54464, "#6d1a10", "master"],
		["sand 31", 54465, 54480, "#0f46bf", "master"],
		["serene 32", 54481, 54496, "#b2cbc8", "master"],
		["view 61", 54497, 54512, "#3f6e9a", "master"],
		["luna 15", 54513, 54528, "#051227", "master"],
		["arch 15", 54529, 54544, "#1778d2", "master"],
		["above 29", 54545, 54560, "#cfd088", "master"],
		["grace 32", 54561, 54576, "#0561d1", "master"],
		["bark 14", 54577, 54592, "#a17e5e", "master"],
		["drift 15", 54593, 54608, "#9fa7ee", "master"],
		["sky 31", 54609, 54624, "#8a5425", "master"],
		["peace 15", 54625, 54640, "#789395", "master"],
		["birch 16", 54641, 54656, "#ccc6b7", "master"],
		["grain 14", 54657, 54672, "#f8e6d9", "master"],
		["below 46", 54673, 54688, "#c1b8b4", "master"],
		["ripple 29", 54689, 54704, "#a7a3a0", "master"],
		["bask 15", 54705, 54720, "#939aa5", "master"],
		["dune 16", 54721, 54736, "#9fa7ee", "master"],
		["calm 46", 54737, 54752, "#aaa2df", "master"],
		["dawn 61", 54753, 54768, "#6a68c7", "master"],
		["cosmo 15", 54769, 54784, "#3b2446", "master"],
		["arid 16", 54785, 54800, "#c5c3b7", "master"],
		["climb 33", 54801, 54816, "#1d443b", "master"],
		["serene 33", 54817, 54832, "#664755", "master"],
		["view 62", 54833, 54848, "#060a1f", "master"],
		["dawn 62", 54849, 54864, "#c36910", "master"],
		["spire 32", 54865, 54880, "#36483b", "master"],
		["height 16", 54881, 54896, "#454c50", "master"],
		["frond 31", 54897, 54912, "#cfc7a5", "master"],
		["lines 16", 54913, 54928, "#4f80c0", "master"],
		["pine 16", 54929, 54944, "#b2d4f5", "master"],
		["still 16", 54945, 54960, "#c77fd2", "master"],
		["gift 16", 54961, 54976, "#c797e8", "master"],
		["rock 31", 54977, 54992, "#1e558c", "master"],
		["wind 15", 54993, 55008, "#f8e6d9", "master"],
		["bright 71", 55009, 55024, "#355732", "master"],
		["range 16", 55025, 55040, "#34447a", "master"],
		["erode 16", 55041, 55056, "#5e92f3", "master"],
		["brood 47", 55057, 55072, "#85a7c8", "master"],
		["calm 47", 55073, 55088, "#7e6064", "master"],
		["brood 48", 55089, 55104, "#71851e", "master"],
		["rise 15", 55105, 55120, "#bca6d7", "master"],
		["mist 76", 55121, 55136, "#052d65", "master"],
		["valley 65", 55137, 55152, "#d5c284", "master"],
		["shine 47", 55153, 55168, "#a3904f", "master"],
		["field 16", 55169, 55184, "#8da40a", "master"],
		["cliff 15", 55185, 55200, "#43b2eb", "master"],
		["glass 16", 55201, 55216, "#6e9ecf", "master"],
		["sol 16", 55217, 55232, "#0b545c", "master"],
		["green 31", 55233, 55248, "#263206", "master"],
		["soar 16", 55249, 55264, "#367bcb", "master"],
		["arrive 29", 55265, 55280, "#b2d4f5", "master"],
		["lake 45", 55281, 55296, "#84857f", "master"],
		["leaf 45", 55297, 55312, "#daee95", "master"],
		["bright 72", 55313, 55328, "#38423a", "master"],
		["leaf 46", 55329, 55344, "#516152", "master"],
		["bright 73", 55345, 55376, "#52373c", "master"],
		["curve 15", 55377, 55392, "#904024", "master"],
		["star 16", 55393, 55408, "#3270cd", "master"],
		["pond 16", 55409, 55424, "#36342a", "master"],
		["frond 32", 55425, 55440, "#3b4b18", "master"],
		["river 48", 55441, 55456, "#c8dce6", "master"],
		["watch 15", 55457, 55472, "#0a2a41", "master"],
		["bright 74", 55473, 55488, "#1f305b", "master"],
		["lush 31", 55489, 55504, "#3b4b18", "master"],
		["sail 16", 55505, 55520, "#8da40a", "master"],
		["below 47", 55521, 55536, "#bad3e2", "master"],
		["wood 16", 55537, 55552, "#b2aaa4", "master"],
		["toad 31", 55553, 55568, "#264056", "master"],
		["mist 77", 55569, 55584, "#a4c1c7", "master"],
		["toad 32", 55585, 55600, "#898391", "master"],
		["mist 78", 55601, 55616, "#714936", "master"],
		["fall 64", 55617, 55632, "#7a5d2b", "master"],
		["float 16", 55633, 55648, "#3a6daf", "master"],
		["clear 16", 55649, 55664, "#40addf", "master"],
		["snow 16", 55665, 55680, "#bbc5d9", "master"],
		["curl 15", 55681, 55696, "#1c600b", "master"],
		["marsh 16", 55697, 55712, "#1b0d35", "master"],
		["sky 32", 55713, 55728, "#081328", "master"],
		["space 16", 55729, 55744, "#2b2c41", "master"],
		["thick 16", 55745, 55760, "#3d3a16", "master"],
		["depth 15", 55761, 55776, "#3a6daf", "master"],
		["above 30", 55777, 55792, "#c8dce6", "master"],
		["pebble 32", 55793, 55808, "#7e707b", "master"],
		["azure 31", 55809, 55824, "#0f98b9", "master"],
		["icey 16", 55825, 55840, "#173ebd", "master"],
		["azure 32", 55841, 55856, "#585e31", "master"],
		["aqua 31", 55857, 55872, "#295771", "master"],
		["leaf 47", 55873, 55888, "#779c35", "master"],
		["breeze 16", 55889, 55904, "#dee6dc", "master"],
		["palm 15", 55905, 55920, "#44c7ca", "master"],
		["melt 16", 55921, 55936, "#2d6194", "master"],
		["green 32", 55937, 55952, "#4c6111", "master"],
		["cove 17", 55953, 55968, "#c3d0e0", "master"],
		["light 32", 55969, 55984, "#0e0f1d", "master"],
		["zeal 15", 55985, 56000, "#89bee6", "master"],
		["vine 16", 56001, 56016, "#4c6111", "master"],
		["storm 15", 56017, 56032, "#548eb1", "master"],
		["climb 34", 56033, 56048, "#4186c8", "master"],
		["wash 32", 56049, 56064, "#756e8d", "master"],
		["solis 15", 56065, 56080, "#d58265", "master"],
		["lake 46", 56081, 56096, "#225c75", "master"],
		["arrive 30", 56097, 56112, "#d3dbce", "master"],
		["wash 33", 56113, 56128, "#bd9794", "master"],
		["cover 32", 56129, 56144, "#134f7b", "master"],
		["wave 31", 56145, 56160, "#138cc5", "master"],
		["shore 16", 56161, 56176, "#e0afae", "master"],
		["freeze 15", 56177, 56192, "#73a0bd", "master"],
		["grove 17", 56193, 56208, "#90510a", "master"],
		["slope 15", 56209, 56224, "#372f30", "master"],
		["lavish 15", 56225, 56240, "#856d1c", "master"],
		["opal 16", 56241, 56256, "#d49bc8", "master"],
		["vivid 33", 56257, 56272, "#609fdc", "master"],
		["wave 32", 56273, 56288, "#138cc5", "master"],
		["air 30", 56289, 56304, "#c3d0e0", "master"],
		["fresh 29", 56305, 56320, "#c6dded", "master"],
		["polar 16", 56321, 56336, "#819864", "master"],
		["white 15", 56337, 56352, "#6d8cab", "master"],
		["below 48", 56353, 56368, "#344f3d", "master"],
		["fresh 30", 56369, 56384, "#42a198", "master"],
		["red 31", 56385, 56400, "#675d45", "master"],
		["ripple 30", 56401, 56416, "#c7a884", "master"],
		["lake 47", 56417, 56432, "#d9ca87", "master"],
		["frost 17", 56433, 56448, "#bec8d1", "master"],
		["ruby 15", 56449, 56464, "#6d1a10", "master"],
		["seed 16", 56465, 56480, "#b5674f", "master"],
		["sea 15", 56481, 56496, "#6a68c7", "master"],
		["arise 31", 56497, 56512, "#0e3650", "master"],
		["red 32", 56513, 56528, "#6d1a10", "master"],
		["sand 32", 56529, 56544, "#0f46bf", "master"],
		["set 32", 56545, 56560, "#372f30", "master"],
		["view 63", 56561, 56576, "#3f6e9a", "master"],
		["luna 16", 56577, 56592, "#051227", "master"],
		["arch 16", 56593, 56608, "#1778d2", "master"],
		["above 31", 56609, 56624, "#cfd088", "master"],
		["air 31", 56625, 56640, "#885c2d", "master"],
		["bark 15", 56641, 56656, "#a17e5e", "master"],
		["drift 16", 56657, 56672, "#9fa7ee", "master"],
		["sky 33", 56673, 56688, "#8a5425", "master"],
		["peace 16", 56689, 56704, "#789395", "master"],
		["fog 16", 56705, 56720, "#8c8237", "master"],
		["grain 15", 56721, 56736, "#f8e6d9", "master"],
		["below 49", 56737, 56752, "#c1b8b4", "master"],
		["ripple 31", 56753, 56768, "#a7a3a0", "master"],
		["bask 16", 56769, 56784, "#939aa5", "master"],
		["sierra 16", 56785, 56800, "#c36910", "master"],
		["calm 48", 56801, 56816, "#aaa2df", "master"],
		["dawn 63", 56817, 56832, "#6a68c7", "master"],
		["cosmo 16", 56833, 56848, "#3b2446", "master"],
		["arid 17", 56849, 56864, "#c5c3b7", "master"],
		["view 64", 56865, 56880, "#3b7fa6", "master"],
		["serene 34", 56881, 56896, "#664755", "master"],
		["view 65", 56897, 56912, "#060a1f", "master"],
		["dawn 64", 56913, 56928, "#c36910", "master"],
		["spire 33", 56929, 56944, "#36483b", "master"],
		["up 16", 56945, 56960, "#2a7b93", "master"],
		["frond 33", 56961, 56976, "#cfc7a5", "master"],
		["lines 17", 56977, 56992, "#4f80c0", "master"],
		["pine 17", 56993, 57008, "#b2d4f5", "master"],
		["still 17", 57009, 57024, "#c77fd2", "master"],
		["arise 32", 57025, 57040, "#385e76", "master"],
		["rock 32", 57041, 57056, "#1e558c", "master"],
		["wind 16", 57057, 57072, "#f8e6d9", "master"],
		["bright 75", 57073, 57088, "#355732", "master"],
		["range 17", 57089, 57104, "#34447a", "master"],
		["flat 17", 57105, 57120, "#3d90ce", "master"],
		["brood 49", 57121, 57136, "#85a7c8", "master"],
		["calm 49", 57137, 57152, "#7e6064", "master"],
		["brood 50", 57153, 57168, "#71851e", "master"],
		["rise 16", 57169, 57184, "#bca6d7", "master"],
		["hole 17", 57185, 57200, "#20202c", "master"],
		["valley 66", 57201, 57216, "#d5c284", "master"],
		["shine 48", 57217, 57232, "#a3904f", "master"],
		["field 17", 57233, 57248, "#8da40a", "master"],
		["cliff 16", 57249, 57264, "#43b2eb", "master"],
		["shine 49", 57265, 57280, "#2f387b", "master"],
		["sol 17", 57281, 57296, "#0b545c", "master"],
		["green 33", 57297, 57312, "#263206", "master"],
		["soar 17", 57313, 57328, "#367bcb", "master"],
		["arrive 31", 57329, 57344, "#b2d4f5", "master"],
		["valley 67", 57345, 57360, "#cea37e", "master"],
		["leaf 48", 57361, 57376, "#daee95", "master"],
		["bright 76", 57377, 57392, "#38423a", "master"],
		["leaf 49", 57393, 57408, "#516152", "master"],
		["bright 77", 57409, 57424, "#52373c", "master"],
		["mossy 17", 57425, 57440, "#96c4df", "master"],
		["curve 16", 57441, 57456, "#904024", "master"],
		["star 17", 57457, 57472, "#3270cd", "master"],
		["pond 17", 57473, 57488, "#36342a", "master"],
		["frond 34", 57489, 57504, "#3b4b18", "master"],
		["view 66", 57505, 57520, "#4186c8", "master"],
		["watch 16", 57521, 57536, "#0a2a41", "master"],
		["bright 78", 57537, 57552, "#1f305b", "master"],
		["lush 32", 57553, 57568, "#3b4b18", "master"],
		["sail 17", 57569, 57584, "#8da40a", "master"],
		["fall 65", 57585, 57600, "#43b2eb", "master"],
		["wood 17", 57601, 57616, "#b2aaa4", "master"],
		["toad 33", 57617, 57632, "#264056", "master"],
		["mist 79", 57633, 57648, "#a4c1c7", "master"],
		["toad 34", 57649, 57664, "#898391", "master"],
		["mist 80", 57665, 57680, "#714936", "master"],
		["fall 66", 57681, 57696, "#7a5d2b", "master"],
		["float 17", 57697, 57712, "#3a6daf", "master"],
		["clear 17", 57713, 57728, "#40addf", "master"],
		["snow 17", 57729, 57744, "#bbc5d9", "master"],
		["curl 16", 57745, 57760, "#1c600b", "master"],
		["marsh 17", 57761, 57776, "#1b0d35", "master"],
		["gaze 16", 57777, 57792, "#040c18", "master"],
		["space 17", 57793, 57808, "#2b2c41", "master"],
		["thick 17", 57809, 57824, "#3d3a16", "master"],
		["depth 16", 57825, 57840, "#3a6daf", "master"],
		["above 32", 57841, 57856, "#c8dce6", "master"],
		["aqua 32", 57857, 57872, "#b9d6e4", "master"],
		["azure 33", 57873, 57888, "#0f98b9", "master"],
		["icey 17", 57889, 57904, "#173ebd", "master"],
		["azure 34", 57905, 57920, "#585e31", "master"],
		["aqua 33", 57921, 57936, "#295771", "master"],
		["fir 16", 57937, 57952, "#15573d", "master"],
		["breeze 17", 57953, 57968, "#dee6dc", "master"],
		["palm 16", 57969, 57984, "#44c7ca", "master"],
		["melt 17", 57985, 58000, "#2d6194", "master"],
		["green 34", 58001, 58016, "#4c6111", "master"],
		["rock 33", 58017, 58032, "#b2cbc8", "master"],
		["light 33", 58033, 58048, "#0e0f1d", "master"],
		["zeal 16", 58049, 58064, "#89bee6", "master"],
		["vine 17", 58065, 58080, "#4c6111", "master"],
		["storm 16", 58081, 58096, "#548eb1", "master"],
		["grace 33", 58097, 58112, "#1b0d35", "master"],
		["wash 34", 58113, 58128, "#756e8d", "master"],
		["solis 16", 58129, 58144, "#d58265", "master"],
		["lake 48", 58145, 58160, "#225c75", "master"],
		["arrive 32", 58161, 58176, "#d3dbce", "master"],
		["shell 33", 58177, 58192, "#3d7ac9", "master"],
		["cover 33", 58193, 58208, "#134f7b", "master"],
		["wave 33", 58209, 58224, "#138cc5", "master"],
		["shore 17", 58225, 58240, "#e0afae", "master"],
		["freeze 16", 58241, 58256, "#73a0bd", "master"],
		["oak 17", 58257, 58272, "#609fdc", "master"],
		["slope 16", 58273, 58288, "#372f30", "master"],
		["lavish 16", 58289, 58304, "#856d1c", "master"],
		["opal 17", 58305, 58320, "#d49bc8", "master"],
		["vivid 34", 58321, 58336, "#609fdc", "master"],
		["vast 34", 58337, 58352, "#c7a884", "master"],
		["air 32", 58353, 58368, "#c3d0e0", "master"],
		["fresh 31", 58369, 58384, "#c6dded", "master"],
		["polar 17", 58385, 58400, "#819864", "master"],
		["white 16", 58401, 58416, "#6d8cab", "master"],
		["fall 67", 58417, 58432, "#364821", "master"],
		["fresh 32", 58433, 58448, "#42a198", "master"],
		["red 33", 58449, 58464, "#675d45", "master"],
		["ripple 32", 58465, 58480, "#c7a884", "master"],
		["lake 49", 58481, 58496, "#d9ca87", "master"],
		["crest 32", 58497, 58512, "#b8abda", "master"],
		["ruby 16", 58513, 58528, "#6d1a10", "master"],
		["seed 17", 58529, 58544, "#b5674f", "master"],
		["sea 16", 58545, 58560, "#6a68c7", "master"],
		["arise 33", 58561, 58576, "#0e3650", "master"],
		["wall 17", 58577, 58592, "#b5abb0", "master"],
		["sand 33", 58593, 58608, "#0f46bf", "master"],
		["set 33", 58609, 58624, "#372f30", "master"],
		["view 67", 58625, 58640, "#3f6e9a", "master"],
		["luna 17", 58641, 58656, "#051227", "master"],
		["lime 17", 58657, 58672, "#75a7dc", "master"],
		["above 33", 58673, 58688, "#cfd088", "master"],
		["air 33", 58689, 58704, "#885c2d", "master"],
		["bark 16", 58705, 58720, "#a17e5e", "master"],
		["drift 17", 58721, 58736, "#9fa7ee", "master"],
		["valley 68", 58737, 58752, "#c37966", "master"],
		["peace 17", 58753, 58768, "#789395", "master"],
		["fog 17", 58769, 58784, "#8c8237", "master"],
		["grain 16", 58785, 58800, "#f8e6d9", "master"],
		["below 50", 58801, 58816, "#c1b8b4", "master"],
		["crest 33", 58817, 58832, "#b2c7d8", "master"],
		["bask 17", 58833, 58848, "#939aa5", "master"],
		["sierra 17", 58849, 58864, "#c36910", "master"],
		["calm 50", 58865, 58880, "#aaa2df", "master"],
		["dawn 65", 58881, 58896, "#6a68c7", "master"],
		["river 49", 58897, 58912, "#587a75", "master"],
		["arid 18", 58913, 58928, "#c5c3b7", "master"],
		["view 68", 58929, 58944, "#3b7fa6", "master"],
		["serene 35", 58945, 58960, "#664755", "master"],
		["view 69", 58961, 58976, "#060a1f", "master"],
		["sand 34", 58977, 58992, "#1e558c", "master"],
		["spire 34", 58993, 59008, "#36483b", "master"],
		["up 17", 59009, 59024, "#2a7b93", "master"],
		["frond 35", 59025, 59040, "#cfc7a5", "master"],
		["lines 18", 59041, 59056, "#4f80c0", "master"],
		["rapid 17", 59057, 59072, "#bad3e2", "master"],
		["still 18", 59073, 59088, "#c77fd2", "master"],
		["arise 34", 59089, 59104, "#385e76", "master"],
		["rock 34", 59105, 59120, "#1e558c", "master"],
		["wind 17", 59121, 59136, "#f8e6d9", "master"],
		["mist 81", 59137, 59152, "#c1b8b4", "master"],
		["range 18", 59153, 59168, "#34447a", "master"],
		["flat 18", 59169, 59184, "#3d90ce", "master"],
		["brood 51", 59185, 59200, "#85a7c8", "master"],
		["calm 51", 59201, 59216, "#7e6064", "master"],
		["dawn 66", 59217, 59232, "#ae8b14", "master"],
		["rise 17", 59233, 59248, "#bca6d7", "master"],
		["hole 18", 59249, 59264, "#20202c", "master"],
		["valley 69", 59265, 59280, "#d5c284", "master"],
		["shine 50", 59281, 59296, "#a3904f", "master"],
		["lush 33", 59297, 59312, "#263206", "master"],
		["cliff 17", 59313, 59328, "#43b2eb", "master"],
		["shine 51", 59329, 59344, "#2f387b", "master"],
		["sol 18", 59345, 59360, "#0b545c", "master"],
		["green 35", 59361, 59376, "#263206", "master"],
		["haze 17", 59377, 59392, "#4f80c0", "master"],
		["arrive 33", 59393, 59408, "#b2d4f5", "master"],
		["valley 70", 59409, 59424, "#cea37e", "master"],
		["leaf 50", 59425, 59440, "#daee95", "master"],
		["bright 79", 59441, 59456, "#38423a", "master"],
		["brook 33", 59457, 59472, "#5e4144", "master"],
		["bright 80", 59473, 59488, "#52373c", "master"],
		["mossy 18", 59489, 59504, "#96c4df", "master"],
		["curve 17", 59505, 59520, "#904024", "master"],
		["star 18", 59521, 59536, "#3270cd", "master"],
		["pond 18", 59537, 59552, "#36342a", "master"],
		["frond 36", 59553, 59568, "#3b4b18", "master"],
		["view 70", 59569, 59584, "#4186c8", "master"],
		["watch 17", 59585, 59600, "#0a2a41", "master"],
		["bright 81", 59601, 59616, "#1f305b", "master"],
		["lush 34", 59617, 59632, "#3b4b18", "master"],
		["sail 18", 59633, 59648, "#8da40a", "master"],
		["fall 68", 59649, 59664, "#43b2eb", "master"],
		["wood 18", 59665, 59680, "#b2aaa4", "master"],
		["toad 35", 59681, 59696, "#264056", "master"],
		["mist 82", 59697, 59712, "#a4c1c7", "master"],
		["toad 36", 59713, 59728, "#898391", "master"],
		["pebble 33", 59729, 59744, "#E6E4B7", "master"],
		["fall 69", 59745, 59760, "#7a5d2b", "master"],
		["float 18", 59761, 59776, "#3a6daf", "master"],
		["clear 18", 59777, 59792, "#40addf", "master"],
		["snow 18", 59793, 59808, "#bbc5d9", "master"],
		["grow 17", 59809, 59824, "#3d3a16", "master"],
		["marsh 18", 59825, 59840, "#1b0d35", "master"],
		["gaze 17", 59841, 59856, "#040c18", "master"],
		["space 18", 59857, 59872, "#2b2c41", "master"],
		["thick 18", 59873, 59888, "#3d3a16", "master"],
		["blue 18", 59889, 59904, "#dee6dc", "master"],
		["above 34", 59905, 59920, "#c8dce6", "master"],
		["aqua 34", 59921, 59936, "#b9d6e4", "master"],
		["azure 35", 59937, 59952, "#0f98b9", "master"],
		["icey 18", 59953, 59968, "#173ebd", "master"],
		["ray 33", 59969, 59984, "#8a8f89", "master"],
		["aqua 35", 59985, 60000, "#295771", "master"],
		["fir 17", 60001, 60016, "#15573d", "master"],
		["breeze 18", 60017, 60032, "#dee6dc", "master"],
		["palm 17", 60033, 60048, "#44c7ca", "master"],
		["light 34", 60049, 60064, "#184d4e", "master"],
		["green 36", 60065, 60080, "#4c6111", "master"],
		["rock 35", 60081, 60096, "#b2cbc8", "master"],
		["light 35", 60097, 60112, "#0e0f1d", "master"],
		["zeal 17", 60113, 60128, "#89bee6", "master"],
		["cover 34", 60129, 60144, "#90510a", "master"],
		["storm 17", 60145, 60160, "#548eb1", "master"],
		["grace 34", 60161, 60176, "#1b0d35", "master"],
		["wash 35", 60177, 60192, "#756e8d", "master"],
		["solis 17", 60193, 60208, "#d58265", "master"],
		["valley 71", 60209, 60224, "#7e93a8", "master"],
		["arrive 34", 60225, 60240, "#d3dbce", "master"],
		["shell 34", 60241, 60256, "#3d7ac9", "master"],
		["cover 35", 60257, 60272, "#134f7b", "master"],
		["wave 34", 60273, 60288, "#138cc5", "master"],
		["vast 35", 60289, 60304, "#ee9361", "master"],
		["freeze 17", 60305, 60320, "#73a0bd", "master"],
		["oak 18", 60321, 60336, "#609fdc", "master"],
		["slope 17", 60337, 60352, "#372f30", "master"],
		["lavish 17", 60353, 60368, "#856d1c", "master"],
		["pyre 18", 60369, 60384, "#451624", "master"],
		["vivid 35", 60385, 60400, "#609fdc", "master"],
		["vast 36", 60401, 60416, "#c7a884", "master"],
		["air 34", 60417, 60432, "#c3d0e0", "master"],
		["fresh 33", 60433, 60448, "#c6dded", "master"],
		["strato 18", 60449, 60464, "#0a408a", "master"],
		["white 17", 60465, 60480, "#6d8cab", "master"],
		["fall 70", 60481, 60496, "#364821", "master"],
		["fresh 34", 60497, 60512, "#42a198", "master"],
		["red 34", 60513, 60528, "#675d45", "master"],
		["dry 18", 60529, 60544, "#0f46bf", "master"],
		["lake 50", 60545, 60560, "#d9ca87", "master"],
		["crest 34", 60561, 60576, "#b8abda", "master"],
		["ruby 17", 60577, 60592, "#6d1a10", "master"],
		["seed 18", 60593, 60608, "#b5674f", "master"],
		["coast 18", 60609, 60624, "#355732", "master"],
		["arise 35", 60625, 60640, "#0e3650", "master"],
		["wall 18", 60641, 60656, "#b5abb0", "master"],
		["sand 35", 60657, 60672, "#0f46bf", "master"],
		["set 34", 60673, 60688, "#372f30", "master"],
		["brood 52", 60689, 60704, "#856d1c", "master"],
		["luna 18", 60705, 60720, "#051227", "master"],
		["lime 18", 60721, 60736, "#75a7dc", "master"],
		["above 35", 60737, 60752, "#cfd088", "master"],
		["air 35", 60753, 60768, "#885c2d", "master"],
		["fall 71", 60769, 60784, "#3989b3", "master"],
		["drift 18", 60785, 60800, "#9fa7ee", "master"],
		["valley 72", 60801, 60816, "#c37966", "master"],
		["peace 18", 60817, 60832, "#789395", "master"],
		["fog 18", 60833, 60848, "#8c8237", "master"],
		["far 17", 60849, 60864, "#367bcb", "master"],
		["below 51", 60865, 60880, "#c1b8b4", "master"],
		["crest 35", 60881, 60896, "#b2c7d8", "master"],
		["bask 18", 60897, 60912, "#939aa5", "master"],
		["sierra 18", 60913, 60928, "#c36910", "master"],
		["amber 17", 60929, 60944, "#b5674f", "master"],
		["dawn 67", 60945, 60960, "#6a68c7", "master"],
		["river 50", 60961, 60976, "#587a75", "master"],
		["arid 19", 60977, 60992, "#c5c3b7", "master"],
		["view 71", 60993, 61008, "#3b7fa6", "master"],
		["set 35", 61009, 61024, "#6b4a3e", "master"],
		["view 72", 61025, 61040, "#060a1f", "master"],
		["sand 36", 61041, 61056, "#1e558c", "master"],
		["spire 35", 61057, 61072, "#36483b", "master"],
		["up 18", 61073, 61088, "#2a7b93", "master"],
		["grass 17", 61089, 61104, "#32283c", "master"],
		["lines 19", 61105, 61120, "#4f80c0", "master"],
		["rapid 18", 61121, 61136, "#bad3e2", "master"],
		["still 19", 61137, 61152, "#c77fd2", "master"],
		["arise 36", 61153, 61168, "#385e76", "master"],
		["spire 36", 61169, 61184, "#bca6d7", "master"],
		["wind 18", 61185, 61200, "#f8e6d9", "master"],
		["mist 83", 61201, 61216, "#c1b8b4", "master"],
		["range 19", 61217, 61232, "#34447a", "master"],
		["flat 19", 61233, 61248, "#3d90ce", "master"],
		["dawn 68", 61249, 61264, "#444b23", "master"],
		["calm 52", 61265, 61280, "#7e6064", "master"],
		["dawn 69", 61281, 61296, "#ae8b14", "master"],
		["rise 18", 61297, 61312, "#bca6d7", "master"],
		["hole 19", 61313, 61328, "#20202c", "master"],
		["dusk 17", 61329, 61344, "#5b447b", "master"],
		["shine 52", 61345, 61360, "#a3904f", "master"],
		["lush 35", 61361, 61376, "#263206", "master"],
		["cliff 18", 61377, 61392, "#43b2eb", "master"],
		["shine 53", 61393, 61408, "#2f387b", "master"],
		["emit 17", 61409, 61424, "#1c3528", "master"],
		["green 37", 61425, 61440, "#263206", "master"],
		["haze 18", 61441, 61456, "#4f80c0", "master"],
		["arrive 35", 61457, 61472, "#b2d4f5", "master"],
		["valley 73", 61473, 61488, "#cea37e", "master"],
		["leaf 51", 61489, 61504, "#daee95", "master"],
		["bright 82", 61505, 61520, "#38423a", "master"],
		["brook 34", 61521, 61536, "#5e4144", "master"],
		["bright 83", 61537, 61552, "#52373c", "master"],
		["mossy 19", 61553, 61568, "#96c4df", "master"],
		["curve 18", 61569, 61584, "#904024", "master"],
		["star 19", 61585, 61600, "#3270cd", "master"],
		["mist 84", 61601, 61616, "#d6c3c5", "master"],
		["frond 37", 61617, 61632, "#3b4b18", "master"],
		["view 73", 61633, 61648, "#4186c8", "master"],
		["watch 18", 61649, 61664, "#0a2a41", "master"],
		["bright 84", 61665, 61680, "#1f305b", "master"],
		["wild 17", 61681, 61696, "#1c600b", "master"],
		["sail 19", 61697, 61712, "#8da40a", "master"],
		["fall 72", 61713, 61728, "#43b2eb", "master"],
		["wood 19", 61729, 61744, "#b2aaa4", "master"],
		["toad 37", 61745, 61760, "#264056", "master"],
		["shine 54", 61761, 61776, "#a17b63", "master"],
		["toad 38", 61777, 61792, "#898391", "master"],
		["pebble 34", 61793, 61808, "#f5f3e8", "master"],
		["fall 73", 61809, 61824, "#7a5d2b", "master"],
		["float 19", 61825, 61840, "#3a6daf", "master"],
		["beach 17", 61841, 61856, "#cdad81", "master"],
		["snow 19", 61857, 61872, "#bbc5d9", "master"],
		["grow 18", 61873, 61888, "#3d3a16", "master"],
		["marsh 19", 61889, 61904, "#1b0d35", "master"],
		["gaze 18", 61905, 61920, "#040c18", "master"],
		["fit 17", 61921, 61936, "#3b6fa7", "master"],
		["thick 19", 61937, 61952, "#3d3a16", "master"],
		["blue 19", 61953, 61968, "#dee6dc", "master"],
		["above 36", 61969, 61984, "#c8dce6", "master"],
		["aqua 36", 61985, 62000, "#b9d6e4", "master"],
		["ray 34", 62001, 62016, "#b1934b", "master"],
		["icey 19", 62017, 62032, "#173ebd", "master"],
		["ray 35", 62033, 62048, "#8a8f89", "master"],
		["aqua 37", 62049, 62064, "#295771", "master"],
		["fir 18", 62065, 62080, "#15573d", "master"],
		["calm 53", 62081, 62096, "#548eb1", "master"],
		["palm 18", 62097, 62112, "#44c7ca", "master"],
		["light 36", 62113, 62128, "#184d4e", "master"],
		["green 38", 62129, 62144, "#4c6111", "master"],
		["rock 36", 62145, 62160, "#b2cbc8", "master"],
		["bluff 18", 62161, 62176, "#3f6e9a", "master"],
		["zeal 18", 62177, 62192, "#89bee6", "master"],
		["cover 36", 62193, 62208, "#90510a", "master"],
		["storm 18", 62209, 62224, "#548eb1", "master"],
		["grace 35", 62225, 62240, "#1b0d35", "master"],
		["shell 35", 62241, 62256, "#d0a973", "master"],
		["solis 18", 62257, 62272, "#d58265", "master"],
		["valley 74", 62273, 62288, "#7e93a8", "master"],
		["arrive 36", 62289, 62304, "#d3dbce", "master"],
		["shell 36", 62305, 62320, "#3d7ac9", "master"],
		["vivid 36", 62321, 62336, "#638cac", "master"],
		["wave 35", 62337, 62352, "#138cc5", "master"],
		["vast 37", 62353, 62368, "#ee9361", "master"],
		["freeze 18", 62369, 62384, "#73a0bd", "master"],
		["oak 19", 62385, 62400, "#609fdc", "master"],
		["chill 18", 62401, 62416, "#aaa2df", "master"],
		["lavish 18", 62417, 62432, "#856d1c", "master"],
		["pyre 19", 62433, 62448, "#451624", "master"],
		["vivid 37", 62449, 62464, "#609fdc", "master"],
		["vast 38", 62465, 62480, "#c7a884", "master"],
		["serene 36", 62481, 62496, "#b2cbc8", "master"],
		["fresh 35", 62497, 62512, "#c6dded", "master"],
		["strato 19", 62513, 62528, "#0a408a", "master"],
		["white 18", 62529, 62544, "#6d8cab", "master"],
		["fall 74", 62545, 62560, "#364821", "master"],
		["grace 36", 62561, 62576, "#0561d1", "master"],
		["red 35", 62577, 62592, "#675d45", "master"],
		["dry 19", 62593, 62608, "#0f46bf", "master"],
		["lake 51", 62609, 62624, "#d9ca87", "master"],
		["crest 36", 62625, 62640, "#b8abda", "master"],
		["birch 17", 62641, 62656, "#ccc6b7", "master"],
		["seed 19", 62657, 62672, "#b5674f", "master"],
		["coast 19", 62673, 62688, "#355732", "master"],
		["arise 37", 62689, 62704, "#0e3650", "master"],
		["wall 19", 62705, 62720, "#b5abb0", "master"],
		["dune 17", 62721, 62736, "#9fa7ee", "master"],
		["set 36", 62737, 62752, "#372f30", "master"],
		["brood 53", 62753, 62768, "#856d1c", "master"],
		["luna 19", 62769, 62784, "#051227", "master"],
		["lime 19", 62785, 62800, "#75a7dc", "master"],
		["climb 35", 62801, 62816, "#1d443b", "master"],
		["air 36", 62817, 62832, "#885c2d", "master"],
		["fall 75", 62833, 62848, "#3989b3", "master"],
		["drift 19", 62849, 62864, "#9fa7ee", "master"],
		["valley 75", 62865, 62880, "#c37966", "master"],
		["height 17", 62881, 62896, "#454c50", "master"],
		["fog 19", 62897, 62912, "#8c8237", "master"],
		["far 18", 62913, 62928, "#367bcb", "master"],
		["below 52", 62929, 62944, "#c1b8b4", "master"],
		["crest 37", 62945, 62960, "#b2c7d8", "master"],
		["gift 17", 62961, 62976, "#c797e8", "master"],
		["sierra 19", 62977, 62992, "#c36910", "master"],
		["amber 18", 62993, 63008, "#b5674f", "master"],
		["dawn 70", 63009, 63024, "#6a68c7", "master"],
		["river 51", 63025, 63040, "#587a75", "master"],
		["erode 17", 63041, 63056, "#5e92f3", "master"],
		["view 74", 63057, 63072, "#3b7fa6", "master"],
		["set 37", 63073, 63088, "#6b4a3e", "master"],
		["view 75", 63089, 63104, "#060a1f", "master"],
		["sand 37", 63105, 63120, "#1e558c", "master"],
		["mist 85", 63121, 63136, "#052d65", "master"],
		["up 19", 63137, 63152, "#2a7b93", "master"],
		["grass 18", 63153, 63168, "#32283c", "master"],
		["lines 20", 63169, 63184, "#4f80c0", "master"],
		["rapid 19", 63185, 63200, "#bad3e2", "master"],
		["glass 17", 63201, 63216, "#6e9ecf", "master"],
		["arise 38", 63217, 63232, "#385e76", "master"],
		["spire 37", 63233, 63248, "#bca6d7", "master"],
		["wind 19", 63249, 63264, "#f8e6d9", "master"],
		["mist 86", 63265, 63280, "#c1b8b4", "master"],
		["lake 52", 63281, 63296, "#84857f", "master"],
		["flat 20", 63297, 63312, "#3d90ce", "master"],
		["dawn 71", 63313, 63328, "#444b23", "master"],
		["calm 54", 63329, 63344, "#7e6064", "master"],
		["dawn 72", 63345, 63360, "#ae8b14", "master"],
		["rise 19", 63361, 63376, "#bca6d7", "master"],
		["hole 20", 63377, 63392, "#20202c", "master"],
		["dusk 18", 63393, 63408, "#5b447b", "master"],
		["shine 55", 63409, 63424, "#a3904f", "master"],
		["lush 36", 63425, 63440, "#263206", "master"],
		["cliff 19", 63441, 63456, "#43b2eb", "master"],
		["shine 56", 63457, 63472, "#2f387b", "master"],
		["emit 18", 63473, 63488, "#1c3528", "master"],
		["green 39", 63489, 63504, "#263206", "master"],
		["haze 19", 63505, 63520, "#4f80c0", "master"],
		["arrive 37", 63521, 63536, "#b2d4f5", "master"],
		["valley 76", 63537, 63552, "#cea37e", "master"],
		["brook 35", 63553, 63568, "#566f3c", "master"],
		["bright 85", 63569, 63584, "#38423a", "master"],
		["brook 36", 63585, 63600, "#5e4144", "master"],
		["bright 86", 63601, 63616, "#52373c", "master"],
		["mossy 20", 63617, 63632, "#96c4df", "master"],
		["river 52", 63633, 63648, "#1b89d3", "master"],
		["star 20", 63649, 63664, "#3270cd", "master"],
		["mist 87", 63665, 63680, "#d6c3c5", "master"],
		["frond 38", 63681, 63696, "#3b4b18", "master"],
		["view 76", 63697, 63712, "#4186c8", "master"],
		["sky 34", 63713, 63728, "#081328", "master"],
		["bright 87", 63729, 63744, "#1f305b", "master"],
		["wild 18", 63745, 63760, "#1c600b", "master"],
		["sail 20", 63761, 63776, "#8da40a", "master"],
		["fall 76", 63777, 63792, "#43b2eb", "master"],
		["pebble 35", 63793, 63808, "#7e707b", "master"],
		["toad 39", 63809, 63824, "#264056", "master"],
		["shine 57", 63825, 63840, "#a17b63", "master"],
		["toad 40", 63841, 63856, "#898391", "master"],
		["pebble 36", 63857, 63872, "#f5f3e8", "master"],
		["leaf 52", 63873, 63888, "#779c35", "master"],
		["float 20", 63889, 63904, "#3a6daf", "master"],
		["beach 18", 63905, 63920, "#cdad81", "master"],
		["snow 20", 63921, 63936, "#bbc5d9", "master"],
		["grow 19", 63937, 63952, "#3d3a16", "master"],
		["cove 18", 63953, 63968, "#c3d0e0", "master"],
		["gaze 19", 63969, 63984, "#040c18", "master"],
		["fit 18", 63985, 64000, "#3b6fa7", "master"],
		["thick 20", 64001, 64016, "#3d3a16", "master"],
		["blue 20", 64017, 64032, "#dee6dc", "master"],
		["climb 36", 64033, 64048, "#4186c8", "master"],
		["aqua 38", 64049, 64064, "#b9d6e4", "master"],
		["ray 36", 64065, 64080, "#b1934b", "master"],
		["icey 20", 64081, 64096, "#173ebd", "master"],
		["ray 37", 64097, 64112, "#8a8f89", "master"],
		["wash 36", 64113, 64128, "#bd9794", "master"],
		["fir 19", 64129, 64144, "#15573d", "master"],
		["calm 55", 64145, 64160, "#548eb1", "master"],
		["palm 19", 64161, 64176, "#44c7ca", "master"],
		["light 37", 64177, 64192, "#184d4e", "master"],
		["grove 18", 64193, 64208, "#90510a", "master"],
		["rock 37", 64209, 64224, "#b2cbc8", "master"],
		["bluff 19", 64225, 64240, "#3f6e9a", "master"],
		["zeal 19", 64241, 64256, "#89bee6", "master"],
		["cover 37", 64257, 64272, "#90510a", "master"],
		["wave 36", 64273, 64288, "#138cc5", "master"],
		["grace 37", 64289, 64304, "#1b0d35", "master"],
		["shell 37", 64305, 64320, "#d0a973", "master"],
		["solis 19", 64321, 64336, "#d58265", "master"],
		["valley 77", 64337, 64352, "#7e93a8", "master"],
		["below 53", 64353, 64368, "#344f3d", "master"],
		["shell 38", 64369, 64384, "#3d7ac9", "master"],
		["vivid 38", 64385, 64400, "#638cac", "master"],
		["wave 37", 64401, 64416, "#138cc5", "master"],
		["vast 39", 64417, 64432, "#ee9361", "master"],
		["frost 18", 64433, 64448, "#bec8d1", "master"],
		["oak 20", 64449, 64464, "#609fdc", "master"],
		["chill 19", 64465, 64480, "#aaa2df", "master"],
		["lavish 19", 64481, 64496, "#856d1c", "master"],
		["pyre 20", 64497, 64512, "#451624", "master"],
		["red 36", 64513, 64528, "#6d1a10", "master"],
		["vast 40", 64529, 64544, "#c7a884", "master"],
		["serene 37", 64545, 64560, "#b2cbc8", "master"],
		["fresh 36", 64561, 64576, "#c6dded", "master"],
		["strato 20", 64577, 64592, "#0a408a", "master"],
		["arch 17", 64593, 64608, "#1778d2", "master"],
		["fall 77", 64609, 64624, "#364821", "master"],
		["grace 38", 64625, 64640, "#0561d1", "master"],
		["red 37", 64641, 64656, "#675d45", "master"],
		["dry 20", 64657, 64672, "#0f46bf", "master"],
		["sky 35", 64673, 64688, "#8a5425", "master"],
		["crest 38", 64689, 64704, "#b8abda", "master"],
		["birch 18", 64705, 64720, "#ccc6b7", "master"],
		["seed 20", 64721, 64736, "#b5674f", "master"],
		["coast 20", 64737, 64752, "#355732", "master"],
		["ripple 33", 64753, 64768, "#a7a3a0", "master"],
		["wall 20", 64769, 64784, "#b5abb0", "master"],
		["dune 18", 64785, 64800, "#9fa7ee", "master"],
		["set 38", 64801, 64816, "#372f30", "master"],
		["brood 54", 64817, 64832, "#856d1c", "master"],
		["cosmo 17", 64833, 64848, "#3b2446", "master"],
		["lime 20", 64849, 64864, "#75a7dc", "master"],
		["climb 37", 64865, 64880, "#1d443b", "master"],
		["air 37", 64881, 64896, "#885c2d", "master"],
		["fall 78", 64897, 64912, "#3989b3", "master"],
		["dawn 73", 64913, 64928, "#c36910", "master"],
		["valley 78", 64929, 64944, "#c37966", "master"],
		["height 18", 64945, 64960, "#454c50", "master"],
		["fog 20", 64961, 64976, "#8c8237", "master"],
		["far 19", 64977, 64992, "#367bcb", "master"],
		["pine 18", 64993, 65008, "#b2d4f5", "master"],
		["crest 39", 65009, 65024, "#b2c7d8", "master"],
		["gift 18", 65025, 65040, "#c797e8", "master"],
		["sierra 20", 65041, 65056, "#c36910", "master"],
		["amber 19", 65057, 65072, "#b5674f", "master"],
		["bright 88", 65073, 65088, "#355732", "master"],
		["river 53", 65089, 65104, "#587a75", "master"],
		["erode 18", 65105, 65120, "#5e92f3", "master"],
		["view 77", 65121, 65136, "#3b7fa6", "master"],
		["set 39", 65137, 65152, "#6b4a3e", "master"],
		["brood 55", 65153, 65168, "#71851e", "master"],
		["sand 38", 65169, 65184, "#1e558c", "master"],
		["mist 88", 65185, 65200, "#052d65", "master"],
		["up 20", 65201, 65216, "#2a7b93", "master"],
		["grass 19", 65217, 65232, "#32283c", "master"],
		["field 18", 65233, 65248, "#8da40a", "master"],
		["rapid 20", 65249, 65264, "#bad3e2", "master"],
		["glass 18", 65265, 65280, "#6e9ecf", "master"],
		["arise 39", 65281, 65296, "#385e76", "master"],
		["spire 38", 65297, 65312, "#bca6d7", "master"],
		["wind 20", 65313, 65328, "#f8e6d9", "master"],
		["mist 89", 65329, 65344, "#c1b8b4", "master"],
		["lake 53", 65345, 65360, "#84857f", "master"],
		["flat 21", 65361, 65376, "#3d90ce", "master"],
		["dawn 74", 65377, 65392, "#444b23", "master"],
		["calm 56", 65393, 65408, "#7e6064", "master"],
		["dawn 75", 65409, 65424, "#ae8b14", "master"],
		["bright 89", 65425, 65440, "#b2ba44", "master"],
		["hole 21", 65441, 65456, "#20202c", "master"],
		["dusk 19", 65457, 65472, "#5b447b", "master"],
		["shine 58", 65473, 65488, "#a3904f", "master"],
		["lush 37", 65489, 65504, "#263206", "master"],
		["river 54", 65505, 65520, "#c8dce6", "master"],
		["shine 59", 65521, 65536, "#2f387b", "master"],
		["emit 19", 65537, 65552, "#1c3528", "master"],
		["green 40", 65553, 65568, "#263206", "master"],
		["haze 20", 65569, 65584, "#4f80c0", "master"],
		["below 54", 65585, 65600, "#bad3e2", "master"],
		["valley 79", 65601, 65616, "#cea37e", "master"],
		["brook 37", 65617, 65632, "#566f3c", "master"],
		["bright 90", 65633, 65648, "#38423a", "master"],
		["brook 38", 65649, 65664, "#5e4144", "master"],
		["mist 90", 65665, 65680, "#714936", "master"],
		["mossy 21", 65681, 65696, "#96c4df", "master"],
		["river 55", 65697, 65712, "#1b89d3", "master"],
		["star 21", 65713, 65728, "#3270cd", "master"],
		["mist 91", 65729, 65744, "#d6c3c5", "master"],
		["curl 17", 65745, 65760, "#1c600b", "master"],
		["view 78", 65761, 65776, "#4186c8", "master"],
		["sky 36", 65777, 65792, "#081328", "master"],
		["bright 91", 65793, 65808, "#1f305b", "master"],
		["wild 19", 65809, 65824, "#1c600b", "master"],
		["depth 17", 65825, 65840, "#3a6daf", "master"],
		["fall 79", 65841, 65856, "#43b2eb", "master"],
		["pebble 37", 65857, 65872, "#7e707b", "master"],
		["toad 41", 65873, 65888, "#264056", "master"],
		["shine 60", 65889, 65904, "#a17b63", "master"],
		["azure 36", 65905, 65920, "#585e31", "master"],
		["pebble 38", 65921, 65936, "#f5f3e8", "master"],
		["leaf 53", 65937, 65952, "#779c35", "master"],
		["float 21", 65953, 65968, "#3a6daf", "master"],
		["beach 19", 65969, 65984, "#cdad81", "master"],
		["melt 18", 65985, 66000, "#2d6194", "master"],
		["grow 20", 66001, 66016, "#3d3a16", "master"],
		["cove 19", 66017, 66032, "#c3d0e0", "master"],
		["gaze 20", 66033, 66048, "#040c18", "master"],
		["fit 19", 66049, 66064, "#3b6fa7", "master"],
		["vine 18", 66065, 66080, "#4c6111", "master"],
		["blue 21", 66081, 66096, "#dee6dc", "master"],
		["climb 38", 66097, 66112, "#4186c8", "master"],
		["aqua 39", 66113, 66128, "#b9d6e4", "master"],
		["ray 38", 66129, 66144, "#b1934b", "master"],
		["lake 54", 66145, 66160, "#225c75", "master"],
		["ray 39", 66161, 66176, "#8a8f89", "master"],
		["wash 37", 66177, 66192, "#bd9794", "master"],
		["fir 20", 66193, 66208, "#15573d", "master"],
		["calm 57", 66209, 66224, "#548eb1", "master"],
		["shore 18", 66225, 66240, "#e0afae", "master"],
		["light 38", 66241, 66256, "#184d4e", "master"],
		["grove 19", 66257, 66272, "#90510a", "master"],
		["rock 38", 66273, 66288, "#b2cbc8", "master"],
		["bluff 20", 66289, 66304, "#3f6e9a", "master"],
		["opal 18", 66305, 66320, "#d49bc8", "master"],
		["cover 38", 66321, 66336, "#90510a", "master"],
		["wave 38", 66337, 66352, "#138cc5", "master"],
		["grace 39", 66353, 66368, "#1b0d35", "master"],
		["shell 39", 66369, 66384, "#d0a973", "master"],
		["polar 18", 66385, 66400, "#819864", "master"],
		["valley 80", 66401, 66416, "#7e93a8", "master"],
		["below 55", 66417, 66432, "#344f3d", "master"],
		["shell 40", 66433, 66448, "#3d7ac9", "master"],
		["vivid 39", 66449, 66464, "#638cac", "master"],
		["ripple 34", 66465, 66480, "#c7a884", "master"],
		["vast 41", 66481, 66496, "#ee9361", "master"],
		["frost 19", 66497, 66512, "#bec8d1", "master"],
		["oak 21", 66513, 66528, "#609fdc", "master"],
		["chill 20", 66529, 66544, "#aaa2df", "master"],
		["sea 17", 66545, 66560, "#6a68c7", "master"],
		["pyre 21", 66561, 66576, "#451624", "master"],
		["red 38", 66577, 66592, "#6d1a10", "master"],
		["vast 42", 66593, 66608, "#c7a884", "master"],
		["serene 38", 66609, 66624, "#b2cbc8", "master"],
		["view 79", 66625, 66640, "#3f6e9a", "master"],
		["strato 21", 66641, 66656, "#0a408a", "master"],
		["arch 18", 66657, 66672, "#1778d2", "master"],
		["fall 80", 66673, 66688, "#364821", "master"],
		["grace 40", 66689, 66704, "#0561d1", "master"],
		["bark 17", 66705, 66720, "#a17e5e", "master"],
		["dry 21", 66721, 66736, "#0f46bf", "master"],
		["sky 37", 66737, 66752, "#8a5425", "master"],
		["crest 40", 66753, 66768, "#b8abda", "master"],
		["birch 19", 66769, 66784, "#ccc6b7", "master"],
		["grain 17", 66785, 66800, "#f8e6d9", "master"],
		["coast 21", 66801, 66816, "#355732", "master"],
		["ripple 35", 66817, 66832, "#a7a3a0", "master"],
		["wall 21", 66833, 66848, "#b5abb0", "master"],
		["dune 19", 66849, 66864, "#9fa7ee", "master"],
		["calm 58", 66865, 66880, "#aaa2df", "master"],
		["brood 56", 66881, 66896, "#856d1c", "master"],
		["cosmo 18", 66897, 66912, "#3b2446", "master"],
		["lime 21", 66913, 66928, "#75a7dc", "master"],
		["climb 39", 66929, 66944, "#1d443b", "master"],
		["serene 39", 66945, 66960, "#664755", "master"],
		["fall 81", 66961, 66976, "#3989b3", "master"],
		["dawn 76", 66977, 66992, "#c36910", "master"],
		["valley 81", 66993, 67008, "#c37966", "master"],
		["height 19", 67009, 67024, "#454c50", "master"],
		["frond 39", 67025, 67040, "#cfc7a5", "master"],
		["far 20", 67041, 67056, "#367bcb", "master"],
		["pine 19", 67057, 67072, "#b2d4f5", "master"],
		["crest 41", 67073, 67088, "#b2c7d8", "master"],
		["gift 19", 67089, 67104, "#c797e8", "master"],
		["rock 39", 67105, 67120, "#1e558c", "master"],
		["amber 20", 67121, 67136, "#b5674f", "master"],
		["bright 92", 67137, 67152, "#355732", "master"],
		["river 56", 67153, 67168, "#587a75", "master"],
		["erode 19", 67169, 67184, "#5e92f3", "master"],
		["view 80", 67185, 67200, "#3b7fa6", "master"],
		["set 40", 67201, 67216, "#6b4a3e", "master"],
		["brood 57", 67217, 67232, "#71851e", "master"],
		["sand 39", 67233, 67248, "#1e558c", "master"],
		["mist 92", 67249, 67264, "#052d65", "master"],
		["up 21", 67265, 67280, "#2a7b93", "master"],
		["grass 20", 67281, 67296, "#32283c", "master"],
		["field 19", 67297, 67312, "#8da40a", "master"],
		["rapid 21", 67313, 67328, "#bad3e2", "master"],
		["glass 19", 67329, 67344, "#6e9ecf", "master"],
		["arise 40", 67345, 67360, "#385e76", "master"],
		["spire 39", 67361, 67376, "#bca6d7", "master"],
		["soar 18", 67377, 67392, "#367bcb", "master"],
		["mist 93", 67393, 67408, "#c1b8b4", "master"],
		["lake 55", 67409, 67424, "#84857f", "master"],
		["flat 22", 67425, 67440, "#3d90ce", "master"],
		["dawn 77", 67441, 67456, "#444b23", "master"],
		["leaf 54", 67457, 67472, "#516152", "master"],
		["dawn 78", 67473, 67488, "#ae8b14", "master"],
		["bright 93", 67489, 67504, "#b2ba44", "master"],
		["hole 22", 67505, 67520, "#20202c", "master"],
		["dusk 20", 67521, 67536, "#5b447b", "master"],
		["pond 19", 67537, 67552, "#36342a", "master"],
		["lush 38", 67553, 67568, "#263206", "master"],
		["river 57", 67569, 67584, "#c8dce6", "master"],
		["shine 61", 67585, 67600, "#2f387b", "master"],
		["emit 20", 67601, 67616, "#1c3528", "master"],
		["lush 39", 67617, 67632, "#3b4b18", "master"],
		["haze 21", 67633, 67648, "#4f80c0", "master"],
		["below 56", 67649, 67664, "#bad3e2", "master"],
		["valley 82", 67665, 67680, "#cea37e", "master"],
		["brook 39", 67681, 67696, "#566f3c", "master"],
		["mist 94", 67697, 67712, "#a4c1c7", "master"],
		["brook 40", 67713, 67728, "#5e4144", "master"],
		["mist 95", 67729, 67744, "#714936", "master"],
		["mossy 22", 67745, 67760, "#96c4df", "master"],
		["river 58", 67761, 67776, "#1b89d3", "master"],
		["clear 19", 67777, 67792, "#40addf", "master"],
		["mist 96", 67793, 67808, "#d6c3c5", "master"],
		["curl 18", 67809, 67824, "#1c600b", "master"],
		["view 81", 67825, 67840, "#4186c8", "master"],
		["sky 38", 67841, 67856, "#081328", "master"],
		["space 19", 67857, 67872, "#2b2c41", "master"],
		["wild 20", 67873, 67888, "#1c600b", "master"],
		["depth 18", 67889, 67904, "#3a6daf", "master"],
		["fall 82", 67905, 67920, "#43b2eb", "master"],
		["pebble 39", 67921, 67936, "#7e707b", "master"],
		["azure 37", 67937, 67952, "#0f98b9", "master"],
		["shine 62", 67953, 67968, "#a17b63", "master"],
		["azure 38", 67969, 67984, "#585e31", "master"],
		["pebble 40", 67985, 68000, "#f5f3e8", "master"],
		["leaf 55", 68001, 68016, "#779c35", "master"],
		["breeze 19", 68017, 68032, "#dee6dc", "master"],
		["beach 20", 68033, 68048, "#cdad81", "master"],
		["melt 19", 68049, 68064, "#2d6194", "master"],
		["grow 21", 68065, 68080, "#3d3a16", "master"],
		["cove 20", 68081, 68096, "#c3d0e0", "master"],
		["light 39", 68097, 68112, "#0e0f1d", "master"],
		["fit 20", 68113, 68128, "#3b6fa7", "master"],
		["vine 19", 68129, 68144, "#4c6111", "master"],
		["blue 22", 68145, 68160, "#dee6dc", "master"],
		["climb 40", 68161, 68176, "#4186c8", "master"],
		["wash 38", 68177, 68192, "#756e8d", "master"],
		["ray 40", 68193, 68208, "#b1934b", "master"],
		["lake 56", 68209, 68224, "#225c75", "master"],
		["ray 41", 68225, 68240, "#8a8f89", "master"],
		["wash 39", 68241, 68256, "#bd9794", "master"],
		["cover 39", 68257, 68272, "#134f7b", "master"],
		["calm 59", 68273, 68288, "#548eb1", "master"],
		["shore 19", 68289, 68304, "#e0afae", "master"],
		["light 40", 68305, 68320, "#184d4e", "master"],
		["grove 20", 68321, 68336, "#90510a", "master"],
		["slope 18", 68337, 68352, "#372f30", "master"],
		["bluff 21", 68353, 68368, "#3f6e9a", "master"],
		["opal 19", 68369, 68384, "#d49bc8", "master"],
		["cover 40", 68385, 68400, "#90510a", "master"],
		["wave 39", 68401, 68416, "#138cc5", "master"],
		["air 38", 68417, 68432, "#c3d0e0", "master"],
		["shell 41", 68433, 68448, "#d0a973", "master"],
		["polar 19", 68449, 68464, "#819864", "master"],
		["valley 83", 68465, 68480, "#7e93a8", "master"],
		["below 57", 68481, 68496, "#344f3d", "master"],
		["fresh 37", 68497, 68512, "#42a198", "master"],
		["vivid 40", 68513, 68528, "#638cac", "master"],
		["ripple 36", 68529, 68544, "#c7a884", "master"],
		["vast 43", 68545, 68560, "#ee9361", "master"],
		["frost 20", 68561, 68576, "#bec8d1", "master"],
		["ruby 18", 68577, 68592, "#6d1a10", "master"],
		["chill 21", 68593, 68608, "#aaa2df", "master"],
		["sea 18", 68609, 68624, "#6a68c7", "master"],
		["pyre 22", 68625, 68640, "#451624", "master"],
		["red 39", 68641, 68656, "#6d1a10", "master"],
		["sand 40", 68657, 68672, "#0f46bf", "master"],
		["serene 40", 68673, 68688, "#b2cbc8", "master"],
		["view 82", 68689, 68704, "#3f6e9a", "master"],
		["strato 22", 68705, 68720, "#0a408a", "master"],
		["arch 19", 68721, 68736, "#1778d2", "master"],
		["above 37", 68737, 68752, "#cfd088", "master"],
		["grace 41", 68753, 68768, "#0561d1", "master"],
		["bark 18", 68769, 68784, "#a17e5e", "master"],
		["dry 22", 68785, 68800, "#0f46bf", "master"],
		["sky 39", 68801, 68816, "#8a5425", "master"],
		["peace 19", 68817, 68832, "#789395", "master"],
		["birch 20", 68833, 68848, "#ccc6b7", "master"],
		["grain 18", 68849, 68864, "#f8e6d9", "master"],
		["coast 22", 68865, 68880, "#355732", "master"],
		["ripple 37", 68881, 68896, "#a7a3a0", "master"],
		["bask 19", 68897, 68912, "#939aa5", "master"],
		["dune 20", 68913, 68928, "#9fa7ee", "master"],
		["calm 60", 68929, 68944, "#aaa2df", "master"],
		["brood 58", 68945, 68960, "#856d1c", "master"],
		["cosmo 19", 68961, 68976, "#3b2446", "master"],
		["arid 20", 68977, 68992, "#c5c3b7", "master"],
		["climb 41", 68993, 69008, "#1d443b", "master"],
		["serene 41", 69009, 69024, "#664755", "master"],
		["fall 83", 69025, 69040, "#3989b3", "master"],
		["dawn 79", 69041, 69056, "#c36910", "master"],
		["valley 84", 69057, 69072, "#c37966", "master"],
		["height 20", 69073, 69088, "#454c50", "master"],
		["frond 40", 69089, 69104, "#cfc7a5", "master"],
		["far 21", 69105, 69120, "#367bcb", "master"],
		["pine 20", 69121, 69136, "#b2d4f5", "master"],
		["crest 42", 69137, 69152, "#b2c7d8", "master"],
		["gift 20", 69153, 69168, "#c797e8", "master"],
		["rock 40", 69169, 69184, "#1e558c", "master"],
		["amber 21", 69185, 69200, "#b5674f", "master"],
		["bright 94", 69201, 69216, "#355732", "master"],
		["river 59", 69217, 69232, "#587a75", "master"],
		["erode 20", 69233, 69248, "#5e92f3", "master"],
		["brood 59", 69249, 69264, "#85a7c8", "master"],
		["set 41", 69265, 69280, "#6b4a3e", "master"],
		["brood 60", 69281, 69296, "#71851e", "master"],
		["sand 41", 69297, 69312, "#1e558c", "master"],
		["mist 97", 69313, 69328, "#052d65", "master"],
		["valley 85", 69329, 69344, "#d5c284", "master"],
		["grass 21", 69345, 69360, "#32283c", "master"],
		["field 20", 69361, 69376, "#8da40a", "master"],
		["rapid 22", 69377, 69392, "#bad3e2", "master"],
		["glass 20", 69393, 69408, "#6e9ecf", "master"],
		["sol 19", 69409, 69424, "#0b545c", "master"],
		["spire 40", 69425, 69440, "#bca6d7", "master"],
		["soar 19", 69441, 69456, "#367bcb", "master"],
		["mist 98", 69457, 69472, "#c1b8b4", "master"],
		["lake 57", 69473, 69488, "#84857f", "master"],
		["leaf 56", 69489, 69504, "#daee95", "master"],
		["dawn 80", 69505, 69520, "#444b23", "master"],
		["leaf 57", 69521, 69536, "#516152", "master"],
		["dawn 81", 69537, 69552, "#ae8b14", "master"],
		["bright 95", 69553, 69568, "#b2ba44", "master"],
		["curve 19", 69569, 69584, "#904024", "master"],
		["dusk 21", 69585, 69600, "#5b447b", "master"],
		["pond 20", 69601, 69616, "#36342a", "master"],
		["lush 40", 69617, 69632, "#263206", "master"],
		["river 60", 69633, 69648, "#c8dce6", "master"],
		["watch 19", 69649, 69664, "#0a2a41", "master"],
		["emit 21", 69665, 69680, "#1c3528", "master"],
		["lush 41", 69681, 69696, "#3b4b18", "master"],
		["haze 22", 69697, 69712, "#4f80c0", "master"],
		["below 58", 69713, 69728, "#bad3e2", "master"],
		["wood 20", 69729, 69744, "#b2aaa4", "master"],
		["brook 41", 69745, 69760, "#566f3c", "master"],
		["mist 99", 69761, 69776, "#a4c1c7", "master"],
		["brook 42", 69777, 69792, "#5e4144", "master"],
		["mist 100", 69793, 69808, "#714936", "master"],
		["fall 84", 69809, 69824, "#7a5d2b", "master"],
		["river 61", 69825, 69840, "#1b89d3", "master"],
		["clear 20", 69841, 69856, "#40addf", "master"],
		["mist 101", 69857, 69872, "#d6c3c5", "master"],
		["curl 19", 69873, 69888, "#1c600b", "master"],
		["marsh 20", 69889, 69904, "#1b0d35", "master"],
		["sky 40", 69905, 69920, "#081328", "master"],
		["space 20", 69921, 69936, "#2b2c41", "master"],
		["wild 21", 69937, 69952, "#1c600b", "master"],
		["depth 19", 69953, 69968, "#3a6daf", "master"],
		["above 38", 69969, 69984, "#c8dce6", "master"],
		["pebble 41", 69985, 70000, "#7e707b", "master"],
		["azure 39", 70001, 70016, "#0f98b9", "master"],
		["shine 63", 70017, 70032, "#a17b63", "master"],
		["azure 40", 70033, 70048, "#585e31", "master"],
		["aqua 40", 70049, 70064, "#295771", "master"],
		["leaf 58", 70065, 70080, "#779c35", "master"],
		["breeze 20", 70081, 70096, "#dee6dc", "master"],
		["beach 21", 70097, 70112, "#cdad81", "master"],
		["melt 20", 70113, 70128, "#2d6194", "master"],
		["green 41", 70129, 70144, "#4c6111", "master"],
		["cove 21", 70145, 70160, "#c3d0e0", "master"],
		["light 41", 70161, 70176, "#0e0f1d", "master"],
		["fit 21", 70177, 70192, "#3b6fa7", "master"],
		["vine 20", 70193, 70208, "#4c6111", "master"],
		["storm 19", 70209, 70224, "#548eb1", "master"],
		["climb 42", 70225, 70240, "#4186c8", "master"],
		["wash 40", 70241, 70256, "#756e8d", "master"],
		["ray 42", 70257, 70272, "#b1934b", "master"],
		["lake 58", 70273, 70288, "#225c75", "master"],
		["arrive 38", 70289, 70304, "#d3dbce", "master"],
		["wash 41", 70305, 70320, "#bd9794", "master"],
		["cover 41", 70321, 70336, "#134f7b", "master"],
		["calm 61", 70337, 70352, "#548eb1", "master"],
		["shore 20", 70353, 70368, "#e0afae", "master"],
		["freeze 19", 70369, 70384, "#73a0bd", "master"],
		["grove 21", 70385, 70400, "#90510a", "master"],
		["slope 19", 70401, 70416, "#372f30", "master"],
		["bluff 22", 70417, 70432, "#3f6e9a", "master"],
		["opal 20", 70433, 70448, "#d49bc8", "master"],
		["vivid 41", 70449, 70464, "#609fdc", "master"],
		["wave 40", 70465, 70480, "#138cc5", "master"],
		["air 39", 70481, 70496, "#c3d0e0", "master"],
		["shell 42", 70497, 70512, "#d0a973", "master"],
		["polar 20", 70513, 70528, "#819864", "master"],
		["white 19", 70529, 70544, "#6d8cab", "master"],
		["below 59", 70545, 70560, "#344f3d", "master"],
		["fresh 38", 70561, 70576, "#42a198", "master"],
		["vivid 42", 70577, 70592, "#638cac", "master"],
		["ripple 38", 70593, 70608, "#c7a884", "master"],
		["lake 59", 70609, 70624, "#d9ca87", "master"],
		["frost 21", 70625, 70640, "#bec8d1", "master"],
		["ruby 19", 70641, 70656, "#6d1a10", "master"],
		["chill 22", 70657, 70672, "#aaa2df", "master"],
		["sea 19", 70673, 70688, "#6a68c7", "master"],
		["arise 41", 70689, 70704, "#0e3650", "master"],
		["red 40", 70705, 70720, "#6d1a10", "master"],
		["sand 42", 70721, 70736, "#0f46bf", "master"],
		["serene 42", 70737, 70752, "#b2cbc8", "master"],
		["view 83", 70753, 70768, "#3f6e9a", "master"],
		["luna 20", 70769, 70784, "#051227", "master"],
		["arch 20", 70785, 70800, "#1778d2", "master"],
		["above 39", 70801, 70816, "#cfd088", "master"],
		["grace 42", 70817, 70832, "#0561d1", "master"],
		["bark 19", 70833, 70848, "#a17e5e", "master"],
		["drift 20", 70849, 70864, "#9fa7ee", "master"],
		["sky 41", 70865, 70880, "#8a5425", "master"],
		["peace 20", 70881, 70896, "#789395", "master"],
		["birch 21", 70897, 70912, "#ccc6b7", "master"],
		["grain 19", 70913, 70928, "#f8e6d9", "master"],
		["below 60", 70929, 70944, "#c1b8b4", "master"],
		["ripple 39", 70945, 70960, "#a7a3a0", "master"],
		["bask 20", 70961, 70976, "#939aa5", "master"],
		["dune 21", 70977, 70992, "#9fa7ee", "master"],
		["calm 62", 70993, 71008, "#aaa2df", "master"],
		["brood 61", 71009, 71024, "#856d1c", "master"],
		["cosmo 20", 71025, 71040, "#3b2446", "master"],
		["arid 21", 71041, 71056, "#c5c3b7", "master"],
		["climb 43", 71057, 71072, "#1d443b", "master"],
		["serene 43", 71073, 71088, "#664755", "master"],
		["fall 85", 71089, 71104, "#3989b3", "master"],
		["dawn 82", 71105, 71120, "#c36910", "master"],
		["spire 41", 71121, 71136, "#36483b", "master"],
		["height 21", 71137, 71152, "#454c50", "master"],
		["frond 41", 71153, 71168, "#cfc7a5", "master"],
		["far 22", 71169, 71184, "#367bcb", "master"],
		["pine 21", 71185, 71200, "#b2d4f5", "master"],
		["still 20", 71201, 71216, "#c77fd2", "master"],
		["gift 21", 71217, 71232, "#c797e8", "master"],
		["rock 41", 71233, 71248, "#1e558c", "master"],
		["amber 22", 71249, 71264, "#b5674f", "master"],
		["bright 96", 71265, 71280, "#355732", "master"],
		["range 20", 71281, 71296, "#34447a", "master"],
		["erode 21", 71297, 71312, "#5e92f3", "master"],
		["brood 62", 71313, 71328, "#85a7c8", "master"],
		["set 42", 71329, 71344, "#6b4a3e", "master"],
		["brood 63", 71345, 71360, "#71851e", "master"],
		["rise 20", 71361, 71376, "#bca6d7", "master"],
		["mist 102", 71377, 71392, "#052d65", "master"],
		["valley 86", 71393, 71408, "#d5c284", "master"],
		["grass 22", 71409, 71424, "#32283c", "master"],
		["field 21", 71425, 71440, "#8da40a", "master"],
		["cliff 20", 71441, 71456, "#43b2eb", "master"],
		["glass 21", 71457, 71472, "#6e9ecf", "master"],
		["sol 20", 71473, 71488, "#0b545c", "master"],
		["spire 42", 71489, 71504, "#bca6d7", "master"],
		["soar 20", 71505, 71520, "#367bcb", "master"],
		["arrive 39", 71521, 71536, "#b2d4f5", "master"],
		["lake 60", 71537, 71552, "#84857f", "master"],
		["leaf 59", 71553, 71568, "#daee95", "master"],
		["dawn 83", 71569, 71584, "#444b23", "master"],
		["leaf 60", 71585, 71600, "#516152", "master"],
		["bright 97", 71601, 71632, "#52373c", "master"],
		["curve 20", 71633, 71648, "#904024", "master"],
		["dusk 22", 71649, 71664, "#5b447b", "master"],
		["pond 21", 71665, 71680, "#36342a", "master"],
		["frond 42", 71681, 71696, "#3b4b18", "master"],
		["river 62", 71697, 71712, "#c8dce6", "master"],
		["watch 20", 71713, 71728, "#0a2a41", "master"],
		["emit 22", 71729, 71744, "#1c3528", "master"],
		["lush 42", 71745, 71760, "#3b4b18", "master"],
		["sail 21", 71761, 71776, "#8da40a", "master"],
		["below 61", 71777, 71792, "#bad3e2", "master"],
		["wood 21", 71793, 71808, "#b2aaa4", "master"],
		["brook 43", 71809, 71824, "#566f3c", "master"],
		["mist 103", 71825, 71840, "#a4c1c7", "master"],
		["toad 42", 71841, 71856, "#898391", "master"],
		["mist 104", 71857, 71872, "#714936", "master"],
		["fall 86", 71873, 71888, "#7a5d2b", "master"],
		["river 63", 71889, 71904, "#1b89d3", "master"],
		["clear 21", 71905, 71920, "#40addf", "master"],
		["snow 21", 71921, 71936, "#bbc5d9", "master"],
		["curl 20", 71937, 71952, "#1c600b", "master"],
		["marsh 21", 71953, 71968, "#1b0d35", "master"],
		["sky 42", 71969, 71984, "#081328", "master"],
		["space 21", 71985, 72000, "#2b2c41", "master"],
		["thick 21", 72001, 72016, "#3d3a16", "master"],
		["depth 20", 72017, 72032, "#3a6daf", "master"],
		["above 40", 72033, 72048, "#c8dce6", "master"],
		["pebble 42", 72049, 72064, "#7e707b", "master"],
		["azure 41", 72065, 72080, "#0f98b9", "master"],
		["icey 21", 72081, 72096, "#173ebd", "master"],
		["azure 42", 72097, 72112, "#585e31", "master"],
		["aqua 41", 72113, 72128, "#295771", "master"],
		["leaf 61", 72129, 72144, "#779c35", "master"],
		["breeze 21", 72145, 72160, "#dee6dc", "master"],
		["palm 20", 72161, 72176, "#44c7ca", "master"],
		["melt 21", 72177, 72192, "#2d6194", "master"],
		["green 42", 72193, 72208, "#4c6111", "master"],
		["cove 22", 72209, 72224, "#c3d0e0", "master"],
		["light 42", 72225, 72240, "#0e0f1d", "master"],
		["zeal 20", 72241, 72256, "#89bee6", "master"],
		["vine 21", 72257, 72272, "#4c6111", "master"],
		["storm 20", 72273, 72288, "#548eb1", "master"],
		["climb 44", 72289, 72304, "#4186c8", "master"],
		["wash 42", 72305, 72320, "#756e8d", "master"],
		["solis 20", 72321, 72336, "#d58265", "master"],
		["lake 61", 72337, 72352, "#225c75", "master"],
		["arrive 40", 72353, 72368, "#d3dbce", "master"],
		["wash 43", 72369, 72384, "#bd9794", "master"],
		["cover 42", 72385, 72400, "#134f7b", "master"],
		["wave 41", 72401, 72416, "#138cc5", "master"],
		["shore 21", 72417, 72432, "#e0afae", "master"],
		["freeze 20", 72433, 72448, "#73a0bd", "master"],
		["grove 22", 72449, 72464, "#90510a", "master"],
		["slope 20", 72465, 72480, "#372f30", "master"],
		["lavish 20", 72481, 72496, "#856d1c", "master"],
		["opal 21", 72497, 72512, "#d49bc8", "master"],
		["vivid 43", 72513, 72528, "#609fdc", "master"],
		["wave 42", 72529, 72544, "#138cc5", "master"],
		["air 40", 72545, 72560, "#c3d0e0", "master"],
		["fresh 39", 72561, 72576, "#c6dded", "master"],
		["polar 21", 72577, 72592, "#819864", "master"],
		["white 20", 72593, 72608, "#6d8cab", "master"],
		["below 62", 72609, 72624, "#344f3d", "master"],
		["fresh 40", 72625, 72640, "#42a198", "master"],
		["red 41", 72641, 72656, "#675d45", "master"],
		["ripple 40", 72657, 72672, "#c7a884", "master"],
		["lake 62", 72673, 72688, "#d9ca87", "master"],
		["frost 22", 72689, 72704, "#bec8d1", "master"],
		["ruby 20", 72705, 72720, "#6d1a10", "master"],
		["seed 21", 72721, 72736, "#b5674f", "master"],
		["sea 20", 72737, 72752, "#6a68c7", "master"],
		["arise 42", 72753, 72768, "#0e3650", "master"],
		["red 42", 72769, 72784, "#6d1a10", "master"],
		["sand 43", 72785, 72800, "#0f46bf", "master"],
		["set 43", 72801, 72816, "#372f30", "master"],
		["view 84", 72817, 72832, "#3f6e9a", "master"],
		["luna 21", 72833, 72848, "#051227", "master"],
		["arch 21", 72849, 72864, "#1778d2", "master"],
		["above 41", 72865, 72880, "#cfd088", "master"],
		["grace 43", 72881, 72896, "#0561d1", "master"],
		["bark 20", 72897, 72912, "#a17e5e", "master"],
		["drift 21", 72913, 72928, "#9fa7ee", "master"],
		["sky 43", 72929, 72944, "#8a5425", "master"],
		["peace 21", 72945, 72960, "#789395", "master"],
		["birch 22", 72961, 72976, "#ccc6b7", "master"],
		["grain 20", 72977, 72992, "#f8e6d9", "master"],
		["below 63", 72993, 73008, "#c1b8b4", "master"],
		["ripple 41", 73009, 73024, "#a7a3a0", "master"],
		["bask 21", 73025, 73040, "#939aa5", "master"],
		["dune 22", 73041, 73056, "#9fa7ee", "master"],
		["calm 63", 73057, 73072, "#aaa2df", "master"],
		["dawn 84", 73073, 73088, "#6a68c7", "master"],
		["cosmo 21", 73089, 73104, "#3b2446", "master"],
		["arid 22", 73105, 73120, "#c5c3b7", "master"],
		["climb 45", 73121, 73136, "#1d443b", "master"],
		["serene 44", 73137, 73152, "#664755", "master"],
		["view 85", 73153, 73168, "#060a1f", "master"],
		["dawn 85", 73169, 73184, "#c36910", "master"],
		["spire 43", 73185, 73200, "#36483b", "master"],
		["height 22", 73201, 73216, "#454c50", "master"],
		["frond 43", 73217, 73232, "#cfc7a5", "master"],
		["lines 21", 73233, 73248, "#4f80c0", "master"],
		["pine 22", 73249, 73264, "#b2d4f5", "master"],
		["still 21", 73265, 73280, "#c77fd2", "master"],
		["gift 22", 73281, 73296, "#c797e8", "master"],
		["rock 42", 73297, 73312, "#1e558c", "master"],
		["wind 21", 73313, 73328, "#f8e6d9", "master"],
		["bright 98", 73329, 73344, "#355732", "master"],
		["range 21", 73345, 73360, "#34447a", "master"],
		["erode 22", 73361, 73376, "#5e92f3", "master"],
		["brood 64", 73377, 73392, "#85a7c8", "master"],
		["calm 64", 73393, 73408, "#7e6064", "master"],
		["brood 65", 73409, 73424, "#71851e", "master"],
		["rise 21", 73425, 73440, "#bca6d7", "master"],
		["mist 105", 73441, 73456, "#052d65", "master"],
		["valley 87", 73457, 73472, "#d5c284", "master"],
		["shine 64", 73473, 73488, "#a3904f", "master"],
		["field 22", 73489, 73504, "#8da40a", "master"],
		["cliff 21", 73505, 73520, "#43b2eb", "master"],
		["glass 22", 73521, 73536, "#6e9ecf", "master"],
		["sol 21", 73537, 73552, "#0b545c", "master"],
		["green 43", 73553, 73568, "#263206", "master"],
		["soar 21", 73569, 73584, "#367bcb", "master"],
		["arrive 41", 73585, 73600, "#b2d4f5", "master"],
		["lake 63", 73601, 73616, "#84857f", "master"],
		["leaf 62", 73617, 73632, "#daee95", "master"],
		["bright 99", 73633, 73648, "#38423a", "master"],
		["leaf 63", 73649, 73664, "#516152", "master"],
		["bright 100", 73665, 73696, "#52373c", "master"],
		["curve 21", 73697, 73712, "#904024", "master"],
		["star 22", 73713, 73728, "#3270cd", "master"],
		["pond 22", 73729, 73744, "#36342a", "master"],
		["frond 44", 73745, 73760, "#3b4b18", "master"],
		["river 64", 73761, 73776, "#c8dce6", "master"],
		["watch 21", 73777, 73792, "#0a2a41", "master"],
		["bright 101", 73793, 73808, "#1f305b", "master"],
		["lush 43", 73809, 73824, "#3b4b18", "master"],
		["sail 22", 73825, 73840, "#8da40a", "master"],
		["below 64", 73841, 73856, "#bad3e2", "master"],
		["wood 22", 73857, 73872, "#b2aaa4", "master"],
		["toad 43", 73873, 73888, "#264056", "master"],
		["mist 106", 73889, 73904, "#a4c1c7", "master"],
		["toad 44", 73905, 73920, "#898391", "master"],
		["mist 107", 73921, 73936, "#714936", "master"],
		["fall 87", 73937, 73952, "#7a5d2b", "master"],
		["float 22", 73953, 73968, "#3a6daf", "master"],
		["clear 22", 73969, 73984, "#40addf", "master"],
		["snow 22", 73985, 74000, "#bbc5d9", "master"],
		["curl 21", 74001, 74016, "#1c600b", "master"],
		["marsh 22", 74017, 74032, "#1b0d35", "master"],
		["gaze 21", 74033, 74048, "#040c18", "master"],
		["space 22", 74049, 74064, "#2b2c41", "master"],
		["thick 22", 74065, 74080, "#3d3a16", "master"],
		["depth 21", 74081, 74096, "#3a6daf", "master"],
		["above 42", 74097, 74112, "#c8dce6", "master"],
		["aqua 42", 74113, 74128, "#b9d6e4", "master"],
		["azure 43", 74129, 74144, "#0f98b9", "master"],
		["icey 22", 74145, 74160, "#173ebd", "master"],
		["azure 44", 74161, 74176, "#585e31", "master"],
		["aqua 43", 74177, 74192, "#295771", "master"],
		["fir 21", 74193, 74208, "#15573d", "master"],
		["breeze 22", 74209, 74224, "#dee6dc", "master"],
		["palm 21", 74225, 74240, "#44c7ca", "master"],
		["melt 22", 74241, 74256, "#2d6194", "master"],
		["green 44", 74257, 74272, "#4c6111", "master"],
		["rock 43", 74273, 74288, "#b2cbc8", "master"],
		["light 43", 74289, 74304, "#0e0f1d", "master"],
		["zeal 21", 74305, 74320, "#89bee6", "master"],
		["vine 22", 74321, 74336, "#4c6111", "master"],
		["storm 21", 74337, 74352, "#548eb1", "master"],
		["grace 44", 74353, 74368, "#1b0d35", "master"],
		["wash 44", 74369, 74384, "#756e8d", "master"],
		["solis 21", 74385, 74400, "#d58265", "master"],
		["lake 64", 74401, 74416, "#225c75", "master"],
		["arrive 42", 74417, 74432, "#d3dbce", "master"],
		["shell 43", 74433, 74448, "#3d7ac9", "master"],
		["cover 43", 74449, 74464, "#134f7b", "master"],
		["wave 43", 74465, 74480, "#138cc5", "master"],
		["shore 22", 74481, 74496, "#e0afae", "master"],
		["freeze 21", 74497, 74512, "#73a0bd", "master"],
		["oak 22", 74513, 74528, "#609fdc", "master"],
		["slope 21", 74529, 74544, "#372f30", "master"],
		["lavish 21", 74545, 74560, "#856d1c", "master"],
		["opal 22", 74561, 74576, "#d49bc8", "master"],
		["vivid 44", 74577, 74592, "#609fdc", "master"],
		["vast 44", 74593, 74608, "#c7a884", "master"],
		["air 41", 74609, 74624, "#c3d0e0", "master"],
		["fresh 41", 74625, 74640, "#c6dded", "master"],
		["polar 22", 74641, 74656, "#819864", "master"],
		["white 21", 74657, 74672, "#6d8cab", "master"],
		["fall 88", 74673, 74688, "#364821", "master"],
		["fresh 42", 74689, 74704, "#42a198", "master"],
		["red 43", 74705, 74720, "#675d45", "master"],
		["ripple 42", 74721, 74736, "#c7a884", "master"],
		["lake 65", 74737, 74752, "#d9ca87", "master"],
		["crest 43", 74753, 74768, "#b8abda", "master"],
		["ruby 21", 74769, 74784, "#6d1a10", "master"],
		["seed 22", 74785, 74800, "#b5674f", "master"],
		["sea 21", 74801, 74816, "#6a68c7", "master"],
		["arise 43", 74817, 74832, "#0e3650", "master"],
		["red 44", 74833, 74848, "#6d1a10", "master"],
		["sand 44", 74849, 74864, "#0f46bf", "master"],
		["set 44", 74865, 74880, "#372f30", "master"],
		["view 86", 74881, 74896, "#3f6e9a", "master"],
		["luna 22", 74897, 74912, "#051227", "master"],
		["arch 22", 74913, 74928, "#1778d2", "master"],
		["above 43", 74929, 74944, "#cfd088", "master"],
		["air 42", 74945, 74960, "#885c2d", "master"],
		["bark 21", 74961, 74976, "#a17e5e", "master"],
		["drift 22", 74977, 74992, "#9fa7ee", "master"],
		["sky 44", 74993, 75008, "#8a5425", "master"],
		["peace 22", 75009, 75024, "#789395", "master"],
		["fog 21", 75025, 75040, "#8c8237", "master"],
		["grain 21", 75041, 75056, "#f8e6d9", "master"],
		["below 65", 75057, 75072, "#c1b8b4", "master"],
		["ripple 43", 75073, 75088, "#a7a3a0", "master"],
		["bask 22", 75089, 75104, "#939aa5", "master"],
		["sierra 21", 75105, 75120, "#c36910", "master"],
		["calm 65", 75121, 75136, "#aaa2df", "master"],
		["dawn 86", 75137, 75152, "#6a68c7", "master"],
		["cosmo 22", 75153, 75168, "#3b2446", "master"],
		["arid 23", 75169, 75184, "#c5c3b7", "master"],
		["view 87", 75185, 75200, "#3b7fa6", "master"],
		["serene 45", 75201, 75216, "#664755", "master"],
		["view 88", 75217, 75232, "#060a1f", "master"],
		["dawn 87", 75233, 75248, "#c36910", "master"],
		["spire 44", 75249, 75264, "#36483b", "master"],
		["up 22", 75265, 75280, "#2a7b93", "master"],
		["frond 45", 75281, 75296, "#cfc7a5", "master"],
		["lines 22", 75297, 75312, "#4f80c0", "master"],
		["pine 23", 75313, 75328, "#b2d4f5", "master"],
		["still 22", 75329, 75344, "#c77fd2", "master"],
		["arise 44", 75345, 75360, "#385e76", "master"],
		["rock 44", 75361, 75376, "#1e558c", "master"],
		["wind 22", 75377, 75392, "#f8e6d9", "master"],
		["bright 102", 75393, 75408, "#355732", "master"],
		["range 22", 75409, 75424, "#34447a", "master"],
		["flat 23", 75425, 75440, "#3d90ce", "master"],
		["brood 66", 75441, 75456, "#85a7c8", "master"],
		["calm 66", 75457, 75472, "#7e6064", "master"],
		["brood 67", 75473, 75488, "#71851e", "master"],
		["rise 22", 75489, 75504, "#bca6d7", "master"],
		["hole 23", 75505, 75520, "#20202c", "master"],
		["valley 88", 75521, 75536, "#d5c284", "master"],
		["shine 65", 75537, 75552, "#a3904f", "master"],
		["field 23", 75553, 75568, "#8da40a", "master"],
		["cliff 22", 75569, 75584, "#43b2eb", "master"],
		["shine 66", 75585, 75600, "#2f387b", "master"],
		["sol 22", 75601, 75616, "#0b545c", "master"],
		["green 45", 75617, 75632, "#263206", "master"],
		["soar 22", 75633, 75648, "#367bcb", "master"],
		["arrive 43", 75649, 75664, "#b2d4f5", "master"],
		["valley 89", 75665, 75680, "#cea37e", "master"],
		["leaf 64", 75681, 75696, "#daee95", "master"],
		["bright 103", 75697, 75712, "#38423a", "master"],
		["leaf 65", 75713, 75728, "#516152", "master"],
		["bright 104", 75729, 75744, "#52373c", "master"],
		["mossy 23", 75745, 75760, "#96c4df", "master"],
		["curve 22", 75761, 75776, "#904024", "master"],
		["star 23", 75777, 75792, "#3270cd", "master"],
		["pond 23", 75793, 75808, "#36342a", "master"],
		["frond 46", 75809, 75824, "#3b4b18", "master"],
		["view 89", 75825, 75840, "#4186c8", "master"],
		["watch 22", 75841, 75856, "#0a2a41", "master"],
		["bright 105", 75857, 75872, "#1f305b", "master"],
		["lush 44", 75873, 75888, "#3b4b18", "master"],
		["sail 23", 75889, 75904, "#8da40a", "master"],
		["fall 89", 75905, 75920, "#43b2eb", "master"],
		["wood 23", 75921, 75936, "#b2aaa4", "master"],
		["toad 45", 75937, 75952, "#264056", "master"],
		["mist 108", 75953, 75968, "#a4c1c7", "master"],
		["toad 46", 75969, 75984, "#898391", "master"],
		["pebble 43", 75985, 76000, "#f5f3e8", "master"],
		["fall 90", 76001, 76016, "#7a5d2b", "master"],
		["float 23", 76017, 76032, "#3a6daf", "master"],
		["clear 23", 76033, 76048, "#40addf", "master"],
		["snow 23", 76049, 76064, "#bbc5d9", "master"],
		["grow 22", 76065, 76080, "#3d3a16", "master"],
		["marsh 23", 76081, 76096, "#1b0d35", "master"],
		["gaze 22", 76097, 76112, "#040c18", "master"],
		["space 23", 76113, 76128, "#2b2c41", "master"],
		["thick 23", 76129, 76144, "#3d3a16", "master"],
		["blue 23", 76145, 76160, "#dee6dc", "master"],
		["above 44", 76161, 76176, "#c8dce6", "master"],
		["aqua 44", 76177, 76192, "#b9d6e4", "master"],
		["azure 45", 76193, 76208, "#0f98b9", "master"],
		["icey 23", 76209, 76224, "#173ebd", "master"],
		["ray 43", 76225, 76240, "#8a8f89", "master"],
		["aqua 45", 76241, 76256, "#295771", "master"],
		["fir 22", 76257, 76272, "#15573d", "master"],
		["breeze 23", 76273, 76288, "#dee6dc", "master"],
		["palm 22", 76289, 76304, "#44c7ca", "master"],
		["light 44", 76305, 76320, "#184d4e", "master"],
		["green 46", 76321, 76336, "#4c6111", "master"],
		["rock 45", 76337, 76352, "#b2cbc8", "master"],
		["light 45", 76353, 76368, "#0e0f1d", "master"],
		["zeal 22", 76369, 76384, "#89bee6", "master"],
		["cover 44", 76385, 76400, "#90510a", "master"],
		["storm 22", 76401, 76416, "#548eb1", "master"],
		["grace 45", 76417, 76432, "#1b0d35", "master"],
		["wash 45", 76433, 76448, "#756e8d", "master"],
		["solis 22", 76449, 76464, "#d58265", "master"],
		["valley 90", 76465, 76480, "#7e93a8", "master"],
		["arrive 44", 76481, 76496, "#d3dbce", "master"],
		["shell 44", 76497, 76512, "#3d7ac9", "master"],
		["cover 45", 76513, 76528, "#134f7b", "master"],
		["wave 44", 76529, 76544, "#138cc5", "master"],
		["vast 45", 76545, 76560, "#ee9361", "master"],
		["freeze 22", 76561, 76576, "#73a0bd", "master"],
		["oak 23", 76577, 76592, "#609fdc", "master"],
		["slope 22", 76593, 76608, "#372f30", "master"],
		["lavish 22", 76609, 76624, "#856d1c", "master"],
		["pyre 23", 76625, 76640, "#451624", "master"],
		["vivid 45", 76641, 76656, "#609fdc", "master"],
		["vast 46", 76657, 76672, "#c7a884", "master"],
		["air 43", 76673, 76688, "#c3d0e0", "master"],
		["fresh 43", 76689, 76704, "#c6dded", "master"],
		["polar 23", 76705, 76720, "#819864", "master"],
		["white 22", 76721, 76736, "#6d8cab", "master"],
		["fall 91", 76737, 76752, "#364821", "master"],
		["fresh 44", 76753, 76768, "#42a198", "master"],
		["red 45", 76769, 76784, "#675d45", "master"],
		["ripple 44", 76785, 76800, "#c7a884", "master"],
		["lake 66", 76801, 76816, "#d9ca87", "master"],
		["crest 44", 76817, 76832, "#b8abda", "master"],
		["ruby 22", 76833, 76848, "#6d1a10", "master"],
		["seed 23", 76849, 76864, "#b5674f", "master"],
		["sea 22", 76865, 76880, "#6a68c7", "master"],
		["arise 45", 76881, 76896, "#0e3650", "master"],
		["wall 22", 76897, 76912, "#b5abb0", "master"],
		["sand 45", 76913, 76928, "#0f46bf", "master"],
		["set 45", 76929, 76944, "#372f30", "master"],
		["view 90", 76945, 76960, "#3f6e9a", "master"],
		["luna 23", 76961, 76976, "#051227", "master"],
		["lime 22", 76977, 76992, "#75a7dc", "master"],
		["above 45", 76993, 77008, "#cfd088", "master"],
		["air 44", 77009, 77024, "#885c2d", "master"],
		["bark 22", 77025, 77040, "#a17e5e", "master"],
		["drift 23", 77041, 77056, "#9fa7ee", "master"],
		["valley 91", 77057, 77072, "#c37966", "master"],
		["peace 23", 77073, 77088, "#789395", "master"],
		["fog 22", 77089, 77104, "#8c8237", "master"],
		["grain 22", 77105, 77120, "#f8e6d9", "master"],
		["below 66", 77121, 77136, "#c1b8b4", "master"],
		["crest 45", 77137, 77152, "#b2c7d8", "master"],
		["bask 23", 77153, 77168, "#939aa5", "master"],
		["sierra 22", 77169, 77184, "#c36910", "master"],
		["calm 67", 77185, 77200, "#aaa2df", "master"],
		["dawn 88", 77201, 77216, "#6a68c7", "master"],
		["river 65", 77217, 77232, "#587a75", "master"],
		["arid 24", 77233, 77248, "#c5c3b7", "master"],
		["view 91", 77249, 77264, "#3b7fa6", "master"],
		["serene 46", 77265, 77280, "#664755", "master"],
		["view 92", 77281, 77296, "#060a1f", "master"],
		["sand 46", 77297, 77312, "#1e558c", "master"],
		["spire 45", 77313, 77328, "#36483b", "master"],
		["up 23", 77329, 77344, "#2a7b93", "master"],
		["frond 47", 77345, 77360, "#cfc7a5", "master"],
		["lines 23", 77361, 77376, "#4f80c0", "master"],
		["rapid 23", 77377, 77392, "#bad3e2", "master"],
		["still 23", 77393, 77408, "#c77fd2", "master"],
		["arise 46", 77409, 77424, "#385e76", "master"],
		["rock 46", 77425, 77440, "#1e558c", "master"],
		["wind 23", 77441, 77456, "#f8e6d9", "master"],
		["mist 109", 77457, 77472, "#c1b8b4", "master"],
		["range 23", 77473, 77488, "#34447a", "master"],
		["flat 24", 77489, 77504, "#3d90ce", "master"],
		["brood 68", 77505, 77520, "#85a7c8", "master"],
		["calm 68", 77521, 77536, "#7e6064", "master"],
		["dawn 89", 77537, 77552, "#ae8b14", "master"],
		["rise 23", 77553, 77568, "#bca6d7", "master"],
		["hole 24", 77569, 77584, "#20202c", "master"],
		["valley 92", 77585, 77600, "#d5c284", "master"],
		["shine 67", 77601, 77616, "#a3904f", "master"],
		["lush 45", 77617, 77632, "#263206", "master"],
		["cliff 23", 77633, 77648, "#43b2eb", "master"],
		["shine 68", 77649, 77664, "#2f387b", "master"],
		["sol 23", 77665, 77680, "#0b545c", "master"],
		["green 47", 77681, 77696, "#263206", "master"],
		["haze 23", 77697, 77712, "#4f80c0", "master"],
		["arrive 45", 77713, 77728, "#b2d4f5", "master"],
		["valley 93", 77729, 77744, "#cea37e", "master"],
		["leaf 66", 77745, 77760, "#daee95", "master"],
		["bright 106", 77761, 77776, "#38423a", "master"],
		["brook 44", 77777, 77792, "#5e4144", "master"],
		["bright 107", 77793, 77808, "#52373c", "master"],
		["mossy 24", 77809, 77824, "#96c4df", "master"],
		["curve 23", 77825, 77840, "#904024", "master"],
		["star 24", 77841, 77856, "#3270cd", "master"],
		["mist 110", 77857, 77872, "#d6c3c5", "master"],
		["frond 48", 77873, 77888, "#3b4b18", "master"],
		["view 93", 77889, 77904, "#4186c8", "master"],
		["watch 23", 77905, 77920, "#0a2a41", "master"],
		["bright 108", 77921, 77936, "#1f305b", "master"],
		["wild 22", 77937, 77952, "#1c600b", "master"],
		["sail 24", 77953, 77968, "#8da40a", "master"],
		["fall 92", 77969, 77984, "#43b2eb", "master"],
		["wood 24", 77985, 78000, "#b2aaa4", "master"],
		["toad 47", 78001, 78016, "#264056", "master"],
		["shine 69", 78017, 78032, "#a17b63", "master"],
		["toad 48", 78033, 78048, "#898391", "master"],
		["pebble 44", 78049, 78064, "#f5f3e8", "master"],
		["fall 93", 78065, 78080, "#7a5d2b", "master"],
		["float 24", 78081, 78096, "#3a6daf", "master"],
		["beach 22", 78097, 78112, "#cdad81", "master"],
		["snow 24", 78113, 78128, "#bbc5d9", "master"],
		["grow 23", 78129, 78144, "#3d3a16", "master"],
		["marsh 24", 78145, 78160, "#1b0d35", "master"],
		["gaze 23", 78161, 78176, "#040c18", "master"],
		["fit 22", 78177, 78192, "#3b6fa7", "master"],
		["thick 24", 78193, 78208, "#3d3a16", "master"],
		["blue 24", 78209, 78224, "#dee6dc", "master"],
		["above 46", 78225, 78240, "#c8dce6", "master"],
		["aqua 46", 78241, 78256, "#b9d6e4", "master"],
		["ray 44", 78257, 78272, "#b1934b", "master"],
		["icey 24", 78273, 78288, "#173ebd", "master"],
		["ray 45", 78289, 78304, "#8a8f89", "master"],
		["aqua 47", 78305, 78320, "#295771", "master"],
		["fir 23", 78321, 78336, "#15573d", "master"],
		["calm 69", 78337, 78352, "#548eb1", "master"],
		["palm 23", 78353, 78368, "#44c7ca", "master"],
		["light 46", 78369, 78384, "#184d4e", "master"],
		["green 48", 78385, 78400, "#4c6111", "master"],
		["rock 47", 78401, 78416, "#b2cbc8", "master"],
		["bluff 23", 78417, 78432, "#3f6e9a", "master"],
		["zeal 23", 78433, 78448, "#89bee6", "master"],
		["cover 46", 78449, 78464, "#90510a", "master"],
		["storm 23", 78465, 78480, "#548eb1", "master"],
		["grace 46", 78481, 78496, "#1b0d35", "master"],
		["shell 45", 78497, 78512, "#d0a973", "master"],
		["solis 23", 78513, 78528, "#d58265", "master"],
		["valley 94", 78529, 78544, "#7e93a8", "master"],
		["arrive 46", 78545, 78560, "#d3dbce", "master"],
		["shell 46", 78561, 78576, "#3d7ac9", "master"],
		["vivid 46", 78577, 78592, "#638cac", "master"],
		["wave 45", 78593, 78608, "#138cc5", "master"],
		["vast 47", 78609, 78624, "#ee9361", "master"],
		["freeze 23", 78625, 78640, "#73a0bd", "master"],
		["oak 24", 78641, 78656, "#609fdc", "master"],
		["slope 23", 78657, 78672, "#372f30", "master"],
		["lavish 23", 78673, 78688, "#856d1c", "master"],
		["pyre 24", 78689, 78704, "#451624", "master"],
		["vivid 47", 78705, 78720, "#609fdc", "master"],
		["vast 48", 78721, 78736, "#c7a884", "master"],
		["air 45", 78737, 78752, "#c3d0e0", "master"],
		["fresh 45", 78753, 78768, "#c6dded", "master"],
		["strato 23", 78769, 78784, "#0a408a", "master"],
		["white 23", 78785, 78800, "#6d8cab", "master"],
		["fall 94", 78801, 78816, "#364821", "master"],
		["fresh 46", 78817, 78832, "#42a198", "master"],
		["red 46", 78833, 78848, "#675d45", "master"],
		["dry 23", 78849, 78864, "#0f46bf", "master"],
		["lake 67", 78865, 78880, "#d9ca87", "master"],
		["crest 46", 78881, 78896, "#b8abda", "master"],
		["ruby 23", 78897, 78912, "#6d1a10", "master"],
		["seed 24", 78913, 78928, "#b5674f", "master"],
		["coast 23", 78929, 78944, "#355732", "master"],
		["arise 47", 78945, 78960, "#0e3650", "master"],
		["wall 23", 78961, 78976, "#b5abb0", "master"],
		["sand 47", 78977, 78992, "#0f46bf", "master"],
		["set 46", 78993, 79008, "#372f30", "master"],
		["brood 69", 79009, 79024, "#856d1c", "master"],
		["luna 24", 79025, 79040, "#051227", "master"],
		["lime 23", 79041, 79056, "#75a7dc", "master"],
		["above 47", 79057, 79072, "#cfd088", "master"],
		["air 46", 79073, 79088, "#885c2d", "master"],
		["fall 95", 79089, 79104, "#3989b3", "master"],
		["drift 24", 79105, 79120, "#9fa7ee", "master"],
		["valley 95", 79121, 79136, "#c37966", "master"],
		["peace 24", 79137, 79152, "#789395", "master"],
		["fog 23", 79153, 79168, "#8c8237", "master"],
		["far 23", 79169, 79184, "#367bcb", "master"],
		["below 67", 79185, 79200, "#c1b8b4", "master"],
		["crest 47", 79201, 79216, "#b2c7d8", "master"],
		["bask 24", 79217, 79232, "#939aa5", "master"],
		["sierra 23", 79233, 79248, "#c36910", "master"],
		["amber 23", 79249, 79264, "#b5674f", "master"],
		["dawn 90", 79265, 79280, "#6a68c7", "master"],
		["river 66", 79281, 79296, "#587a75", "master"],
		["arid 25", 79297, 79312, "#c5c3b7", "master"],
		["view 94", 79313, 79328, "#3b7fa6", "master"],
		["set 47", 79329, 79344, "#6b4a3e", "master"],
		["view 95", 79345, 79360, "#060a1f", "master"],
		["sand 48", 79361, 79376, "#1e558c", "master"],
		["spire 46", 79377, 79392, "#36483b", "master"],
		["up 24", 79393, 79408, "#2a7b93", "master"],
		["grass 23", 79409, 79424, "#32283c", "master"],
		["lines 24", 79425, 79440, "#4f80c0", "master"],
		["rapid 24", 79441, 79456, "#bad3e2", "master"],
		["still 24", 79457, 79472, "#c77fd2", "master"],
		["arise 48", 79473, 79488, "#385e76", "master"],
		["spire 47", 79489, 79504, "#bca6d7", "master"],
		["wind 24", 79505, 79520, "#f8e6d9", "master"],
		["mist 111", 79521, 79536, "#c1b8b4", "master"],
		["range 24", 79537, 79552, "#34447a", "master"],
		["flat 25", 79553, 79568, "#3d90ce", "master"],
		["dawn 91", 79569, 79584, "#444b23", "master"],
		["calm 70", 79585, 79600, "#7e6064", "master"],
		["dawn 92", 79601, 79616, "#ae8b14", "master"],
		["rise 24", 79617, 79632, "#bca6d7", "master"],
		["hole 25", 79633, 79648, "#20202c", "master"],
		["dusk 23", 79649, 79664, "#5b447b", "master"],
		["shine 70", 79665, 79680, "#a3904f", "master"],
		["lush 46", 79681, 79696, "#263206", "master"],
		["cliff 24", 79697, 79712, "#43b2eb", "master"],
		["shine 71", 79713, 79728, "#2f387b", "master"],
		["emit 23", 79729, 79744, "#1c3528", "master"],
		["green 49", 79745, 79760, "#263206", "master"],
		["haze 24", 79761, 79776, "#4f80c0", "master"],
		["arrive 47", 79777, 79792, "#b2d4f5", "master"],
		["valley 96", 79793, 79808, "#cea37e", "master"],
		["brook 45", 79809, 79824, "#566f3c", "master"],
		["bright 109", 79825, 79840, "#38423a", "master"],
		["brook 46", 79841, 79856, "#5e4144", "master"],
		["bright 110", 79857, 79872, "#52373c", "master"],
		["mossy 25", 79873, 79888, "#96c4df", "master"],
		["river 67", 79889, 79904, "#1b89d3", "master"],
		["star 25", 79905, 79920, "#3270cd", "master"],
		["mist 112", 79921, 79936, "#d6c3c5", "master"],
		["frond 49", 79937, 79952, "#3b4b18", "master"],
		["view 96", 79953, 79968, "#4186c8", "master"],
		["sky 45", 79969, 79984, "#081328", "master"],
		["bright 111", 79985, 80000, "#1f305b", "master"],
		["wild 23", 80001, 80016, "#1c600b", "master"],
		["sail 25", 80017, 80032, "#8da40a", "master"],
		["fall 96", 80033, 80048, "#43b2eb", "master"],
		["pebble 45", 80049, 80064, "#7e707b", "master"],
		["toad 49", 80065, 80080, "#264056", "master"],
		["shine 72", 80081, 80096, "#a17b63", "master"],
		["toad 50", 80097, 80112, "#898391", "master"],
		["pebble 46", 80113, 80128, "#f5f3e8", "master"],
		["leaf 67", 80129, 80144, "#779c35", "master"],
		["float 25", 80145, 80160, "#3a6daf", "master"],
		["beach 23", 80161, 80176, "#cdad81", "master"],
		["snow 25", 80177, 80192, "#bbc5d9", "master"],
		["grow 24", 80193, 80208, "#3d3a16", "master"],
		["cove 23", 80209, 80224, "#c3d0e0", "master"],
		["gaze 24", 80225, 80240, "#040c18", "master"],
		["fit 23", 80241, 80256, "#3b6fa7", "master"],
		["thick 25", 80257, 80272, "#3d3a16", "master"],
		["blue 25", 80273, 80288, "#dee6dc", "master"],
		["climb 46", 80289, 80304, "#4186c8", "master"],
		["aqua 48", 80305, 80320, "#b9d6e4", "master"],
		["ray 46", 80321, 80336, "#b1934b", "master"],
		["icey 25", 80337, 80352, "#173ebd", "master"],
		["ray 47", 80353, 80368, "#8a8f89", "master"],
		["wash 46", 80369, 80384, "#bd9794", "master"],
		["fir 24", 80385, 80400, "#15573d", "master"],
		["calm 71", 80401, 80416, "#548eb1", "master"],
		["palm 24", 80417, 80432, "#44c7ca", "master"],
		["light 47", 80433, 80448, "#184d4e", "master"],
		["grove 23", 80449, 80464, "#90510a", "master"],
		["rock 48", 80465, 80480, "#b2cbc8", "master"],
		["bluff 24", 80481, 80496, "#3f6e9a", "master"],
		["zeal 24", 80497, 80512, "#89bee6", "master"],
		["cover 47", 80513, 80528, "#90510a", "master"],
		["storm 24", 80529, 80544, "#548eb1", "master"],
		["grace 47", 80545, 80560, "#1b0d35", "master"],
		["shell 47", 80561, 80576, "#d0a973", "master"],
		["solis 24", 80577, 80592, "#d58265", "master"],
		["valley 97", 80593, 80608, "#7e93a8", "master"],
		["arrive 48", 80609, 80624, "#d3dbce", "master"],
		["shell 48", 80625, 80640, "#3d7ac9", "master"],
		["vivid 48", 80641, 80656, "#638cac", "master"],
		["wave 46", 80657, 80672, "#138cc5", "master"],
		["vast 49", 80673, 80688, "#ee9361", "master"],
		["freeze 24", 80689, 80704, "#73a0bd", "master"],
		["oak 25", 80705, 80720, "#609fdc", "master"],
		["chill 23", 80721, 80736, "#aaa2df", "master"],
		["lavish 24", 80737, 80752, "#856d1c", "master"],
		["pyre 25", 80753, 80768, "#451624", "master"],
		["vivid 49", 80769, 80784, "#609fdc", "master"],
		["vast 50", 80785, 80800, "#c7a884", "master"],
		["serene 47", 80801, 80816, "#b2cbc8", "master"],
		["fresh 47", 80817, 80832, "#c6dded", "master"],
		["strato 24", 80833, 80848, "#0a408a", "master"],
		["white 24", 80849, 80864, "#6d8cab", "master"],
		["fall 97", 80865, 80880, "#364821", "master"],
		["grace 48", 80881, 80896, "#0561d1", "master"],
		["red 47", 80897, 80912, "#675d45", "master"],
		["dry 24", 80913, 80928, "#0f46bf", "master"],
		["lake 68", 80929, 80944, "#d9ca87", "master"],
		["crest 48", 80945, 80960, "#b8abda", "master"],
		["birch 23", 80961, 80976, "#ccc6b7", "master"],
		["seed 25", 80977, 80992, "#b5674f", "master"],
		["coast 24", 80993, 81008, "#355732", "master"],
		["arise 49", 81009, 81024, "#0e3650", "master"],
		["wall 24", 81025, 81040, "#b5abb0", "master"],
		["dune 23", 81041, 81056, "#9fa7ee", "master"],
		["set 48", 81057, 81072, "#372f30", "master"],
		["brood 70", 81073, 81088, "#856d1c", "master"],
		["luna 25", 81089, 81104, "#051227", "master"],
		["lime 24", 81105, 81120, "#75a7dc", "master"],
		["climb 47", 81121, 81136, "#1d443b", "master"],
		["air 47", 81137, 81152, "#885c2d", "master"],
		["fall 98", 81153, 81168, "#3989b3", "master"],
		["drift 25", 81169, 81184, "#9fa7ee", "master"],
		["valley 98", 81185, 81200, "#c37966", "master"],
		["height 23", 81201, 81216, "#454c50", "master"],
		["fog 24", 81217, 81232, "#8c8237", "master"],
		["far 24", 81233, 81248, "#367bcb", "master"],
		["below 68", 81249, 81264, "#c1b8b4", "master"],
		["crest 49", 81265, 81280, "#b2c7d8", "master"],
		["gift 23", 81281, 81296, "#c797e8", "master"],
		["sierra 24", 81297, 81312, "#c36910", "master"],
		["amber 24", 81313, 81328, "#b5674f", "master"],
		["dawn 93", 81329, 81344, "#6a68c7", "master"],
		["river 68", 81345, 81360, "#587a75", "master"],
		["erode 23", 81361, 81376, "#5e92f3", "master"],
		["view 97", 81377, 81392, "#3b7fa6", "master"],
		["set 49", 81393, 81408, "#6b4a3e", "master"],
		["view 98", 81409, 81424, "#060a1f", "master"],
		["sand 49", 81425, 81440, "#1e558c", "master"],
		["mist 113", 81441, 81456, "#052d65", "master"],
		["up 25", 81457, 81472, "#2a7b93", "master"],
		["grass 24", 81473, 81488, "#32283c", "master"],
		["lines 25", 81489, 81504, "#4f80c0", "master"],
		["rapid 25", 81505, 81520, "#bad3e2", "master"],
		["glass 23", 81521, 81536, "#6e9ecf", "master"],
		["arise 50", 81537, 81552, "#385e76", "master"],
		["spire 48", 81553, 81568, "#bca6d7", "master"],
		["wind 25", 81569, 81584, "#f8e6d9", "master"],
		["mist 114", 81585, 81600, "#c1b8b4", "master"],
		["lake 69", 81601, 81616, "#84857f", "master"],
		["flat 26", 81617, 81632, "#3d90ce", "master"],
		["dawn 94", 81633, 81648, "#444b23", "master"],
		["calm 72", 81649, 81664, "#7e6064", "master"],
		["dawn 95", 81665, 81680, "#ae8b14", "master"],
		["bright 112", 81681, 81696, "#b2ba44", "master"],
		["hole 26", 81697, 81712, "#20202c", "master"],
		["dusk 24", 81713, 81728, "#5b447b", "master"],
		["shine 73", 81729, 81744, "#a3904f", "master"],
		["lush 47", 81745, 81760, "#263206", "master"],
		["river 69", 81761, 81776, "#c8dce6", "master"],
		["shine 74", 81777, 81792, "#2f387b", "master"],
		["emit 24", 81793, 81808, "#1c3528", "master"],
		["green 50", 81809, 81824, "#263206", "master"],
		["haze 25", 81825, 81840, "#4f80c0", "master"],
		["below 69", 81841, 81856, "#bad3e2", "master"],
		["valley 99", 81857, 81872, "#cea37e", "master"],
		["brook 47", 81873, 81888, "#566f3c", "master"],
		["bright 113", 81889, 81904, "#38423a", "master"],
		["brook 48", 81905, 81920, "#5e4144", "master"],
		["mist 115", 81921, 81936, "#714936", "master"],
		["mossy 26", 81937, 81952, "#96c4df", "master"],
		["river 70", 81953, 81968, "#1b89d3", "master"],
		["star 26", 81969, 81984, "#3270cd", "master"],
		["mist 116", 81985, 82000, "#d6c3c5", "master"],
		["curl 22", 82001, 82016, "#1c600b", "master"],
		["view 99", 82017, 82032, "#4186c8", "master"],
		["sky 46", 82033, 82048, "#081328", "master"],
		["bright 114", 82049, 82064, "#1f305b", "master"],
		["wild 24", 82065, 82080, "#1c600b", "master"],
		["depth 22", 82081, 82096, "#3a6daf", "master"],
		["fall 99", 82097, 82112, "#43b2eb", "master"],
		["pebble 47", 82113, 82128, "#7e707b", "master"],
		["toad 51", 82129, 82144, "#264056", "master"],
		["shine 75", 82145, 82160, "#a17b63", "master"],
		["azure 46", 82161, 82176, "#585e31", "master"],
		["pebble 48", 82177, 82192, "#f5f3e8", "master"],
		["leaf 68", 82193, 82208, "#779c35", "master"],
		["float 26", 82209, 82224, "#3a6daf", "master"],
		["beach 24", 82225, 82240, "#cdad81", "master"],
		["melt 23", 82241, 82256, "#2d6194", "master"],
		["grow 25", 82257, 82272, "#3d3a16", "master"],
		["cove 24", 82273, 82288, "#c3d0e0", "master"],
		["gaze 25", 82289, 82304, "#040c18", "master"],
		["fit 24", 82305, 82320, "#3b6fa7", "master"],
		["vine 23", 82321, 82336, "#4c6111", "master"],
		["blue 26", 82337, 82352, "#dee6dc", "master"],
		["climb 48", 82353, 82368, "#4186c8", "master"],
		["aqua 49", 82369, 82384, "#b9d6e4", "master"],
		["ray 48", 82385, 82400, "#b1934b", "master"],
		["lake 70", 82401, 82416, "#225c75", "master"],
		["ray 49", 82417, 82432, "#8a8f89", "master"],
		["wash 47", 82433, 82448, "#bd9794", "master"],
		["fir 25", 82449, 82464, "#15573d", "master"],
		["calm 73", 82465, 82480, "#548eb1", "master"],
		["palm 25", 82481, 82496, "#44c7ca", "master"],
		["light 48", 82497, 82512, "#184d4e", "master"],
		["grove 24", 82513, 82528, "#90510a", "master"],
		["rock 49", 82529, 82544, "#b2cbc8", "master"],
		["bluff 25", 82545, 82560, "#3f6e9a", "master"],
		["zeal 25", 82561, 82576, "#89bee6", "master"],
		["cover 48", 82577, 82592, "#90510a", "master"],
		["wave 47", 82593, 82608, "#138cc5", "master"],
		["grace 49", 82609, 82624, "#1b0d35", "master"],
		["shell 49", 82625, 82640, "#d0a973", "master"],
		["solis 25", 82641, 82656, "#d58265", "master"],
		["valley 100", 82657, 82672, "#7e93a8", "master"],
		["below 70", 82673, 82688, "#344f3d", "master"],
		["shell 50", 82689, 82704, "#3d7ac9", "master"],
		["vivid 50", 82705, 82720, "#638cac", "master"],
		["wave 48", 82721, 82736, "#138cc5", "master"],
		["vast 51", 82737, 82752, "#ee9361", "master"],
		["frost 23", 82753, 82768, "#bec8d1", "master"],
		["oak 26", 82769, 82784, "#609fdc", "master"],
		["chill 24", 82785, 82800, "#aaa2df", "master"],
		["lavish 25", 82801, 82816, "#856d1c", "master"],
		["pyre 26", 82817, 82832, "#451624", "master"],
		["red 48", 82833, 82848, "#6d1a10", "master"],
		["vast 52", 82849, 82864, "#c7a884", "master"],
		["serene 48", 82865, 82880, "#b2cbc8", "master"],
		["fresh 48", 82881, 82896, "#c6dded", "master"],
		["strato 25", 82897, 82912, "#0a408a", "master"],
		["arch 23", 82913, 82928, "#1778d2", "master"],
		["fall 100", 82929, 82944, "#364821", "master"],
		["grace 50", 82945, 82960, "#0561d1", "master"],
		["red 49", 82961, 82976, "#675d45", "master"],
		["dry 25", 82977, 82992, "#0f46bf", "master"],
		["sky 47", 82993, 83008, "#8a5425", "master"],
		["crest 50", 83009, 83024, "#b8abda", "master"],
		["birch 24", 83025, 83040, "#ccc6b7", "master"],
		["seed 26", 83041, 83056, "#b5674f", "master"],
		["coast 25", 83057, 83072, "#355732", "master"],
		["ripple 45", 83073, 83088, "#a7a3a0", "master"],
		["wall 25", 83089, 83104, "#b5abb0", "master"],
		["dune 24", 83105, 83120, "#9fa7ee", "master"],
		["set 50", 83121, 83136, "#372f30", "master"],
		["brood 71", 83137, 83152, "#856d1c", "master"],
		["cosmo 23", 83153, 83168, "#3b2446", "master"],
		["lime 25", 83169, 83184, "#75a7dc", "master"],
		["climb 49", 83185, 83200, "#1d443b", "master"],
		["air 48", 83201, 83216, "#885c2d", "master"],
		["fall 101", 83217, 83232, "#3989b3", "master"],
		["dawn 96", 83233, 83248, "#c36910", "master"],
		["valley 101", 83249, 83264, "#c37966", "master"],
		["height 24", 83265, 83280, "#454c50", "master"],
		["fog 25", 83281, 83296, "#8c8237", "master"],
		["far 25", 83297, 83312, "#367bcb", "master"],
		["pine 24", 83313, 83328, "#b2d4f5", "master"],
		["crest 51", 83329, 83344, "#b2c7d8", "master"],
		["gift 24", 83345, 83360, "#c797e8", "master"],
		["sierra 25", 83361, 83376, "#c36910", "master"],
		["amber 25", 83377, 83392, "#b5674f", "master"],
		["bright 115", 83393, 83408, "#355732", "master"],
		["river 71", 83409, 83424, "#587a75", "master"],
		["erode 24", 83425, 83440, "#5e92f3", "master"],
		["view 100", 83441, 83456, "#3b7fa6", "master"],
		["set 51", 83457, 83472, "#6b4a3e", "master"],
		["brood 72", 83473, 83488, "#71851e", "master"],
		["sand 50", 83489, 83504, "#1e558c", "master"],
		["mist 117", 83505, 83520, "#052d65", "master"],
		["up 26", 83521, 83536, "#2a7b93", "master"],
		["grass 25", 83537, 83552, "#32283c", "master"],
		["field 24", 83553, 83568, "#8da40a", "master"],
		["rapid 26", 83569, 83584, "#bad3e2", "master"],
		["glass 24", 83585, 83600, "#6e9ecf", "master"],
		["arise 51", 83601, 83616, "#385e76", "master"],
		["spire 49", 83617, 83632, "#bca6d7", "master"],
		["soar 23", 83633, 83648, "#367bcb", "master"],
		["mist 118", 83649, 83664, "#c1b8b4", "master"],
		["lake 71", 83665, 83680, "#84857f", "master"],
		["flat 27", 83681, 83696, "#3d90ce", "master"],
		["dawn 97", 83697, 83712, "#444b23", "master"],
		["leaf 69", 83713, 83728, "#516152", "master"],
		["dawn 98", 83729, 83744, "#ae8b14", "master"],
		["bright 116", 83745, 83760, "#b2ba44", "master"],
		["hole 27", 83761, 83776, "#20202c", "master"],
		["dusk 25", 83777, 83792, "#5b447b", "master"],
		["pond 24", 83793, 83808, "#36342a", "master"],
		["lush 48", 83809, 83824, "#263206", "master"],
		["river 72", 83825, 83840, "#c8dce6", "master"],
		["shine 76", 83841, 83856, "#2f387b", "master"],
		["emit 25", 83857, 83872, "#1c3528", "master"],
		["lush 49", 83873, 83888, "#3b4b18", "master"],
		["haze 26", 83889, 83904, "#4f80c0", "master"],
		["below 71", 83905, 83920, "#bad3e2", "master"],
		["valley 102", 83921, 83936, "#cea37e", "master"],
		["brook 49", 83937, 83952, "#566f3c", "master"],
		["mist 119", 83953, 83968, "#a4c1c7", "master"],
		["brook 50", 83969, 83984, "#5e4144", "master"],
		["mist 120", 83985, 84000, "#714936", "master"],
		["mossy 27", 84001, 84016, "#96c4df", "master"],
		["river 73", 84017, 84032, "#1b89d3", "master"],
		["clear 24", 84033, 84048, "#40addf", "master"],
		["mist 121", 84049, 84064, "#d6c3c5", "master"],
		["curl 23", 84065, 84080, "#1c600b", "master"],
		["view 101", 84081, 84096, "#4186c8", "master"],
		["sky 48", 84097, 84112, "#081328", "master"],
		["space 24", 84113, 84128, "#2b2c41", "master"],
		["wild 25", 84129, 84144, "#1c600b", "master"],
		["depth 23", 84145, 84160, "#3a6daf", "master"],
		["fall 102", 84161, 84176, "#43b2eb", "master"],
		["pebble 49", 84177, 84192, "#7e707b", "master"],
		["azure 47", 84193, 84208, "#0f98b9", "master"],
		["shine 77", 84209, 84224, "#a17b63", "master"],
		["azure 48", 84225, 84240, "#585e31", "master"],
		["pebble 50", 84241, 84256, "#f5f3e8", "master"],
		["leaf 70", 84257, 84272, "#779c35", "master"],
		["breeze 24", 84273, 84288, "#dee6dc", "master"],
		["beach 25", 84289, 84304, "#cdad81", "master"],
		["melt 24", 84305, 84320, "#2d6194", "master"],
		["grow 26", 84321, 84336, "#3d3a16", "master"],
		["cove 25", 84337, 84352, "#c3d0e0", "master"],
		["gaze 26", 84353, 84368, "#040c18", "master"],
		["fit 25", 84369, 84384, "#3b6fa7", "master"],
		["vine 24", 84385, 84400, "#4c6111", "master"],
		["blue 27", 84401, 84416, "#dee6dc", "master"],
		["climb 50", 84417, 84432, "#4186c8", "master"],
		["aqua 50", 84433, 84448, "#b9d6e4", "master"],
		["ray 50", 84449, 84464, "#b1934b", "master"],
		["lake 72", 84465, 84480, "#225c75", "master"],
		["ray 51", 84481, 84496, "#8a8f89", "master"],
		["wash 48", 84497, 84512, "#bd9794", "master"],
		["fir 26", 84513, 84528, "#15573d", "master"],
		["calm 74", 84529, 84544, "#548eb1", "master"],
		["shore 23", 84545, 84560, "#e0afae", "master"],
		["light 49", 84561, 84576, "#184d4e", "master"],
		["grove 25", 84577, 84592, "#90510a", "master"],
		["rock 50", 84593, 84608, "#b2cbc8", "master"],
		["bluff 26", 84609, 84624, "#3f6e9a", "master"],
		["opal 23", 84625, 84640, "#d49bc8", "master"],
		["cover 49", 84641, 84656, "#90510a", "master"],
		["wave 49", 84657, 84672, "#138cc5", "master"],
		["grace 51", 84673, 84688, "#1b0d35", "master"],
		["shell 51", 84689, 84704, "#d0a973", "master"],
		["polar 24", 84705, 84720, "#819864", "master"],
		["valley 103", 84721, 84736, "#7e93a8", "master"],
		["below 72", 84737, 84752, "#344f3d", "master"],
		["shell 52", 84753, 84768, "#3d7ac9", "master"],
		["vivid 51", 84769, 84784, "#638cac", "master"],
		["ripple 46", 84785, 84800, "#c7a884", "master"],
		["vast 53", 84801, 84816, "#ee9361", "master"],
		["frost 24", 84817, 84832, "#bec8d1", "master"],
		["oak 27", 84833, 84848, "#609fdc", "master"],
		["chill 25", 84849, 84864, "#aaa2df", "master"],
		["sea 23", 84865, 84880, "#6a68c7", "master"],
		["pyre 27", 84881, 84896, "#451624", "master"],
		["red 50", 84897, 84912, "#6d1a10", "master"],
		["vast 54", 84913, 84928, "#c7a884", "master"],
		["serene 49", 84929, 84944, "#b2cbc8", "master"],
		["view 102", 84945, 84960, "#3f6e9a", "master"],
		["strato 26", 84961, 84976, "#0a408a", "master"],
		["arch 24", 84977, 84992, "#1778d2", "master"],
		["fall 103", 84993, 85008, "#364821", "master"],
		["grace 52", 85009, 85024, "#0561d1", "master"],
		["bark 23", 85025, 85040, "#a17e5e", "master"],
		["dry 26", 85041, 85056, "#0f46bf", "master"],
		["sky 49", 85057, 85072, "#8a5425", "master"],
		["crest 52", 85073, 85088, "#b8abda", "master"],
		["birch 25", 85089, 85104, "#ccc6b7", "master"],
		["grain 23", 85105, 85120, "#f8e6d9", "master"],
		["coast 26", 85121, 85136, "#355732", "master"],
		["ripple 47", 85137, 85152, "#a7a3a0", "master"],
		["wall 26", 85153, 85168, "#b5abb0", "master"],
		["dune 25", 85169, 85184, "#9fa7ee", "master"],
		["calm 75", 85185, 85200, "#aaa2df", "master"],
		["brood 73", 85201, 85216, "#856d1c", "master"],
		["cosmo 24", 85217, 85232, "#3b2446", "master"],
		["lime 26", 85233, 85248, "#75a7dc", "master"],
		["climb 51", 85249, 85264, "#1d443b", "master"],
		["serene 50", 85265, 85280, "#664755", "master"],
		["fall 104", 85281, 85296, "#3989b3", "master"],
		["dawn 99", 85297, 85312, "#c36910", "master"],
		["valley 104", 85313, 85328, "#c37966", "master"],
		["height 25", 85329, 85344, "#454c50", "master"],
		["frond 50", 85345, 85360, "#cfc7a5", "master"],
		["far 26", 85361, 85376, "#367bcb", "master"],
		["pine 25", 85377, 85392, "#b2d4f5", "master"],
		["crest 53", 85393, 85408, "#b2c7d8", "master"],
		["gift 25", 85409, 85424, "#c797e8", "master"],
		["rock 51", 85425, 85440, "#1e558c", "master"],
		["amber 26", 85441, 85456, "#b5674f", "master"],
		["bright 117", 85457, 85472, "#355732", "master"],
		["river 74", 85473, 85488, "#587a75", "master"],
		["erode 25", 85489, 85504, "#5e92f3", "master"],
		["brood 74", 85505, 85520, "#85a7c8", "master"],
		["set 52", 85521, 85536, "#6b4a3e", "master"],
		["brood 75", 85537, 85552, "#71851e", "master"],
		["sand 51", 85553, 85568, "#1e558c", "master"],
		["mist 122", 85569, 85584, "#052d65", "master"],
		["valley 105", 85585, 85600, "#d5c284", "master"],
		["grass 26", 85601, 85616, "#32283c", "master"],
		["field 25", 85617, 85632, "#8da40a", "master"],
		["rapid 27", 85633, 85648, "#bad3e2", "master"],
		["glass 25", 85649, 85664, "#6e9ecf", "master"],
		["sol 24", 85665, 85680, "#0b545c", "master"],
		["spire 50", 85681, 85696, "#bca6d7", "master"],
		["soar 24", 85697, 85712, "#367bcb", "master"],
		["mist 123", 85713, 85728, "#c1b8b4", "master"],
		["lake 73", 85729, 85744, "#84857f", "master"],
		["leaf 71", 85745, 85760, "#daee95", "master"],
		["dawn 100", 85761, 85776, "#444b23", "master"],
		["leaf 72", 85777, 85792, "#516152", "master"],
		["dawn 101", 85793, 85808, "#ae8b14", "master"],
		["bright 118", 85809, 85824, "#b2ba44", "master"],
		["curve 24", 85825, 85840, "#904024", "master"],
		["dusk 26", 85841, 85856, "#5b447b", "master"],
		["pond 25", 85857, 85872, "#36342a", "master"],
		["lush 50", 85873, 85888, "#263206", "master"],
		["river 75", 85889, 85904, "#c8dce6", "master"],
		["watch 24", 85905, 85920, "#0a2a41", "master"],
		["emit 26", 85921, 85936, "#1c3528", "master"],
		["lush 51", 85937, 85952, "#3b4b18", "master"],
		["haze 27", 85953, 85968, "#4f80c0", "master"],
		["below 73", 85969, 85984, "#bad3e2", "master"],
		["wood 25", 85985, 86000, "#b2aaa4", "master"],
		["brook 51", 86001, 86016, "#566f3c", "master"],
		["mist 124", 86017, 86032, "#a4c1c7", "master"],
		["brook 52", 86033, 86048, "#5e4144", "master"],
		["mist 125", 86049, 86064, "#714936", "master"],
		["fall 105", 86065, 86080, "#7a5d2b", "master"],
		["river 76", 86081, 86096, "#1b89d3", "master"],
		["clear 25", 86097, 86112, "#40addf", "master"],
		["mist 126", 86113, 86128, "#d6c3c5", "master"],
		["curl 24", 86129, 86144, "#1c600b", "master"],
		["marsh 25", 86145, 86160, "#1b0d35", "master"],
		["sky 50", 86161, 86176, "#081328", "master"],
		["space 25", 86177, 86192, "#2b2c41", "master"],
		["wild 26", 86193, 86208, "#1c600b", "master"],
		["depth 24", 86209, 86224, "#3a6daf", "master"],
		["fall 106", 86225, 86240, "#43b2eb", "master"],
		["pebble 51", 86241, 86256, "#7e707b", "master"],
		["azure 49", 86257, 86272, "#0f98b9", "master"],
		["shine 78", 86273, 86288, "#a17b63", "master"],
		["azure 50", 86289, 86304, "#585e31", "master"],
		["pebble 52", 86305, 86320, "#f5f3e8", "master"],
		["leaf 73", 86321, 86336, "#779c35", "master"],
		["breeze 25", 86337, 86352, "#dee6dc", "master"],
		["beach 26", 86353, 86368, "#cdad81", "master"],
		["melt 25", 86369, 86384, "#2d6194", "master"],
		["grow 27", 86385, 86400, "#3d3a16", "master"],
		["cove 26", 86401, 86416, "#c3d0e0", "master"],
		["light 50", 86417, 86432, "#0e0f1d", "master"],
		["fit 26", 86433, 86448, "#3b6fa7", "master"],
		["vine 25", 86449, 86464, "#4c6111", "master"],
		["blue 28", 86465, 86480, "#dee6dc", "master"],
		["climb 52", 86481, 86496, "#4186c8", "master"],
		["wash 49", 86497, 86512, "#756e8d", "master"],
		["ray 52", 86513, 86528, "#b1934b", "master"],
		["lake 74", 86529, 86544, "#225c75", "master"],
		["ray 53", 86545, 86560, "#8a8f89", "master"],
		["wash 50", 86561, 86576, "#bd9794", "master"],
		["cover 50", 86577, 86592, "#134f7b", "master"],
		["calm 76", 86593, 86608, "#548eb1", "master"],
		["shore 24", 86609, 86624, "#e0afae", "master"],
		["light 51", 86625, 86640, "#184d4e", "master"],
		["grove 26", 86641, 86656, "#90510a", "master"],
		["slope 24", 86657, 86672, "#372f30", "master"],
		["bluff 27", 86673, 86688, "#3f6e9a", "master"],
		["opal 24", 86689, 86704, "#d49bc8", "master"],
		["cover 51", 86705, 86720, "#90510a", "master"],
		["wave 50", 86721, 86736, "#138cc5", "master"],
		["air 49", 86737, 86752, "#c3d0e0", "master"],
		["shell 53", 86753, 86768, "#d0a973", "master"],
		["polar 25", 86769, 86784, "#819864", "master"],
		["valley 106", 86785, 86800, "#7e93a8", "master"],
		["below 74", 86801, 86816, "#344f3d", "master"],
		["fresh 49", 86817, 86832, "#42a198", "master"],
		["vivid 52", 86833, 86848, "#638cac", "master"],
		["ripple 48", 86849, 86864, "#c7a884", "master"],
		["vast 55", 86865, 86880, "#ee9361", "master"],
		["frost 25", 86881, 86896, "#bec8d1", "master"],
		["ruby 24", 86897, 86912, "#6d1a10", "master"],
		["chill 26", 86913, 86928, "#aaa2df", "master"],
		["sea 24", 86929, 86944, "#6a68c7", "master"],
		["pyre 28", 86945, 86960, "#451624", "master"],
		["red 51", 86961, 86976, "#6d1a10", "master"],
		["sand 52", 86977, 86992, "#0f46bf", "master"],
		["serene 51", 86993, 87008, "#b2cbc8", "master"],
		["view 103", 87009, 87024, "#3f6e9a", "master"],
		["strato 27", 87025, 87040, "#0a408a", "master"],
		["arch 25", 87041, 87056, "#1778d2", "master"],
		["above 48", 87057, 87072, "#cfd088", "master"],
		["grace 53", 87073, 87088, "#0561d1", "master"],
		["bark 24", 87089, 87104, "#a17e5e", "master"],
		["dry 27", 87105, 87120, "#0f46bf", "master"],
		["sky 51", 87121, 87136, "#8a5425", "master"],
		["peace 25", 87137, 87152, "#789395", "master"],
		["birch 26", 87153, 87168, "#ccc6b7", "master"],
		["grain 24", 87169, 87184, "#f8e6d9", "master"],
		["coast 27", 87185, 87200, "#355732", "master"],
		["ripple 49", 87201, 87216, "#a7a3a0", "master"],
		["bask 25", 87217, 87232, "#939aa5", "master"],
		["dune 26", 87233, 87248, "#9fa7ee", "master"],
		["calm 77", 87249, 87264, "#aaa2df", "master"],
		["brood 76", 87265, 87280, "#856d1c", "master"],
		["cosmo 25", 87281, 87296, "#3b2446", "master"],
		["arid 26", 87297, 87312, "#c5c3b7", "master"],
		["climb 53", 87313, 87328, "#1d443b", "master"],
		["serene 52", 87329, 87344, "#664755", "master"],
		["fall 107", 87345, 87360, "#3989b3", "master"],
		["dawn 102", 87361, 87376, "#c36910", "master"],
		["spire 51", 87377, 87392, "#36483b", "master"],
		["height 26", 87393, 87408, "#454c50", "master"],
		["frond 51", 87409, 87424, "#cfc7a5", "master"],
		["far 27", 87425, 87440, "#367bcb", "master"],
		["pine 26", 87441, 87456, "#b2d4f5", "master"],
		["still 25", 87457, 87472, "#c77fd2", "master"],
		["gift 26", 87473, 87488, "#c797e8", "master"],
		["rock 52", 87489, 87504, "#1e558c", "master"],
		["amber 27", 87505, 87520, "#b5674f", "master"],
		["bright 119", 87521, 87536, "#355732", "master"],
		["range 25", 87537, 87552, "#34447a", "master"],
		["erode 26", 87553, 87568, "#5e92f3", "master"],
		["brood 77", 87569, 87584, "#85a7c8", "master"],
		["set 53", 87585, 87600, "#6b4a3e", "master"],
		["brood 78", 87601, 87616, "#71851e", "master"],
		["rise 25", 87617, 87632, "#bca6d7", "master"],
		["mist 127", 87633, 87648, "#052d65", "master"],
		["valley 107", 87649, 87664, "#d5c284", "master"],
		["grass 27", 87665, 87680, "#32283c", "master"],
		["field 26", 87681, 87696, "#8da40a", "master"],
		["cliff 25", 87697, 87712, "#43b2eb", "master"],
		["glass 26", 87713, 87728, "#6e9ecf", "master"],
		["sol 25", 87729, 87744, "#0b545c", "master"],
		["spire 52", 87745, 87760, "#bca6d7", "master"],
		["soar 25", 87761, 87776, "#367bcb", "master"],
		["arrive 49", 87777, 87792, "#b2d4f5", "master"],
		["lake 75", 87793, 87808, "#84857f", "master"],
		["leaf 74", 87809, 87824, "#daee95", "master"],
		["dawn 103", 87825, 87840, "#444b23", "master"],
		["leaf 75", 87841, 87856, "#516152", "master"],
		["bright 120", 87857, 87888, "#52373c", "master"],
		["curve 25", 87889, 87904, "#904024", "master"],
		["dusk 27", 87905, 87920, "#5b447b", "master"],
		["pond 26", 87921, 87936, "#36342a", "master"],
		["frond 52", 87937, 87952, "#3b4b18", "master"],
		["river 77", 87953, 87968, "#c8dce6", "master"],
		["watch 25", 87969, 87984, "#0a2a41", "master"],
		["emit 27", 87985, 88000, "#1c3528", "master"],
		["lush 52", 88001, 88016, "#3b4b18", "master"],
		["sail 26", 88017, 88032, "#8da40a", "master"],
		["below 75", 88033, 88048, "#bad3e2", "master"],
		["wood 26", 88049, 88064, "#b2aaa4", "master"],
		["brook 53", 88065, 88080, "#566f3c", "master"],
		["mist 128", 88081, 88096, "#a4c1c7", "master"],
		["toad 52", 88097, 88112, "#898391", "master"],
		["mist 129", 88113, 88128, "#714936", "master"],
		["fall 108", 88129, 88144, "#7a5d2b", "master"],
		["river 78", 88145, 88160, "#1b89d3", "master"],
		["clear 26", 88161, 88176, "#40addf", "master"],
		["mist 130", 88177, 88192, "#d6c3c5", "master"],
		["curl 25", 88193, 88208, "#1c600b", "master"],
		["marsh 26", 88209, 88224, "#1b0d35", "master"],
		["sky 52", 88225, 88240, "#081328", "master"],
		["space 26", 88241, 88256, "#2b2c41", "master"],
		["wild 27", 88257, 88272, "#1c600b", "master"],
		["depth 25", 88273, 88288, "#3a6daf", "master"],
		["above 49", 88289, 88304, "#c8dce6", "master"],
		["pebble 53", 88305, 88320, "#7e707b", "master"],
		["azure 51", 88321, 88336, "#0f98b9", "master"],
		["shine 79", 88337, 88352, "#a17b63", "master"],
		["azure 52", 88353, 88368, "#585e31", "master"],
		["aqua 51", 88369, 88384, "#295771", "master"],
		["leaf 76", 88385, 88400, "#779c35", "master"],
		["breeze 26", 88401, 88416, "#dee6dc", "master"],
		["beach 27", 88417, 88432, "#cdad81", "master"],
		["melt 26", 88433, 88448, "#2d6194", "master"],
		["green 51", 88449, 88464, "#4c6111", "master"],
		["cove 27", 88465, 88480, "#c3d0e0", "master"],
		["light 52", 88481, 88496, "#0e0f1d", "master"],
		["fit 27", 88497, 88512, "#3b6fa7", "master"],
		["vine 26", 88513, 88528, "#4c6111", "master"],
		["storm 25", 88529, 88544, "#548eb1", "master"],
		["climb 54", 88545, 88560, "#4186c8", "master"],
		["wash 51", 88561, 88576, "#756e8d", "master"],
		["ray 54", 88577, 88592, "#b1934b", "master"],
		["lake 76", 88593, 88608, "#225c75", "master"],
		["arrive 50", 88609, 88624, "#d3dbce", "master"],
		["wash 52", 88625, 88640, "#bd9794", "master"],
		["cover 52", 88641, 88656, "#134f7b", "master"],
		["calm 78", 88657, 88672, "#548eb1", "master"],
		["shore 25", 88673, 88688, "#e0afae", "master"],
		["freeze 25", 88689, 88704, "#73a0bd", "master"],
		["grove 27", 88705, 88720, "#90510a", "master"],
		["slope 25", 88721, 88736, "#372f30", "master"],
		["bluff 28", 88737, 88752, "#3f6e9a", "master"],
		["opal 25", 88753, 88768, "#d49bc8", "master"],
		["vivid 53", 88769, 88784, "#609fdc", "master"],
		["wave 51", 88785, 88800, "#138cc5", "master"],
		["air 50", 88801, 88816, "#c3d0e0", "master"],
		["shell 54", 88817, 88832, "#d0a973", "master"],
		["polar 26", 88833, 88848, "#819864", "master"],
		["white 25", 88849, 88864, "#6d8cab", "master"],
		["below 76", 88865, 88880, "#344f3d", "master"],
		["fresh 50", 88881, 88896, "#42a198", "master"],
		["vivid 54", 88897, 88912, "#638cac", "master"],
		["ripple 50", 88913, 88928, "#c7a884", "master"],
		["lake 77", 88929, 88944, "#d9ca87", "master"],
		["frost 26", 88945, 88960, "#bec8d1", "master"],
		["ruby 25", 88961, 88976, "#6d1a10", "master"],
		["chill 27", 88977, 88992, "#aaa2df", "master"],
		["sea 25", 88993, 89008, "#6a68c7", "master"],
		["arise 52", 89009, 89024, "#0e3650", "master"],
		["red 52", 89025, 89040, "#6d1a10", "master"],
		["sand 53", 89041, 89056, "#0f46bf", "master"],
		["serene 53", 89057, 89072, "#b2cbc8", "master"],
		["view 104", 89073, 89088, "#3f6e9a", "master"],
		["luna 26", 89089, 89104, "#051227", "master"],
		["arch 26", 89105, 89120, "#1778d2", "master"],
		["above 50", 89121, 89136, "#cfd088", "master"],
		["grace 54", 89137, 89152, "#0561d1", "master"],
		["bark 25", 89153, 89168, "#a17e5e", "master"],
		["drift 26", 89169, 89184, "#9fa7ee", "master"],
		["sky 53", 89185, 89200, "#8a5425", "master"],
		["peace 26", 89201, 89216, "#789395", "master"],
		["birch 27", 89217, 89232, "#ccc6b7", "master"],
		["grain 25", 89233, 89248, "#f8e6d9", "master"],
		["below 77", 89249, 89264, "#c1b8b4", "master"],
		["ripple 51", 89265, 89280, "#a7a3a0", "master"],
		["bask 26", 89281, 89296, "#939aa5", "master"],
		["dune 27", 89297, 89312, "#9fa7ee", "master"],
		["calm 79", 89313, 89328, "#aaa2df", "master"],
		["dawn 104", 89329, 89344, "#6a68c7", "master"],
		["cosmo 26", 89345, 89360, "#3b2446", "master"],
		["arid 27", 89361, 89376, "#c5c3b7", "master"],
		["climb 55", 89377, 89392, "#1d443b", "master"],
		["serene 54", 89393, 89408, "#664755", "master"],
		["view 105", 89409, 89424, "#060a1f", "master"],
		["dawn 105", 89425, 89440, "#c36910", "master"],
		["spire 53", 89441, 89456, "#36483b", "master"],
		["height 27", 89457, 89472, "#454c50", "master"],
		["frond 53", 89473, 89488, "#cfc7a5", "master"],
		["lines 26", 89489, 89504, "#4f80c0", "master"],
		["pine 27", 89505, 89520, "#b2d4f5", "master"],
		["still 26", 89521, 89536, "#c77fd2", "master"],
		["gift 27", 89537, 89552, "#c797e8", "master"],
		["rock 53", 89553, 89568, "#1e558c", "master"],
		["wind 26", 89569, 89584, "#f8e6d9", "master"],
		["bright 121", 89585, 89600, "#355732", "master"],
		["range 26", 89601, 89616, "#34447a", "master"],
		["erode 27", 89617, 89632, "#5e92f3", "master"],
		["brood 79", 89633, 89648, "#85a7c8", "master"],
		["calm 80", 89649, 89664, "#7e6064", "master"],
		["brood 80", 89665, 89680, "#71851e", "master"],
		["rise 26", 89681, 89696, "#bca6d7", "master"],
		["mist 131", 89697, 89712, "#052d65", "master"],
		["valley 108", 89713, 89728, "#d5c284", "master"],
		["shine 80", 89729, 89744, "#a3904f", "master"],
		["field 27", 89745, 89760, "#8da40a", "master"],
		["cliff 26", 89761, 89776, "#43b2eb", "master"],
		["glass 27", 89777, 89792, "#6e9ecf", "master"],
		["sol 26", 89793, 89808, "#0b545c", "master"],
		["green 52", 89809, 89824, "#263206", "master"],
		["soar 26", 89825, 89840, "#367bcb", "master"],
		["arrive 51", 89841, 89856, "#b2d4f5", "master"],
		["lake 78", 89857, 89872, "#84857f", "master"],
		["leaf 77", 89873, 89888, "#daee95", "master"],
		["bright 122", 89889, 89904, "#38423a", "master"],
		["leaf 78", 89905, 89920, "#516152", "master"],
		["bright 123", 89921, 89952, "#52373c", "master"],
		["curve 26", 89953, 89968, "#904024", "master"],
		["star 27", 89969, 89984, "#3270cd", "master"],
		["pond 27", 89985, 90000, "#36342a", "master"],
		["frond 54", 90001, 90016, "#3b4b18", "master"],
		["river 79", 90017, 90032, "#c8dce6", "master"],
		["watch 26", 90033, 90048, "#0a2a41", "master"],
		["emit 28", 90049, 90064, "#1c3528", "master"],
		["lush 53", 90065, 90080, "#3b4b18", "master"],
		["sail 27", 90081, 90096, "#8da40a", "master"],
		["below 78", 90097, 90112, "#bad3e2", "master"],
		["wood 27", 90113, 90128, "#b2aaa4", "master"],
		["brook 54", 90129, 90144, "#566f3c", "master"],
		["mist 132", 90145, 90160, "#a4c1c7", "master"],
		["toad 53", 90161, 90176, "#898391", "master"],
		["mist 133", 90177, 90192, "#714936", "master"],
		["fall 109", 90193, 90208, "#7a5d2b", "master"],
		["river 80", 90209, 90224, "#1b89d3", "master"],
		["clear 27", 90225, 90240, "#40addf", "master"],
		["snow 26", 90241, 90256, "#bbc5d9", "master"],
		["curl 26", 90257, 90272, "#1c600b", "master"],
		["marsh 27", 90273, 90288, "#1b0d35", "master"],
		["sky 54", 90289, 90304, "#081328", "master"],
		["space 27", 90305, 90320, "#2b2c41", "master"],
		["thick 26", 90321, 90336, "#3d3a16", "master"],
		["depth 26", 90337, 90352, "#3a6daf", "master"],
		["above 51", 90353, 90368, "#c8dce6", "master"],
		["pebble 54", 90369, 90384, "#7e707b", "master"],
		["azure 53", 90385, 90400, "#0f98b9", "master"],
		["icey 26", 90401, 90416, "#173ebd", "master"],
		["azure 54", 90417, 90432, "#585e31", "master"],
		["aqua 52", 90433, 90448, "#295771", "master"],
		["leaf 79", 90449, 90464, "#779c35", "master"],
		["breeze 27", 90465, 90480, "#dee6dc", "master"],
		["palm 26", 90481, 90496, "#44c7ca", "master"],
		["melt 27", 90497, 90512, "#2d6194", "master"],
		["green 53", 90513, 90528, "#4c6111", "master"],
		["cove 28", 90529, 90544, "#c3d0e0", "master"],
		["light 53", 90545, 90560, "#0e0f1d", "master"],
		["zeal 26", 90561, 90576, "#89bee6", "master"],
		["vine 27", 90577, 90592, "#4c6111", "master"],
		["storm 26", 90593, 90608, "#548eb1", "master"],
		["climb 56", 90609, 90624, "#4186c8", "master"],
		["wash 53", 90625, 90640, "#756e8d", "master"],
		["solis 26", 90641, 90656, "#d58265", "master"],
		["lake 79", 90657, 90672, "#225c75", "master"],
		["arrive 52", 90673, 90688, "#d3dbce", "master"],
		["wash 54", 90689, 90704, "#bd9794", "master"],
		["cover 53", 90705, 90720, "#134f7b", "master"],
		["wave 52", 90721, 90736, "#138cc5", "master"],
		["shore 26", 90737, 90752, "#e0afae", "master"],
		["freeze 26", 90753, 90768, "#73a0bd", "master"],
		["grove 28", 90769, 90784, "#90510a", "master"],
		["slope 26", 90785, 90800, "#372f30", "master"],
		["lavish 26", 90801, 90816, "#856d1c", "master"],
		["opal 26", 90817, 90832, "#d49bc8", "master"],
		["vivid 55", 90833, 90848, "#609fdc", "master"],
		["wave 53", 90849, 90864, "#138cc5", "master"],
		["air 51", 90865, 90880, "#c3d0e0", "master"],
		["fresh 51", 90881, 90896, "#c6dded", "master"],
		["polar 27", 90897, 90912, "#819864", "master"],
		["white 26", 90913, 90928, "#6d8cab", "master"],
		["below 79", 90929, 90944, "#344f3d", "master"],
		["fresh 52", 90945, 90960, "#42a198", "master"],
		["red 53", 90961, 90976, "#675d45", "master"],
		["ripple 52", 90977, 90992, "#c7a884", "master"],
		["lake 80", 90993, 91008, "#d9ca87", "master"],
		["frost 27", 91009, 91024, "#bec8d1", "master"],
		["ruby 26", 91025, 91040, "#6d1a10", "master"],
		["seed 27", 91041, 91056, "#b5674f", "master"],
		["sea 26", 91057, 91072, "#6a68c7", "master"],
		["arise 53", 91073, 91088, "#0e3650", "master"],
		["red 54", 91089, 91104, "#6d1a10", "master"],
		["sand 54", 91105, 91120, "#0f46bf", "master"],
		["set 54", 91121, 91136, "#372f30", "master"],
		["view 106", 91137, 91152, "#3f6e9a", "master"],
		["luna 27", 91153, 91168, "#051227", "master"],
		["arch 27", 91169, 91184, "#1778d2", "master"],
		["above 52", 91185, 91200, "#cfd088", "master"],
		["air 52", 91201, 91216, "#885c2d", "master"],
		["bark 26", 91217, 91232, "#a17e5e", "master"],
		["drift 27", 91233, 91248, "#9fa7ee", "master"],
		["sky 55", 91249, 91264, "#8a5425", "master"],
		["peace 27", 91265, 91280, "#789395", "master"],
		["fog 26", 91281, 91296, "#8c8237", "master"],
		["grain 26", 91297, 91312, "#f8e6d9", "master"],
		["below 80", 91313, 91328, "#c1b8b4", "master"],
		["ripple 53", 91329, 91344, "#a7a3a0", "master"],
		["bask 27", 91345, 91360, "#939aa5", "master"],
		["sierra 26", 91361, 91376, "#c36910", "master"],
		["calm 81", 91377, 91392, "#aaa2df", "master"],
		["dawn 106", 91393, 91408, "#6a68c7", "master"],
		["cosmo 27", 91409, 91424, "#3b2446", "master"],
		["arid 28", 91425, 91440, "#c5c3b7", "master"],
		["view 107", 91441, 91456, "#3b7fa6", "master"],
		["serene 55", 91457, 91472, "#664755", "master"],
		["view 108", 91473, 91488, "#060a1f", "master"],
		["dawn 107", 91489, 91504, "#c36910", "master"],
		["spire 54", 91505, 91520, "#36483b", "master"],
		["up 27", 91521, 91536, "#2a7b93", "master"],
		["frond 55", 91537, 91552, "#cfc7a5", "master"],
		["lines 27", 91553, 91568, "#4f80c0", "master"],
		["pine 28", 91569, 91584, "#b2d4f5", "master"],
		["still 27", 91585, 91600, "#c77fd2", "master"],
		["arise 54", 91601, 91616, "#385e76", "master"],
		["rock 54", 91617, 91632, "#1e558c", "master"],
		["wind 27", 91633, 91648, "#f8e6d9", "master"],
		["bright 124", 91649, 91664, "#355732", "master"],
		["range 27", 91665, 91680, "#34447a", "master"],
		["flat 28", 91681, 91696, "#3d90ce", "master"],
		["brood 81", 91697, 91712, "#85a7c8", "master"],
		["calm 82", 91713, 91728, "#7e6064", "master"],
		["brood 82", 91729, 91744, "#71851e", "master"],
		["rise 27", 91745, 91760, "#bca6d7", "master"],
		["hole 28", 91761, 91776, "#20202c", "master"],
		["valley 109", 91777, 91792, "#d5c284", "master"],
		["shine 81", 91793, 91808, "#a3904f", "master"],
		["field 28", 91809, 91824, "#8da40a", "master"],
		["cliff 27", 91825, 91840, "#43b2eb", "master"],
		["shine 82", 91841, 91856, "#2f387b", "master"],
		["sol 27", 91857, 91872, "#0b545c", "master"],
		["green 54", 91873, 91888, "#263206", "master"],
		["soar 27", 91889, 91904, "#367bcb", "master"],
		["arrive 53", 91905, 91920, "#b2d4f5", "master"],
		["valley 110", 91921, 91936, "#cea37e", "master"],
		["leaf 80", 91937, 91952, "#daee95", "master"],
		["bright 125", 91953, 91968, "#38423a", "master"],
		["leaf 81", 91969, 91984, "#516152", "master"],
		["bright 126", 91985, 92016, "#52373c", "master"],
		["curve 27", 92017, 92032, "#904024", "master"],
		["star 28", 92033, 92048, "#3270cd", "master"],
		["pond 28", 92049, 92064, "#36342a", "master"],
		["frond 56", 92065, 92080, "#3b4b18", "master"],
		["river 81", 92081, 92096, "#c8dce6", "master"],
		["watch 27", 92097, 92112, "#0a2a41", "master"],
		["bright 127", 92113, 92128, "#1f305b", "master"],
		["lush 54", 92129, 92144, "#3b4b18", "master"],
		["sail 28", 92145, 92160, "#8da40a", "master"],
		["below 81", 92161, 92176, "#bad3e2", "master"],
		["wood 28", 92177, 92192, "#b2aaa4", "master"],
		["toad 54", 92193, 92208, "#264056", "master"],
		["mist 134", 92209, 92224, "#a4c1c7", "master"],
		["toad 55", 92225, 92240, "#898391", "master"],
		["mist 135", 92241, 92256, "#714936", "master"],
		["fall 110", 92257, 92272, "#7a5d2b", "master"],
		["float 27", 92273, 92288, "#3a6daf", "master"],
		["clear 28", 92289, 92304, "#40addf", "master"],
		["snow 27", 92305, 92320, "#bbc5d9", "master"],
		["curl 27", 92321, 92336, "#1c600b", "master"],
		["marsh 28", 92337, 92352, "#1b0d35", "master"],
		["gaze 27", 92353, 92368, "#040c18", "master"],
		["space 28", 92369, 92384, "#2b2c41", "master"],
		["thick 27", 92385, 92400, "#3d3a16", "master"],
		["depth 27", 92401, 92416, "#3a6daf", "master"],
		["above 53", 92417, 92432, "#c8dce6", "master"],
		["aqua 53", 92433, 92448, "#b9d6e4", "master"],
		["azure 55", 92449, 92464, "#0f98b9", "master"],
		["icey 27", 92465, 92480, "#173ebd", "master"],
		["azure 56", 92481, 92496, "#585e31", "master"],
		["aqua 54", 92497, 92512, "#295771", "master"],
		["fir 27", 92513, 92528, "#15573d", "master"],
		["breeze 28", 92529, 92544, "#dee6dc", "master"],
		["palm 27", 92545, 92560, "#44c7ca", "master"],
		["melt 28", 92561, 92576, "#2d6194", "master"],
		["green 55", 92577, 92592, "#4c6111", "master"],
		["rock 55", 92593, 92608, "#b2cbc8", "master"],
		["light 54", 92609, 92624, "#0e0f1d", "master"],
		["zeal 27", 92625, 92640, "#89bee6", "master"],
		["vine 28", 92641, 92656, "#4c6111", "master"],
		["storm 27", 92657, 92672, "#548eb1", "master"],
		["grace 55", 92673, 92688, "#1b0d35", "master"],
		["wash 55", 92689, 92704, "#756e8d", "master"],
		["solis 27", 92705, 92720, "#d58265", "master"],
		["lake 81", 92721, 92736, "#225c75", "master"],
		["arrive 54", 92737, 92752, "#d3dbce", "master"],
		["shell 55", 92753, 92768, "#3d7ac9", "master"],
		["cover 54", 92769, 92784, "#134f7b", "master"],
		["wave 54", 92785, 92800, "#138cc5", "master"],
		["shore 27", 92801, 92816, "#e0afae", "master"],
		["freeze 27", 92817, 92832, "#73a0bd", "master"],
		["oak 28", 92833, 92848, "#609fdc", "master"],
		["slope 27", 92849, 92864, "#372f30", "master"],
		["lavish 27", 92865, 92880, "#856d1c", "master"],
		["opal 27", 92881, 92896, "#d49bc8", "master"],
		["vivid 56", 92897, 92912, "#609fdc", "master"],
		["vast 56", 92913, 92928, "#c7a884", "master"],
		["air 53", 92929, 92944, "#c3d0e0", "master"],
		["fresh 53", 92945, 92960, "#c6dded", "master"],
		["polar 28", 92961, 92976, "#819864", "master"],
		["white 27", 92977, 92992, "#6d8cab", "master"],
		["fall 111", 92993, 93008, "#364821", "master"],
		["fresh 54", 93009, 93024, "#42a198", "master"],
		["red 55", 93025, 93040, "#675d45", "master"],
		["ripple 54", 93041, 93056, "#c7a884", "master"],
		["lake 82", 93057, 93072, "#d9ca87", "master"],
		["crest 54", 93073, 93088, "#b8abda", "master"],
		["ruby 27", 93089, 93104, "#6d1a10", "master"],
		["seed 28", 93105, 93120, "#b5674f", "master"],
		["sea 27", 93121, 93136, "#6a68c7", "master"],
		["arise 55", 93137, 93152, "#0e3650", "master"],
		["wall 27", 93153, 93168, "#b5abb0", "master"],
		["sand 55", 93169, 93184, "#0f46bf", "master"],
		["set 55", 93185, 93200, "#372f30", "master"],
		["view 109", 93201, 93216, "#3f6e9a", "master"],
		["luna 28", 93217, 93232, "#051227", "master"],
		["lime 27", 93233, 93248, "#75a7dc", "master"],
		["above 54", 93249, 93264, "#cfd088", "master"],
		["air 54", 93265, 93280, "#885c2d", "master"],
		["bark 27", 93281, 93296, "#a17e5e", "master"],
		["drift 28", 93297, 93312, "#9fa7ee", "master"],
		["valley 111", 93313, 93328, "#c37966", "master"],
		["peace 28", 93329, 93344, "#789395", "master"],
		["fog 27", 93345, 93360, "#8c8237", "master"],
		["grain 27", 93361, 93376, "#f8e6d9", "master"],
		["below 82", 93377, 93392, "#c1b8b4", "master"],
		["crest 55", 93393, 93408, "#b2c7d8", "master"],
		["bask 28", 93409, 93424, "#939aa5", "master"],
		["sierra 27", 93425, 93440, "#c36910", "master"],
		["calm 83", 93441, 93456, "#aaa2df", "master"],
		["dawn 108", 93457, 93472, "#6a68c7", "master"],
		["river 82", 93473, 93488, "#587a75", "master"],
		["arid 29", 93489, 93504, "#c5c3b7", "master"],
		["view 110", 93505, 93520, "#3b7fa6", "master"],
		["serene 56", 93521, 93536, "#664755", "master"],
		["view 111", 93537, 93552, "#060a1f", "master"],
		["sand 56", 93553, 93568, "#1e558c", "master"],
		["spire 55", 93569, 93584, "#36483b", "master"],
		["up 28", 93585, 93600, "#2a7b93", "master"],
		["frond 57", 93601, 93616, "#cfc7a5", "master"],
		["lines 28", 93617, 93632, "#4f80c0", "master"],
		["rapid 28", 93633, 93648, "#bad3e2", "master"],
		["still 28", 93649, 93664, "#c77fd2", "master"],
		["arise 56", 93665, 93680, "#385e76", "master"],
		["rock 56", 93681, 93696, "#1e558c", "master"],
		["wind 28", 93697, 93712, "#f8e6d9", "master"],
		["mist 136", 93713, 93728, "#c1b8b4", "master"],
		["range 28", 93729, 93744, "#34447a", "master"],
		["flat 29", 93745, 93760, "#3d90ce", "master"],
		["brood 83", 93761, 93776, "#85a7c8", "master"],
		["calm 84", 93777, 93792, "#7e6064", "master"],
		["dawn 109", 93793, 93808, "#ae8b14", "master"],
		["rise 28", 93809, 93824, "#bca6d7", "master"],
		["hole 29", 93825, 93840, "#20202c", "master"],
		["valley 112", 93841, 93856, "#d5c284", "master"],
		["shine 83", 93857, 93872, "#a3904f", "master"],
		["field 29", 93873, 93888, "#8da40a", "master"],
		["cliff 28", 93889, 93904, "#43b2eb", "master"],
		["shine 84", 93905, 93920, "#2f387b", "master"],
		["sol 28", 93921, 93936, "#0b545c", "master"],
		["green 56", 93937, 93952, "#263206", "master"],
		["soar 28", 93953, 93968, "#367bcb", "master"],
		["arrive 55", 93969, 93984, "#b2d4f5", "master"],
		["valley 113", 93985, 94000, "#cea37e", "master"],
		["leaf 82", 94001, 94016, "#daee95", "master"],
		["bright 128", 94017, 94032, "#38423a", "master"],
		["leaf 83", 94033, 94048, "#516152", "master"],
		["bright 129", 94049, 94064, "#52373c", "master"],
		["mossy 28", 94065, 94080, "#96c4df", "master"],
		["curve 28", 94081, 94096, "#904024", "master"],
		["star 29", 94097, 94112, "#3270cd", "master"],
		["pond 29", 94113, 94128, "#36342a", "master"],
		["frond 58", 94129, 94144, "#3b4b18", "master"],
		["view 112", 94145, 94160, "#4186c8", "master"],
		["watch 28", 94161, 94176, "#0a2a41", "master"],
		["bright 130", 94177, 94192, "#1f305b", "master"],
		["lush 55", 94193, 94208, "#3b4b18", "master"],
		["sail 29", 94209, 94224, "#8da40a", "master"],
		["fall 112", 94225, 94240, "#43b2eb", "master"],
		["wood 29", 94241, 94256, "#b2aaa4", "master"],
		["toad 56", 94257, 94272, "#264056", "master"],
		["mist 137", 94273, 94288, "#a4c1c7", "master"],
		["toad 57", 94289, 94304, "#898391", "master"],
		["pebble 55", 94305, 94320, "#f5f3e8", "master"],
		["fall 113", 94321, 94336, "#7a5d2b", "master"],
		["float 28", 94337, 94352, "#3a6daf", "master"],
		["clear 29", 94353, 94368, "#40addf", "master"],
		["snow 28", 94369, 94384, "#bbc5d9", "master"],
		["grow 28", 94385, 94400, "#3d3a16", "master"],
		["marsh 29", 94401, 94416, "#1b0d35", "master"],
		["gaze 28", 94417, 94432, "#040c18", "master"],
		["space 29", 94433, 94448, "#2b2c41", "master"],
		["thick 28", 94449, 94464, "#3d3a16", "master"],
		["blue 29", 94465, 94480, "#dee6dc", "master"],
		["above 55", 94481, 94496, "#c8dce6", "master"],
		["aqua 55", 94497, 94512, "#b9d6e4", "master"],
		["azure 57", 94513, 94528, "#0f98b9", "master"],
		["icey 28", 94529, 94544, "#173ebd", "master"],
		["ray 55", 94545, 94560, "#8a8f89", "master"],
		["aqua 56", 94561, 94576, "#295771", "master"],
		["fir 28", 94577, 94592, "#15573d", "master"],
		["breeze 29", 94593, 94608, "#dee6dc", "master"],
		["palm 28", 94609, 94624, "#44c7ca", "master"],
		["light 55", 94625, 94640, "#184d4e", "master"],
		["green 57", 94641, 94656, "#4c6111", "master"],
		["rock 57", 94657, 94672, "#b2cbc8", "master"],
		["light 56", 94673, 94688, "#0e0f1d", "master"],
		["zeal 28", 94689, 94704, "#89bee6", "master"],
		["cover 55", 94705, 94720, "#90510a", "master"],
		["storm 28", 94721, 94736, "#548eb1", "master"],
		["grace 56", 94737, 94752, "#1b0d35", "master"],
		["wash 56", 94753, 94768, "#756e8d", "master"],
		["solis 28", 94769, 94784, "#d58265", "master"],
		["valley 114", 94785, 94800, "#7e93a8", "master"],
		["arrive 56", 94801, 94816, "#d3dbce", "master"],
		["shell 56", 94817, 94832, "#3d7ac9", "master"],
		["cover 56", 94833, 94848, "#134f7b", "master"],
		["wave 55", 94849, 94864, "#138cc5", "master"],
		["vast 57", 94865, 94880, "#ee9361", "master"],
		["freeze 28", 94881, 94896, "#73a0bd", "master"],
		["oak 29", 94897, 94912, "#609fdc", "master"],
		["slope 28", 94913, 94928, "#372f30", "master"],
		["lavish 28", 94929, 94944, "#856d1c", "master"],
		["pyre 29", 94945, 94960, "#451624", "master"],
		["vivid 57", 94961, 94976, "#609fdc", "master"],
		["vast 58", 94977, 94992, "#c7a884", "master"],
		["air 55", 94993, 95008, "#c3d0e0", "master"],
		["fresh 55", 95009, 95024, "#c6dded", "master"],
		["strato 28", 95025, 95040, "#0a408a", "master"],
		["white 28", 95041, 95056, "#6d8cab", "master"],
		["fall 114", 95057, 95072, "#364821", "master"],
		["fresh 56", 95073, 95088, "#42a198", "master"],
		["red 56", 95089, 95104, "#675d45", "master"],
		["dry 28", 95105, 95120, "#0f46bf", "master"],
		["lake 83", 95121, 95136, "#d9ca87", "master"],
		["crest 56", 95137, 95152, "#b8abda", "master"],
		["ruby 28", 95153, 95168, "#6d1a10", "master"],
		["seed 29", 95169, 95184, "#b5674f", "master"],
		["coast 28", 95185, 95200, "#355732", "master"],
		["arise 57", 95201, 95216, "#0e3650", "master"],
		["wall 28", 95217, 95232, "#b5abb0", "master"],
		["sand 57", 95233, 95248, "#0f46bf", "master"],
		["set 56", 95249, 95264, "#372f30", "master"],
		["brood 84", 95265, 95280, "#856d1c", "master"],
		["luna 29", 95281, 95296, "#051227", "master"],
		["lime 28", 95297, 95312, "#75a7dc", "master"],
		["above 56", 95313, 95328, "#cfd088", "master"],
		["air 56", 95329, 95344, "#885c2d", "master"],
		["fall 115", 95345, 95360, "#3989b3", "master"],
		["drift 29", 95361, 95376, "#9fa7ee", "master"],
		["valley 115", 95377, 95392, "#c37966", "master"],
		["peace 29", 95393, 95408, "#789395", "master"],
		["fog 28", 95409, 95424, "#8c8237", "master"],
		["far 28", 95425, 95440, "#367bcb", "master"],
		["below 83", 95441, 95456, "#c1b8b4", "master"],
		["crest 57", 95457, 95472, "#b2c7d8", "master"],
		["bask 29", 95473, 95488, "#939aa5", "master"],
		["sierra 28", 95489, 95504, "#c36910", "master"],
		["amber 28", 95505, 95520, "#b5674f", "master"],
		["dawn 110", 95521, 95536, "#6a68c7", "master"],
		["river 83", 95537, 95552, "#587a75", "master"],
		["arid 30", 95553, 95568, "#c5c3b7", "master"],
		["view 113", 95569, 95584, "#3b7fa6", "master"],
		["set 57", 95585, 95600, "#6b4a3e", "master"],
		["view 114", 95601, 95616, "#060a1f", "master"],
		["sand 58", 95617, 95632, "#1e558c", "master"],
		["spire 56", 95633, 95648, "#36483b", "master"],
		["up 29", 95649, 95664, "#2a7b93", "master"],
		["grass 28", 95665, 95680, "#32283c", "master"],
		["lines 29", 95681, 95696, "#4f80c0", "master"],
		["rapid 29", 95697, 95712, "#bad3e2", "master"],
		["still 29", 95713, 95728, "#c77fd2", "master"],
		["arise 58", 95729, 95744, "#385e76", "master"],
		["spire 57", 95745, 95760, "#bca6d7", "master"],
		["wind 29", 95761, 95776, "#f8e6d9", "master"],
		["mist 138", 95777, 95792, "#c1b8b4", "master"],
		["range 29", 95793, 95808, "#34447a", "master"],
		["flat 30", 95809, 95824, "#3d90ce", "master"],
		["brood 85", 95825, 95840, "#85a7c8", "master"],
		["calm 85", 95841, 95856, "#7e6064", "master"],
		["dawn 111", 95857, 95872, "#ae8b14", "master"],
		["rise 29", 95873, 95888, "#bca6d7", "master"],
		["hole 30", 95889, 95904, "#20202c", "master"],
		["valley 116", 95905, 95920, "#d5c284", "master"],
		["shine 85", 95921, 95936, "#a3904f", "master"],
		["lush 56", 95937, 95952, "#263206", "master"],
		["cliff 29", 95953, 95968, "#43b2eb", "master"],
		["shine 86", 95969, 95984, "#2f387b", "master"],
		["sol 29", 95985, 96000, "#0b545c", "master"],
		["green 58", 96001, 96016, "#263206", "master"],
		["haze 28", 96017, 96032, "#4f80c0", "master"],
		["arrive 57", 96033, 96048, "#b2d4f5", "master"],
		["valley 117", 96049, 96064, "#cea37e", "master"],
		["leaf 84", 96065, 96080, "#daee95", "master"],
		["bright 131", 96081, 96096, "#38423a", "master"],
		["brook 55", 96097, 96112, "#5e4144", "master"],
		["bright 132", 96113, 96128, "#52373c", "master"],
		["mossy 29", 96129, 96144, "#96c4df", "master"],
		["curve 29", 96145, 96160, "#904024", "master"],
		["star 30", 96161, 96176, "#3270cd", "master"],
		["mist 139", 96177, 96192, "#d6c3c5", "master"],
		["frond 59", 96193, 96208, "#3b4b18", "master"],
		["view 115", 96209, 96224, "#4186c8", "master"],
		["watch 29", 96225, 96240, "#0a2a41", "master"],
		["bright 133", 96241, 96256, "#1f305b", "master"],
		["wild 28", 96257, 96272, "#1c600b", "master"],
		["sail 30", 96273, 96288, "#8da40a", "master"],
		["fall 116", 96289, 96304, "#43b2eb", "master"],
		["wood 30", 96305, 96320, "#b2aaa4", "master"],
		["toad 58", 96321, 96336, "#264056", "master"],
		["shine 87", 96337, 96352, "#a17b63", "master"],
		["toad 59", 96353, 96368, "#898391", "master"],
		["pebble 56", 96369, 96384, "#f5f3e8", "master"],
		["fall 117", 96385, 96400, "#7a5d2b", "master"],
		["float 29", 96401, 96416, "#3a6daf", "master"],
		["beach 28", 96417, 96432, "#cdad81", "master"],
		["snow 29", 96433, 96448, "#bbc5d9", "master"],
		["grow 29", 96449, 96464, "#3d3a16", "master"],
		["marsh 30", 96465, 96480, "#1b0d35", "master"],
		["gaze 29", 96481, 96496, "#040c18", "master"],
		["fit 28", 96497, 96512, "#3b6fa7", "master"],
		["thick 29", 96513, 96528, "#3d3a16", "master"],
		["blue 30", 96529, 96544, "#dee6dc", "master"],
		["above 57", 96545, 96560, "#c8dce6", "master"],
		["aqua 57", 96561, 96576, "#b9d6e4", "master"],
		["ray 56", 96577, 96592, "#b1934b", "master"],
		["icey 29", 96593, 96608, "#173ebd", "master"],
		["ray 57", 96609, 96624, "#8a8f89", "master"],
		["aqua 58", 96625, 96640, "#295771", "master"],
		["fir 29", 96641, 96656, "#15573d", "master"],
		["calm 86", 96657, 96672, "#548eb1", "master"],
		["palm 29", 96673, 96688, "#44c7ca", "master"],
		["light 57", 96689, 96704, "#184d4e", "master"],
		["green 59", 96705, 96720, "#4c6111", "master"],
		["rock 58", 96721, 96736, "#b2cbc8", "master"],
		["bluff 29", 96737, 96752, "#3f6e9a", "master"],
		["zeal 29", 96753, 96768, "#89bee6", "master"],
		["cover 57", 96769, 96784, "#90510a", "master"],
		["storm 29", 96785, 96800, "#548eb1", "master"],
		["grace 57", 96801, 96816, "#1b0d35", "master"],
		["shell 57", 96817, 96832, "#d0a973", "master"],
		["solis 29", 96833, 96848, "#d58265", "master"],
		["valley 118", 96849, 96864, "#7e93a8", "master"],
		["arrive 58", 96865, 96880, "#d3dbce", "master"],
		["shell 58", 96881, 96896, "#3d7ac9", "master"],
		["vivid 58", 96897, 96912, "#638cac", "master"],
		["wave 56", 96913, 96928, "#138cc5", "master"],
		["vast 59", 96929, 96944, "#ee9361", "master"],
		["freeze 29", 96945, 96960, "#73a0bd", "master"],
		["oak 30", 96961, 96976, "#609fdc", "master"],
		["chill 28", 96977, 96992, "#aaa2df", "master"],
		["lavish 29", 96993, 97008, "#856d1c", "master"],
		["pyre 30", 97009, 97024, "#451624", "master"],
		["vivid 59", 97025, 97040, "#609fdc", "master"],
		["vast 60", 97041, 97056, "#c7a884", "master"],
		["serene 57", 97057, 97072, "#b2cbc8", "master"],
		["fresh 57", 97073, 97088, "#c6dded", "master"],
		["strato 29", 97089, 97104, "#0a408a", "master"],
		["white 29", 97105, 97120, "#6d8cab", "master"],
		["fall 118", 97121, 97136, "#364821", "master"],
		["grace 58", 97137, 97152, "#0561d1", "master"],
		["red 57", 97153, 97168, "#675d45", "master"],
		["dry 29", 97169, 97184, "#0f46bf", "master"],
		["lake 84", 97185, 97200, "#d9ca87", "master"],
		["crest 58", 97201, 97216, "#b8abda", "master"],
		["birch 28", 97217, 97232, "#ccc6b7", "master"],
		["seed 30", 97233, 97248, "#b5674f", "master"],
		["coast 29", 97249, 97264, "#355732", "master"],
		["arise 59", 97265, 97280, "#0e3650", "master"],
		["wall 29", 97281, 97296, "#b5abb0", "master"],
		["dune 28", 97297, 97312, "#9fa7ee", "master"],
		["set 58", 97313, 97328, "#372f30", "master"],
		["brood 86", 97329, 97344, "#856d1c", "master"],
		["luna 30", 97345, 97360, "#051227", "master"],
		["lime 29", 97361, 97376, "#75a7dc", "master"],
		["climb 57", 97377, 97392, "#1d443b", "master"],
		["air 57", 97393, 97408, "#885c2d", "master"],
		["fall 119", 97409, 97424, "#3989b3", "master"],
		["drift 30", 97425, 97440, "#9fa7ee", "master"],
		["valley 119", 97441, 97456, "#c37966", "master"],
		["height 28", 97457, 97472, "#454c50", "master"],
		["fog 29", 97473, 97488, "#8c8237", "master"],
		["far 29", 97489, 97504, "#367bcb", "master"],
		["below 84", 97505, 97520, "#c1b8b4", "master"],
		["crest 59", 97521, 97536, "#b2c7d8", "master"],
		["gift 28", 97537, 97552, "#c797e8", "master"],
		["sierra 29", 97553, 97568, "#c36910", "master"],
		["amber 29", 97569, 97584, "#b5674f", "master"],
		["dawn 112", 97585, 97600, "#6a68c7", "master"],
		["river 84", 97601, 97616, "#587a75", "master"],
		["erode 28", 97617, 97632, "#5e92f3", "master"],
		["view 116", 97633, 97648, "#3b7fa6", "master"],
		["set 59", 97649, 97664, "#6b4a3e", "master"],
		["view 117", 97665, 97680, "#060a1f", "master"],
		["sand 59", 97681, 97696, "#1e558c", "master"],
		["spire 58", 97697, 97712, "#36483b", "master"],
		["up 30", 97713, 97728, "#2a7b93", "master"],
		["grass 29", 97729, 97744, "#32283c", "master"],
		["lines 30", 97745, 97760, "#4f80c0", "master"],
		["rapid 30", 97761, 97776, "#bad3e2", "master"],
		["still 30", 97777, 97792, "#c77fd2", "master"],
		["arise 60", 97793, 97808, "#385e76", "master"],
		["spire 59", 97809, 97824, "#bca6d7", "master"],
		["wind 30", 97825, 97840, "#f8e6d9", "master"],
		["mist 140", 97841, 97856, "#c1b8b4", "master"],
		["range 30", 97857, 97872, "#34447a", "master"],
		["flat 31", 97873, 97888, "#3d90ce", "master"],
		["dawn 113", 97889, 97904, "#444b23", "master"],
		["calm 87", 97905, 97920, "#7e6064", "master"],
		["dawn 114", 97921, 97936, "#ae8b14", "master"],
		["rise 30", 97937, 97952, "#bca6d7", "master"],
		["hole 31", 97953, 97968, "#20202c", "master"],
		["dusk 28", 97969, 97984, "#5b447b", "master"],
		["shine 88", 97985, 98000, "#a3904f", "master"],
		["lush 57", 98001, 98016, "#263206", "master"],
		["cliff 30", 98017, 98032, "#43b2eb", "master"],
		["shine 89", 98033, 98048, "#2f387b", "master"],
		["emit 29", 98049, 98064, "#1c3528", "master"],
		["green 60", 98065, 98080, "#263206", "master"],
		["haze 29", 98081, 98096, "#4f80c0", "master"],
		["arrive 59", 98097, 98112, "#b2d4f5", "master"],
		["valley 120", 98113, 98128, "#cea37e", "master"],
		["brook 56", 98129, 98144, "#566f3c", "master"],
		["bright 134", 98145, 98160, "#38423a", "master"],
		["brook 57", 98161, 98176, "#5e4144", "master"],
		["bright 135", 98177, 98192, "#52373c", "master"],
		["mossy 30", 98193, 98208, "#96c4df", "master"],
		["river 85", 98209, 98224, "#1b89d3", "master"],
		["star 31", 98225, 98240, "#3270cd", "master"],
		["mist 141", 98241, 98256, "#d6c3c5", "master"],
		["frond 60", 98257, 98272, "#3b4b18", "master"],
		["view 118", 98273, 98288, "#4186c8", "master"],
		["sky 56", 98289, 98304, "#081328", "master"],
		["bright 136", 98305, 98320, "#1f305b", "master"],
		["wild 29", 98321, 98336, "#1c600b", "master"],
		["sail 31", 98337, 98352, "#8da40a", "master"],
		["fall 120", 98353, 98368, "#43b2eb", "master"],
		["pebble 57", 98369, 98384, "#7e707b", "master"],
		["toad 60", 98385, 98400, "#264056", "master"],
		["shine 90", 98401, 98416, "#a17b63", "master"],
		["toad 61", 98417, 98432, "#898391", "master"],
		["pebble 58", 98433, 98448, "#f5f3e8", "master"],
		["leaf 85", 98449, 98464, "#779c35", "master"],
		["float 30", 98465, 98480, "#3a6daf", "master"],
		["beach 29", 98481, 98496, "#cdad81", "master"],
		["snow 30", 98497, 98512, "#bbc5d9", "master"],
		["grow 30", 98513, 98528, "#3d3a16", "master"],
		["cove 29", 98529, 98544, "#c3d0e0", "master"],
		["gaze 30", 98545, 98560, "#040c18", "master"],
		["fit 29", 98561, 98576, "#3b6fa7", "master"],
		["thick 30", 98577, 98592, "#3d3a16", "master"],
		["blue 31", 98593, 98608, "#dee6dc", "master"],
		["climb 58", 98609, 98624, "#4186c8", "master"],
		["aqua 59", 98625, 98640, "#b9d6e4", "master"],
		["ray 58", 98641, 98656, "#b1934b", "master"],
		["icey 30", 98657, 98672, "#173ebd", "master"],
		["ray 59", 98673, 98688, "#8a8f89", "master"],
		["wash 57", 98689, 98704, "#bd9794", "master"],
		["fir 30", 98705, 98720, "#15573d", "master"],
		["calm 88", 98721, 98736, "#548eb1", "master"],
		["palm 30", 98737, 98752, "#44c7ca", "master"],
		["light 58", 98753, 98768, "#184d4e", "master"],
		["grove 29", 98769, 98784, "#90510a", "master"],
		["rock 59", 98785, 98800, "#b2cbc8", "master"],
		["bluff 30", 98801, 98816, "#3f6e9a", "master"],
		["zeal 30", 98817, 98832, "#89bee6", "master"],
		["cover 58", 98833, 98848, "#90510a", "master"],
		["wave 57", 98849, 98864, "#138cc5", "master"],
		["grace 59", 98865, 98880, "#1b0d35", "master"],
		["shell 59", 98881, 98896, "#d0a973", "master"],
		["solis 30", 98897, 98912, "#d58265", "master"],
		["valley 121", 98913, 98928, "#7e93a8", "master"],
		["below 85", 98929, 98944, "#344f3d", "master"],
		["shell 60", 98945, 98960, "#3d7ac9", "master"],
		["vivid 60", 98961, 98976, "#638cac", "master"],
		["wave 58", 98977, 98992, "#138cc5", "master"],
		["vast 61", 98993, 99008, "#ee9361", "master"],
		["frost 28", 99009, 99024, "#bec8d1", "master"],
		["oak 31", 99025, 99040, "#609fdc", "master"],
		["chill 29", 99041, 99056, "#aaa2df", "master"],
		["lavish 30", 99057, 99072, "#856d1c", "master"],
		["pyre 31", 99073, 99088, "#451624", "master"],
		["red 58", 99089, 99104, "#6d1a10", "master"],
		["vast 62", 99105, 99120, "#c7a884", "master"],
		["serene 58", 99121, 99136, "#b2cbc8", "master"],
		["fresh 58", 99137, 99152, "#c6dded", "master"],
		["strato 30", 99153, 99168, "#0a408a", "master"],
		["arch 28", 99169, 99184, "#1778d2", "master"],
		["fall 121", 99185, 99200, "#364821", "master"],
		["grace 60", 99201, 99216, "#0561d1", "master"],
		["red 59", 99217, 99232, "#675d45", "master"],
		["dry 30", 99233, 99248, "#0f46bf", "master"],
		["sky 57", 99249, 99264, "#8a5425", "master"],
		["crest 60", 99265, 99280, "#b8abda", "master"],
		["birch 29", 99281, 99296, "#ccc6b7", "master"],
		["seed 31", 99297, 99312, "#b5674f", "master"],
		["coast 30", 99313, 99328, "#355732", "master"],
		["ripple 55", 99329, 99344, "#a7a3a0", "master"],
		["wall 30", 99345, 99360, "#b5abb0", "master"],
		["dune 29", 99361, 99376, "#9fa7ee", "master"],
		["set 60", 99377, 99392, "#372f30", "master"],
		["brood 87", 99393, 99408, "#856d1c", "master"],
		["cosmo 28", 99409, 99424, "#3b2446", "master"],
		["lime 30", 99425, 99440, "#75a7dc", "master"],
		["climb 59", 99441, 99456, "#1d443b", "master"],
		["air 58", 99457, 99472, "#885c2d", "master"],
		["fall 122", 99473, 99488, "#3989b3", "master"],
		["dawn 115", 99489, 99504, "#c36910", "master"],
		["valley 122", 99505, 99520, "#c37966", "master"],
		["height 29", 99521, 99536, "#454c50", "master"],
		["fog 30", 99537, 99552, "#8c8237", "master"],
		["far 30", 99553, 99568, "#367bcb", "master"],
		["pine 29", 99569, 99584, "#b2d4f5", "master"],
		["crest 61", 99585, 99600, "#b2c7d8", "master"],
		["gift 29", 99601, 99616, "#c797e8", "master"],
		["sierra 30", 99617, 99632, "#c36910", "master"],
		["amber 30", 99633, 99648, "#b5674f", "master"],
		["dawn 116", 99649, 99664, "#6a68c7", "master"],
		["river 86", 99665, 99680, "#587a75", "master"],
		["erode 29", 99681, 99696, "#5e92f3", "master"],
		["view 119", 99697, 99712, "#3b7fa6", "master"],
		["set 61", 99713, 99728, "#6b4a3e", "master"],
		["view 120", 99729, 99744, "#060a1f", "master"],
		["sand 60", 99745, 99760, "#1e558c", "master"],
		["mist 142", 99761, 99776, "#052d65", "master"],
		["up 31", 99777, 99792, "#2a7b93", "master"],
		["grass 30", 99793, 99808, "#32283c", "master"],
		["lines 31", 99809, 99824, "#4f80c0", "master"],
		["rapid 31", 99825, 99840, "#bad3e2", "master"],
		["glass 28", 99841, 99856, "#6e9ecf", "master"],
		["arise 61", 99857, 99872, "#385e76", "master"],
		["spire 60", 99873, 99888, "#bca6d7", "master"],
		["wind 31", 99889, 99904, "#f8e6d9", "master"],
		["mist 143", 99905, 99920, "#c1b8b4", "master"],
		["lake 85", 99921, 99936, "#84857f", "master"],
		["flat 32", 99937, 99952, "#3d90ce", "master"],
		["dawn 117", 99953, 99968, "#444b23", "master"],
		["calm 89", 99969, 99984, "#7e6064", "master"],
		["dawn 118", 99985, 100000, "#ae8b14", "master"],
	],
};
